
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("978hs", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $d0ad5ab1919b7b90$export$d7f512c98c859244);
$parcel$export(module.exports, "default", () => $d0ad5ab1919b7b90$export$2e2bcd8739ae039);
$parcel$export(module.exports, "standardizeLocale", () => $d0ad5ab1919b7b90$export$ca06804549ae25fb);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore json imports are ts-ignored

var $bnqi9 = parcelRequire("bnqi9");
const $d0ad5ab1919b7b90$export$d7f512c98c859244 = 'en_US';
const $d0ad5ab1919b7b90$export$a95850d20423e414 = 'fr_FR';
const $d0ad5ab1919b7b90$var$locales = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($bnqi9)))).map((locale)=>locale.replace('-', '_'));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d0ad5ab1919b7b90$export$2e2bcd8739ae039 = $d0ad5ab1919b7b90$var$locales;
const $d0ad5ab1919b7b90$export$ca06804549ae25fb = (locale)=>locale.replace('_', '-');

});
parcelRegister("bnqi9", function(module, exports) {
module.exports = JSON.parse("{\"cs-CZ\":{},\"da-DK\":{},\"de-DE\":{},\"en-GB\":{},\"en-UK\":{},\"en-US\":{},\"en-ZZ\":{},\"es-ES\":{},\"et-EE\":{},\"fi-FI\":{},\"fr-FR\":{},\"hu-HU\":{},\"is-IS\":{},\"it-IT\":{},\"ja-JP\":{},\"ko-KR\":{},\"nb-NO\":{},\"nl-NL\":{},\"pl-PL\":{},\"pt-BR\":{},\"pt-PT\":{},\"ro-RO\":{},\"ru-RU\":{},\"sk-SK\":{},\"sv-SE\":{},\"tr-TR\":{},\"zh-CN\":{},\"zh-TW\":{}}");

});


parcelRegister("2IWJd", function(module, exports) {
/* eslint-disable jira/filename-case */ 
parcelRequire("haztg");




// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $ea48c295c5aeec61$var$lazyImports = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("8w5ez"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("lPmfV"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("9OCIS"));
};
// We set this global variable to ensure it is available to all environments
// and then overwrite its value to TRUE in the JiraSPA entries: SSR and non-SSR
$parcel$global.__SPA__ = false;

});
parcelRegister("haztg", function(module, exports) {
/* eslint-disable jira/filename-case */ 
var $m9zhS = parcelRequire("m9zhS");

var $1ekWM = parcelRequire("1ekWM");

var $bDxkI = parcelRequire("bDxkI");

var $k11SN = parcelRequire("k11SN");

var $lSsUZ = parcelRequire("lSsUZ");
if (!(0, $k11SN.default)('fe_platform_error_tracking_enabled_sentry')) (0, $m9zhS.installGlobalHandler)();
(0, $bDxkI.installErrorHandler)((0, $lSsUZ.platformErrorHandler));
(0, $1ekWM.default)();

});
parcelRegister("m9zhS", function(module, exports) {
$parcel$export(module.exports, "installGlobalHandler", () => $dbf63ead6b018b68$export$7da675e3dd1bd6b5);
/* eslint-disable jira/filename-case */ 
var $68wlw = parcelRequire("68wlw");
const $dbf63ead6b018b68$export$7da675e3dd1bd6b5 = ()=>false ? undefined : (0, $68wlw.installGlobalHandler)();

});
parcelRegister("68wlw", function(module, exports) {
$parcel$export(module.exports, "installGlobalHandler", () => $e866344ae571008f$export$7da675e3dd1bd6b5);
/* eslint-disable jira/filename-case */ 
var $84Maa = parcelRequire("84Maa");
var $eGgLE = parcelRequire("eGgLE");
var $c2AmC = parcelRequire("c2AmC");

var $lmSpp = parcelRequire("lmSpp");
var $lJt5a = parcelRequire("lJt5a");
var $gpdQo = parcelRequire("gpdQo");
var $kb1Yw = parcelRequire("kb1Yw");

var $l1vE2 = parcelRequire("l1vE2");

var $2HuOR = parcelRequire("2HuOR");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $gToGk = parcelRequire("gToGk");

var $5HYmv = parcelRequire("5HYmv");

var $7YAQr = parcelRequire("7YAQr");

var $dcgSS = parcelRequire("dcgSS");
const $e866344ae571008f$var$SENTRY_URL = 'https://12742a0abbd1484686195dca8ba74be6@o55978.ingest.sentry.io/5988809';
const $e866344ae571008f$var$FRONTEND_RESOURCES = [
    // Our DEV and PROD environments in Micros Static
    /https:\/\/jira-frontend.*\..*\.atl-paas\.net\//,
    // For devs using `yarn start`
    /atlastunnel/,
    /localhost/,
    // Old S3 DEV environment
    /https:\/\/d398cwy4pffc4s\.cloudfront\.net\//,
    // Monolith staging|hello|ap|us environment
    /https:\/\/(d25s903c0x7s6j|dgjotco7y2aa|d9x1z07c483jl|d1vkjhvgh6tvn1).cloudfront.net\//,
    // Old S3 PROD environment
    /https:\/\/d2oj435jmh0qvz\.cloudfront\.net\//,
    // Automation S3 dev|staging|prod environment
    /https:\/\/(d3r49bgl1frqoy|d2v2wiwzx86dg|d283vu6e5qi87p).cloudfront.net\//
];
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
// Remove Breadcrumbs integration from the Sentry default integrations
// we will re-add it manually with custom options
const $e866344ae571008f$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
// This is used to mark which frames of the stacktrace are part of our app. They will be
// displayed in a different UI in Sentry.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e866344ae571008f$var$rewriteFramesIteratee = (frame)=>{
    const curFrame = frame;
    if (curFrame.filename) curFrame.in_app = $e866344ae571008f$var$FRONTEND_RESOURCES.some((resource)=>resource.test(frame.filename));
    return curFrame;
};
const $e866344ae571008f$var$getSentryEnvironment = ()=>{
    if ((0, $i860n.fg)('jira-bypass-sentry-environment-filter')) return 'dev';
    return (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)().environment ?? 'no-environment';
};
/**
 * Initializes Sentry for error logging with configurations tailored to the application's environment. It ensures error
 * reports are not duplicated if Sentry is already active, and sets up custom handling for errors and breadcrumbs,
 * enhancing error reporting with specific application context like bundler version, build variant, and user information.
 *
 * We import this code early in SSR static fallback (in entry-fs/), to catch errors in that code. However, it is
 * compiled in a different Parcel build, so typical bundler deduplication doesn't work and this script is run twice
 * (from different script tags), so we prevent double-init here using a global (only read+written here).
 */ const $e866344ae571008f$export$7da675e3dd1bd6b5 = ()=>{
    // @ts-expect-error global to communicate between multiple copies of this file. Should not be accessed elsewhere.
    if (globalThis.__JIRA_SENTRY_INSTALLED) return;
    // @ts-expect-error global to communicate between multiple copies of this file. Should not be accessed elsewhere.
    globalThis.__JIRA_SENTRY_INSTALLED = true;
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = (0, $84Maa.getCurrentHub)().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    let environment = $e866344ae571008f$var$getSentryEnvironment();
    if (environment === 'prod') environment = 'production';
    const tags = {
        region: (0, $6bEm8.default)('ajs-region') || 'unknown',
        // @ts-expect-error globalThis.__SSR_FALLBACK__ only exists in static fallback
        isStaticFallback: (0, $gToGk.getSsrStatus)() === 'static' || !!globalThis.__SSR_FALLBACK__,
        ...(0, $i860n.fg)('jfp-magma-panda-spa-state') ? {
            bifrostConsumer: globalThis.BUILD_KEY?.startsWith('MRJF') ? 'jira-frontend-bifrost' : 'jira-fe'
        } : {}
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUNDLER_VERSION) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const bundlerVersionTag = window.BUNDLER_VERSION.includes('@') ? window.BUNDLER_VERSION : `webpack@${window.BUNDLER_VERSION}`;
        tags.bundler = bundlerVersionTag;
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUILD_VARIANT) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    tags.variant = window.BUILD_VARIANT;
    const config = {
        // This is evaluated against the *first* frame of the stack trace.
        // If it doesn't match, the error is not sent.
        allowUrls: $e866344ae571008f$var$FRONTEND_RESOURCES,
        beforeSend: (0, $7YAQr.normaliseSentryEvent),
        // Sentry dom adds more attrs (like title, alt...) to breadcrumbs
        // but they might contain UGC/PII so we need to force strip them
        beforeBreadcrumb: (0, $5HYmv.normaliseSentryBreadcrumbs),
        dsn: (0, $l1vE2.isFedRamp)() ? undefined : $e866344ae571008f$var$SENTRY_URL,
        enabled: !(0, $i860n.fg)('jfp_disable_sentry_bb') || !globalThis.BUILD_KEY?.startsWith('MRJF-BB'),
        environment: environment,
        initialScope: {
            tags: tags,
            user: {
                id: (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)().atlassianAccountId ?? undefined
            }
        },
        integrations: (integrations)=>[
                ...$e866344ae571008f$var$getFilteredIntegrations(integrations),
                new (0, $c2AmC.Integrations).Breadcrumbs({
                    // only enable breadcrumbs for dom (UI clicks and inputs)
                    // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
                    dom: {
                        serializeAttribute: (0, $5HYmv.SERIALIZABLE_ATTRIBUTES),
                        maxStringLength: 300
                    },
                    fetch: false,
                    xhr: false,
                    console: false,
                    history: false,
                    sentry: false
                }),
                new (0, $lJt5a.Dedupe)(),
                new (0, $gpdQo.ExtraErrorData)(),
                new (0, $kb1Yw.RewriteFrames)({
                    iteratee: $e866344ae571008f$var$rewriteFramesIteratee
                }),
                ...(0, $i860n.fg)('jira-capture-console-errors-in-sentry') ? [
                    new (0, $lmSpp.CaptureConsole)({
                        levels: [
                            'error'
                        ]
                    })
                ] : []
            ],
        maxBreadcrumbs: 15,
        release: globalThis.BUILD_KEY,
        dist: globalThis.BUILD_VARIANT || 'default'
    };
    (0, $eGgLE.init)(config);
    // Once Sentry is initialized, start reporting Atlaspack errors
    (0, $dcgSS.handleAtlaspackErrors)();
    // Returning this value to prevent tree shaking in SSR
    return 'sentry-init';
};

});
parcelRegister("eGgLE", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $ab01fea2d781af24$export$5ef831fccfce35e5);
$parcel$export(module.exports, "getDefaultIntegrations", () => $ab01fea2d781af24$export$5783b2920b1d62b9);
$parcel$export(module.exports, "init", () => $ab01fea2d781af24$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $ab01fea2d781af24$export$3a8fd680da42627b);
$parcel$export(module.exports, "forceLoad", () => $ab01fea2d781af24$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $ab01fea2d781af24$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "wrap", () => $ab01fea2d781af24$export$4997ffc0176396a6);
$parcel$export(module.exports, "captureUserFeedback", () => $ab01fea2d781af24$export$88cefaf72d1e58a3);

var $dmS7i = parcelRequire("dmS7i");
var $2sSit = parcelRequire("2sSit");
var $84Maa = parcelRequire("84Maa");
var $dFnv4 = parcelRequire("dFnv4");
var $5hILL = parcelRequire("5hILL");
var $85Shi = parcelRequire("85Shi");
var $kOHMF = parcelRequire("kOHMF");

var $4rg5W = parcelRequire("4rg5W");
var $7I6pg = parcelRequire("7I6pg");
var $lnX7A = parcelRequire("lnX7A");
var $40AKY = parcelRequire("40AKY");

var $iQyrW = parcelRequire("iQyrW");

var $3gMoL = parcelRequire("3gMoL");

var $2TIK5 = parcelRequire("2TIK5");

var $lfdSs = parcelRequire("lfdSs");

var $9nLSz = parcelRequire("9nLSz");

var $efJnc = parcelRequire("efJnc");

var $5lgCu = parcelRequire("5lgCu");

var $2JxJk = parcelRequire("2JxJk");

var $eqOkL = parcelRequire("eqOkL");

var $21oNa = parcelRequire("21oNa");

var $5UoQk = parcelRequire("5UoQk");

var $6Em6n = parcelRequire("6Em6n");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $ab01fea2d781af24$export$5ef831fccfce35e5 = [
    (0, $85Shi.inboundFiltersIntegration)(),
    (0, $2sSit.functionToStringIntegration)(),
    (0, $eqOkL.browserApiErrorsIntegration)(),
    (0, $lfdSs.breadcrumbsIntegration)(),
    (0, $efJnc.globalHandlersIntegration)(),
    (0, $2JxJk.linkedErrorsIntegration)(),
    (0, $9nLSz.dedupeIntegration)(),
    (0, $5lgCu.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $ab01fea2d781af24$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$ab01fea2d781af24$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $ab01fea2d781af24$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $ab01fea2d781af24$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $2TIK5.WINDOW).SENTRY_RELEASE && (0, $2TIK5.WINDOW).SENTRY_RELEASE.id) options.release = (0, $2TIK5.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $lnX7A.stackParserFromStackParserOptions)(options.stackParser || (0, $21oNa.defaultStackParser)),
        integrations: (0, $dFnv4.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $40AKY.supportsFetch)() ? (0, $5UoQk.makeFetchTransport) : (0, $6Em6n.makeXHRTransport))
    };
    (0, $kOHMF.initAndBind)((0, $iQyrW.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $ab01fea2d781af24$var$startSessionTracking();
}
const $ab01fea2d781af24$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $84Maa.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $2TIK5.WINDOW).document) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $2TIK5.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $5hILL.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $2TIK5.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $2TIK5.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $2TIK5.WINDOW).document.head || (0, $2TIK5.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $ab01fea2d781af24$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $ab01fea2d781af24$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ab01fea2d781af24$export$4997ffc0176396a6(fn) {
    return (0, $2TIK5.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $ab01fea2d781af24$var$startSessionTracking() {
    if (typeof (0, $2TIK5.WINDOW).document === 'undefined') {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $dmS7i.startSession)({
        ignoreDuration: true
    });
    (0, $dmS7i.captureSession)();
    // We want to create a session for every navigation as well
    (0, $4rg5W.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $dmS7i.startSession)({
                ignoreDuration: true
            });
            (0, $dmS7i.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $ab01fea2d781af24$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $dmS7i.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("2sSit", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $1cb850892184e0a2$export$7918117e9202e4fb);
$parcel$export(module.exports, "FunctionToString", () => $1cb850892184e0a2$export$da4704525c20ae79);

var $iiQEB = parcelRequire("iiQEB");

var $dmS7i = parcelRequire("dmS7i");

var $dFnv4 = parcelRequire("dFnv4");
let $1cb850892184e0a2$var$originalFunctionToString;
const $1cb850892184e0a2$var$INTEGRATION_NAME = 'FunctionToString';
const $1cb850892184e0a2$var$SETUP_CLIENTS = new WeakMap();
const $1cb850892184e0a2$var$_functionToStringIntegration = ()=>{
    return {
        name: $1cb850892184e0a2$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $1cb850892184e0a2$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $iiQEB.getOriginalFunction)(this);
                    const context = $1cb850892184e0a2$var$SETUP_CLIENTS.has((0, $dmS7i.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $1cb850892184e0a2$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $1cb850892184e0a2$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $1cb850892184e0a2$export$7918117e9202e4fb = (0, $dFnv4.defineIntegration)($1cb850892184e0a2$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1cb850892184e0a2$export$da4704525c20ae79 = (0, $dFnv4.convertIntegrationFnToClass)($1cb850892184e0a2$var$INTEGRATION_NAME, $1cb850892184e0a2$export$7918117e9202e4fb);

});
parcelRegister("dFnv4", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $9f31555b4a9c9ead$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $9f31555b4a9c9ead$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $9f31555b4a9c9ead$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $9f31555b4a9c9ead$export$35abcfd71227c6ca);
$parcel$export(module.exports, "addIntegration", () => $9f31555b4a9c9ead$export$2d8f5188773bcddd);
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $9f31555b4a9c9ead$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $9f31555b4a9c9ead$export$2323046b9414659f);

var $h7F1u = parcelRequire("h7F1u");
var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $d86W5 = parcelRequire("d86W5");

var $dmS7i = parcelRequire("dmS7i");

var $84Maa = parcelRequire("84Maa");
const $9f31555b4a9c9ead$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $9f31555b4a9c9ead$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $9f31555b4a9c9ead$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $h7F1u.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $9f31555b4a9c9ead$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $9f31555b4a9c9ead$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $9f31555b4a9c9ead$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $9f31555b4a9c9ead$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $9f31555b4a9c9ead$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $9f31555b4a9c9ead$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($9f31555b4a9c9ead$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $d86W5.addGlobalEventProcessor), (0, $84Maa.getCurrentHub));
        $9f31555b4a9c9ead$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $9f31555b4a9c9ead$export$2d8f5188773bcddd(integration) {
    const client = (0, $dmS7i.getClient)();
    if (!client || !client.addIntegration) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $9f31555b4a9c9ead$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $9f31555b4a9c9ead$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $9f31555b4a9c9ead$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("5hILL", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $3d914490da83fdb7$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $3d914490da83fdb7$export$671c7ed8e40a7a57);

var $5Na3j = parcelRequire("5Na3j");
var $iiQEB = parcelRequire("iiQEB");
const $3d914490da83fdb7$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $3d914490da83fdb7$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $3d914490da83fdb7$var$_getIngestEndpoint(dsn) {
    return `${$3d914490da83fdb7$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $3d914490da83fdb7$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $iiQEB.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $3d914490da83fdb7$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $3d914490da83fdb7$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$3d914490da83fdb7$var$_getIngestEndpoint(dsn)}?${$3d914490da83fdb7$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $3d914490da83fdb7$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $5Na3j.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$3d914490da83fdb7$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $5Na3j.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("5Na3j", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $4379538fdd47a10e$export$44d472fbb931a776);
$parcel$export(module.exports, "dsnFromString", () => $4379538fdd47a10e$export$b892860177f70a30);
$parcel$export(module.exports, "makeDsn", () => $4379538fdd47a10e$export$128827c3562ec0cb);

var $fmZZ6 = parcelRequire("fmZZ6");

var $7I6pg = parcelRequire("7I6pg");
/** Regular expression used to parse a Dsn. */ const $4379538fdd47a10e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $4379538fdd47a10e$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $4379538fdd47a10e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $4379538fdd47a10e$export$b892860177f70a30(str) {
    const match = $4379538fdd47a10e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $7I6pg.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $4379538fdd47a10e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $4379538fdd47a10e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $4379538fdd47a10e$var$validateDsn(dsn) {
    if (!(0, $fmZZ6.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $7I6pg.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $7I6pg.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$4379538fdd47a10e$var$isValidProtocol(protocol)) {
        (0, $7I6pg.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $7I6pg.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $4379538fdd47a10e$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $4379538fdd47a10e$export$b892860177f70a30(from) : $4379538fdd47a10e$var$dsnFromComponents(from);
    if (!components || !$4379538fdd47a10e$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("85Shi", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $5e48e4d320ae439e$export$cb3c5c2ceb9818ba);
$parcel$export(module.exports, "InboundFilters", () => $5e48e4d320ae439e$export$2ffbb5359dcc6be4);

var $h7F1u = parcelRequire("h7F1u");
var $7I6pg = parcelRequire("7I6pg");
var $4TtIy = parcelRequire("4TtIy");

var $aCaWa = parcelRequire("aCaWa");

var $dFnv4 = parcelRequire("dFnv4");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $5e48e4d320ae439e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $5e48e4d320ae439e$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $5e48e4d320ae439e$var$INTEGRATION_NAME = 'InboundFilters';
const $5e48e4d320ae439e$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $5e48e4d320ae439e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $5e48e4d320ae439e$var$_mergeOptions(options, clientOptions);
            return $5e48e4d320ae439e$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $5e48e4d320ae439e$export$cb3c5c2ceb9818ba = (0, $dFnv4.defineIntegration)($5e48e4d320ae439e$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5e48e4d320ae439e$export$2ffbb5359dcc6be4 = (0, $dFnv4.convertIntegrationFnToClass)($5e48e4d320ae439e$var$INTEGRATION_NAME, $5e48e4d320ae439e$export$cb3c5c2ceb9818ba);
function $5e48e4d320ae439e$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $5e48e4d320ae439e$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $5e48e4d320ae439e$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5e48e4d320ae439e$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $5e48e4d320ae439e$var$_isSentryError(event)) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $h7F1u.getEventDescription)(event)}`);
        return true;
    }
    if ($5e48e4d320ae439e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $h7F1u.getEventDescription)(event)}`);
        return true;
    }
    if ($5e48e4d320ae439e$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $h7F1u.getEventDescription)(event)}`);
        return true;
    }
    if ($5e48e4d320ae439e$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $h7F1u.getEventDescription)(event)}.\nUrl: ${$5e48e4d320ae439e$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$5e48e4d320ae439e$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $h7F1u.getEventDescription)(event)}.\nUrl: ${$5e48e4d320ae439e$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $5e48e4d320ae439e$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $5e48e4d320ae439e$var$_getPossibleEventMessages(event).some((message)=>(0, $4TtIy.stringMatchesSomePattern)(message, ignoreErrors));
}
function $5e48e4d320ae439e$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $4TtIy.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $5e48e4d320ae439e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $5e48e4d320ae439e$var$_getEventFilterUrl(event);
    return !url ? false : (0, $4TtIy.stringMatchesSomePattern)(url, denyUrls);
}
function $5e48e4d320ae439e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $5e48e4d320ae439e$var$_getEventFilterUrl(event);
    return !url ? true : (0, $4TtIy.stringMatchesSomePattern)(url, allowUrls);
}
function $5e48e4d320ae439e$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $aCaWa.DEBUG_BUILD) && possibleMessages.length === 0) (0, $7I6pg.logger).error(`Could not extract message for event ${(0, $h7F1u.getEventDescription)(event)}`);
    return possibleMessages;
}
function $5e48e4d320ae439e$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5e48e4d320ae439e$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5e48e4d320ae439e$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $5e48e4d320ae439e$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).error(`Cannot extract url for event ${(0, $h7F1u.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("kOHMF", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $f27a70c337f965eb$export$5333c3f1c58d9bc1);
$parcel$export(module.exports, "setCurrentClient", () => $f27a70c337f965eb$export$ecb76f41d43c0e43);

var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $dmS7i = parcelRequire("dmS7i");

var $84Maa = parcelRequire("84Maa");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $f27a70c337f965eb$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $aCaWa.DEBUG_BUILD) (0, $7I6pg.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $7I6pg.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $dmS7i.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $f27a70c337f965eb$export$ecb76f41d43c0e43(client);
    $f27a70c337f965eb$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $f27a70c337f965eb$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $84Maa.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $f27a70c337f965eb$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("4rg5W", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $33b62b23f021e4dd$export$3f18c56c58114e75);

var $iiQEB = parcelRequire("iiQEB");



var $hi3E4 = parcelRequire("hi3E4");

var $djhN8 = parcelRequire("djhN8");

var $cPqXP = parcelRequire("cPqXP");
const $33b62b23f021e4dd$var$WINDOW = (0, $hi3E4.GLOBAL_OBJ);
let $33b62b23f021e4dd$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $33b62b23f021e4dd$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $33b62b23f021e4dd$var$instrumentHistory);
}
function $33b62b23f021e4dd$var$instrumentHistory() {
    if (!(0, $djhN8.supportsHistory)()) return;
    const oldOnPopState = $33b62b23f021e4dd$var$WINDOW.onpopstate;
    $33b62b23f021e4dd$var$WINDOW.onpopstate = function(...args) {
        const to = $33b62b23f021e4dd$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $33b62b23f021e4dd$var$lastHref;
        $33b62b23f021e4dd$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $cPqXP.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $33b62b23f021e4dd$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $33b62b23f021e4dd$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $cPqXP.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $iiQEB.fill)($33b62b23f021e4dd$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $iiQEB.fill)($33b62b23f021e4dd$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("djhN8", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $9b0ad9b738a8a796$export$67fc34576016d6ec);

var $hi3E4 = parcelRequire("hi3E4");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $9b0ad9b738a8a796$var$WINDOW = (0, $hi3E4.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $9b0ad9b738a8a796$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $9b0ad9b738a8a796$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $9b0ad9b738a8a796$var$WINDOW && !!$9b0ad9b738a8a796$var$WINDOW.history.pushState && !!$9b0ad9b738a8a796$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("cPqXP", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $956f29ead8520975$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $956f29ead8520975$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $956f29ead8520975$export$b18c893e424d3127);

var $fmZZ6 = parcelRequire("fmZZ6");

var $7I6pg = parcelRequire("7I6pg");

var $lnX7A = parcelRequire("lnX7A");
// We keep the handlers globally
const $956f29ead8520975$var$handlers = {};
const $956f29ead8520975$var$instrumented = {};
/** Add a handler function. */ function $956f29ead8520975$export$a4e09611e30da72e(type, handler) {
    $956f29ead8520975$var$handlers[type] = $956f29ead8520975$var$handlers[type] || [];
    $956f29ead8520975$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $956f29ead8520975$export$b17eab759a1cb5fe() {
    Object.keys($956f29ead8520975$var$handlers).forEach((key)=>{
        $956f29ead8520975$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $956f29ead8520975$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$956f29ead8520975$var$instrumented[type]) {
        instrumentFn();
        $956f29ead8520975$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $956f29ead8520975$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $956f29ead8520975$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fmZZ6.DEBUG_BUILD) && (0, $7I6pg.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $lnX7A.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("40AKY", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $2eb3aca1944ff384$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $2eb3aca1944ff384$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $2eb3aca1944ff384$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReportingObserver", () => $2eb3aca1944ff384$export$531055a6c684a70a);

var $fmZZ6 = parcelRequire("fmZZ6");

var $7I6pg = parcelRequire("7I6pg");

var $hi3E4 = parcelRequire("hi3E4");
// eslint-disable-next-line deprecation/deprecation
const $2eb3aca1944ff384$var$WINDOW = (0, $hi3E4.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $2eb3aca1944ff384$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $2eb3aca1944ff384$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $2eb3aca1944ff384$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $2eb3aca1944ff384$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $2eb3aca1944ff384$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $2eb3aca1944ff384$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $2eb3aca1944ff384$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$2eb3aca1944ff384$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($2eb3aca1944ff384$export$18cf36ed71d733e7($2eb3aca1944ff384$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $2eb3aca1944ff384$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $2eb3aca1944ff384$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fmZZ6.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $2eb3aca1944ff384$export$531055a6c684a70a() {
    return 'ReportingObserver' in $2eb3aca1944ff384$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $2eb3aca1944ff384$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$2eb3aca1944ff384$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("iQyrW", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $db87ce4bcab390c5$export$1df9218a526d318d);

var $b6cMu = parcelRequire("b6cMu");
var $ciWI5 = parcelRequire("ciWI5");

var $1sNzt = parcelRequire("1sNzt");
var $5Na3j = parcelRequire("5Na3j");
var $f3FpS = parcelRequire("f3FpS");
var $7I6pg = parcelRequire("7I6pg");

var $3gMoL = parcelRequire("3gMoL");

var $etX8V = parcelRequire("etX8V");

var $2TIK5 = parcelRequire("2TIK5");

var $ej73F = parcelRequire("ej73F");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $db87ce4bcab390c5$export$1df9218a526d318d extends (0, $ciWI5.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $2TIK5.WINDOW).SENTRY_SDK_SOURCE || (0, $f3FpS.getSDKSource)();
        (0, $b6cMu.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $2TIK5.WINDOW).document) (0, $2TIK5.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $2TIK5.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $etX8V.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $etX8V.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $ej73F.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $1sNzt.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $5Na3j.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("b6cMu", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $814a2b4c9d7ae037$export$b9f95b027256052c);

var $gLE2H = parcelRequire("gLE2H");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $814a2b4c9d7ae037$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $gLE2H.SDK_VERSION)
            })),
        version: (0, $gLE2H.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("ciWI5", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $8f54b51647a645eb$export$4f22f74eddb7716a);
$parcel$export(module.exports, "addEventProcessor", () => $8f54b51647a645eb$export$9aac0b9f77928fbf);

var $eoF3x = parcelRequire("eoF3x");
var $h7F1u = parcelRequire("h7F1u");
var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");
var $5Na3j = parcelRequire("5Na3j");
var $2VQuW = parcelRequire("2VQuW");
var $fqZAk = parcelRequire("fqZAk");

var $5hILL = parcelRequire("5hILL");

var $aCaWa = parcelRequire("aCaWa");

var $l04vj = parcelRequire("l04vj");

var $dmS7i = parcelRequire("dmS7i");

var $84Maa = parcelRequire("84Maa");

var $dFnv4 = parcelRequire("dFnv4");

var $1xs5F = parcelRequire("1xs5F");

var $8Ly0x = parcelRequire("8Ly0x");

var $aw8s7 = parcelRequire("aw8s7");

var $1jkNj = parcelRequire("1jkNj");
const $8f54b51647a645eb$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $8f54b51647a645eb$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $5Na3j.makeDsn)(options.dsn);
        else (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $5hILL.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $h7F1u.checkOrSetAlreadyCaught)(exception)) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log($8f54b51647a645eb$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $9r1pX.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $9r1pX.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $h7F1u.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log($8f54b51647a645eb$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $8Ly0x.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $2VQuW.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $dFnv4.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $dFnv4.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $l04vj.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $eoF3x.addItemToEnvelope)(env, (0, $eoF3x.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $l04vj.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $1xs5F.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $dFnv4.setupIntegrations)(this, integrations);
        (0, $dFnv4.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $8Ly0x.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $2VQuW.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $84Maa.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $1jkNj.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $aw8s7.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $aCaWa.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $7I6pg.logger).log(sentryError.message);
                else (0, $7I6pg.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $8f54b51647a645eb$var$isTransactionEvent(event);
        const isError = $8f54b51647a645eb$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $2VQuW.rejectedSyncPromise)(new (0, $fqZAk.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $fqZAk.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $8f54b51647a645eb$var$processBeforeSend(options, prepared, hint);
            return $8f54b51647a645eb$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $fqZAk.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $fqZAk.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $fqZAk.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).error('Error while sending event:', reason);
        });
        else (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $8f54b51647a645eb$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9r1pX.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9r1pX.isPlainObject)(event) && event !== null) throw new (0, $fqZAk.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $fqZAk.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9r1pX.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $fqZAk.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $8f54b51647a645eb$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($8f54b51647a645eb$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($8f54b51647a645eb$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $8f54b51647a645eb$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $8f54b51647a645eb$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $8f54b51647a645eb$export$9aac0b9f77928fbf(callback) {
    const client = (0, $dmS7i.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("eoF3x", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $a7b327757f1f0ae3$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $a7b327757f1f0ae3$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $a7b327757f1f0ae3$export$c56c55acf0136fd3);
$parcel$export(module.exports, "envelopeContainsItemType", () => $a7b327757f1f0ae3$export$604a45d95a155e2b);
$parcel$export(module.exports, "serializeEnvelope", () => $a7b327757f1f0ae3$export$32f9b428425aac85);
$parcel$export(module.exports, "parseEnvelope", () => $a7b327757f1f0ae3$export$3338d0c7b6e17a2b);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $a7b327757f1f0ae3$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $a7b327757f1f0ae3$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $a7b327757f1f0ae3$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $a7b327757f1f0ae3$export$92b6093782fe661b);

var $5Na3j = parcelRequire("5Na3j");

var $bsqJK = parcelRequire("bsqJK");

var $iiQEB = parcelRequire("iiQEB");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a7b327757f1f0ae3$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a7b327757f1f0ae3$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $a7b327757f1f0ae3$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $a7b327757f1f0ae3$export$604a45d95a155e2b(envelope, types) {
    return $a7b327757f1f0ae3$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $a7b327757f1f0ae3$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $a7b327757f1f0ae3$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $a7b327757f1f0ae3$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $a7b327757f1f0ae3$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $bsqJK.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $a7b327757f1f0ae3$var$concatBuffers(parts);
}
function $a7b327757f1f0ae3$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $a7b327757f1f0ae3$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $a7b327757f1f0ae3$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $a7b327757f1f0ae3$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $iiQEB.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $a7b327757f1f0ae3$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $a7b327757f1f0ae3$export$b11169581eeaf237(type) {
    return $a7b327757f1f0ae3$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $a7b327757f1f0ae3$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $a7b327757f1f0ae3$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5Na3j.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $iiQEB.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("fqZAk", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $b3c90e309e21eb78$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $b3c90e309e21eb78$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("l04vj", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $f49d177ac4385140$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $f49d177ac4385140$export$c31057337a18010f);

var $eoF3x = parcelRequire("eoF3x");
var $5Na3j = parcelRequire("5Na3j");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $f49d177ac4385140$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $f49d177ac4385140$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $eoF3x.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5Na3j.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $eoF3x.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $f49d177ac4385140$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $eoF3x.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $f49d177ac4385140$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $eoF3x.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $eoF3x.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("1xs5F", function(module, exports) {
$parcel$export(module.exports, "createMetricEnvelope", () => $11eea9b2c3b7b25b$export$f23eb96e33154901);

var $eoF3x = parcelRequire("eoF3x");
var $5Na3j = parcelRequire("5Na3j");

var $hWySO = parcelRequire("hWySO");
/**
 * Create envelope from a metric aggregate.
 */ function $11eea9b2c3b7b25b$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $5Na3j.dsnToString)(dsn);
    const item = $11eea9b2c3b7b25b$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $eoF3x.createEnvelope)(headers, [
        item
    ]);
}
function $11eea9b2c3b7b25b$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $hWySO.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("hWySO", function(module, exports) {
$parcel$export(module.exports, "getBucketKey", () => $d102e97be5b5f80b$export$b8bd8c4dffa5aa2d);
$parcel$export(module.exports, "simpleHash", () => $d102e97be5b5f80b$export$b211ce59c0ea1cfb);
$parcel$export(module.exports, "serializeMetricBuckets", () => $d102e97be5b5f80b$export$66decd709db01dc8);
$parcel$export(module.exports, "sanitizeUnit", () => $d102e97be5b5f80b$export$2d8c9911396bbf5f);
$parcel$export(module.exports, "sanitizeMetricKey", () => $d102e97be5b5f80b$export$d3b3167f2ebbcecc);
$parcel$export(module.exports, "sanitizeTags", () => $d102e97be5b5f80b$export$ae49af12dbdf2477);

var $iiQEB = parcelRequire("iiQEB");
/**
 * Generate bucket key from metric properties.
 */ function $d102e97be5b5f80b$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $iiQEB.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $d102e97be5b5f80b$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $d102e97be5b5f80b$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $d102e97be5b5f80b$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $d102e97be5b5f80b$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $d102e97be5b5f80b$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $d102e97be5b5f80b$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $d102e97be5b5f80b$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $d102e97be5b5f80b$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $d102e97be5b5f80b$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $d102e97be5b5f80b$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $d102e97be5b5f80b$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $d102e97be5b5f80b$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $d102e97be5b5f80b$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("1sNzt", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $110edbc1d47065fc$export$f3b9ed77c03eeb00);

var $eoF3x = parcelRequire("eoF3x");

var $8t2EY = parcelRequire("8t2EY");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $110edbc1d47065fc$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $8t2EY.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $eoF3x.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("f3FpS", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $af67434239e3bd1e$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $af67434239e3bd1e$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $af67434239e3bd1e$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("3gMoL", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $261868a79b7a13aa$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $261868a79b7a13aa$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("etX8V", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $a8b1a6ac7ebf584c$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $a8b1a6ac7ebf584c$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $a8b1a6ac7ebf584c$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $a8b1a6ac7ebf584c$export$5425b53185d13d6c);

var $dmS7i = parcelRequire("dmS7i");

var $h7F1u = parcelRequire("h7F1u");
var $iiQEB = parcelRequire("iiQEB");
var $9r1pX = parcelRequire("9r1pX");
var $bsqJK = parcelRequire("bsqJK");
var $2VQuW = parcelRequire("2VQuW");
/**
 * This function creates an exception from a JavaScript Error
 */ function $a8b1a6ac7ebf584c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $a8b1a6ac7ebf584c$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $a8b1a6ac7ebf584c$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $a8b1a6ac7ebf584c$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $dmS7i.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9r1pX.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $a8b1a6ac7ebf584c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $bsqJK.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $a8b1a6ac7ebf584c$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $a8b1a6ac7ebf584c$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $a8b1a6ac7ebf584c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $a8b1a6ac7ebf584c$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $a8b1a6ac7ebf584c$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $a8b1a6ac7ebf584c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a8b1a6ac7ebf584c$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($a8b1a6ac7ebf584c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a8b1a6ac7ebf584c$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a8b1a6ac7ebf584c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a8b1a6ac7ebf584c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $h7F1u.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $2VQuW.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a8b1a6ac7ebf584c$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a8b1a6ac7ebf584c$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $2VQuW.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $a8b1a6ac7ebf584c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9r1pX.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $a8b1a6ac7ebf584c$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9r1pX.isDOMError)(exception) || (0, $9r1pX.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $a8b1a6ac7ebf584c$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $9r1pX.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a8b1a6ac7ebf584c$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $h7F1u.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9r1pX.isError)(exception)) // we have a real Error object, do nothing
    return $a8b1a6ac7ebf584c$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $9r1pX.isPlainObject)(exception) || (0, $9r1pX.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $a8b1a6ac7ebf584c$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $h7F1u.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a8b1a6ac7ebf584c$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $h7F1u.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $h7F1u.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $a8b1a6ac7ebf584c$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a8b1a6ac7ebf584c$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $9r1pX.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a8b1a6ac7ebf584c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $iiQEB.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9r1pX.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9r1pX.isEvent)(exception)) {
        const className = $a8b1a6ac7ebf584c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a8b1a6ac7ebf584c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("2TIK5", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $21c36cb8ae10bf74$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $21c36cb8ae10bf74$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $21c36cb8ae10bf74$export$4997ffc0176396a6);


var $dmS7i = parcelRequire("dmS7i");

var $h7F1u = parcelRequire("h7F1u");
var $iiQEB = parcelRequire("iiQEB");
var $hi3E4 = parcelRequire("hi3E4");
const $21c36cb8ae10bf74$export$56d8a8a25bd48b81 = (0, $hi3E4.GLOBAL_OBJ);
let $21c36cb8ae10bf74$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $21c36cb8ae10bf74$export$b79738ab10c590b2() {
    return $21c36cb8ae10bf74$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $21c36cb8ae10bf74$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $21c36cb8ae10bf74$var$ignoreOnError++;
    setTimeout(()=>{
        $21c36cb8ae10bf74$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $21c36cb8ae10bf74$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $iiQEB.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$21c36cb8ae10bf74$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $21c36cb8ae10bf74$export$1265a142ff5ba165();
            (0, $dmS7i.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $h7F1u.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $h7F1u.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $dmS7i.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $iiQEB.markFunctionWrapped)(sentryWrapped, fn);
    (0, $iiQEB.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("ej73F", function(module, exports) {
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $a6a8509db3c72242$export$24a4dfcb686ee5bf);

var $eoF3x = parcelRequire("eoF3x");
var $5Na3j = parcelRequire("5Na3j");
/**
 * Creates an envelope from a user feedback.
 */ function $a6a8509db3c72242$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $5Na3j.dsnToString)(dsn)
        }
    };
    const item = $a6a8509db3c72242$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $eoF3x.createEnvelope)(headers, [
        item
    ]);
}
function $a6a8509db3c72242$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("lfdSs", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $f775c36b5ddf5178$export$c079d904b326663a);
$parcel$export(module.exports, "Breadcrumbs", () => $f775c36b5ddf5178$export$2dc68d50d56fbbd);

var $dmS7i = parcelRequire("dmS7i");
var $dFnv4 = parcelRequire("dFnv4");

var $hgMmk = parcelRequire("hgMmk");
var $e6ZUP = parcelRequire("e6ZUP");
var $dPv3P = parcelRequire("dPv3P");
var $4rg5W = parcelRequire("4rg5W");
var $3evL1 = parcelRequire("3evL1");
var $cx9zm = parcelRequire("cx9zm");
var $h7F1u = parcelRequire("h7F1u");
var $7I6pg = parcelRequire("7I6pg");
var $rcz3w = parcelRequire("rcz3w");
var $4TtIy = parcelRequire("4TtIy");
var $953Ix = parcelRequire("953Ix");

var $3gMoL = parcelRequire("3gMoL");

var $2TIK5 = parcelRequire("2TIK5");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $f775c36b5ddf5178$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $f775c36b5ddf5178$var$INTEGRATION_NAME = 'Breadcrumbs';
const $f775c36b5ddf5178$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $f775c36b5ddf5178$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $e6ZUP.addConsoleInstrumentationHandler)($f775c36b5ddf5178$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $hgMmk.addClickKeypressInstrumentationHandler)($f775c36b5ddf5178$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $3evL1.addXhrInstrumentationHandler)($f775c36b5ddf5178$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $dPv3P.addFetchInstrumentationHandler)($f775c36b5ddf5178$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $4rg5W.addHistoryInstrumentationHandler)($f775c36b5ddf5178$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $f775c36b5ddf5178$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $f775c36b5ddf5178$export$c079d904b326663a = (0, $dFnv4.defineIntegration)($f775c36b5ddf5178$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f775c36b5ddf5178$export$2dc68d50d56fbbd = (0, $dFnv4.convertIntegrationFnToClass)($f775c36b5ddf5178$var$INTEGRATION_NAME, $f775c36b5ddf5178$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $f775c36b5ddf5178$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $dmS7i.getClient)() !== client) return;
        (0, $dmS7i.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $h7F1u.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $f775c36b5ddf5178$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $dmS7i.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $f775c36b5ddf5178$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$f775c36b5ddf5178$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$f775c36b5ddf5178$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $f775c36b5ddf5178$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $f775c36b5ddf5178$var$_isEvent(event) ? event.target : event;
            target = (0, $cx9zm.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cx9zm.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $dmS7i.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $f775c36b5ddf5178$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $dmS7i.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $953Ix.severityLevelFromString)(handlerData.level),
            message: (0, $4TtIy.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $4TtIy.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $dmS7i.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $f775c36b5ddf5178$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $dmS7i.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $3evL1.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $dmS7i.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $f775c36b5ddf5178$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $dmS7i.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $dmS7i.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $dmS7i.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $f775c36b5ddf5178$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $dmS7i.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $rcz3w.parseUrl)((0, $2TIK5.WINDOW).location.href);
        let parsedFrom = from ? (0, $rcz3w.parseUrl)(from) : undefined;
        const parsedTo = (0, $rcz3w.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $dmS7i.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $f775c36b5ddf5178$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("hgMmk", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $c9297165a50d601e$export$5aeffd3db2cf9df7);

var $h7F1u = parcelRequire("h7F1u");

var $iiQEB = parcelRequire("iiQEB");

var $hi3E4 = parcelRequire("hi3E4");

var $cPqXP = parcelRequire("cPqXP");
const $c9297165a50d601e$var$WINDOW = (0, $hi3E4.GLOBAL_OBJ);
const $c9297165a50d601e$var$DEBOUNCE_DURATION = 1000;
let $c9297165a50d601e$var$debounceTimerID;
let $c9297165a50d601e$var$lastCapturedEventType;
let $c9297165a50d601e$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c9297165a50d601e$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $c9297165a50d601e$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c9297165a50d601e$export$3014bbf0af0e1d4a() {
    if (!$c9297165a50d601e$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $cPqXP.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $c9297165a50d601e$var$makeDOMEventHandler(triggerDOMHandler, true);
    $c9297165a50d601e$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $c9297165a50d601e$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $c9297165a50d601e$var$WINDOW[target] && $c9297165a50d601e$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $iiQEB.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c9297165a50d601e$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $iiQEB.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c9297165a50d601e$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c9297165a50d601e$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c9297165a50d601e$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c9297165a50d601e$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c9297165a50d601e$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c9297165a50d601e$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c9297165a50d601e$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $iiQEB.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $iiQEB.addNonEnumerableProperty)(target, '_sentryId', (0, $h7F1u.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c9297165a50d601e$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c9297165a50d601e$var$lastCapturedEventType = event.type;
            $c9297165a50d601e$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c9297165a50d601e$var$debounceTimerID);
        $c9297165a50d601e$var$debounceTimerID = $c9297165a50d601e$var$WINDOW.setTimeout(()=>{
            $c9297165a50d601e$var$lastCapturedEventTargetId = undefined;
            $c9297165a50d601e$var$lastCapturedEventType = undefined;
        }, $c9297165a50d601e$var$DEBOUNCE_DURATION);
    };
}
function $c9297165a50d601e$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("e6ZUP", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $a461a7594e050628$export$1d6e0d073f9e6723);

var $7I6pg = parcelRequire("7I6pg");

var $iiQEB = parcelRequire("iiQEB");

var $hi3E4 = parcelRequire("hi3E4");

var $cPqXP = parcelRequire("cPqXP");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a461a7594e050628$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $a461a7594e050628$var$instrumentConsole);
}
function $a461a7594e050628$var$instrumentConsole() {
    if (!('console' in (0, $hi3E4.GLOBAL_OBJ))) return;
    (0, $7I6pg.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $hi3E4.GLOBAL_OBJ).console)) return;
        (0, $iiQEB.fill)((0, $hi3E4.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $7I6pg.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $cPqXP.triggerHandlers)('console', handlerData);
                const log = (0, $7I6pg.originalConsoleMethods)[level];
                log && log.apply((0, $hi3E4.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("dPv3P", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $a11821ca90f6ff1f$export$f75d3c772c923df0);

var $iiQEB = parcelRequire("iiQEB");

var $40AKY = parcelRequire("40AKY");

var $hi3E4 = parcelRequire("hi3E4");

var $cPqXP = parcelRequire("cPqXP");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a11821ca90f6ff1f$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $a11821ca90f6ff1f$var$instrumentFetch);
}
function $a11821ca90f6ff1f$var$instrumentFetch() {
    if (!(0, $40AKY.supportsNativeFetch)()) return;
    (0, $iiQEB.fill)((0, $hi3E4.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $a11821ca90f6ff1f$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $cPqXP.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $hi3E4.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $cPqXP.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $cPqXP.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $a11821ca90f6ff1f$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $a11821ca90f6ff1f$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($a11821ca90f6ff1f$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $a11821ca90f6ff1f$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $a11821ca90f6ff1f$var$getUrlFromResource(url),
            method: $a11821ca90f6ff1f$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $a11821ca90f6ff1f$var$getUrlFromResource(arg),
        method: $a11821ca90f6ff1f$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

});

parcelRegister("3evL1", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $25ab50445df2cdfd$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $25ab50445df2cdfd$export$26ace48dd54c9aea);

var $9r1pX = parcelRequire("9r1pX");

var $iiQEB = parcelRequire("iiQEB");

var $hi3E4 = parcelRequire("hi3E4");

var $cPqXP = parcelRequire("cPqXP");
const $25ab50445df2cdfd$var$WINDOW = (0, $hi3E4.GLOBAL_OBJ);
const $25ab50445df2cdfd$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $25ab50445df2cdfd$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $25ab50445df2cdfd$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $25ab50445df2cdfd$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$25ab50445df2cdfd$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $iiQEB.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9r1pX.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $25ab50445df2cdfd$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$25ab50445df2cdfd$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$25ab50445df2cdfd$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $cPqXP.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $iiQEB.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $iiQEB.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$25ab50445df2cdfd$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9r1pX.isString)(header) && (0, $9r1pX.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $iiQEB.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$25ab50445df2cdfd$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $cPqXP.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $25ab50445df2cdfd$var$parseUrl(url) {
    if ((0, $9r1pX.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("rcz3w", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $051c44c33a96fdae$export$7a5253c0f62e0150);
$parcel$export(module.exports, "stripUrlQueryAndFragment", () => $051c44c33a96fdae$export$ce084c78234bd35);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $051c44c33a96fdae$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $051c44c33a96fdae$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $051c44c33a96fdae$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $051c44c33a96fdae$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("953Ix", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $69c776e380f7ae08$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $69c776e380f7ae08$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $69c776e380f7ae08$export$e01cef29b4327697(level) {
    return $69c776e380f7ae08$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $69c776e380f7ae08$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $69c776e380f7ae08$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("9nLSz", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $6d4b66d217e37716$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $6d4b66d217e37716$export$688d98c249d31ad3);

var $dFnv4 = parcelRequire("dFnv4");

var $7I6pg = parcelRequire("7I6pg");

var $3gMoL = parcelRequire("3gMoL");
const $6d4b66d217e37716$var$INTEGRATION_NAME = 'Dedupe';
const $6d4b66d217e37716$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $6d4b66d217e37716$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($6d4b66d217e37716$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $6d4b66d217e37716$export$6d39aa44cd0c7567 = (0, $dFnv4.defineIntegration)($6d4b66d217e37716$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6d4b66d217e37716$export$688d98c249d31ad3 = (0, $dFnv4.convertIntegrationFnToClass)($6d4b66d217e37716$var$INTEGRATION_NAME, $6d4b66d217e37716$export$6d39aa44cd0c7567);
function $6d4b66d217e37716$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($6d4b66d217e37716$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($6d4b66d217e37716$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $6d4b66d217e37716$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$6d4b66d217e37716$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6d4b66d217e37716$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6d4b66d217e37716$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $6d4b66d217e37716$var$_getExceptionFromEvent(previousEvent);
    const currentException = $6d4b66d217e37716$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$6d4b66d217e37716$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$6d4b66d217e37716$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $6d4b66d217e37716$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $6d4b66d217e37716$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $6d4b66d217e37716$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $6d4b66d217e37716$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $6d4b66d217e37716$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $6d4b66d217e37716$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("efJnc", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $a605a99474caef82$export$66acc70e8cf2b71a);
$parcel$export(module.exports, "GlobalHandlers", () => $a605a99474caef82$export$204155decbc90e5a);

var $dmS7i = parcelRequire("dmS7i");
var $dFnv4 = parcelRequire("dFnv4");

var $4CcuA = parcelRequire("4CcuA");
var $73l0k = parcelRequire("73l0k");
var $cx9zm = parcelRequire("cx9zm");
var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");

var $3gMoL = parcelRequire("3gMoL");

var $etX8V = parcelRequire("etX8V");

var $2TIK5 = parcelRequire("2TIK5");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $a605a99474caef82$var$INTEGRATION_NAME = 'GlobalHandlers';
const $a605a99474caef82$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $a605a99474caef82$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $a605a99474caef82$var$_installGlobalOnErrorHandler(client);
                $a605a99474caef82$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $a605a99474caef82$var$_installGlobalOnUnhandledRejectionHandler(client);
                $a605a99474caef82$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $a605a99474caef82$export$66acc70e8cf2b71a = (0, $dFnv4.defineIntegration)($a605a99474caef82$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a605a99474caef82$export$204155decbc90e5a = (0, $dFnv4.convertIntegrationFnToClass)($a605a99474caef82$var$INTEGRATION_NAME, $a605a99474caef82$export$66acc70e8cf2b71a);
function $a605a99474caef82$var$_installGlobalOnErrorHandler(client) {
    (0, $4CcuA.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a605a99474caef82$var$getOptions();
        if ((0, $dmS7i.getClient)() !== client || (0, $2TIK5.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $9r1pX.isString)(msg) ? $a605a99474caef82$var$_eventFromIncompleteOnError(msg, url, line, column) : $a605a99474caef82$var$_enhanceEventWithInitialFrame((0, $etX8V.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $dmS7i.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $a605a99474caef82$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $73l0k.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a605a99474caef82$var$getOptions();
        if ((0, $dmS7i.getClient)() !== client || (0, $2TIK5.shouldIgnoreOnError)()) return;
        const error = $a605a99474caef82$var$_getUnhandledRejectionError(e);
        const event = (0, $9r1pX.isPrimitive)(error) ? $a605a99474caef82$var$_eventFromRejectionWithPrimitive(error) : (0, $etX8V.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $dmS7i.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $a605a99474caef82$var$_getUnhandledRejectionError(error) {
    if ((0, $9r1pX.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $a605a99474caef82$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a605a99474caef82$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $9r1pX.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $a605a99474caef82$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a605a99474caef82$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $9r1pX.isString)(url) && url.length > 0 ? url : (0, $cx9zm.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $a605a99474caef82$var$globalHandlerLog(type) {
    (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Global Handler attached: ${type}`);
}
function $a605a99474caef82$var$getOptions() {
    const client = (0, $dmS7i.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("4CcuA", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $35c466bc428d978b$export$55b5c3ba2194f0c6);

var $hi3E4 = parcelRequire("hi3E4");

var $cPqXP = parcelRequire("cPqXP");
let $35c466bc428d978b$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $35c466bc428d978b$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $35c466bc428d978b$var$instrumentError);
}
function $35c466bc428d978b$var$instrumentError() {
    $35c466bc428d978b$var$_oldOnErrorHandler = (0, $hi3E4.GLOBAL_OBJ).onerror;
    (0, $hi3E4.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $cPqXP.triggerHandlers)('error', handlerData);
        if ($35c466bc428d978b$var$_oldOnErrorHandler && !$35c466bc428d978b$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $35c466bc428d978b$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $hi3E4.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("73l0k", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $52291b3e37579a29$export$8bf4fc6858821a4e);

var $hi3E4 = parcelRequire("hi3E4");

var $cPqXP = parcelRequire("cPqXP");
let $52291b3e37579a29$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $52291b3e37579a29$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $cPqXP.addHandler)(type, handler);
    (0, $cPqXP.maybeInstrument)(type, $52291b3e37579a29$var$instrumentUnhandledRejection);
}
function $52291b3e37579a29$var$instrumentUnhandledRejection() {
    $52291b3e37579a29$var$_oldOnUnhandledRejectionHandler = (0, $hi3E4.GLOBAL_OBJ).onunhandledrejection;
    (0, $hi3E4.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $cPqXP.triggerHandlers)('unhandledrejection', handlerData);
        if ($52291b3e37579a29$var$_oldOnUnhandledRejectionHandler && !$52291b3e37579a29$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $52291b3e37579a29$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $hi3E4.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("5lgCu", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $3e3bce459de660be$export$1378794447170364);
$parcel$export(module.exports, "HttpContext", () => $3e3bce459de660be$export$5d2ee9a544b09a94);

var $dFnv4 = parcelRequire("dFnv4");

var $2TIK5 = parcelRequire("2TIK5");
const $3e3bce459de660be$var$INTEGRATION_NAME = 'HttpContext';
const $3e3bce459de660be$var$_httpContextIntegration = ()=>{
    return {
        name: $3e3bce459de660be$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $2TIK5.WINDOW).navigator && !(0, $2TIK5.WINDOW).location && !(0, $2TIK5.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $2TIK5.WINDOW).location && (0, $2TIK5.WINDOW).location.href;
            const { referrer: referrer } = (0, $2TIK5.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $2TIK5.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $3e3bce459de660be$export$1378794447170364 = (0, $dFnv4.defineIntegration)($3e3bce459de660be$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3e3bce459de660be$export$5d2ee9a544b09a94 = (0, $dFnv4.convertIntegrationFnToClass)($3e3bce459de660be$var$INTEGRATION_NAME, $3e3bce459de660be$export$1378794447170364);

});

parcelRegister("2JxJk", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $1fd9f2d5449641ec$export$ebabb00eb7f3a395);
$parcel$export(module.exports, "LinkedErrors", () => $1fd9f2d5449641ec$export$8d1e60aaf616fb4f);

var $dFnv4 = parcelRequire("dFnv4");

var $bB9Vc = parcelRequire("bB9Vc");

var $etX8V = parcelRequire("etX8V");
const $1fd9f2d5449641ec$var$DEFAULT_KEY = 'cause';
const $1fd9f2d5449641ec$var$DEFAULT_LIMIT = 5;
const $1fd9f2d5449641ec$var$INTEGRATION_NAME = 'LinkedErrors';
const $1fd9f2d5449641ec$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $1fd9f2d5449641ec$var$DEFAULT_LIMIT;
    const key = options.key || $1fd9f2d5449641ec$var$DEFAULT_KEY;
    return {
        name: $1fd9f2d5449641ec$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $bB9Vc.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $etX8V.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $1fd9f2d5449641ec$export$ebabb00eb7f3a395 = (0, $dFnv4.defineIntegration)($1fd9f2d5449641ec$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1fd9f2d5449641ec$export$8d1e60aaf616fb4f = (0, $dFnv4.convertIntegrationFnToClass)($1fd9f2d5449641ec$var$INTEGRATION_NAME, $1fd9f2d5449641ec$export$ebabb00eb7f3a395);

});
parcelRegister("bB9Vc", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $871ad89b77234469$export$b91c38ed7d8ae9b2);

var $9r1pX = parcelRequire("9r1pX");

var $4TtIy = parcelRequire("4TtIy");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $871ad89b77234469$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9r1pX.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $871ad89b77234469$var$truncateAggregateExceptions($871ad89b77234469$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $871ad89b77234469$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9r1pX.isInstanceOf)(error[key], Error)) {
        $871ad89b77234469$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $871ad89b77234469$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $871ad89b77234469$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9r1pX.isInstanceOf)(childError, Error)) {
            $871ad89b77234469$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $871ad89b77234469$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $871ad89b77234469$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $871ad89b77234469$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $871ad89b77234469$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $871ad89b77234469$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $4TtIy.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("eqOkL", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $a81a89ab7a9e8b4f$export$59bfe9f1c76150e);
$parcel$export(module.exports, "TryCatch", () => $a81a89ab7a9e8b4f$export$f1a018517668e6d3);

var $dFnv4 = parcelRequire("dFnv4");

var $iiQEB = parcelRequire("iiQEB");
var $lnX7A = parcelRequire("lnX7A");

var $2TIK5 = parcelRequire("2TIK5");
const $a81a89ab7a9e8b4f$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $a81a89ab7a9e8b4f$var$INTEGRATION_NAME = 'TryCatch';
const $a81a89ab7a9e8b4f$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $a81a89ab7a9e8b4f$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $iiQEB.fill)((0, $2TIK5.WINDOW), 'setTimeout', $a81a89ab7a9e8b4f$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $iiQEB.fill)((0, $2TIK5.WINDOW), 'setInterval', $a81a89ab7a9e8b4f$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $iiQEB.fill)((0, $2TIK5.WINDOW), 'requestAnimationFrame', $a81a89ab7a9e8b4f$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $2TIK5.WINDOW)) (0, $iiQEB.fill)(XMLHttpRequest.prototype, 'send', $a81a89ab7a9e8b4f$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $a81a89ab7a9e8b4f$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($a81a89ab7a9e8b4f$var$_wrapEventTarget);
            }
        }
    };
};
const $a81a89ab7a9e8b4f$export$59bfe9f1c76150e = (0, $dFnv4.defineIntegration)($a81a89ab7a9e8b4f$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a81a89ab7a9e8b4f$export$f1a018517668e6d3 = (0, $dFnv4.convertIntegrationFnToClass)($a81a89ab7a9e8b4f$var$INTEGRATION_NAME, $a81a89ab7a9e8b4f$export$59bfe9f1c76150e);
function $a81a89ab7a9e8b4f$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $2TIK5.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $lnX7A.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a81a89ab7a9e8b4f$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $2TIK5.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $lnX7A.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $a81a89ab7a9e8b4f$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiQEB.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $lnX7A.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $iiQEB.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $lnX7A.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $2TIK5.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $a81a89ab7a9e8b4f$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $2TIK5.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $iiQEB.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $2TIK5.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $lnX7A.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $2TIK5.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $lnX7A.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $iiQEB.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("21oNa", function(module, exports) {
$parcel$export(module.exports, "chromeStackLineParser", () => $178ee7ecf26af97b$export$263a749fff749872);
$parcel$export(module.exports, "geckoStackLineParser", () => $178ee7ecf26af97b$export$cdba47a5dd2804d);
$parcel$export(module.exports, "winjsStackLineParser", () => $178ee7ecf26af97b$export$179460296da408e8);
$parcel$export(module.exports, "opera10StackLineParser", () => $178ee7ecf26af97b$export$f892b52c880ffc7a);
$parcel$export(module.exports, "opera11StackLineParser", () => $178ee7ecf26af97b$export$af11af13f09fb0dc);
$parcel$export(module.exports, "defaultStackLineParsers", () => $178ee7ecf26af97b$export$7197c0fe6554c079);
$parcel$export(module.exports, "defaultStackParser", () => $178ee7ecf26af97b$export$2b2b997d81bf3907);

var $lnX7A = parcelRequire("lnX7A");
// global reference to slice
const $178ee7ecf26af97b$var$UNKNOWN_FUNCTION = '?';
const $178ee7ecf26af97b$var$OPERA10_PRIORITY = 10;
const $178ee7ecf26af97b$var$OPERA11_PRIORITY = 20;
const $178ee7ecf26af97b$var$CHROME_PRIORITY = 30;
const $178ee7ecf26af97b$var$WINJS_PRIORITY = 40;
const $178ee7ecf26af97b$var$GECKO_PRIORITY = 50;
function $178ee7ecf26af97b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $178ee7ecf26af97b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $178ee7ecf26af97b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $178ee7ecf26af97b$var$chromeStackParserFn = (line)=>{
    const parts = $178ee7ecf26af97b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $178ee7ecf26af97b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $178ee7ecf26af97b$var$extractSafariExtensionDetails(parts[1] || $178ee7ecf26af97b$var$UNKNOWN_FUNCTION, parts[2]);
        return $178ee7ecf26af97b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $178ee7ecf26af97b$export$263a749fff749872 = [
    $178ee7ecf26af97b$var$CHROME_PRIORITY,
    $178ee7ecf26af97b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $178ee7ecf26af97b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $178ee7ecf26af97b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $178ee7ecf26af97b$var$gecko = (line)=>{
    const parts = $178ee7ecf26af97b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $178ee7ecf26af97b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $178ee7ecf26af97b$var$UNKNOWN_FUNCTION;
        [func, filename] = $178ee7ecf26af97b$var$extractSafariExtensionDetails(func, filename);
        return $178ee7ecf26af97b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $178ee7ecf26af97b$export$cdba47a5dd2804d = [
    $178ee7ecf26af97b$var$GECKO_PRIORITY,
    $178ee7ecf26af97b$var$gecko
];
const $178ee7ecf26af97b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $178ee7ecf26af97b$var$winjs = (line)=>{
    const parts = $178ee7ecf26af97b$var$winjsRegex.exec(line);
    return parts ? $178ee7ecf26af97b$var$createFrame(parts[2], parts[1] || $178ee7ecf26af97b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $178ee7ecf26af97b$export$179460296da408e8 = [
    $178ee7ecf26af97b$var$WINJS_PRIORITY,
    $178ee7ecf26af97b$var$winjs
];
const $178ee7ecf26af97b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $178ee7ecf26af97b$var$opera10 = (line)=>{
    const parts = $178ee7ecf26af97b$var$opera10Regex.exec(line);
    return parts ? $178ee7ecf26af97b$var$createFrame(parts[2], parts[3] || $178ee7ecf26af97b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $178ee7ecf26af97b$export$f892b52c880ffc7a = [
    $178ee7ecf26af97b$var$OPERA10_PRIORITY,
    $178ee7ecf26af97b$var$opera10
];
const $178ee7ecf26af97b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $178ee7ecf26af97b$var$opera11 = (line)=>{
    const parts = $178ee7ecf26af97b$var$opera11Regex.exec(line);
    return parts ? $178ee7ecf26af97b$var$createFrame(parts[5], parts[3] || parts[4] || $178ee7ecf26af97b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $178ee7ecf26af97b$export$af11af13f09fb0dc = [
    $178ee7ecf26af97b$var$OPERA11_PRIORITY,
    $178ee7ecf26af97b$var$opera11
];
const $178ee7ecf26af97b$export$7197c0fe6554c079 = [
    $178ee7ecf26af97b$export$263a749fff749872,
    $178ee7ecf26af97b$export$cdba47a5dd2804d,
    $178ee7ecf26af97b$export$179460296da408e8
];
const $178ee7ecf26af97b$export$2b2b997d81bf3907 = (0, $lnX7A.createStackParser)(...$178ee7ecf26af97b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $178ee7ecf26af97b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $178ee7ecf26af97b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("5UoQk", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $44d5740a60778901$export$b2311068c46d7cc8);

var $6fbbQ = parcelRequire("6fbbQ");

var $2VQuW = parcelRequire("2VQuW");

var $6Fcjn = parcelRequire("6Fcjn");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $44d5740a60778901$export$b2311068c46d7cc8(options, nativeFetch = (0, $6Fcjn.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $6Fcjn.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $2VQuW.rejectedSyncPromise)(e);
        }
    }
    return (0, $6fbbQ.createTransport)(options, makeRequest);
}

});
parcelRegister("6fbbQ", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $48bcd2e885afc56b$export$d09f50d9ab7f7b69);

var $eoF3x = parcelRequire("eoF3x");
var $lDqxe = parcelRequire("lDqxe");
var $7I6pg = parcelRequire("7I6pg");
var $lWTr7 = parcelRequire("lWTr7");
var $2VQuW = parcelRequire("2VQuW");
var $fqZAk = parcelRequire("fqZAk");

var $aCaWa = parcelRequire("aCaWa");
const $48bcd2e885afc56b$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $48bcd2e885afc56b$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $lWTr7.makePromiseBuffer)(options.bufferSize || $48bcd2e885afc56b$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $eoF3x.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $eoF3x.envelopeItemTypeToDataCategory)(type);
            if ((0, $lDqxe.isRateLimited)(rateLimits, dataCategory)) {
                const event = $48bcd2e885afc56b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $2VQuW.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $eoF3x.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $eoF3x.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $48bcd2e885afc56b$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $eoF3x.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $eoF3x.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $lDqxe.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $fqZAk.SentryError)) {
                (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $2VQuW.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $48bcd2e885afc56b$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("lDqxe", function(module, exports) {
$parcel$export(module.exports, "parseRetryAfterHeader", () => $fc01d2cb7cdd703b$export$615352e17ed7741);
$parcel$export(module.exports, "isRateLimited", () => $fc01d2cb7cdd703b$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $fc01d2cb7cdd703b$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $fc01d2cb7cdd703b$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $fc01d2cb7cdd703b$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $fc01d2cb7cdd703b$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $fc01d2cb7cdd703b$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $fc01d2cb7cdd703b$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $fc01d2cb7cdd703b$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $fc01d2cb7cdd703b$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $fc01d2cb7cdd703b$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("lWTr7", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $ffaa044abaa1478e$export$85a4f67f852183e6);

var $fqZAk = parcelRequire("fqZAk");

var $2VQuW = parcelRequire("2VQuW");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $ffaa044abaa1478e$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $2VQuW.rejectedSyncPromise)(new (0, $fqZAk.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $2VQuW.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $2VQuW.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("6Fcjn", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $4da01f3c4b293d65$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $4da01f3c4b293d65$export$d499686d2dd738c6);

var $40AKY = parcelRequire("40AKY");
var $7I6pg = parcelRequire("7I6pg");

var $3gMoL = parcelRequire("3gMoL");

var $2TIK5 = parcelRequire("2TIK5");
let $4da01f3c4b293d65$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $4da01f3c4b293d65$export$8be2119ce08e3379() {
    if ($4da01f3c4b293d65$var$cachedFetchImpl) return $4da01f3c4b293d65$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $40AKY.isNativeFetch)((0, $2TIK5.WINDOW).fetch)) return $4da01f3c4b293d65$var$cachedFetchImpl = (0, $2TIK5.WINDOW).fetch.bind((0, $2TIK5.WINDOW));
    const document = (0, $2TIK5.WINDOW).document;
    let fetchImpl = (0, $2TIK5.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $4da01f3c4b293d65$var$cachedFetchImpl = fetchImpl.bind((0, $2TIK5.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $4da01f3c4b293d65$export$d499686d2dd738c6() {
    $4da01f3c4b293d65$var$cachedFetchImpl = undefined;
}

});


parcelRegister("6Em6n", function(module, exports) {
$parcel$export(module.exports, "makeXHRTransport", () => $4d779f731e7f0204$export$5e1441cee30d5a39);

var $6fbbQ = parcelRequire("6fbbQ");

var $2VQuW = parcelRequire("2VQuW");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $4d779f731e7f0204$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $4d779f731e7f0204$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $2VQuW.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $4d779f731e7f0204$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $6fbbQ.createTransport)(options, makeRequest);
}

});


parcelRegister("c2AmC", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $8c41e10ad57ddbc0$export$99d02219d259eb94);
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("2sSit")).FunctionToString);
$parcel$export(module.exports, "Hub", () => (parcelRequire("84Maa")).Hub);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("85Shi")).InboundFilters);
$parcel$export(module.exports, "ModuleMetadata", () => (parcelRequire("4qRd6")).ModuleMetadata);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("gLE2H")).SDK_VERSION);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => (parcelRequire("2iz3c")).SEMANTIC_ATTRIBUTE_SENTRY_OP);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => (parcelRequire("2iz3c")).SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => (parcelRequire("2iz3c")).SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => (parcelRequire("2iz3c")).SEMANTIC_ATTRIBUTE_SENTRY_SOURCE);
$parcel$export(module.exports, "Scope", () => (parcelRequire("dmR7m")).Scope);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("dmS7i")).addBreadcrumb);
$parcel$export(module.exports, "addEventProcessor", () => (parcelRequire("ciWI5")).addEventProcessor);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("d86W5")).addGlobalEventProcessor);
$parcel$export(module.exports, "addIntegration", () => (parcelRequire("dFnv4")).addIntegration);
$parcel$export(module.exports, "addTracingExtensions", () => (parcelRequire("iCMnl")).addTracingExtensions);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("dmS7i")).captureEvent);
$parcel$export(module.exports, "captureException", () => (parcelRequire("dmS7i")).captureException);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("dmS7i")).captureMessage);
$parcel$export(module.exports, "captureSession", () => (parcelRequire("dmS7i")).captureSession);
$parcel$export(module.exports, "close", () => (parcelRequire("dmS7i")).close);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("dmS7i")).configureScope);
$parcel$export(module.exports, "continueTrace", () => (parcelRequire("9lKdF")).continueTrace);
$parcel$export(module.exports, "createTransport", () => (parcelRequire("6fbbQ")).createTransport);
$parcel$export(module.exports, "endSession", () => (parcelRequire("dmS7i")).endSession);
$parcel$export(module.exports, "extractTraceparentData", () => (parcelRequire("dWocc")).extractTraceparentData);
$parcel$export(module.exports, "flush", () => (parcelRequire("dmS7i")).flush);
$parcel$export(module.exports, "functionToStringIntegration", () => (parcelRequire("2sSit")).functionToStringIntegration);
$parcel$export(module.exports, "getActiveSpan", () => (parcelRequire("9lKdF")).getActiveSpan);
$parcel$export(module.exports, "getActiveTransaction", () => (parcelRequire("dWocc")).getActiveTransaction);
$parcel$export(module.exports, "getClient", () => (parcelRequire("dmS7i")).getClient);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("84Maa")).getCurrentHub);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("dmS7i")).getCurrentScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("84Maa")).getHubFromCarrier);
$parcel$export(module.exports, "getSpanStatusFromHttpCode", () => (parcelRequire("c40Kr")).getSpanStatusFromHttpCode);
$parcel$export(module.exports, "inboundFiltersIntegration", () => (parcelRequire("85Shi")).inboundFiltersIntegration);
$parcel$export(module.exports, "isInitialized", () => (parcelRequire("dmS7i")).isInitialized);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("dmS7i")).lastEventId);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("84Maa")).makeMain);
$parcel$export(module.exports, "makeMultiplexedTransport", () => (parcelRequire("pc4Pc")).makeMultiplexedTransport);
$parcel$export(module.exports, "metrics", () => (parcelRequire("jxWdC")).metrics);
$parcel$export(module.exports, "moduleMetadataIntegration", () => (parcelRequire("4qRd6")).moduleMetadataIntegration);
$parcel$export(module.exports, "parameterize", () => (parcelRequire("kilk2")).parameterize);
$parcel$export(module.exports, "setContext", () => (parcelRequire("dmS7i")).setContext);
$parcel$export(module.exports, "setCurrentClient", () => (parcelRequire("kOHMF")).setCurrentClient);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("dmS7i")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("dmS7i")).setExtras);
$parcel$export(module.exports, "setHttpStatus", () => (parcelRequire("c40Kr")).setHttpStatus);
$parcel$export(module.exports, "setMeasurement", () => (parcelRequire("chwAd")).setMeasurement);
$parcel$export(module.exports, "setTag", () => (parcelRequire("dmS7i")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("dmS7i")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("dmS7i")).setUser);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => (parcelRequire("c40Kr")).spanStatusfromHttpCode);
$parcel$export(module.exports, "startInactiveSpan", () => (parcelRequire("9lKdF")).startInactiveSpan);
$parcel$export(module.exports, "startSession", () => (parcelRequire("dmS7i")).startSession);
$parcel$export(module.exports, "startSpan", () => (parcelRequire("9lKdF")).startSpan);
$parcel$export(module.exports, "startSpanManual", () => (parcelRequire("9lKdF")).startSpanManual);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("dmS7i")).startTransaction);
$parcel$export(module.exports, "trace", () => (parcelRequire("9lKdF")).trace);
$parcel$export(module.exports, "withActiveSpan", () => (parcelRequire("dmS7i")).withActiveSpan);
$parcel$export(module.exports, "withIsolationScope", () => (parcelRequire("dmS7i")).withIsolationScope);
$parcel$export(module.exports, "withScope", () => (parcelRequire("dmS7i")).withScope);
$parcel$export(module.exports, "WINDOW", () => (parcelRequire("2TIK5")).WINDOW);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("iQyrW")).BrowserClient);
$parcel$export(module.exports, "makeFetchTransport", () => (parcelRequire("5UoQk")).makeFetchTransport);
$parcel$export(module.exports, "makeXHRTransport", () => (parcelRequire("6Em6n")).makeXHRTransport);
$parcel$export(module.exports, "chromeStackLineParser", () => (parcelRequire("21oNa")).chromeStackLineParser);
$parcel$export(module.exports, "defaultStackLineParsers", () => (parcelRequire("21oNa")).defaultStackLineParsers);
$parcel$export(module.exports, "defaultStackParser", () => (parcelRequire("21oNa")).defaultStackParser);
$parcel$export(module.exports, "geckoStackLineParser", () => (parcelRequire("21oNa")).geckoStackLineParser);
$parcel$export(module.exports, "opera10StackLineParser", () => (parcelRequire("21oNa")).opera10StackLineParser);
$parcel$export(module.exports, "opera11StackLineParser", () => (parcelRequire("21oNa")).opera11StackLineParser);
$parcel$export(module.exports, "winjsStackLineParser", () => (parcelRequire("21oNa")).winjsStackLineParser);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("etX8V")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("etX8V")).eventFromMessage);
$parcel$export(module.exports, "exceptionFromError", () => (parcelRequire("etX8V")).exceptionFromError);
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => (parcelRequire("ej73F")).createUserFeedbackEnvelope);
$parcel$export(module.exports, "captureUserFeedback", () => (parcelRequire("eGgLE")).captureUserFeedback);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eGgLE")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eGgLE")).forceLoad);
$parcel$export(module.exports, "getDefaultIntegrations", () => (parcelRequire("eGgLE")).getDefaultIntegrations);
$parcel$export(module.exports, "init", () => (parcelRequire("eGgLE")).init);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eGgLE")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eGgLE")).showReportDialog);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eGgLE")).wrap);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("lfdSs")).Breadcrumbs);
$parcel$export(module.exports, "breadcrumbsIntegration", () => (parcelRequire("lfdSs")).breadcrumbsIntegration);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("9nLSz")).Dedupe);
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("efJnc")).GlobalHandlers);
$parcel$export(module.exports, "globalHandlersIntegration", () => (parcelRequire("efJnc")).globalHandlersIntegration);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("5lgCu")).HttpContext);
$parcel$export(module.exports, "httpContextIntegration", () => (parcelRequire("5lgCu")).httpContextIntegration);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("2JxJk")).LinkedErrors);
$parcel$export(module.exports, "linkedErrorsIntegration", () => (parcelRequire("2JxJk")).linkedErrorsIntegration);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("eqOkL")).TryCatch);
$parcel$export(module.exports, "browserApiErrorsIntegration", () => (parcelRequire("eqOkL")).browserApiErrorsIntegration);
$parcel$export(module.exports, "Replay", () => (parcelRequire("5MpFc")).InternalReplay);
$parcel$export(module.exports, "getReplay", () => (parcelRequire("5MpFc")).internalGetReplay);
$parcel$export(module.exports, "replayIntegration", () => (parcelRequire("5MpFc")).internalReplayIntegration);
$parcel$export(module.exports, "ReplayCanvas", () => (parcelRequire("5IZWm")).ReplayCanvas);
$parcel$export(module.exports, "replayCanvasIntegration", () => (parcelRequire("5IZWm")).replayCanvasIntegration);
$parcel$export(module.exports, "Feedback", () => (parcelRequire("5MpFc")).Feedback);
$parcel$export(module.exports, "feedbackIntegration", () => (parcelRequire("5MpFc")).feedbackIntegration);
$parcel$export(module.exports, "sendFeedback", () => (parcelRequire("5MpFc")).sendFeedback);
$parcel$export(module.exports, "captureConsoleIntegration", () => (parcelRequire("3zcyB")).captureConsoleIntegration);
$parcel$export(module.exports, "contextLinesIntegration", () => (parcelRequire("2J7EI")).contextLinesIntegration);
$parcel$export(module.exports, "debugIntegration", () => (parcelRequire("6JGJC")).debugIntegration);
$parcel$export(module.exports, "dedupeIntegration", () => (parcelRequire("8Ropc")).dedupeIntegration);
$parcel$export(module.exports, "extraErrorDataIntegration", () => (parcelRequire("rjBqd")).extraErrorDataIntegration);
$parcel$export(module.exports, "httpClientIntegration", () => (parcelRequire("7uXTZ")).httpClientIntegration);
$parcel$export(module.exports, "reportingObserverIntegration", () => (parcelRequire("3CqqH")).reportingObserverIntegration);
$parcel$export(module.exports, "rewriteFramesIntegration", () => (parcelRequire("2J6kR")).rewriteFramesIntegration);
$parcel$export(module.exports, "sessionTimingIntegration", () => (parcelRequire("8C1r5")).sessionTimingIntegration);
$parcel$export(module.exports, "BrowserTracing", () => (parcelRequire("b4EUg")).BrowserTracing);
$parcel$export(module.exports, "browserTracingIntegration", () => (parcelRequire("h3C2f")).browserTracingIntegration);
$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => (parcelRequire("je0dc")).defaultRequestInstrumentationOptions);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => (parcelRequire("je0dc")).instrumentOutgoingRequests);
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", () => (parcelRequire("h3C2f")).startBrowserTracingNavigationSpan);
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", () => (parcelRequire("h3C2f")).startBrowserTracingPageLoadSpan);
$parcel$export(module.exports, "makeBrowserOfflineTransport", () => (parcelRequire("crjkJ")).makeBrowserOfflineTransport);
$parcel$export(module.exports, "onProfilingStartRouteTransaction", () => (parcelRequire("4ylGE")).onProfilingStartRouteTransaction);
$parcel$export(module.exports, "BrowserProfilingIntegration", () => (parcelRequire("2I8JG")).BrowserProfilingIntegration);
$parcel$export(module.exports, "browserProfilingIntegration", () => (parcelRequire("2I8JG")).browserProfilingIntegration);

var $dmS7i = parcelRequire("dmS7i");
var $ciWI5 = parcelRequire("ciWI5");
var $d86W5 = parcelRequire("d86W5");
var $dFnv4 = parcelRequire("dFnv4");
var $iCMnl = parcelRequire("iCMnl");
var $9lKdF = parcelRequire("9lKdF");
var $6fbbQ = parcelRequire("6fbbQ");
var $dWocc = parcelRequire("dWocc");
var $2sSit = parcelRequire("2sSit");
var $84Maa = parcelRequire("84Maa");
var $c40Kr = parcelRequire("c40Kr");
var $85Shi = parcelRequire("85Shi");
var $3ktBp = parcelRequire("3ktBp");
var $pc4Pc = parcelRequire("pc4Pc");
var $jxWdC = parcelRequire("jxWdC");
var $4qRd6 = parcelRequire("4qRd6");
var $kilk2 = parcelRequire("kilk2");
var $dmR7m = parcelRequire("dmR7m");
var $gLE2H = parcelRequire("gLE2H");
var $2iz3c = parcelRequire("2iz3c");
var $kOHMF = parcelRequire("kOHMF");
var $chwAd = parcelRequire("chwAd");

var $2TIK5 = parcelRequire("2TIK5");

var $iQyrW = parcelRequire("iQyrW");

var $5UoQk = parcelRequire("5UoQk");

var $6Em6n = parcelRequire("6Em6n");

var $21oNa = parcelRequire("21oNa");

var $etX8V = parcelRequire("etX8V");

var $ej73F = parcelRequire("ej73F");

var $eGgLE = parcelRequire("eGgLE");

var $lfdSs = parcelRequire("lfdSs");

var $9nLSz = parcelRequire("9nLSz");

var $efJnc = parcelRequire("efJnc");

var $5lgCu = parcelRequire("5lgCu");

var $2JxJk = parcelRequire("2JxJk");

var $eqOkL = parcelRequire("eqOkL");

var $6cnML = parcelRequire("6cnML");

var $5MpFc = parcelRequire("5MpFc");

var $5IZWm = parcelRequire("5IZWm");

var $5MpFc = parcelRequire("5MpFc");

var $3zcyB = parcelRequire("3zcyB");
var $2J7EI = parcelRequire("2J7EI");
var $6JGJC = parcelRequire("6JGJC");
var $8Ropc = parcelRequire("8Ropc");
var $rjBqd = parcelRequire("rjBqd");
var $7uXTZ = parcelRequire("7uXTZ");
var $3CqqH = parcelRequire("3CqqH");
var $2J6kR = parcelRequire("2J6kR");
var $8C1r5 = parcelRequire("8C1r5");

var $b4EUg = parcelRequire("b4EUg");
var $h3C2f = parcelRequire("h3C2f");
var $je0dc = parcelRequire("je0dc");

var $crjkJ = parcelRequire("crjkJ");

var $4ylGE = parcelRequire("4ylGE");

var $2I8JG = parcelRequire("2I8JG");
let $8c41e10ad57ddbc0$var$windowIntegrations = {};
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $8c41e10ad57ddbc0$export$99d02219d259eb94 = {
    ...$8c41e10ad57ddbc0$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $3ktBp.Integrations),
    ...$6cnML
};

});
parcelRegister("iCMnl", function(module, exports) {
$parcel$export(module.exports, "startIdleTransaction", () => $d8f14cfce20a86a3$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $d8f14cfce20a86a3$export$653d0ef2bad9cdf9);

var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $84Maa = parcelRequire("84Maa");

var $ajbYg = parcelRequire("ajbYg");

var $5FLQK = parcelRequire("5FLQK");

var $dkCHP = parcelRequire("dkCHP");

var $4iC5n = parcelRequire("4iC5n");

var $jBgts = parcelRequire("jBgts");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $d8f14cfce20a86a3$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $ajbYg.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $d8f14cfce20a86a3$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $jBgts.Transaction)(transactionContext, this);
    transaction = (0, $4iC5n.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $d8f14cfce20a86a3$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $dkCHP.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $4iC5n.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $d8f14cfce20a86a3$export$653d0ef2bad9cdf9() {
    const carrier = (0, $84Maa.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $d8f14cfce20a86a3$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $d8f14cfce20a86a3$var$traceHeaders;
    (0, $5FLQK.registerErrorInstrumentation)();
}

});
parcelRegister("5FLQK", function(module, exports) {
$parcel$export(module.exports, "registerErrorInstrumentation", () => $4215e60ae7db064c$export$637857c1d87b640c);

var $4CcuA = parcelRequire("4CcuA");
var $73l0k = parcelRequire("73l0k");
var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $dWocc = parcelRequire("dWocc");
let $4215e60ae7db064c$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $4215e60ae7db064c$export$637857c1d87b640c() {
    if ($4215e60ae7db064c$var$errorsInstrumented) return;
    $4215e60ae7db064c$var$errorsInstrumented = true;
    (0, $4CcuA.addGlobalErrorInstrumentationHandler)($4215e60ae7db064c$var$errorCallback);
    (0, $73l0k.addGlobalUnhandledRejectionInstrumentationHandler)($4215e60ae7db064c$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $4215e60ae7db064c$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $dWocc.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$4215e60ae7db064c$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("dWocc", function(module, exports) {
$parcel$export(module.exports, "getActiveTransaction", () => $a26375e6bd72fbd5$export$a7feb32fdd923295);
$parcel$export(module.exports, "extractTraceparentData", () => $a26375e6bd72fbd5$export$8e9a29865c0a1226);

var $eUr7O = parcelRequire("eUr7O");

var $84Maa = parcelRequire("84Maa");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a26375e6bd72fbd5$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $84Maa.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $a26375e6bd72fbd5$export$8e9a29865c0a1226 = (0, $eUr7O.extractTraceparentData);

});


parcelRegister("dkCHP", function(module, exports) {
$parcel$export(module.exports, "TRACING_DEFAULTS", () => $9b4b2ac9afd59f0b$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $9b4b2ac9afd59f0b$export$b279e6bd7040371f);

var $7I6pg = parcelRequire("7I6pg");
var $8t2EY = parcelRequire("8t2EY");

var $aCaWa = parcelRequire("aCaWa");

var $ajbYg = parcelRequire("ajbYg");

var $ijnVc = parcelRequire("ijnVc");

var $jBgts = parcelRequire("jBgts");
const $9b4b2ac9afd59f0b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $9b4b2ac9afd59f0b$var$FINISH_REASON_TAG = 'finishReason';
const $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $9b4b2ac9afd59f0b$export$370d6113c18ba86c extends (0, $ijnVc.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $ajbYg.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $9b4b2ac9afd59f0b$export$b279e6bd7040371f extends (0, $jBgts.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $9b4b2ac9afd59f0b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $9b4b2ac9afd59f0b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $9b4b2ac9afd59f0b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $ajbYg.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($9b4b2ac9afd59f0b$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $aCaWa.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $7I6pg.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $ajbYg.spanToJSON)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $ajbYg.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $aCaWa.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $7I6pg.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $7I6pg.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $9b4b2ac9afd59f0b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $8t2EY.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $9b4b2ac9afd59f0b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("ijnVc", function(module, exports) {
$parcel$export(module.exports, "SpanRecorder", () => $d54c8ea9c44c883b$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $d54c8ea9c44c883b$export$5f1714a13ed34c01);

var $iiQEB = parcelRequire("iiQEB");
var $7I6pg = parcelRequire("7I6pg");
var $8t2EY = parcelRequire("8t2EY");
var $h7F1u = parcelRequire("h7F1u");

var $aCaWa = parcelRequire("aCaWa");

var $a73mh = parcelRequire("a73mh");

var $2iz3c = parcelRequire("2iz3c");

var $kdA50 = parcelRequire("kdA50");

var $ajbYg = parcelRequire("ajbYg");

var $c40Kr = parcelRequire("c40Kr");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $d54c8ea9c44c883b$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $d54c8ea9c44c883b$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $h7F1u.uuid4)();
        this._spanId = spanContext.spanId || (0, $h7F1u.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $8t2EY.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || 'manual',
            [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $ajbYg.TRACE_FLAG_SAMPLED) : (0, $ajbYg.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $d54c8ea9c44c883b$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $kdA50.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $aCaWa.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $ajbYg.spanToJSON)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $7I6pg.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $c40Kr.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $kdA50.getRootSpan)(this);
        if ((0, $aCaWa.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $7I6pg.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $ajbYg.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $ajbYg.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $iiQEB.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $ajbYg.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $iiQEB.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $a73mh.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("a73mh", function(module, exports) {
$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $75cd29b57f0bf036$export$2e7205e45c58797d);
$parcel$export(module.exports, "updateMetricSummaryOnActiveSpan", () => $75cd29b57f0bf036$export$aefd1a302602f922);

var $iiQEB = parcelRequire("iiQEB");




var $9lKdF = parcelRequire("9lKdF");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $75cd29b57f0bf036$var$SPAN_METRIC_SUMMARY;
function $75cd29b57f0bf036$var$getMetricStorageForSpan(span) {
    return $75cd29b57f0bf036$var$SPAN_METRIC_SUMMARY ? $75cd29b57f0bf036$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $75cd29b57f0bf036$export$2e7205e45c58797d(span) {
    const storage = $75cd29b57f0bf036$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $iiQEB.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $75cd29b57f0bf036$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $9lKdF.getActiveSpan)();
    if (span) {
        const storage = $75cd29b57f0bf036$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$75cd29b57f0bf036$var$SPAN_METRIC_SUMMARY) $75cd29b57f0bf036$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $75cd29b57f0bf036$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("9lKdF", function(module, exports) {
$parcel$export(module.exports, "trace", () => $6ce9ed6c28349188$export$357889f174732d38);
$parcel$export(module.exports, "startSpan", () => $6ce9ed6c28349188$export$a1bd95187356f372);
$parcel$export(module.exports, "startSpanManual", () => $6ce9ed6c28349188$export$c10292ad04b92aea);
$parcel$export(module.exports, "startInactiveSpan", () => $6ce9ed6c28349188$export$63dbba021a6b4047);
$parcel$export(module.exports, "getActiveSpan", () => $6ce9ed6c28349188$export$1be426a8e585c83e);
$parcel$export(module.exports, "continueTrace", () => $6ce9ed6c28349188$export$d2ee9b39b25437b3);
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $6ce9ed6c28349188$export$c08fbc656a245d03);

var $iiQEB = parcelRequire("iiQEB");
var $7I6pg = parcelRequire("7I6pg");
var $eUr7O = parcelRequire("eUr7O");

var $aCaWa = parcelRequire("aCaWa");

var $84Maa = parcelRequire("84Maa");

var $ajbYg = parcelRequire("ajbYg");



var $aw8s7 = parcelRequire("aw8s7");

var $dmS7i = parcelRequire("dmS7i");

var $hGrs1 = parcelRequire("hGrs1");

var $6B8d6 = parcelRequire("6B8d6");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $6ce9ed6c28349188$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $84Maa.getCurrentHub)();
    const scope = (0, $dmS7i.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $6ce9ed6c28349188$var$normalizeContext(context);
    const activeSpan = $6ce9ed6c28349188$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $hGrs1.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6ce9ed6c28349188$export$a1bd95187356f372(context, callback) {
    const spanContext = $6ce9ed6c28349188$var$normalizeContext(context);
    return (0, $84Maa.runWithAsyncContext)(()=>{
        return (0, $dmS7i.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $84Maa.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6ce9ed6c28349188$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $hGrs1.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $ajbYg.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $6ce9ed6c28349188$export$cb9e396e6b90b703 = $6ce9ed6c28349188$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6ce9ed6c28349188$export$c10292ad04b92aea(context, callback) {
    const spanContext = $6ce9ed6c28349188$var$normalizeContext(context);
    return (0, $84Maa.runWithAsyncContext)(()=>{
        return (0, $dmS7i.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $84Maa.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6ce9ed6c28349188$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $hGrs1.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $ajbYg.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6ce9ed6c28349188$export$63dbba021a6b4047(context) {
    if (!(0, $6B8d6.hasTracingEnabled)()) return undefined;
    const spanContext = $6ce9ed6c28349188$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $84Maa.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $6ce9ed6c28349188$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $dmS7i.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $6ce9ed6c28349188$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $6ce9ed6c28349188$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $dmS7i.getCurrentScope)().getSpan();
}
const $6ce9ed6c28349188$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $dmS7i.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $eUr7O.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $aCaWa.DEBUG_BUILD) && traceparentData) (0, $7I6pg.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $iiQEB.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $84Maa.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $6ce9ed6c28349188$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $6B8d6.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $84Maa.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $aw8s7.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $ajbYg.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $6ce9ed6c28349188$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $6ce9ed6c28349188$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $ajbYg.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $6ce9ed6c28349188$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $6ce9ed6c28349188$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $6ce9ed6c28349188$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $iiQEB.addNonEnumerableProperty)(span, $6ce9ed6c28349188$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $iiQEB.addNonEnumerableProperty)(span, $6ce9ed6c28349188$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $6ce9ed6c28349188$export$c08fbc656a245d03(span) {
    return {
        scope: span[$6ce9ed6c28349188$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$6ce9ed6c28349188$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("hGrs1", function(module, exports) {
$parcel$export(module.exports, "handleCallbackErrors", () => $cdfba71664fae50b$export$18ce21a8b7efd7e9);

var $9r1pX = parcelRequire("9r1pX");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $cdfba71664fae50b$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $cdfba71664fae50b$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $cdfba71664fae50b$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $9r1pX.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("6B8d6", function(module, exports) {
$parcel$export(module.exports, "hasTracingEnabled", () => $4cdc91339da2dd79$export$5008da00b1b6dee6);

var $dmS7i = parcelRequire("dmS7i");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $4cdc91339da2dd79$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $dmS7i.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("2iz3c", function(module, exports) {
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $1ac8738365b1db29$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $1ac8738365b1db29$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $1ac8738365b1db29$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $1ac8738365b1db29$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $1ac8738365b1db29$export$1efec95406bbe327);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $1ac8738365b1db29$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $1ac8738365b1db29$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $1ac8738365b1db29$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $1ac8738365b1db29$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $1ac8738365b1db29$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("c40Kr", function(module, exports) {
$parcel$export(module.exports, "getSpanStatusFromHttpCode", () => $8c8670528508d802$export$5fd4dc48a2131589);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $8c8670528508d802$export$ac65c70d78fcdb55);
$parcel$export(module.exports, "setHttpStatus", () => $8c8670528508d802$export$2ad6630ec8164254);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $8c8670528508d802$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($8c8670528508d802$export$beb8e6a823e89c5d || ($8c8670528508d802$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $8c8670528508d802$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $8c8670528508d802$export$ac65c70d78fcdb55 = $8c8670528508d802$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $8c8670528508d802$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $8c8670528508d802$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("jBgts", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $e44e406b026b92dd$export$febc5573c75cefb0);

var $iiQEB = parcelRequire("iiQEB");
var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $84Maa = parcelRequire("84Maa");

var $a73mh = parcelRequire("a73mh");

var $2iz3c = parcelRequire("2iz3c");

var $ajbYg = parcelRequire("ajbYg");

var $aw8s7 = parcelRequire("aw8s7");

var $ijnVc = parcelRequire("ijnVc");

var $9lKdF = parcelRequire("9lKdF");
/** JSDoc */ class $e44e406b026b92dd$export$febc5573c75cefb0 extends (0, $ijnVc.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $84Maa.getCurrentHub)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $ijnVc.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $ajbYg.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $iiQEB.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $aw8s7.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $ajbYg.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $ajbYg.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $9lKdF.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $ajbYg.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $iiQEB.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $aw8s7.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $a73mh.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("4iC5n", function(module, exports) {
$parcel$export(module.exports, "sampleTransaction", () => $321662e1eb2c7816$export$b3258c3993bc9b71);
$parcel$export(module.exports, "isValidSampleRate", () => $321662e1eb2c7816$export$2603c8d332a51c42);

var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $2iz3c = parcelRequire("2iz3c");

var $6B8d6 = parcelRequire("6B8d6");

var $ajbYg = parcelRequire("ajbYg");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $321662e1eb2c7816$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $6B8d6.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$321662e1eb2c7816$export$2603c8d332a51c42(sampleRate)) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $aCaWa.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $7I6pg.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $ajbYg.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $321662e1eb2c7816$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $9r1pX.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("3ktBp", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $26ca33bf22e6e660$export$99d02219d259eb94);

var $iCMnl = parcelRequire("iCMnl");

var $dkCHP = parcelRequire("dkCHP");

var $ijnVc = parcelRequire("ijnVc");


var $dWocc = parcelRequire("dWocc");

var $c40Kr = parcelRequire("c40Kr");

var $9lKdF = parcelRequire("9lKdF");

var $aw8s7 = parcelRequire("aw8s7");

var $chwAd = parcelRequire("chwAd");

var $4iC5n = parcelRequire("4iC5n");

var $2iz3c = parcelRequire("2iz3c");


var $dmS7i = parcelRequire("dmS7i");

var $84Maa = parcelRequire("84Maa");



var $dmR7m = parcelRequire("dmR7m");

var $d86W5 = parcelRequire("d86W5");

var $5hILL = parcelRequire("5hILL");

var $ciWI5 = parcelRequire("ciWI5");


var $kOHMF = parcelRequire("kOHMF");

var $6fbbQ = parcelRequire("6fbbQ");

var $2CFWY = parcelRequire("2CFWY");

var $pc4Pc = parcelRequire("pc4Pc");

var $gLE2H = parcelRequire("gLE2H");

var $dFnv4 = parcelRequire("dFnv4");




var $5xyU1 = parcelRequire("5xyU1");

var $6B8d6 = parcelRequire("6B8d6");

var $aw6iz = parcelRequire("aw6iz");


var $kilk2 = parcelRequire("kilk2");

var $ajbYg = parcelRequire("ajbYg");


var $b6cMu = parcelRequire("b6cMu");

var $gh9LO = parcelRequire("gh9LO");

var $4qRd6 = parcelRequire("4qRd6");


var $85Shi = parcelRequire("85Shi");

var $2sSit = parcelRequire("2sSit");


var $eWD3o = parcelRequire("eWD3o");

var $jxWdC = parcelRequire("jxWdC");
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $26ca33bf22e6e660$export$99d02219d259eb94 = $eWD3o;

});
parcelRegister("chwAd", function(module, exports) {
$parcel$export(module.exports, "setMeasurement", () => $8f1058e0a51cea07$export$7cc31b475d33a706);

var $dWocc = parcelRequire("dWocc");
/**
 * Adds a measurement to the current active transaction.
 */ function $8f1058e0a51cea07$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $dWocc.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

});

parcelRegister("2CFWY", function(module, exports) {
$parcel$export(module.exports, "makeOfflineTransport", () => $1e8fabd2c75b275a$export$405ec66a0e87547a);

var $eoF3x = parcelRequire("eoF3x");
var $7I6pg = parcelRequire("7I6pg");
var $lDqxe = parcelRequire("lDqxe");

var $aCaWa = parcelRequire("aCaWa");
const $1e8fabd2c75b275a$export$638fddefcf0452da = 100; // 100 ms
const $1e8fabd2c75b275a$export$998db03eaf5cf3f3 = 5000; // 5 seconds
const $1e8fabd2c75b275a$var$MAX_DELAY = 3.6e6; // 1 hour
function $1e8fabd2c75b275a$var$log(msg, error) {
    (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).info(`[Offline]: ${msg}`, error);
}
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $1e8fabd2c75b275a$export$405ec66a0e87547a(createTransport) {
    return (options)=>{
        const transport = createTransport(options);
        const store = options.createStore ? options.createStore(options) : undefined;
        let retryDelay = $1e8fabd2c75b275a$export$998db03eaf5cf3f3;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We don't queue Session Replay envelopes because they are:
            // - Ordered and Replay relies on the response status to know when they're successfully sent.
            // - Likely to fill the queue quickly and block other events from being sent.
            // We also want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, $eoF3x.envelopeContainsItemType)(env, [
                'replay_event',
                'replay_recording',
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (!store) return;
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.pop();
                if (found) {
                    $1e8fabd2c75b275a$var$log('Attempting to send previously queued event');
                    send(found).catch((e)=>{
                        $1e8fabd2c75b275a$var$log('Failed to retry sending', e);
                    });
                }
            }, delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== 'number' && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $1e8fabd2c75b275a$var$MAX_DELAY);
        }
        async function send(envelope) {
            try {
                const result = await transport.send(envelope);
                let delay = $1e8fabd2c75b275a$export$638fddefcf0452da;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers && result.headers['retry-after']) delay = (0, $lDqxe.parseRetryAfterHeader)(result.headers['retry-after']);
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $1e8fabd2c75b275a$export$998db03eaf5cf3f3;
                return result;
            } catch (e) {
                if (store && await shouldQueue(envelope, e, retryDelay)) {
                    await store.insert(envelope);
                    flushWithBackOff();
                    $1e8fabd2c75b275a$var$log('Error sending. Event queued', e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (t)=>transport.flush(t)
        };
    };
}

});

parcelRegister("pc4Pc", function(module, exports) {
$parcel$export(module.exports, "makeMultiplexedTransport", () => $04bbb41e7fe4254c$export$53bbcd410607e756);

var $eoF3x = parcelRequire("eoF3x");
var $5Na3j = parcelRequire("5Na3j");

var $5hILL = parcelRequire("5hILL");
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $04bbb41e7fe4254c$export$b92f55f7516d9100(env, types) {
    let event;
    (0, $eoF3x.forEachEnvelopeItem)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $04bbb41e7fe4254c$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $04bbb41e7fe4254c$export$b92f55f7516d9100(envelope, [
                    'event',
                    'transaction',
                    'profile',
                    'replay_event'
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function $04bbb41e7fe4254c$var$overrideDsn(envelope, dsn) {
    return (0, $eoF3x.createEnvelope)(dsn ? {
        ...envelope[0],
        dsn: dsn
    } : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function $04bbb41e7fe4254c$export$53bbcd410607e756(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = (0, $5Na3j.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, $5hILL.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn, options.tunnel);
                transport = release ? $04bbb41e7fe4254c$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types && types.length ? types : [
                    'event'
                ];
                return $04bbb41e7fe4254c$export$b92f55f7516d9100(envelope, eventTypes);
            }
            const transports = matcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === 'string') return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            if (transports.length === 0) // Don't override the DSN in the header for the fallback transport. '' is falsy
            transports.push([
                '',
                fallbackTransport
            ]);
            const results = await Promise.all(transports.map(([dsn, transport])=>transport.send($04bbb41e7fe4254c$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const promises = [
                await fallbackTransport.flush(timeout)
            ];
            for (const [, transport] of otherTransports)promises.push(await transport.flush(timeout));
            return promises.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}

});

parcelRegister("5xyU1", function(module, exports) {
$parcel$export(module.exports, "createSpanEnvelope", () => $408b1bb8b203b838$export$19a0081d4b39d77);

var $eoF3x = parcelRequire("eoF3x");
var $5Na3j = parcelRequire("5Na3j");
/**
 * Create envelope from Span item.
 */ function $408b1bb8b203b838$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $5Na3j.dsnToString)(dsn);
    const items = spans.map($408b1bb8b203b838$var$createSpanItem);
    return (0, $eoF3x.createEnvelope)(headers, items);
}
function $408b1bb8b203b838$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}

});

parcelRegister("aw6iz", function(module, exports) {
$parcel$export(module.exports, "isSentryRequestUrl", () => $7a81c74e8e2900bb$export$d92e61f5600202af);
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $7a81c74e8e2900bb$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $7a81c74e8e2900bb$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $7a81c74e8e2900bb$var$checkDsn(url, dsn) || $7a81c74e8e2900bb$var$checkTunnel(url, tunnel);
}
function $7a81c74e8e2900bb$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $7a81c74e8e2900bb$var$removeTrailingSlash(url) === $7a81c74e8e2900bb$var$removeTrailingSlash(tunnel);
}
function $7a81c74e8e2900bb$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $7a81c74e8e2900bb$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $7a81c74e8e2900bb$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

});

parcelRegister("kilk2", function(module, exports) {
$parcel$export(module.exports, "parameterize", () => $ec66073f52600696$export$4cb5eb704d6ec224);
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */ function $ec66073f52600696$export$4cb5eb704d6ec224(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}

});

parcelRegister("4qRd6", function(module, exports) {
$parcel$export(module.exports, "moduleMetadataIntegration", () => $33a2dd96fb12fb2e$export$b3b128c3ae01ded0);
$parcel$export(module.exports, "ModuleMetadata", () => $33a2dd96fb12fb2e$export$6cd9b4efeff4101a);

var $eoF3x = parcelRequire("eoF3x");

var $dFnv4 = parcelRequire("dFnv4");

var $bmhzE = parcelRequire("bmhzE");
const $33a2dd96fb12fb2e$var$INTEGRATION_NAME = 'ModuleMetadata';
const $33a2dd96fb12fb2e$var$_moduleMetadataIntegration = ()=>{
    return {
        name: $33a2dd96fb12fb2e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (typeof client.on !== 'function') return;
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope)=>{
                (0, $eoF3x.forEachEnvelopeItem)(envelope, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $bmhzE.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
        },
        processEvent (event, _hint, client) {
            const stackParser = client.getOptions().stackParser;
            (0, $bmhzE.addMetadataToStackFrames)(stackParser, event);
            return event;
        }
    };
};
const $33a2dd96fb12fb2e$export$b3b128c3ae01ded0 = (0, $dFnv4.defineIntegration)($33a2dd96fb12fb2e$var$_moduleMetadataIntegration);
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $33a2dd96fb12fb2e$export$6cd9b4efeff4101a = (0, $dFnv4.convertIntegrationFnToClass)($33a2dd96fb12fb2e$var$INTEGRATION_NAME, $33a2dd96fb12fb2e$export$b3b128c3ae01ded0);

});
parcelRegister("bmhzE", function(module, exports) {
$parcel$export(module.exports, "addMetadataToStackFrames", () => $844f61a049552efb$export$94b52ecabddf6844);
$parcel$export(module.exports, "stripMetadataFromStackFrames", () => $844f61a049552efb$export$5d4932fac9735eed);

var $hi3E4 = parcelRequire("hi3E4");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $844f61a049552efb$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $844f61a049552efb$var$parsedStacks = new Set();
function $844f61a049552efb$var$ensureMetadataStacksAreParsed(parser) {
    if (!(0, $hi3E4.GLOBAL_OBJ)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, $hi3E4.GLOBAL_OBJ)._sentryModuleMetadata)){
        const metadata = (0, $hi3E4.GLOBAL_OBJ)._sentryModuleMetadata[stack];
        if ($844f61a049552efb$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $844f61a049552efb$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $844f61a049552efb$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $844f61a049552efb$export$fb4062399a51f94a(parser, filename) {
    $844f61a049552efb$var$ensureMetadataStacksAreParsed(parser);
    return $844f61a049552efb$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $844f61a049552efb$export$94b52ecabddf6844(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || []){
                if (!frame.filename) continue;
                const metadata = $844f61a049552efb$export$fb4062399a51f94a(parser, frame.filename);
                if (metadata) frame.module_metadata = metadata;
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function $844f61a049552efb$export$5d4932fac9735eed(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || [])delete frame.module_metadata;
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}

});


parcelRegister("eWD3o", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("2sSit")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("85Shi")).InboundFilters);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("4RdTC")).LinkedErrors);

var $2sSit = parcelRequire("2sSit");

var $85Shi = parcelRequire("85Shi");

var $4RdTC = parcelRequire("4RdTC");
 /* eslint-disable deprecation/deprecation */ 
});
parcelRegister("4RdTC", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $3896e41e9499e3c4$export$8d1e60aaf616fb4f);

var $bB9Vc = parcelRequire("bB9Vc");
var $8KTbr = parcelRequire("8KTbr");

var $dFnv4 = parcelRequire("dFnv4");
const $3896e41e9499e3c4$var$DEFAULT_KEY = 'cause';
const $3896e41e9499e3c4$var$DEFAULT_LIMIT = 5;
const $3896e41e9499e3c4$var$INTEGRATION_NAME = 'LinkedErrors';
const $3896e41e9499e3c4$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $3896e41e9499e3c4$var$DEFAULT_LIMIT;
    const key = options.key || $3896e41e9499e3c4$var$DEFAULT_KEY;
    return {
        name: $3896e41e9499e3c4$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $bB9Vc.applyAggregateErrorsToEvent)((0, $8KTbr.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $3896e41e9499e3c4$export$ebabb00eb7f3a395 = (0, $dFnv4.defineIntegration)($3896e41e9499e3c4$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3896e41e9499e3c4$export$8d1e60aaf616fb4f = (0, $dFnv4.convertIntegrationFnToClass)($3896e41e9499e3c4$var$INTEGRATION_NAME, $3896e41e9499e3c4$export$ebabb00eb7f3a395);

});
parcelRegister("8KTbr", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $65fd6ceaa0ded3de$export$a6c2d27607295951);

var $9r1pX = parcelRequire("9r1pX");

var $h7F1u = parcelRequire("h7F1u");

var $bsqJK = parcelRequire("bsqJK");

var $iiQEB = parcelRequire("iiQEB");
/**
 * Extracts stack frames from the error.stack string
 */ function $65fd6ceaa0ded3de$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $65fd6ceaa0ded3de$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $65fd6ceaa0ded3de$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $65fd6ceaa0ded3de$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $iiQEB.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $65fd6ceaa0ded3de$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    let extras;
    if (!(0, $9r1pX.isError)(exception)) {
        if ((0, $9r1pX.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ['__serialized__']: (0, $bsqJK.normalizeToSize)(exception, normalizeDepth)
            };
            const message = $65fd6ceaa0ded3de$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $65fd6ceaa0ded3de$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $h7F1u.addExceptionTypeValue)(event, undefined, undefined);
    (0, $h7F1u.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $65fd6ceaa0ded3de$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $65fd6ceaa0ded3de$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $9r1pX.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

});



parcelRegister("jxWdC", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $e3ae42605fb556e7$export$b0c5c2fac8144e54);

var $7I6pg = parcelRequire("7I6pg");

var $aCaWa = parcelRequire("aCaWa");

var $dmS7i = parcelRequire("dmS7i");

var $ajbYg = parcelRequire("ajbYg");

var $djQin = parcelRequire("djQin");

var $76Lv6 = parcelRequire("76Lv6");
function $e3ae42605fb556e7$var$addToMetricsAggregator(metricType, name, value, data = {}) {
    const client = (0, $dmS7i.getClient)();
    const scope = (0, $dmS7i.getCurrentScope)();
    if (client) {
        if (!client.metricsAggregator) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs');
            return;
        }
        const { unit: unit, tags: tags, timestamp: timestamp } = data;
        const { release: release, environment: environment } = client.getOptions();
        // eslint-disable-next-line deprecation/deprecation
        const transaction = scope.getTransaction();
        const metricTags = {};
        if (release) metricTags.release = release;
        if (environment) metricTags.environment = environment;
        if (transaction) metricTags.transaction = (0, $ajbYg.spanToJSON)(transaction).description || '';
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Adding value of ${value} to ${metricType} metric ${name}`);
        client.metricsAggregator.add(metricType, name, value, unit, {
            ...metricTags,
            ...tags
        }, timestamp);
    }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $e3ae42605fb556e7$export$a2647aa13413c947(name, value = 1, data) {
    $e3ae42605fb556e7$var$addToMetricsAggregator((0, $djQin.COUNTER_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $e3ae42605fb556e7$export$fd8e353f0040520a(name, value, data) {
    $e3ae42605fb556e7$var$addToMetricsAggregator((0, $djQin.DISTRIBUTION_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $e3ae42605fb556e7$export$adaa4cf7ef1b65be(name, value, data) {
    $e3ae42605fb556e7$var$addToMetricsAggregator((0, $djQin.SET_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function $e3ae42605fb556e7$export$b0660673397c6c28(name, value, data) {
    $e3ae42605fb556e7$var$addToMetricsAggregator((0, $djQin.GAUGE_METRIC_TYPE), name, value, data);
}
const $e3ae42605fb556e7$export$b0c5c2fac8144e54 = {
    increment: $e3ae42605fb556e7$export$a2647aa13413c947,
    distribution: $e3ae42605fb556e7$export$fd8e353f0040520a,
    set: $e3ae42605fb556e7$export$adaa4cf7ef1b65be,
    gauge: $e3ae42605fb556e7$export$b0660673397c6c28,
    MetricsAggregator: /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */ // eslint-disable-next-line deprecation/deprecation
    $76Lv6.MetricsAggregator,
    metricsAggregatorIntegration: $76Lv6.metricsAggregatorIntegration
};

});
parcelRegister("djQin", function(module, exports) {
$parcel$export(module.exports, "COUNTER_METRIC_TYPE", () => $9b259d7c07d2c16c$export$ffbd59c90957aeda);
$parcel$export(module.exports, "GAUGE_METRIC_TYPE", () => $9b259d7c07d2c16c$export$41106537ee4dbdd);
$parcel$export(module.exports, "SET_METRIC_TYPE", () => $9b259d7c07d2c16c$export$d2e7506772279f4e);
$parcel$export(module.exports, "DISTRIBUTION_METRIC_TYPE", () => $9b259d7c07d2c16c$export$9818d6472d7991f0);
$parcel$export(module.exports, "DEFAULT_BROWSER_FLUSH_INTERVAL", () => $9b259d7c07d2c16c$export$9fcf9b73aae4b12);
const $9b259d7c07d2c16c$export$ffbd59c90957aeda = 'c';
const $9b259d7c07d2c16c$export$41106537ee4dbdd = 'g';
const $9b259d7c07d2c16c$export$d2e7506772279f4e = 's';
const $9b259d7c07d2c16c$export$9818d6472d7991f0 = 'd';
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $9b259d7c07d2c16c$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $9b259d7c07d2c16c$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $9b259d7c07d2c16c$export$aa41e9d920739c1a = 10000;

});

parcelRegister("76Lv6", function(module, exports) {
$parcel$export(module.exports, "metricsAggregatorIntegration", () => $52cdf09b5b842331$export$4c88deba5759110b);
$parcel$export(module.exports, "MetricsAggregator", () => $52cdf09b5b842331$export$a2510bffabd4ed26);

var $dFnv4 = parcelRequire("dFnv4");

var $fjB3t = parcelRequire("fjB3t");
const $52cdf09b5b842331$var$INTEGRATION_NAME = 'MetricsAggregator';
const $52cdf09b5b842331$var$_metricsAggregatorIntegration = ()=>{
    return {
        name: $52cdf09b5b842331$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            client.metricsAggregator = new (0, $fjB3t.BrowserMetricsAggregator)(client);
        }
    };
};
const $52cdf09b5b842331$export$4c88deba5759110b = (0, $dFnv4.defineIntegration)($52cdf09b5b842331$var$_metricsAggregatorIntegration);
/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $52cdf09b5b842331$export$a2510bffabd4ed26 = (0, $dFnv4.convertIntegrationFnToClass)($52cdf09b5b842331$var$INTEGRATION_NAME, $52cdf09b5b842331$export$4c88deba5759110b);

});
parcelRegister("fjB3t", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsAggregator", () => $b2655fb7addcf7ef$export$ba883a03ada27e19);

var $8t2EY = parcelRequire("8t2EY");

var $djQin = parcelRequire("djQin");

var $kjB7m = parcelRequire("kjB7m");

var $a73mh = parcelRequire("a73mh");

var $hWySO = parcelRequire("hWySO");
/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */ class $b2655fb7addcf7ef$export$ba883a03ada27e19 {
    // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
    // when the aggregator is garbage collected.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
    constructor(_client){
        this._client = _client;
        this._buckets = new Map();
        this._interval = setInterval(()=>this.flush(), (0, $djQin.DEFAULT_BROWSER_FLUSH_INTERVAL));
    }
    /**
   * @inheritDoc
   */ add(metricType, unsanitizedName, value, unsanitizedUnit = 'none', unsanitizedTags = {}, maybeFloatTimestamp = (0, $8t2EY.timestampInSeconds)()) {
        const timestamp = Math.floor(maybeFloatTimestamp);
        const name = (0, $hWySO.sanitizeMetricKey)(unsanitizedName);
        const tags = (0, $hWySO.sanitizeTags)(unsanitizedTags);
        const unit = (0, $hWySO.sanitizeUnit)(unsanitizedUnit);
        const bucketKey = (0, $hWySO.getBucketKey)(metricType, name, unit, tags);
        let bucketItem = this._buckets.get(bucketKey);
        // If this is a set metric, we need to calculate the delta from the previous weight.
        const previousWeight = bucketItem && metricType === (0, $djQin.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
        if (bucketItem) {
            bucketItem.metric.add(value);
            // TODO(abhi): Do we need this check?
            if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
        } else {
            bucketItem = {
                // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                metric: new (0, $kjB7m.METRIC_MAP)[metricType](value),
                timestamp: timestamp,
                metricType: metricType,
                name: name,
                unit: unit,
                tags: tags
            };
            this._buckets.set(bucketKey, bucketItem);
        }
        // If value is a string, it's a set metric so calculate the delta from the previous weight.
        const val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
        (0, $a73mh.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
    }
    /**
   * @inheritDoc
   */ flush() {
        // short circuit if buckets are empty.
        if (this._buckets.size === 0) return;
        if (this._client.captureAggregateMetrics) {
            // TODO(@anonrig): Use Object.values() when we support ES6+
            const metricBuckets = Array.from(this._buckets).map(([, bucketItem])=>bucketItem);
            this._client.captureAggregateMetrics(metricBuckets);
        }
        this._buckets.clear();
    }
    /**
   * @inheritDoc
   */ close() {
        clearInterval(this._interval);
        this.flush();
    }
}

});
parcelRegister("kjB7m", function(module, exports) {
$parcel$export(module.exports, "METRIC_MAP", () => $eca25fc967dcc811$export$c3e86dbb157e974e);

var $djQin = parcelRequire("djQin");

var $hWySO = parcelRequire("hWySO");
/**
 * A metric instance representing a counter.
 */ class $eca25fc967dcc811$export$2598fd6c664a7ae3 {
    constructor(_value){
        this._value = _value;
    }
    /** @inheritDoc */ get weight() {
        return 1;
    }
    /** @inheritdoc */ add(value) {
        this._value += value;
    }
    /** @inheritdoc */ toString() {
        return `${this._value}`;
    }
}
/**
 * A metric instance representing a gauge.
 */ class $eca25fc967dcc811$export$56f7b30259c6ff43 {
    constructor(value){
        this._last = value;
        this._min = value;
        this._max = value;
        this._sum = value;
        this._count = 1;
    }
    /** @inheritDoc */ get weight() {
        return 5;
    }
    /** @inheritdoc */ add(value) {
        this._last = value;
        if (value < this._min) this._min = value;
        if (value > this._max) this._max = value;
        this._sum += value;
        this._count++;
    }
    /** @inheritdoc */ toString() {
        return `${this._last}:${this._min}:${this._max}:${this._sum}:${this._count}`;
    }
}
/**
 * A metric instance representing a distribution.
 */ class $eca25fc967dcc811$export$94f4651a38b34288 {
    constructor(first){
        this._value = [
            first
        ];
    }
    /** @inheritDoc */ get weight() {
        return this._value.length;
    }
    /** @inheritdoc */ add(value) {
        this._value.push(value);
    }
    /** @inheritdoc */ toString() {
        return this._value.join(':');
    }
}
/**
 * A metric instance representing a set.
 */ class $eca25fc967dcc811$export$4d1d31acf43c5a17 {
    constructor(first){
        this.first = first;
        this._value = new Set([
            first
        ]);
    }
    /** @inheritDoc */ get weight() {
        return this._value.size;
    }
    /** @inheritdoc */ add(value) {
        this._value.add(value);
    }
    /** @inheritdoc */ toString() {
        return Array.from(this._value).map((val)=>typeof val === 'string' ? (0, $hWySO.simpleHash)(val) : val).join(':');
    }
}
const $eca25fc967dcc811$export$c3e86dbb157e974e = {
    [(0, $djQin.COUNTER_METRIC_TYPE)]: $eca25fc967dcc811$export$2598fd6c664a7ae3,
    [(0, $djQin.GAUGE_METRIC_TYPE)]: $eca25fc967dcc811$export$56f7b30259c6ff43,
    [(0, $djQin.DISTRIBUTION_METRIC_TYPE)]: $eca25fc967dcc811$export$94f4651a38b34288,
    [(0, $djQin.SET_METRIC_TYPE)]: $eca25fc967dcc811$export$4d1d31acf43c5a17
};

});





parcelRegister("6cnML", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("efJnc")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("eqOkL")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("lfdSs")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("2JxJk")).LinkedErrors);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("5lgCu")).HttpContext);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("9nLSz")).Dedupe);

var $efJnc = parcelRequire("efJnc");

var $eqOkL = parcelRequire("eqOkL");

var $lfdSs = parcelRequire("lfdSs");

var $2JxJk = parcelRequire("2JxJk");

var $5lgCu = parcelRequire("5lgCu");

var $9nLSz = parcelRequire("9nLSz");
 /* eslint-disable deprecation/deprecation */ 
});

parcelRegister("5IZWm", function(module, exports) {
$parcel$export(module.exports, "replayCanvasIntegration", () => $42b11bdc599f963a$export$71ba62165d5c834d);
$parcel$export(module.exports, "ReplayCanvas", () => $42b11bdc599f963a$export$5f05966c3e8baf2f);

var $867Yq = parcelRequire("867Yq");

var $dFnv4 = parcelRequire("dFnv4");
var $42b11bdc599f963a$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($42b11bdc599f963a$var$NodeType || ($42b11bdc599f963a$var$NodeType = {}));
function $42b11bdc599f963a$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $42b11bdc599f963a$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $42b11bdc599f963a$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $42b11bdc599f963a$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($42b11bdc599f963a$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
const $42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $42b11bdc599f963a$var$_mirror = {
    map: {},
    getId () {
        console.error($42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $42b11bdc599f963a$var$_mirror = new Proxy($42b11bdc599f963a$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($42b11bdc599f963a$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $42b11bdc599f963a$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $42b11bdc599f963a$var$setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$42b11bdc599f963a$var$hookSetter(target, key, original || {}, true);
}
function $42b11bdc599f963a$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
/[1-9][0-9]{12}/.test(Date.now().toString());
function $42b11bdc599f963a$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $42b11bdc599f963a$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $42b11bdc599f963a$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $42b11bdc599f963a$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $42b11bdc599f963a$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $42b11bdc599f963a$var$distanceToMatch(el, $42b11bdc599f963a$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const $42b11bdc599f963a$var$cachedImplementations = {};
function $42b11bdc599f963a$var$getImplementation(name) {
    const cached = $42b11bdc599f963a$var$cachedImplementations[name];
    if (cached) return cached;
    const document = window.document;
    let impl = window[name];
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {}
    return $42b11bdc599f963a$var$cachedImplementations[name] = impl.bind(window);
}
function $42b11bdc599f963a$var$onRequestAnimationFrame(...rest) {
    return $42b11bdc599f963a$var$getImplementation('requestAnimationFrame')(...rest);
}
function $42b11bdc599f963a$var$setTimeout(...rest) {
    return $42b11bdc599f963a$var$getImplementation('setTimeout')(...rest);
}
var $42b11bdc599f963a$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($42b11bdc599f963a$var$CanvasContext || {});
let $42b11bdc599f963a$var$errorHandler;
function $42b11bdc599f963a$var$registerErrorHandler(handler) {
    $42b11bdc599f963a$var$errorHandler = handler;
}
const $42b11bdc599f963a$var$callbackWrapper = (cb)=>{
    if (!$42b11bdc599f963a$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($42b11bdc599f963a$var$errorHandler && $42b11bdc599f963a$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $42b11bdc599f963a$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $42b11bdc599f963a$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $42b11bdc599f963a$var$i = 0; $42b11bdc599f963a$var$i < $42b11bdc599f963a$var$chars.length; $42b11bdc599f963a$var$i++)$42b11bdc599f963a$var$lookup[$42b11bdc599f963a$var$chars.charCodeAt($42b11bdc599f963a$var$i)] = $42b11bdc599f963a$var$i;
var $42b11bdc599f963a$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $42b11bdc599f963a$var$chars[bytes[i] >> 2];
        base64 += $42b11bdc599f963a$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $42b11bdc599f963a$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $42b11bdc599f963a$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $42b11bdc599f963a$var$canvasVarMap = new Map();
function $42b11bdc599f963a$var$variableListFor(ctx, ctor) {
    let contextMap = $42b11bdc599f963a$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $42b11bdc599f963a$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $42b11bdc599f963a$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($42b11bdc599f963a$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
    const name = value.constructor.name;
    const list = $42b11bdc599f963a$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $42b11bdc599f963a$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$42b11bdc599f963a$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $42b11bdc599f963a$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $42b11bdc599f963a$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = 'HTMLImageElement';
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $42b11bdc599f963a$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($42b11bdc599f963a$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = $42b11bdc599f963a$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $42b11bdc599f963a$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$42b11bdc599f963a$var$serializeArg(arg, win, ctx));
};
const $42b11bdc599f963a$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $42b11bdc599f963a$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') continue;
        const restoreHandler = $42b11bdc599f963a$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$42b11bdc599f963a$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) $42b11bdc599f963a$var$setTimeout(()=>{
                    const recordArgs = $42b11bdc599f963a$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $42b11bdc599f963a$var$CanvasContext['2D'],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        const hookHandler = $42b11bdc599f963a$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $42b11bdc599f963a$var$CanvasContext['2D'],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $42b11bdc599f963a$var$getNormalizedContextName(contextType) {
    return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function $42b11bdc599f963a$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $42b11bdc599f963a$var$patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType, ...args) {
                if (!$42b11bdc599f963a$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $42b11bdc599f963a$var$getNormalizedContextName(contextType);
                    if (!('__context' in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        'webgl',
                        'webgl2'
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === 'object') {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $42b11bdc599f963a$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            'isContextLost',
            'canvas',
            'drawingBufferWidth',
            'drawingBufferHeight'
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== 'function') continue;
            const restoreHandler = $42b11bdc599f963a$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $42b11bdc599f963a$var$saveWebGLVar(result, win, this);
                    if ('tagName' in this.canvas && !$42b11bdc599f963a$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        const recordArgs = $42b11bdc599f963a$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = $42b11bdc599f963a$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $42b11bdc599f963a$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$42b11bdc599f963a$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $42b11bdc599f963a$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') handlers.push(...$42b11bdc599f963a$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $42b11bdc599f963a$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
var $42b11bdc599f963a$var$r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function $42b11bdc599f963a$var$t() {
    const t = new Blob([
        $42b11bdc599f963a$var$r
    ]);
    return URL.createObjectURL(t);
}
class $42b11bdc599f963a$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = 'all', win: win, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maxCanvasSize: maxCanvasSize, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions, errorHandler: errorHandler } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) $42b11bdc599f963a$var$registerErrorHandler(errorHandler);
        if (options.enableManualSnapshot) return;
        $42b11bdc599f963a$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === 'all') this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === 'number') this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
        const canvasContextReset = $42b11bdc599f963a$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
        const rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $42b11bdc599f963a$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $42b11bdc599f963a$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $42b11bdc599f963a$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    snapshot(canvasElement) {
        const { options: options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === 'all' ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
        this.resetObservers = ()=>{
            cancelAnimationFrame(rafId);
        };
    }
    takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
        const snapshotInProgressMap = new Map();
        const worker = new Worker($42b11bdc599f963a$var$t());
        worker.onmessage = (e)=>{
            const data = e.data;
            const { id: id } = data;
            snapshotInProgressMap.set(id, false);
            if (!('base64' in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $42b11bdc599f963a$var$CanvasContext['2D'],
                commands: [
                    {
                        property: 'clearRect',
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: 'drawImage',
                        args: [
                            {
                                rr_type: 'ImageBitmap',
                                args: [
                                    {
                                        rr_type: 'Blob',
                                        data: [
                                            {
                                                rr_type: 'ArrayBuffer',
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0,
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = (canvasElement)=>{
            if (canvasElement) return [
                canvasElement
            ];
            const matchedCanvas = [];
            win.document.querySelectorAll('canvas').forEach((canvas)=>{
                if (!$42b11bdc599f963a$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = $42b11bdc599f963a$var$onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas)=>{
                const id = this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id)) return;
                if (!canvas.width || !canvas.height) return;
                snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot && [
                    'webgl',
                    'webgl2'
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if ((0, $867Yq._optionalChain)([
                        context,
                        'optionalAccess',
                        (_)=>_.getContextAttributes,
                        'call',
                        (_2)=>_2(),
                        'optionalAccess',
                        (_3)=>_3.preserveDrawingBuffer
                    ]) === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                createImageBitmap(canvas).then((bitmap)=>{
                    worker.postMessage({
                        id: id,
                        bitmap: bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions: dataURLOptions,
                        maxCanvasSize: maxCanvasSize
                    }, [
                        bitmap
                    ]);
                }).catch((error)=>{
                    $42b11bdc599f963a$var$callbackWrapper(()=>{
                        throw error;
                    })();
                });
            });
            rafId = $42b11bdc599f963a$var$onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = $42b11bdc599f963a$var$onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        $42b11bdc599f963a$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $42b11bdc599f963a$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $42b11bdc599f963a$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $42b11bdc599f963a$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
const $42b11bdc599f963a$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.5
        }
    }
};
const $42b11bdc599f963a$var$INTEGRATION_NAME = 'ReplayCanvas';
const $42b11bdc599f963a$var$DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ const $42b11bdc599f963a$var$_replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || 'medium',
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, $42b11bdc599f963a$var$DEFAULT_MAX_CANVAS_SIZE) : $42b11bdc599f963a$var$DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, $42b11bdc599f963a$var$DEFAULT_MAX_CANVAS_SIZE) : $42b11bdc599f963a$var$DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $42b11bdc599f963a$var$INTEGRATION_NAME,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce () {},
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot, maxCanvasSize: maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new $42b11bdc599f963a$var$CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === 'object') err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$42b11bdc599f963a$var$CANVAS_QUALITY[quality || 'medium'] || $42b11bdc599f963a$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement) {
            const canvasManager = await _canvasManager;
            canvasManager.snapshot(canvasElement);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const $42b11bdc599f963a$export$71ba62165d5c834d = (0, $dFnv4.defineIntegration)($42b11bdc599f963a$var$_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */ // eslint-disable-next-line deprecation/deprecation
const $42b11bdc599f963a$export$5f05966c3e8baf2f = (0, $dFnv4.convertIntegrationFnToClass)($42b11bdc599f963a$var$INTEGRATION_NAME, $42b11bdc599f963a$export$71ba62165d5c834d);

});
parcelRegister("867Yq", function(module, exports) {
$parcel$export(module.exports, "_optionalChain", () => $5e5511a3a1a9c46f$export$3cc482e6b02f32f7);
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $5e5511a3a1a9c46f$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});


parcelRegister("3zcyB", function(module, exports) {
$parcel$export(module.exports, "captureConsoleIntegration", () => $298e618c62a8781e$export$caa9b6c4a4144db4);

var $dmS7i = parcelRequire("dmS7i");
var $dFnv4 = parcelRequire("dFnv4");

var $e6ZUP = parcelRequire("e6ZUP");
var $h7F1u = parcelRequire("h7F1u");
var $7I6pg = parcelRequire("7I6pg");
var $hi3E4 = parcelRequire("hi3E4");
var $4TtIy = parcelRequire("4TtIy");
var $953Ix = parcelRequire("953Ix");
const $298e618c62a8781e$var$INTEGRATION_NAME = 'CaptureConsole';
const $298e618c62a8781e$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $7I6pg.CONSOLE_LEVELS);
    return {
        name: $298e618c62a8781e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!('console' in (0, $hi3E4.GLOBAL_OBJ))) return;
            (0, $e6ZUP.addConsoleInstrumentationHandler)(({ args: args, level: level })=>{
                if ((0, $dmS7i.getClient)() !== client || !levels.includes(level)) return;
                $298e618c62a8781e$var$consoleHandler(args, level);
            });
        }
    };
};
const $298e618c62a8781e$export$caa9b6c4a4144db4 = (0, $dFnv4.defineIntegration)($298e618c62a8781e$var$_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $298e618c62a8781e$export$25a43cb5b5c58c08 = (0, $dFnv4.convertIntegrationFnToClass)($298e618c62a8781e$var$INTEGRATION_NAME, $298e618c62a8781e$export$caa9b6c4a4144db4);
function $298e618c62a8781e$var$consoleHandler(args, level) {
    const captureContext = {
        level: (0, $953Ix.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, $dmS7i.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $h7F1u.addExceptionMechanism)(event, {
                handled: false,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert' && args[0] === false) {
            const message = `Assertion failed: ${(0, $4TtIy.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
            scope.setExtra('arguments', args.slice(1));
            (0, $dmS7i.captureMessage)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === 'error' && error) {
            (0, $dmS7i.captureException)(error, captureContext);
            return;
        }
        const message = (0, $4TtIy.safeJoin)(args, ' ');
        (0, $dmS7i.captureMessage)(message, captureContext);
    });
}

});

parcelRegister("2J7EI", function(module, exports) {
$parcel$export(module.exports, "contextLinesIntegration", () => $1fc5b905ee791981$export$74173d114ed4f354);

var $dFnv4 = parcelRequire("dFnv4");

var $h7F1u = parcelRequire("h7F1u");
var $hi3E4 = parcelRequire("hi3E4");
var $rcz3w = parcelRequire("rcz3w");
const $1fc5b905ee791981$var$WINDOW = (0, $hi3E4.GLOBAL_OBJ);
const $1fc5b905ee791981$var$DEFAULT_LINES_OF_CONTEXT = 7;
const $1fc5b905ee791981$var$INTEGRATION_NAME = 'ContextLines';
const $1fc5b905ee791981$var$_contextLinesIntegration = (options = {})=>{
    const contextLines = options.frameContextLines != null ? options.frameContextLines : $1fc5b905ee791981$var$DEFAULT_LINES_OF_CONTEXT;
    return {
        name: $1fc5b905ee791981$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event) {
            return $1fc5b905ee791981$var$addSourceContext(event, contextLines);
        }
    };
};
const $1fc5b905ee791981$export$74173d114ed4f354 = (0, $dFnv4.defineIntegration)($1fc5b905ee791981$var$_contextLinesIntegration);
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1fc5b905ee791981$export$a1f484ece213940c = (0, $dFnv4.convertIntegrationFnToClass)($1fc5b905ee791981$var$INTEGRATION_NAME, $1fc5b905ee791981$export$74173d114ed4f354);
/**
 * Processes an event and adds context lines.
 */ function $1fc5b905ee791981$var$addSourceContext(event, contextLines) {
    const doc = $1fc5b905ee791981$var$WINDOW.document;
    const htmlFilename = $1fc5b905ee791981$var$WINDOW.location && (0, $rcz3w.stripUrlQueryAndFragment)($1fc5b905ee791981$var$WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    const exceptions = event.exception && event.exception.values;
    if (!exceptions || !exceptions.length) return event;
    const html = doc.documentElement.innerHTML;
    if (!html) return event;
    const htmlLines = [
        '<!DOCTYPE html>',
        '<html>',
        ...html.split('\n'),
        '</html>'
    ];
    exceptions.forEach((exception)=>{
        const stacktrace = exception.stacktrace;
        if (stacktrace && stacktrace.frames) stacktrace.frames = stacktrace.frames.map((frame)=>$1fc5b905ee791981$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, contextLines));
    });
    return event;
}
/**
 * Only exported for testing
 */ function $1fc5b905ee791981$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, $h7F1u.addContextToFrame)(htmlLines, frame, linesOfContext);
    return frame;
}

});

parcelRegister("6JGJC", function(module, exports) {
$parcel$export(module.exports, "debugIntegration", () => $4e78184eee5808a5$export$6c044612ac549e3);

var $dFnv4 = parcelRequire("dFnv4");

var $7I6pg = parcelRequire("7I6pg");
const $4e78184eee5808a5$var$INTEGRATION_NAME = 'Debug';
const $4e78184eee5808a5$var$_debugIntegration = (options = {})=>{
    const _options = {
        debugger: false,
        stringify: false,
        ...options
    };
    return {
        name: $4e78184eee5808a5$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!client.on) return;
            client.on('beforeSendEvent', (event, hint)=>{
                if (_options.debugger) // eslint-disable-next-line no-debugger
                debugger;
                /* eslint-disable no-console */ (0, $7I6pg.consoleSandbox)(()=>{
                    if (_options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint && Object.keys(hint).length) console.log(JSON.stringify(hint, null, 2));
                    } else {
                        console.log(event);
                        if (hint && Object.keys(hint).length) console.log(hint);
                    }
                });
            /* eslint-enable no-console */ });
        }
    };
};
const $4e78184eee5808a5$export$6c044612ac549e3 = (0, $dFnv4.defineIntegration)($4e78184eee5808a5$var$_debugIntegration);
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4e78184eee5808a5$export$153e5dc2c098b35c = (0, $dFnv4.convertIntegrationFnToClass)($4e78184eee5808a5$var$INTEGRATION_NAME, $4e78184eee5808a5$export$6c044612ac549e3);

});

parcelRegister("8Ropc", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $01aa2a228ceb35ae$export$6d39aa44cd0c7567);

var $dFnv4 = parcelRequire("dFnv4");

var $7I6pg = parcelRequire("7I6pg");

var $aiWLI = parcelRequire("aiWLI");
const $01aa2a228ceb35ae$var$INTEGRATION_NAME = 'Dedupe';
const $01aa2a228ceb35ae$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $01aa2a228ceb35ae$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($01aa2a228ceb35ae$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $aiWLI.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $01aa2a228ceb35ae$export$6d39aa44cd0c7567 = (0, $dFnv4.defineIntegration)($01aa2a228ceb35ae$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $01aa2a228ceb35ae$export$688d98c249d31ad3 = (0, $dFnv4.convertIntegrationFnToClass)($01aa2a228ceb35ae$var$INTEGRATION_NAME, $01aa2a228ceb35ae$export$6d39aa44cd0c7567);
/** only exported for tests. */ function $01aa2a228ceb35ae$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($01aa2a228ceb35ae$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($01aa2a228ceb35ae$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $01aa2a228ceb35ae$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$01aa2a228ceb35ae$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$01aa2a228ceb35ae$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $01aa2a228ceb35ae$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $01aa2a228ceb35ae$var$_getExceptionFromEvent(previousEvent);
    const currentException = $01aa2a228ceb35ae$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$01aa2a228ceb35ae$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$01aa2a228ceb35ae$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $01aa2a228ceb35ae$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $01aa2a228ceb35ae$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $01aa2a228ceb35ae$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $01aa2a228ceb35ae$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $01aa2a228ceb35ae$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $01aa2a228ceb35ae$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});
parcelRegister("aiWLI", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $78092c06a8a5f4bc$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $78092c06a8a5f4bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("rjBqd", function(module, exports) {
$parcel$export(module.exports, "extraErrorDataIntegration", () => $0521ba651aae668d$export$6e0872131894301d);

var $dFnv4 = parcelRequire("dFnv4");

var $iiQEB = parcelRequire("iiQEB");
var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");
var $bsqJK = parcelRequire("bsqJK");

var $aiWLI = parcelRequire("aiWLI");
const $0521ba651aae668d$var$INTEGRATION_NAME = 'ExtraErrorData';
const $0521ba651aae668d$var$_extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: $0521ba651aae668d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return $0521ba651aae668d$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const $0521ba651aae668d$export$6e0872131894301d = (0, $dFnv4.defineIntegration)($0521ba651aae668d$var$_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $0521ba651aae668d$export$56d961ef3a52a072 = (0, $dFnv4.convertIntegrationFnToClass)($0521ba651aae668d$var$INTEGRATION_NAME, $0521ba651aae668d$export$6e0872131894301d);
function $0521ba651aae668d$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, $9r1pX.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $0521ba651aae668d$var$_extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $bsqJK.normalize)(errorData, depth);
        if ((0, $9r1pX.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $iiQEB.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $0521ba651aae668d$var$_extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $9r1pX.isError)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $9r1pX.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $9r1pX.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $aiWLI.DEBUG_BUILD) && (0, $7I6pg.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});

parcelRegister("7uXTZ", function(module, exports) {
$parcel$export(module.exports, "httpClientIntegration", () => $5759cd0f366a5760$export$8a3b7aeb379b3907);

var $dmS7i = parcelRequire("dmS7i");
var $dFnv4 = parcelRequire("dFnv4");
var $aw6iz = parcelRequire("aw6iz");

var $h7F1u = parcelRequire("h7F1u");
var $dPv3P = parcelRequire("dPv3P");
var $3evL1 = parcelRequire("3evL1");
var $hi3E4 = parcelRequire("hi3E4");
var $7I6pg = parcelRequire("7I6pg");
var $40AKY = parcelRequire("40AKY");

var $aiWLI = parcelRequire("aiWLI");
const $5759cd0f366a5760$var$INTEGRATION_NAME = 'HttpClient';
const $5759cd0f366a5760$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $5759cd0f366a5760$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            $5759cd0f366a5760$var$_wrapFetch(client, _options);
            $5759cd0f366a5760$var$_wrapXHR(client, _options);
        }
    };
};
const $5759cd0f366a5760$export$8a3b7aeb379b3907 = (0, $dFnv4.defineIntegration)($5759cd0f366a5760$var$_httpClientIntegration);
/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5759cd0f366a5760$export$8c6ee871e681f0f4 = (0, $dFnv4.convertIntegrationFnToClass)($5759cd0f366a5760$var$INTEGRATION_NAME, $5759cd0f366a5760$export$8a3b7aeb379b3907);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $5759cd0f366a5760$var$_fetchResponseHandler(options, requestInfo, response, requestInit) {
    if ($5759cd0f366a5760$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $5759cd0f366a5760$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($5759cd0f366a5760$var$_shouldSendDefaultPii()) [{ headers: requestHeaders, cookies: requestCookies }, { headers: responseHeaders, cookies: responseCookies }] = [
            {
                cookieHeader: 'Cookie',
                obj: request
            },
            {
                cookieHeader: 'Set-Cookie',
                obj: response
            }
        ].map(({ cookieHeader: cookieHeader, obj: obj })=>{
            const headers = $5759cd0f366a5760$var$_extractFetchHeaders(obj.headers);
            let cookies;
            try {
                const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
                if (cookieString) cookies = $5759cd0f366a5760$var$_parseCookieString(cookieString);
            } catch (e) {
                (0, $aiWLI.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Could not extract cookies from header ${cookieHeader}`);
            }
            return {
                headers: headers,
                cookies: cookies
            };
        });
        const event = $5759cd0f366a5760$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies
        });
        (0, $dmS7i.captureEvent)(event);
    }
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $5759cd0f366a5760$var$_xhrResponseHandler(options, xhr, method, headers) {
    if ($5759cd0f366a5760$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($5759cd0f366a5760$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $5759cd0f366a5760$var$_parseCookieString(cookieString);
            } catch (e) {
                (0, $aiWLI.DEBUG_BUILD) && (0, $7I6pg.logger).log('Could not extract cookies from response headers');
            }
            try {
                responseHeaders = $5759cd0f366a5760$var$_getXHRResponseHeaders(xhr);
            } catch (e) {
                (0, $aiWLI.DEBUG_BUILD) && (0, $7I6pg.logger).log('Could not extract headers from response');
            }
            requestHeaders = headers;
        }
        const event = $5759cd0f366a5760$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies
        });
        (0, $dmS7i.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $5759cd0f366a5760$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $5759cd0f366a5760$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $5759cd0f366a5760$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $5759cd0f366a5760$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $5759cd0f366a5760$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $5759cd0f366a5760$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $5759cd0f366a5760$var$_wrapFetch(client, options) {
    if (!(0, $40AKY.supportsNativeFetch)()) return;
    (0, $dPv3P.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $dmS7i.getClient)() !== client) return;
        const { response: response, args: args } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $5759cd0f366a5760$var$_fetchResponseHandler(options, requestInfo, response, requestInit);
    });
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $5759cd0f366a5760$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $hi3E4.GLOBAL_OBJ))) return;
    (0, $3evL1.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $dmS7i.getClient)() !== client) return;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $3evL1.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $5759cd0f366a5760$var$_xhrResponseHandler(options, xhr, method, headers);
        } catch (e) {
            (0, $aiWLI.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $5759cd0f366a5760$var$_shouldCaptureResponse(options, status, url) {
    return $5759cd0f366a5760$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $5759cd0f366a5760$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $aw6iz.isSentryRequestUrl)(url, (0, $dmS7i.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $5759cd0f366a5760$var$_createEvent(data) {
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $5759cd0f366a5760$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $h7F1u.addExceptionMechanism)(event, {
        type: 'http.client',
        handled: false
    });
    return event;
}
function $5759cd0f366a5760$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $5759cd0f366a5760$var$_shouldSendDefaultPii() {
    const client = (0, $dmS7i.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

});

parcelRegister("3CqqH", function(module, exports) {
$parcel$export(module.exports, "reportingObserverIntegration", () => $2a296c0f3176022a$export$609cccfa9f328cc5);

var $dmS7i = parcelRequire("dmS7i");
var $dFnv4 = parcelRequire("dFnv4");

var $hi3E4 = parcelRequire("hi3E4");
var $40AKY = parcelRequire("40AKY");
const $2a296c0f3176022a$var$WINDOW = (0, $hi3E4.GLOBAL_OBJ);
const $2a296c0f3176022a$var$INTEGRATION_NAME = 'ReportingObserver';
const $2a296c0f3176022a$var$SETUP_CLIENTS = new WeakMap();
const $2a296c0f3176022a$var$_reportingObserverIntegration = (options = {})=>{
    const types = options.types || [
        'crash',
        'deprecation',
        'intervention'
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!$2a296c0f3176022a$var$SETUP_CLIENTS.has((0, $dmS7i.getClient)())) return;
        for (const report of reports)(0, $dmS7i.withScope)((scope)=>{
            scope.setExtra('url', report.url);
            const label = `ReportingObserver [${report.type}]`;
            let details = 'No details available';
            if (report.body) {
                // Object.keys doesn't work on ReportBody, as all properties are inheirted
                const plainBody = {};
                // eslint-disable-next-line guard-for-in
                for(const prop in report.body)plainBody[prop] = report.body[prop];
                scope.setExtra('body', plainBody);
                if (report.type === 'crash') {
                    const body = report.body;
                    // A fancy way to create a message out of crashId OR reason OR both OR fallback
                    details = [
                        body.crashId || '',
                        body.reason || ''
                    ].join(' ').trim() || details;
                } else {
                    const body = report.body;
                    details = body.message || details;
                }
            }
            (0, $dmS7i.captureMessage)(`${label}: ${details}`);
        });
    }
    return {
        name: $2a296c0f3176022a$var$INTEGRATION_NAME,
        setupOnce () {
            if (!(0, $40AKY.supportsReportingObserver)()) return;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            const observer = new $2a296c0f3176022a$var$WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            observer.observe();
        },
        setup (client) {
            $2a296c0f3176022a$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $2a296c0f3176022a$export$609cccfa9f328cc5 = (0, $dFnv4.defineIntegration)($2a296c0f3176022a$var$_reportingObserverIntegration);
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $2a296c0f3176022a$export$922d48d1e32daf68 = (0, $dFnv4.convertIntegrationFnToClass)($2a296c0f3176022a$var$INTEGRATION_NAME, $2a296c0f3176022a$export$609cccfa9f328cc5);

});

parcelRegister("2J6kR", function(module, exports) {
$parcel$export(module.exports, "rewriteFramesIntegration", () => $1fc4b2d374d3bc42$export$5ed0db6416cb6ea2);

var $dFnv4 = parcelRequire("dFnv4");

var $1SqCr = parcelRequire("1SqCr");
const $1fc4b2d374d3bc42$var$INTEGRATION_NAME = 'RewriteFrames';
const $1fc4b2d374d3bc42$var$_rewriteFramesIntegration = (options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const iteratee = options.iteratee || ((frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $1SqCr.relative)(root, filename) : (0, $1SqCr.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $1fc4b2d374d3bc42$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
const $1fc4b2d374d3bc42$export$5ed0db6416cb6ea2 = (0, $dFnv4.defineIntegration)($1fc4b2d374d3bc42$var$_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1fc4b2d374d3bc42$export$af39fa91d1acf248 = (0, $dFnv4.convertIntegrationFnToClass)($1fc4b2d374d3bc42$var$INTEGRATION_NAME, $1fc4b2d374d3bc42$export$5ed0db6416cb6ea2);

});
parcelRegister("1SqCr", function(module, exports) {
$parcel$export(module.exports, "relative", () => $15df7b98938a7627$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $15df7b98938a7627$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $15df7b98938a7627$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $15df7b98938a7627$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $15df7b98938a7627$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $15df7b98938a7627$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $15df7b98938a7627$export$f7ad0328861e2f03(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $15df7b98938a7627$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $15df7b98938a7627$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $15df7b98938a7627$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $15df7b98938a7627$export$f7ad0328861e2f03(from).slice(1);
    to = $15df7b98938a7627$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $15df7b98938a7627$var$trim(from.split('/'));
    const toParts = $15df7b98938a7627$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $15df7b98938a7627$export$6af368f973c74c5(path) {
    const isPathAbsolute = $15df7b98938a7627$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $15df7b98938a7627$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $15df7b98938a7627$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $15df7b98938a7627$export$f7e2c8231c57a8bd(...args) {
    return $15df7b98938a7627$export$6af368f973c74c5(args.join('/'));
}
/** JSDoc */ function $15df7b98938a7627$export$7f7b8152cc673abe(path) {
    const result = $15df7b98938a7627$var$splitPath(path);
    const root = result[0];
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $15df7b98938a7627$export$9bf319d8f74f51d1(path, ext) {
    let f = $15df7b98938a7627$var$splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

});


parcelRegister("8C1r5", function(module, exports) {
$parcel$export(module.exports, "sessionTimingIntegration", () => $6452fc7b734fa7ec$export$5787162663950c6d);

var $dFnv4 = parcelRequire("dFnv4");
const $6452fc7b734fa7ec$var$INTEGRATION_NAME = 'SessionTiming';
const $6452fc7b734fa7ec$var$_sessionTimingIntegration = ()=>{
    const startTime = Date.now();
    return {
        name: $6452fc7b734fa7ec$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event) {
            const now = Date.now();
            return {
                ...event,
                extra: {
                    ...event.extra,
                    ['session:start']: startTime,
                    ['session:duration']: now - startTime,
                    ['session:end']: now
                }
            };
        }
    };
};
const $6452fc7b734fa7ec$export$5787162663950c6d = (0, $dFnv4.defineIntegration)($6452fc7b734fa7ec$var$_sessionTimingIntegration);
/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6452fc7b734fa7ec$export$43065883b38218d8 = (0, $dFnv4.convertIntegrationFnToClass)($6452fc7b734fa7ec$var$INTEGRATION_NAME, $6452fc7b734fa7ec$export$5787162663950c6d);

});

parcelRegister("b4EUg", function(module, exports) {
$parcel$export(module.exports, "BrowserTracing", () => $0214a45527a24a87$export$46d3bbd0375f5fa4);

var $iCMnl = parcelRequire("iCMnl");
var $dWocc = parcelRequire("dWocc");
var $dmS7i = parcelRequire("dmS7i");
var $2iz3c = parcelRequire("2iz3c");
var $dkCHP = parcelRequire("dkCHP");

var $cx9zm = parcelRequire("cx9zm");
var $7I6pg = parcelRequire("7I6pg");
var $eUr7O = parcelRequire("eUr7O");

var $aNUuF = parcelRequire("aNUuF");

var $b9Kot = parcelRequire("b9Kot");

var $6pOMQ = parcelRequire("6pOMQ");

var $iRvYJ = parcelRequire("iRvYJ");

var $je0dc = parcelRequire("je0dc");

var $8DHE7 = parcelRequire("8DHE7");

var $1xpaI = parcelRequire("1xpaI");
const $0214a45527a24a87$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $0214a45527a24a87$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $dkCHP.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $8DHE7.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $je0dc.defaultRequestInstrumentationOptions)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $0214a45527a24a87$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $0214a45527a24a87$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $0214a45527a24a87$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $iCMnl.addTracingExtensions)();
        if (0, $aNUuF.DEBUG_BUILD) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$0214a45527a24a87$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $iRvYJ.startTrackingWebVitals)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $iRvYJ.startTrackingINP)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $iRvYJ.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $iRvYJ.startTrackingInteractions)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $aNUuF.DEBUG_BUILD) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7I6pg.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $b9Kot.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $je0dc.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $0214a45527a24a87$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $0214a45527a24a87$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $eUr7O.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $1xpaI.WINDOW);
        const idleTransaction = (0, $iCMnl.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $1xpaI.WINDOW).document) {
                (0, $1xpaI.WINDOW).document.addEventListener('readystatechange', ()=>{
                    if ([
                        'interactive',
                        'complete'
                    ].includes((0, $1xpaI.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $1xpaI.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $iRvYJ.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $dWocc.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $1xpaI.WINDOW);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $0214a45527a24a87$var$getSource(this._latestRoute.context) : 'url'
                }
            };
            inflightInteractionTransaction = (0, $iCMnl.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            if ((0, $1xpaI.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $dmS7i.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $dWocc.getActiveTransaction)();
            const currentScope = (0, $dmS7i.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($0214a45527a24a87$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === 'first-input') {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $0214a45527a24a87$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $0214a45527a24a87$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $6pOMQ.addPerformanceInstrumentationHandler)('event', handleEntries);
        (0, $6pOMQ.addPerformanceInstrumentationHandler)('first-input', handleEntries);
    }
}
/** Returns the value of a meta tag */ function $0214a45527a24a87$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $cx9zm.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $0214a45527a24a87$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $0214a45527a24a87$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}

});
parcelRegister("aNUuF", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $7dda4d6d9c08010d$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7dda4d6d9c08010d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("b9Kot", function(module, exports) {
$parcel$export(module.exports, "registerBackgroundTabDetection", () => $81f485c83a2a2075$export$6f18f55521af71a1);

var $dWocc = parcelRequire("dWocc");
var $ajbYg = parcelRequire("ajbYg");

var $7I6pg = parcelRequire("7I6pg");

var $aNUuF = parcelRequire("aNUuF");

var $1xpaI = parcelRequire("1xpaI");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $81f485c83a2a2075$export$6f18f55521af71a1() {
    if ((0, $1xpaI.WINDOW).document) (0, $1xpaI.WINDOW).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $dWocc.getActiveTransaction)();
        if ((0, $1xpaI.WINDOW).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $ajbYg.spanToJSON)(activeTransaction);
            (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});
parcelRegister("1xpaI", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $11ec662047103031$export$56d8a8a25bd48b81);

var $hi3E4 = parcelRequire("hi3E4");
const $11ec662047103031$export$56d8a8a25bd48b81 = (0, $hi3E4.GLOBAL_OBJ);

});


parcelRegister("6pOMQ", function(module, exports) {
$parcel$export(module.exports, "addClsInstrumentationHandler", () => $4abc791494dedd53$export$861b82818b37ba5b);
$parcel$export(module.exports, "addLcpInstrumentationHandler", () => $4abc791494dedd53$export$3fd4b53331200102);
$parcel$export(module.exports, "addTtfbInstrumentationHandler", () => $4abc791494dedd53$export$699d9529c099a797);
$parcel$export(module.exports, "addFidInstrumentationHandler", () => $4abc791494dedd53$export$2707d7471c0b918f);
$parcel$export(module.exports, "addInpInstrumentationHandler", () => $4abc791494dedd53$export$da3b76aa2022cbd7);
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", () => $4abc791494dedd53$export$69816c1a049f8db6);

var $lnX7A = parcelRequire("lnX7A");
var $7I6pg = parcelRequire("7I6pg");

var $aNUuF = parcelRequire("aNUuF");

var $DNJAa = parcelRequire("DNJAa");

var $2O0NT = parcelRequire("2O0NT");

var $bNDM4 = parcelRequire("bNDM4");

var $gZiBR = parcelRequire("gZiBR");

var $6gthQ = parcelRequire("6gthQ");

var $6rlAH = parcelRequire("6rlAH");
const $4abc791494dedd53$var$handlers = {};
const $4abc791494dedd53$var$instrumented = {};
let $4abc791494dedd53$var$_previousCls;
let $4abc791494dedd53$var$_previousFid;
let $4abc791494dedd53$var$_previousLcp;
let $4abc791494dedd53$var$_previousTtfb;
let $4abc791494dedd53$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $4abc791494dedd53$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $4abc791494dedd53$var$addMetricObserver('cls', callback, $4abc791494dedd53$var$instrumentCls, $4abc791494dedd53$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $4abc791494dedd53$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $4abc791494dedd53$var$addMetricObserver('lcp', callback, $4abc791494dedd53$var$instrumentLcp, $4abc791494dedd53$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $4abc791494dedd53$export$699d9529c099a797(callback) {
    return $4abc791494dedd53$var$addMetricObserver('ttfb', callback, $4abc791494dedd53$var$instrumentTtfb, $4abc791494dedd53$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4abc791494dedd53$export$2707d7471c0b918f(callback) {
    return $4abc791494dedd53$var$addMetricObserver('fid', callback, $4abc791494dedd53$var$instrumentFid, $4abc791494dedd53$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4abc791494dedd53$export$da3b76aa2022cbd7(callback) {
    return $4abc791494dedd53$var$addMetricObserver('inp', callback, $4abc791494dedd53$var$instrumentInp, $4abc791494dedd53$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4abc791494dedd53$export$69816c1a049f8db6(type, callback) {
    $4abc791494dedd53$var$addHandler(type, callback);
    if (!$4abc791494dedd53$var$instrumented[type]) {
        $4abc791494dedd53$var$instrumentPerformanceObserver(type);
        $4abc791494dedd53$var$instrumented[type] = true;
    }
    return $4abc791494dedd53$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $4abc791494dedd53$var$triggerHandlers(type, data) {
    const typeHandlers = $4abc791494dedd53$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $lnX7A.getFunctionName)(handler)}\nError:`, e);
    }
}
function $4abc791494dedd53$var$instrumentCls() {
    return (0, $DNJAa.onCLS)((metric)=>{
        $4abc791494dedd53$var$triggerHandlers('cls', {
            metric: metric
        });
        $4abc791494dedd53$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $4abc791494dedd53$var$instrumentFid() {
    return (0, $2O0NT.onFID)((metric)=>{
        $4abc791494dedd53$var$triggerHandlers('fid', {
            metric: metric
        });
        $4abc791494dedd53$var$_previousFid = metric;
    });
}
function $4abc791494dedd53$var$instrumentLcp() {
    return (0, $gZiBR.onLCP)((metric)=>{
        $4abc791494dedd53$var$triggerHandlers('lcp', {
            metric: metric
        });
        $4abc791494dedd53$var$_previousLcp = metric;
    });
}
function $4abc791494dedd53$var$instrumentTtfb() {
    return (0, $6rlAH.onTTFB)((metric)=>{
        $4abc791494dedd53$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $4abc791494dedd53$var$_previousTtfb = metric;
    });
}
function $4abc791494dedd53$var$instrumentInp() {
    return (0, $bNDM4.onINP)((metric)=>{
        $4abc791494dedd53$var$triggerHandlers('inp', {
            metric: metric
        });
        $4abc791494dedd53$var$_previousInp = metric;
    });
}
function $4abc791494dedd53$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $4abc791494dedd53$var$addHandler(type, callback);
    let stopListening;
    if (!$4abc791494dedd53$var$instrumented[type]) {
        stopListening = instrumentFn();
        $4abc791494dedd53$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $4abc791494dedd53$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $4abc791494dedd53$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $6gthQ.observe)(type, (entries)=>{
        $4abc791494dedd53$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $4abc791494dedd53$var$addHandler(type, handler) {
    $4abc791494dedd53$var$handlers[type] = $4abc791494dedd53$var$handlers[type] || [];
    $4abc791494dedd53$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $4abc791494dedd53$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $4abc791494dedd53$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("DNJAa", function(module, exports) {
$parcel$export(module.exports, "onCLS", () => $077a38cefeaf3e20$export$a7873055838e5ad8);

var $eZvtZ = parcelRequire("eZvtZ");

var $b9wAs = parcelRequire("b9wAs");

var $6gthQ = parcelRequire("6gthQ");

var $4fiPy = parcelRequire("4fiPy");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $077a38cefeaf3e20$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $b9wAs.initMetric)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $6gthQ.observe)('layout-shift', handleEntries);
    if (po) {
        report = (0, $eZvtZ.bindReporter)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $4fiPy.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("eZvtZ", function(module, exports) {
$parcel$export(module.exports, "bindReporter", () => $ae9f2f00b407d5af$export$17679dccdd551979);
const $ae9f2f00b407d5af$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("b9wAs", function(module, exports) {
$parcel$export(module.exports, "initMetric", () => $02186a9505828afa$export$3c29b44508a0612b);

var $1xpaI = parcelRequire("1xpaI");

var $5MdwD = parcelRequire("5MdwD");

var $edDXy = parcelRequire("edDXy");

var $dbL4b = parcelRequire("dbL4b");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $02186a9505828afa$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $dbL4b.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $1xpaI.WINDOW).document && (0, $1xpaI.WINDOW).document.prerendering || (0, $edDXy.getActivationStart)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $5MdwD.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("5MdwD", function(module, exports) {
$parcel$export(module.exports, "generateUniqueID", () => $434bed49f7004c3c$export$407ea409d1f3b539);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $434bed49f7004c3c$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("edDXy", function(module, exports) {
$parcel$export(module.exports, "getActivationStart", () => $a5a146b4ad02a9fd$export$d3e828b3c7b5b845);

var $dbL4b = parcelRequire("dbL4b");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a5a146b4ad02a9fd$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $dbL4b.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("dbL4b", function(module, exports) {
$parcel$export(module.exports, "getNavigationEntry", () => $99a0cfe31e83af07$export$6431553786c94949);

var $1xpaI = parcelRequire("1xpaI");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $99a0cfe31e83af07$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $1xpaI.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $1xpaI.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $99a0cfe31e83af07$export$6431553786c94949 = ()=>{
    if ((0, $1xpaI.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $1xpaI.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $99a0cfe31e83af07$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $1xpaI.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};

});



parcelRegister("6gthQ", function(module, exports) {
$parcel$export(module.exports, "observe", () => $48faf4750789522e$export$d1203567a167490e);
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $48faf4750789522e$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("4fiPy", function(module, exports) {
$parcel$export(module.exports, "onHidden", () => $31772b7e096b06e4$export$91ec2be6fdd8f1b4);

var $1xpaI = parcelRequire("1xpaI");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $31772b7e096b06e4$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $1xpaI.WINDOW).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $1xpaI.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};

});


parcelRegister("2O0NT", function(module, exports) {
$parcel$export(module.exports, "onFID", () => $20b0dfe361c58f4d$export$39705a25c49af873);

var $eZvtZ = parcelRequire("eZvtZ");

var $5GlTO = parcelRequire("5GlTO");

var $b9wAs = parcelRequire("b9wAs");

var $6gthQ = parcelRequire("6gthQ");

var $4fiPy = parcelRequire("4fiPy");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $20b0dfe361c58f4d$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $5GlTO.getVisibilityWatcher)();
    const metric = (0, $b9wAs.initMetric)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $6gthQ.observe)('first-input', handleEntries);
    report = (0, $eZvtZ.bindReporter)(onReport, metric);
    if (po) (0, $4fiPy.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("5GlTO", function(module, exports) {
$parcel$export(module.exports, "getVisibilityWatcher", () => $4231dcb41b33b99d$export$443f86b2c77012c4);

var $1xpaI = parcelRequire("1xpaI");

var $4fiPy = parcelRequire("4fiPy");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $4231dcb41b33b99d$var$firstHiddenTime = -1;
const $4231dcb41b33b99d$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $1xpaI.WINDOW).document && (0, $1xpaI.WINDOW).document.visibilityState) $4231dcb41b33b99d$var$firstHiddenTime = (0, $1xpaI.WINDOW).document.visibilityState === 'hidden' && !(0, $1xpaI.WINDOW).document.prerendering ? 0 : Infinity;
};
const $4231dcb41b33b99d$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $4fiPy.onHidden)(({ timeStamp: timeStamp })=>{
        $4231dcb41b33b99d$var$firstHiddenTime = timeStamp;
    }, true);
};
const $4231dcb41b33b99d$export$443f86b2c77012c4 = ()=>{
    if ($4231dcb41b33b99d$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $4231dcb41b33b99d$var$initHiddenTime();
        $4231dcb41b33b99d$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $4231dcb41b33b99d$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("bNDM4", function(module, exports) {
$parcel$export(module.exports, "onINP", () => $89731facd8536856$export$7df4b36ecaed99e1);

var $eZvtZ = parcelRequire("eZvtZ");

var $b9wAs = parcelRequire("b9wAs");

var $6gthQ = parcelRequire("6gthQ");

var $4fiPy = parcelRequire("4fiPy");

var $e1MoK = parcelRequire("e1MoK");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $89731facd8536856$var$getInteractionCountForNavigation = ()=>{
    return (0, $e1MoK.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $89731facd8536856$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $89731facd8536856$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $89731facd8536856$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $89731facd8536856$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $89731facd8536856$var$longestInteractionList[$89731facd8536856$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $89731facd8536856$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $89731facd8536856$var$longestInteractionList.length < $89731facd8536856$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $89731facd8536856$var$longestInteractionMap[interaction.id] = interaction;
            $89731facd8536856$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $89731facd8536856$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $89731facd8536856$var$longestInteractionList.splice($89731facd8536856$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $89731facd8536856$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $89731facd8536856$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($89731facd8536856$var$longestInteractionList.length - 1, Math.floor($89731facd8536856$var$getInteractionCountForNavigation() / 50));
    return $89731facd8536856$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $89731facd8536856$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $e1MoK.initInteractionCountPolyfill)();
    const metric = (0, $b9wAs.initMetric)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $89731facd8536856$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$89731facd8536856$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $89731facd8536856$var$processEntry(entry);
            }
        });
        const inp = $89731facd8536856$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $6gthQ.observe)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $eZvtZ.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $4fiPy.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $89731facd8536856$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

});
parcelRegister("e1MoK", function(module, exports) {
$parcel$export(module.exports, "getInteractionCount", () => $a366b393670acb9d$export$8a962f2683a476d1);
$parcel$export(module.exports, "initInteractionCountPolyfill", () => $a366b393670acb9d$export$67d90cda6b78a2eb);

var $6gthQ = parcelRequire("6gthQ");
let $a366b393670acb9d$var$interactionCountEstimate = 0;
let $a366b393670acb9d$var$minKnownInteractionId = Infinity;
let $a366b393670acb9d$var$maxKnownInteractionId = 0;
const $a366b393670acb9d$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $a366b393670acb9d$var$minKnownInteractionId = Math.min($a366b393670acb9d$var$minKnownInteractionId, e.interactionId);
            $a366b393670acb9d$var$maxKnownInteractionId = Math.max($a366b393670acb9d$var$maxKnownInteractionId, e.interactionId);
            $a366b393670acb9d$var$interactionCountEstimate = $a366b393670acb9d$var$maxKnownInteractionId ? ($a366b393670acb9d$var$maxKnownInteractionId - $a366b393670acb9d$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $a366b393670acb9d$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $a366b393670acb9d$export$8a962f2683a476d1 = ()=>{
    return $a366b393670acb9d$var$po ? $a366b393670acb9d$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $a366b393670acb9d$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $a366b393670acb9d$var$po) return;
    $a366b393670acb9d$var$po = (0, $6gthQ.observe)('event', $a366b393670acb9d$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("gZiBR", function(module, exports) {
$parcel$export(module.exports, "onLCP", () => $c5e0c7529aee9c5f$export$947b1626ab8d5632);

var $1xpaI = parcelRequire("1xpaI");

var $eZvtZ = parcelRequire("eZvtZ");

var $edDXy = parcelRequire("edDXy");

var $5GlTO = parcelRequire("5GlTO");

var $b9wAs = parcelRequire("b9wAs");

var $6gthQ = parcelRequire("6gthQ");

var $4fiPy = parcelRequire("4fiPy");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c5e0c7529aee9c5f$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $c5e0c7529aee9c5f$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $5GlTO.getVisibilityWatcher)();
    const metric = (0, $b9wAs.initMetric)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $edDXy.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $6gthQ.observe)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $eZvtZ.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$c5e0c7529aee9c5f$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $c5e0c7529aee9c5f$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $1xpaI.WINDOW).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $4fiPy.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("6rlAH", function(module, exports) {
$parcel$export(module.exports, "onTTFB", () => $4b06032ebdfc8a07$export$33a01e6c5f2c7e33);

var $1xpaI = parcelRequire("1xpaI");

var $eZvtZ = parcelRequire("eZvtZ");

var $edDXy = parcelRequire("edDXy");

var $dbL4b = parcelRequire("dbL4b");

var $b9wAs = parcelRequire("b9wAs");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $4b06032ebdfc8a07$var$whenReady = (callback)=>{
    if (!(0, $1xpaI.WINDOW).document) return;
    if ((0, $1xpaI.WINDOW).document.prerendering) addEventListener('prerenderingchange', ()=>$4b06032ebdfc8a07$var$whenReady(callback), true);
    else if ((0, $1xpaI.WINDOW).document.readyState !== 'complete') addEventListener('load', ()=>$4b06032ebdfc8a07$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $4b06032ebdfc8a07$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $b9wAs.initMetric)('TTFB');
    const report = (0, $eZvtZ.bindReporter)(onReport, metric, opts.reportAllChanges);
    $4b06032ebdfc8a07$var$whenReady(()=>{
        const navEntry = (0, $dbL4b.getNavigationEntry)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $edDXy.getActivationStart)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

});


parcelRegister("iRvYJ", function(module, exports) {
$parcel$export(module.exports, "startTrackingWebVitals", () => $dbb5fb7d8bd0bec4$export$7c69f0412d101b88);
$parcel$export(module.exports, "startTrackingLongTasks", () => $dbb5fb7d8bd0bec4$export$f396d19077034ad2);
$parcel$export(module.exports, "startTrackingInteractions", () => $dbb5fb7d8bd0bec4$export$e27543e0976315e4);
$parcel$export(module.exports, "startTrackingINP", () => $dbb5fb7d8bd0bec4$export$f17d06681a4744a3);
$parcel$export(module.exports, "addPerformanceEntries", () => $dbb5fb7d8bd0bec4$export$5f8fa6b3467a7443);

var $5xyU1 = parcelRequire("5xyU1");
var $dWocc = parcelRequire("dWocc");
var $dmS7i = parcelRequire("dmS7i");
var $6B8d6 = parcelRequire("6B8d6");
var $4iC5n = parcelRequire("4iC5n");
var $chwAd = parcelRequire("chwAd");
var $ijnVc = parcelRequire("ijnVc");
var $ajbYg = parcelRequire("ajbYg");

var $8t2EY = parcelRequire("8t2EY");
var $cx9zm = parcelRequire("cx9zm");
var $7I6pg = parcelRequire("7I6pg");
var $rcz3w = parcelRequire("rcz3w");

var $aNUuF = parcelRequire("aNUuF");

var $6pOMQ = parcelRequire("6pOMQ");

var $1xpaI = parcelRequire("1xpaI");

var $5GlTO = parcelRequire("5GlTO");

var $cIIXj = parcelRequire("cIIXj");

var $dbL4b = parcelRequire("dbL4b");
const $dbb5fb7d8bd0bec4$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $dbb5fb7d8bd0bec4$var$msToSec(time) {
    return time / 1000;
}
function $dbb5fb7d8bd0bec4$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $1xpaI.WINDOW) && (0, $1xpaI.WINDOW).addEventListener && (0, $1xpaI.WINDOW).performance;
}
let $dbb5fb7d8bd0bec4$var$_performanceCursor = 0;
let $dbb5fb7d8bd0bec4$var$_measurements = {};
let $dbb5fb7d8bd0bec4$var$_lcpEntry;
let $dbb5fb7d8bd0bec4$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $dbb5fb7d8bd0bec4$export$7c69f0412d101b88() {
    const performance = $dbb5fb7d8bd0bec4$var$getBrowserPerformanceAPI();
    if (performance && (0, $8t2EY.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $1xpaI.WINDOW).performance.mark('sentry-tracing-init');
        const fidCallback = $dbb5fb7d8bd0bec4$var$_trackFID();
        const clsCallback = $dbb5fb7d8bd0bec4$var$_trackCLS();
        const lcpCallback = $dbb5fb7d8bd0bec4$var$_trackLCP();
        const ttfbCallback = $dbb5fb7d8bd0bec4$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $dbb5fb7d8bd0bec4$export$f396d19077034ad2() {
    (0, $6pOMQ.addPerformanceInstrumentationHandler)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $dWocc.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $dbb5fb7d8bd0bec4$var$msToSec((0, $8t2EY.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $dbb5fb7d8bd0bec4$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $dbb5fb7d8bd0bec4$export$e27543e0976315e4() {
    (0, $6pOMQ.addPerformanceInstrumentationHandler)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $dWocc.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $dbb5fb7d8bd0bec4$var$msToSec((0, $8t2EY.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $dbb5fb7d8bd0bec4$var$msToSec(entry.duration);
                const span = {
                    description: (0, $cx9zm.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $cx9zm.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $dbb5fb7d8bd0bec4$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $dbb5fb7d8bd0bec4$var$getBrowserPerformanceAPI();
    if (performance && (0, $8t2EY.browserPerformanceTimeOrigin)) {
        const inpCallback = $dbb5fb7d8bd0bec4$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $dbb5fb7d8bd0bec4$var$_trackCLS() {
    return (0, $6pOMQ.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding CLS');
        $dbb5fb7d8bd0bec4$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $dbb5fb7d8bd0bec4$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $dbb5fb7d8bd0bec4$var$_trackLCP() {
    return (0, $6pOMQ.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding LCP');
        $dbb5fb7d8bd0bec4$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $dbb5fb7d8bd0bec4$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $dbb5fb7d8bd0bec4$var$_trackFID() {
    return (0, $6pOMQ.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $dbb5fb7d8bd0bec4$var$msToSec((0, $8t2EY.browserPerformanceTimeOrigin));
        const startTime = $dbb5fb7d8bd0bec4$var$msToSec(entry.startTime);
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding FID');
        $dbb5fb7d8bd0bec4$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $dbb5fb7d8bd0bec4$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $dbb5fb7d8bd0bec4$var$_trackTtfb() {
    return (0, $6pOMQ.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding TTFB');
        $dbb5fb7d8bd0bec4$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $dbb5fb7d8bd0bec4$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $dbb5fb7d8bd0bec4$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $6pOMQ.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $dbb5fb7d8bd0bec4$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $dmS7i.getClient)();
        if (!entry || !client) return;
        const interactionType = $dbb5fb7d8bd0bec4$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $dbb5fb7d8bd0bec4$var$msToSec((0, $8t2EY.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $dbb5fb7d8bd0bec4$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $ijnVc.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $cx9zm.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $dbb5fb7d8bd0bec4$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $5xyU1.createSpanEnvelope)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $dbb5fb7d8bd0bec4$export$5f8fa6b3467a7443(transaction) {
    const performance = $dbb5fb7d8bd0bec4$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $1xpaI.WINDOW).performance.getEntries || !(0, $8t2EY.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $dbb5fb7d8bd0bec4$var$msToSec((0, $8t2EY.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $ajbYg.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($dbb5fb7d8bd0bec4$var$_performanceCursor).forEach((entry)=>{
        const startTime = $dbb5fb7d8bd0bec4$var$msToSec(entry.startTime);
        const duration = $dbb5fb7d8bd0bec4$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $dbb5fb7d8bd0bec4$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $dbb5fb7d8bd0bec4$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $5GlTO.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding FP');
                        $dbb5fb7d8bd0bec4$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding FCP');
                        $dbb5fb7d8bd0bec4$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $dbb5fb7d8bd0bec4$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $dbb5fb7d8bd0bec4$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $dbb5fb7d8bd0bec4$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $dbb5fb7d8bd0bec4$var$_addTtfbRequestTimeToMeasurements($dbb5fb7d8bd0bec4$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$dbb5fb7d8bd0bec4$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $dbb5fb7d8bd0bec4$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $dbb5fb7d8bd0bec4$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $dbb5fb7d8bd0bec4$var$_measurements['mark.fid'];
        if (fidMark && $dbb5fb7d8bd0bec4$var$_measurements['fid']) {
            // create span for FID
            (0, $cIIXj._startChild)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $dbb5fb7d8bd0bec4$var$msToSec($dbb5fb7d8bd0bec4$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $dbb5fb7d8bd0bec4$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $dbb5fb7d8bd0bec4$var$_measurements)) delete $dbb5fb7d8bd0bec4$var$_measurements.cls;
        Object.keys($dbb5fb7d8bd0bec4$var$_measurements).forEach((measurementName)=>{
            (0, $chwAd.setMeasurement)(measurementName, $dbb5fb7d8bd0bec4$var$_measurements[measurementName].value, $dbb5fb7d8bd0bec4$var$_measurements[measurementName].unit);
        });
        $dbb5fb7d8bd0bec4$var$_tagMetricInfo(transaction);
    }
    $dbb5fb7d8bd0bec4$var$_lcpEntry = undefined;
    $dbb5fb7d8bd0bec4$var$_clsEntry = undefined;
    $dbb5fb7d8bd0bec4$var$_measurements = {};
}
/** Create measure related spans */ function $dbb5fb7d8bd0bec4$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $cIIXj._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dbb5fb7d8bd0bec4$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $dbb5fb7d8bd0bec4$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $dbb5fb7d8bd0bec4$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $dbb5fb7d8bd0bec4$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $dbb5fb7d8bd0bec4$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $dbb5fb7d8bd0bec4$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $dbb5fb7d8bd0bec4$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $cIIXj._startChild)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(start),
        endTimestamp: timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dbb5fb7d8bd0bec4$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $cIIXj._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(entry.responseEnd)
        });
        (0, $cIIXj._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $dbb5fb7d8bd0bec4$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $dbb5fb7d8bd0bec4$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $rcz3w.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $dbb5fb7d8bd0bec4$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $dbb5fb7d8bd0bec4$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $dbb5fb7d8bd0bec4$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $1xpaI.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $cIIXj._startChild)(transaction, {
        description: resourceUrl.replace((0, $1xpaI.WINDOW).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $dbb5fb7d8bd0bec4$var$_trackNavigator(transaction) {
    const navigator = (0, $1xpaI.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $cIIXj.isMeasurementValue)(connection.rtt)) $dbb5fb7d8bd0bec4$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $cIIXj.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $cIIXj.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $dbb5fb7d8bd0bec4$var$_tagMetricInfo(transaction) {
    if ($dbb5fb7d8bd0bec4$var$_lcpEntry) {
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($dbb5fb7d8bd0bec4$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $cx9zm.htmlTreeAsString)($dbb5fb7d8bd0bec4$var$_lcpEntry.element));
        if ($dbb5fb7d8bd0bec4$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $dbb5fb7d8bd0bec4$var$_lcpEntry.id);
        if ($dbb5fb7d8bd0bec4$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $dbb5fb7d8bd0bec4$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $dbb5fb7d8bd0bec4$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($dbb5fb7d8bd0bec4$var$_clsEntry && $dbb5fb7d8bd0bec4$var$_clsEntry.sources) {
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding CLS Data');
        $dbb5fb7d8bd0bec4$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $cx9zm.htmlTreeAsString)(source.node)));
    }
}
function $dbb5fb7d8bd0bec4$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $dbb5fb7d8bd0bec4$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $dbb5fb7d8bd0bec4$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $dbL4b.getNavigationEntry)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $dbb5fb7d8bd0bec4$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $6B8d6.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $1xpaI.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $4iC5n.isValidSampleRate)(sampleRate)) {
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}

});
parcelRegister("cIIXj", function(module, exports) {
$parcel$export(module.exports, "isMeasurementValue", () => $942c775bfebf81a4$export$27169ccae1b439e3);
$parcel$export(module.exports, "_startChild", () => $942c775bfebf81a4$export$8bd469e1f37aa721);
/**
 * Checks if a given value is a valid measurement value.
 */ function $942c775bfebf81a4$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $942c775bfebf81a4$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("je0dc", function(module, exports) {
$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => $dfef7d3572e1ddb6$export$cc17fb3c0bc95cd7);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => $dfef7d3572e1ddb6$export$864489cb3478db3e);

var $dmS7i = parcelRequire("dmS7i");
var $aw8s7 = parcelRequire("aw8s7");
var $84Maa = parcelRequire("84Maa");
var $6B8d6 = parcelRequire("6B8d6");
var $2iz3c = parcelRequire("2iz3c");
var $c40Kr = parcelRequire("c40Kr");
var $ajbYg = parcelRequire("ajbYg");
var $9lKdF = parcelRequire("9lKdF");

var $dPv3P = parcelRequire("dPv3P");
var $3evL1 = parcelRequire("3evL1");
var $94mso = parcelRequire("94mso");
var $8t2EY = parcelRequire("8t2EY");
var $eUr7O = parcelRequire("eUr7O");
var $rcz3w = parcelRequire("rcz3w");
var $4TtIy = parcelRequire("4TtIy");

var $4sgy7 = parcelRequire("4sgy7");

var $6pOMQ = parcelRequire("6pOMQ");

var $1xpaI = parcelRequire("1xpaI");
/* eslint-disable max-lines */ const $dfef7d3572e1ddb6$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $dfef7d3572e1ddb6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $dfef7d3572e1ddb6$export$15bd0305d05ad07b,
    tracePropagationTargets: $dfef7d3572e1ddb6$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $dfef7d3572e1ddb6$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $dfef7d3572e1ddb6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $dfef7d3572e1ddb6$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$dfef7d3572e1ddb6$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $dPv3P.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $4sgy7.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $dfef7d3572e1ddb6$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $rcz3w.parseUrl)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $dfef7d3572e1ddb6$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $3evL1.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $dfef7d3572e1ddb6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $dfef7d3572e1ddb6$var$addHTTPTimings(createdSpan);
    });
}
function $dfef7d3572e1ddb6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $dfef7d3572e1ddb6$var$addHTTPTimings(span) {
    const { url: url } = (0, $ajbYg.spanToJSON)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $6pOMQ.addPerformanceInstrumentationHandler)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($dfef7d3572e1ddb6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $dfef7d3572e1ddb6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $dfef7d3572e1ddb6$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $dfef7d3572e1ddb6$var$getAbsoluteTime(time = 0) {
    return (((0, $8t2EY.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $dfef7d3572e1ddb6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $dfef7d3572e1ddb6$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $8t2EY.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $dfef7d3572e1ddb6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $dfef7d3572e1ddb6$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $4TtIy.stringMatchesSomePattern)(url, tracePropagationTargets || $dfef7d3572e1ddb6$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $dfef7d3572e1ddb6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $3evL1.SENTRY_XHR_DATA_KEY];
    if (!(0, $6B8d6.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $c40Kr.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $dmS7i.getCurrentScope)();
    const isolationScope = (0, $84Maa.getIsolationScope)();
    const fullUrl = $dfef7d3572e1ddb6$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $rcz3w.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $9lKdF.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $dmS7i.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $ajbYg.spanToTraceHeader)(span) : (0, $eUr7O.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $94mso.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $aw8s7.getDynamicSamplingContextFromSpan)(span) : (0, $aw8s7.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $dfef7d3572e1ddb6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $dfef7d3572e1ddb6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $94mso.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $dfef7d3572e1ddb6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $1xpaI.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}

});
parcelRegister("4sgy7", function(module, exports) {
$parcel$export(module.exports, "instrumentFetchRequest", () => $33e69d4b1d565a1f$export$6d73c62358c655be);

var $dmS7i = parcelRequire("dmS7i");
var $aw8s7 = parcelRequire("aw8s7");
var $84Maa = parcelRequire("84Maa");
var $6B8d6 = parcelRequire("6B8d6");
var $2iz3c = parcelRequire("2iz3c");
var $c40Kr = parcelRequire("c40Kr");
var $ajbYg = parcelRequire("ajbYg");
var $9lKdF = parcelRequire("9lKdF");

var $94mso = parcelRequire("94mso");
var $eUr7O = parcelRequire("eUr7O");
var $9r1pX = parcelRequire("9r1pX");
var $rcz3w = parcelRequire("rcz3w");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $33e69d4b1d565a1f$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $6B8d6.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $33e69d4b1d565a1f$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $dmS7i.getCurrentScope)();
    const client = (0, $dmS7i.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $33e69d4b1d565a1f$var$getFullURL(url);
    const host = fullUrl ? (0, $rcz3w.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $9lKdF.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $33e69d4b1d565a1f$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $33e69d4b1d565a1f$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $84Maa.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $ajbYg.spanToTraceHeader)(span) : (0, $eUr7O.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $94mso.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $aw8s7.getDynamicSamplingContextFromSpan)(span) : (0, $aw8s7.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $9r1pX.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $9r1pX.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $94mso.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $94mso.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $33e69d4b1d565a1f$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $33e69d4b1d565a1f$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $c40Kr.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}

});


parcelRegister("8DHE7", function(module, exports) {
$parcel$export(module.exports, "instrumentRoutingWithDefaults", () => $64a3d26fac87572e$export$86649cc09fe75143);

var $4rg5W = parcelRequire("4rg5W");
var $8t2EY = parcelRequire("8t2EY");
var $7I6pg = parcelRequire("7I6pg");

var $aNUuF = parcelRequire("aNUuF");

var $1xpaI = parcelRequire("1xpaI");
/**
 * Default function implementing pageload and navigation transactions
 */ function $64a3d26fac87572e$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $1xpaI.WINDOW) || !(0, $1xpaI.WINDOW).location) {
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $1xpaI.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $1xpaI.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $8t2EY.browserPerformanceTimeOrigin) ? (0, $8t2EY.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $4rg5W.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $1xpaI.WINDOW).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}

});


parcelRegister("h3C2f", function(module, exports) {
$parcel$export(module.exports, "browserTracingIntegration", () => $c6b03883f77e682f$export$b4109253475213e9);
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", () => $c6b03883f77e682f$export$aa44a07f82af519f);
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", () => $c6b03883f77e682f$export$7d159749bd9969ad);

var $iCMnl = parcelRequire("iCMnl");
var $9lKdF = parcelRequire("9lKdF");
var $dWocc = parcelRequire("dWocc");
var $dmS7i = parcelRequire("dmS7i");
var $84Maa = parcelRequire("84Maa");
var $2iz3c = parcelRequire("2iz3c");
var $ajbYg = parcelRequire("ajbYg");
var $dkCHP = parcelRequire("dkCHP");

var $4rg5W = parcelRequire("4rg5W");
var $8t2EY = parcelRequire("8t2EY");
var $cx9zm = parcelRequire("cx9zm");
var $7I6pg = parcelRequire("7I6pg");
var $eUr7O = parcelRequire("eUr7O");

var $aNUuF = parcelRequire("aNUuF");

var $b9Kot = parcelRequire("b9Kot");

var $6pOMQ = parcelRequire("6pOMQ");

var $iRvYJ = parcelRequire("iRvYJ");

var $je0dc = parcelRequire("je0dc");

var $1xpaI = parcelRequire("1xpaI");
const $c6b03883f77e682f$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $c6b03883f77e682f$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $dkCHP.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $je0dc.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $c6b03883f77e682f$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $aNUuF.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $iCMnl.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$c6b03883f77e682f$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $iRvYJ.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $iRvYJ.startTrackingINP)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $iRvYJ.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, $iRvYJ.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $84Maa.getCurrentHub)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $c6b03883f77e682f$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $c6b03883f77e682f$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $eUr7O.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $1xpaI.WINDOW);
        const idleTransaction = (0, $iCMnl.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $1xpaI.WINDOW).document) {
            (0, $1xpaI.WINDOW).document.addEventListener('readystatechange', ()=>{
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $1xpaI.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                'interactive',
                'complete'
            ].includes((0, $1xpaI.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $iRvYJ.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $c6b03883f77e682f$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $aNUuF.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7I6pg.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
            let activeSpan;
            let startingUrl = (0, $1xpaI.WINDOW).location && (0, $1xpaI.WINDOW).location.href;
            if (client.on) {
                client.on('startNavigationSpan', (context)=>{
                    if (activeSpan) {
                        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $ajbYg.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'navigation',
                        ...context
                    });
                });
                client.on('startPageLoadSpan', (context)=>{
                    if (activeSpan) {
                        (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $ajbYg.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'pageload',
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $1xpaI.WINDOW).location) {
                const context = {
                    name: (0, $1xpaI.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $8t2EY.browserPerformanceTimeOrigin) ? (0, $8t2EY.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: 'auto.pageload.browser',
                    attributes: {
                        [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
                    }
                };
                $c6b03883f77e682f$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $1xpaI.WINDOW).location) (0, $4rg5W.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $1xpaI.WINDOW).location.pathname,
                        origin: 'auto.navigation.browser',
                        attributes: {
                            [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
                        }
                    };
                    $c6b03883f77e682f$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $b9Kot.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) $c6b03883f77e682f$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $c6b03883f77e682f$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $je0dc.instrumentOutgoingRequests)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $c6b03883f77e682f$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startPageLoadSpan', spanOptions);
    const span = (0, $9lKdF.getActiveSpan)();
    const op = span && (0, $ajbYg.spanToJSON)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $c6b03883f77e682f$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startNavigationSpan', spanOptions);
    const span = (0, $9lKdF.getActiveSpan)();
    const op = span && (0, $ajbYg.spanToJSON)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $c6b03883f77e682f$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $cx9zm.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $c6b03883f77e682f$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = 'ui.action.click';
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $dWocc.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            'navigation',
            'pageload'
        ].includes(currentTransaction.op)) {
            (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason('interactionInterrupted');
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $aNUuF.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $1xpaI.WINDOW);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.context ? $c6b03883f77e682f$var$getSource(latestRoute.context) : 'url'
            }
        };
        inflightInteractionTransaction = (0, $iCMnl.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, $84Maa.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        'click'
    ].forEach((type)=>{
        if ((0, $1xpaI.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $c6b03883f77e682f$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $c6b03883f77e682f$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $c6b03883f77e682f$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $dmS7i.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $dWocc.getActiveTransaction)();
        const currentScope = (0, $dmS7i.getCurrentScope)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($c6b03883f77e682f$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === 'first-input') {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $c6b03883f77e682f$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $c6b03883f77e682f$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $6pOMQ.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, $6pOMQ.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}
function $c6b03883f77e682f$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $2iz3c.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

});

parcelRegister("crjkJ", function(module, exports) {
$parcel$export(module.exports, "makeBrowserOfflineTransport", () => $90e700dcbe3e461c$export$79c8882827636cf2);

var $2CFWY = parcelRequire("2CFWY");

var $eoF3x = parcelRequire("eoF3x");
// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $90e700dcbe3e461c$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
/** Create or open an IndexedDb store */ function $90e700dcbe3e461c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $90e700dcbe3e461c$var$promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, 'readwrite').objectStore(storeName)));
}
function $90e700dcbe3e461c$var$keys(store) {
    return $90e700dcbe3e461c$var$promisifyRequest(store.getAllKeys());
}
/** Insert into the store */ function $90e700dcbe3e461c$export$21a5ca8aa77d35ff(store, value, maxQueueSize) {
    return store((store)=>{
        return $90e700dcbe3e461c$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, Math.max(...keys, 0) + 1);
            return $90e700dcbe3e461c$var$promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function $90e700dcbe3e461c$export$3e41007ebfff0e64(store) {
    return store((store)=>{
        return $90e700dcbe3e461c$var$keys(store).then((keys)=>{
            if (keys.length === 0) return undefined;
            return $90e700dcbe3e461c$var$promisifyRequest(store.get(keys[0])).then((value)=>{
                store.delete(keys[0]);
                return $90e700dcbe3e461c$var$promisifyRequest(store.transaction).then(()=>value);
            });
        });
    });
}
function $90e700dcbe3e461c$var$createIndexedDbStore(options) {
    let store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = $90e700dcbe3e461c$export$f51a9068ac82ea43(options.dbName || 'sentry-offline', options.storeName || 'queue');
        return store;
    }
    return {
        insert: async (env)=>{
            try {
                const serialized = await (0, $eoF3x.serializeEnvelope)(env, options.textEncoder);
                await $90e700dcbe3e461c$export$21a5ca8aa77d35ff(getStore(), serialized, options.maxQueueSize || 30);
            } catch (_) {
            //
            }
        },
        pop: async ()=>{
            try {
                const deserialized = await $90e700dcbe3e461c$export$3e41007ebfff0e64(getStore());
                if (deserialized) return (0, $eoF3x.parseEnvelope)(deserialized, options.textEncoder || new TextEncoder(), options.textDecoder || new TextDecoder());
            } catch (_) {
            //
            }
            return undefined;
        }
    };
}
function $90e700dcbe3e461c$var$makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>createTransport({
            ...options,
            createStore: $90e700dcbe3e461c$var$createIndexedDbStore
        });
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function $90e700dcbe3e461c$export$79c8882827636cf2(createTransport) {
    return $90e700dcbe3e461c$var$makeIndexedDbOfflineTransport((0, $2CFWY.makeOfflineTransport)(createTransport));
}

});

parcelRegister("4ylGE", function(module, exports) {
$parcel$export(module.exports, "onProfilingStartRouteTransaction", () => $350b28fc4f393028$export$410ca53b300571c6);
$parcel$export(module.exports, "startProfileForTransaction", () => $350b28fc4f393028$export$a5c90b2530e76e64);

var $ajbYg = parcelRequire("ajbYg");

var $7I6pg = parcelRequire("7I6pg");
var $8t2EY = parcelRequire("8t2EY");
var $h7F1u = parcelRequire("h7F1u");

var $3gMoL = parcelRequire("3gMoL");

var $2TIK5 = parcelRequire("2TIK5");

var $a306A = parcelRequire("a306A");
/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function $350b28fc4f393028$export$410ca53b300571c6(transaction) {
    if (!transaction) {
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] Transaction is undefined, skipping profiling');
        return transaction;
    }
    if ((0, $a306A.shouldProfileTransaction)(transaction)) return $350b28fc4f393028$export$a5c90b2530e76e64(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $350b28fc4f393028$export$a5c90b2530e76e64(transaction) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $a306A.isAutomatedPageLoadTransaction)(transaction)) startTimestamp = (0, $8t2EY.timestampInSeconds)() * 1000;
    const profiler = (0, $a306A.startJSSelfProfile)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log(`[Profiling] started profiling transaction: ${(0, $ajbYg.spanToJSON)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $h7F1u.uuid4)();
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
        if (!transaction) return null;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return null;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $2TIK5.WINDOW).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log(`[Profiling] stopped profiling of transaction: ${(0, $ajbYg.spanToJSON)(transaction).description}`);
            // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log(`[Profiling] profiler returned null profile for: ${(0, $ajbYg.spanToJSON)(transaction).description}`, 'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started');
                return null;
            }
            (0, $a306A.addProfileToGlobalCache)(profileId, profile);
            return null;
        }).catch((error)=>{
            if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] error while stopping profiler:', error);
            return null;
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $2TIK5.WINDOW).setTimeout(()=>{
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] max profile duration elapsed, stopping profiling for:', (0, $ajbYg.spanToJSON)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $a306A.MAX_PROFILE_DURATION_MS));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext('profile', {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}

});
parcelRegister("a306A", function(module, exports) {
$parcel$export(module.exports, "isAutomatedPageLoadTransaction", () => $750a441a204e3a37$export$7c501dd6adb8177c);
$parcel$export(module.exports, "addProfilesToEnvelope", () => $750a441a204e3a37$export$4df36760a75f76bc);
$parcel$export(module.exports, "findProfiledTransactionsFromEnvelope", () => $750a441a204e3a37$export$df9bb0fc214ff8cd);
$parcel$export(module.exports, "MAX_PROFILE_DURATION_MS", () => $750a441a204e3a37$export$8640c0b5c7d98a81);
$parcel$export(module.exports, "startJSSelfProfile", () => $750a441a204e3a37$export$9f4f648547a4284f);
$parcel$export(module.exports, "shouldProfileTransaction", () => $750a441a204e3a37$export$ea6683c0c72c1201);
$parcel$export(module.exports, "createProfilingEvent", () => $750a441a204e3a37$export$5c2c5e805edd874f);
$parcel$export(module.exports, "getActiveProfilesCount", () => $750a441a204e3a37$export$9d723f414195854a);
$parcel$export(module.exports, "takeProfileFromGlobalCache", () => $750a441a204e3a37$export$6285310796363de1);
$parcel$export(module.exports, "addProfileToGlobalCache", () => $750a441a204e3a37$export$7ddae68097f7e530);

var $gh9LO = parcelRequire("gh9LO");
var $dmS7i = parcelRequire("dmS7i");

var $8t2EY = parcelRequire("8t2EY");
var $eoF3x = parcelRequire("eoF3x");
var $hi3E4 = parcelRequire("hi3E4");
var $7I6pg = parcelRequire("7I6pg");
var $h7F1u = parcelRequire("h7F1u");

var $3gMoL = parcelRequire("3gMoL");

var $2TIK5 = parcelRequire("2TIK5");
/* eslint-disable max-lines */ const $750a441a204e3a37$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $750a441a204e3a37$var$THREAD_ID_STRING = String(0);
const $750a441a204e3a37$var$THREAD_NAME = 'main';
// Machine properties (eval only once)
let $750a441a204e3a37$var$OS_PLATFORM = '';
let $750a441a204e3a37$var$OS_PLATFORM_VERSION = '';
let $750a441a204e3a37$var$OS_ARCH = '';
let $750a441a204e3a37$var$OS_BROWSER = (0, $2TIK5.WINDOW).navigator && (0, $2TIK5.WINDOW).navigator.userAgent || '';
let $750a441a204e3a37$var$OS_MODEL = '';
const $750a441a204e3a37$var$OS_LOCALE = (0, $2TIK5.WINDOW).navigator && (0, $2TIK5.WINDOW).navigator.language || (0, $2TIK5.WINDOW).navigator && (0, $2TIK5.WINDOW).navigator.languages && (0, $2TIK5.WINDOW).navigator.languages[0] || '';
function $750a441a204e3a37$var$isUserAgentData(data) {
    return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $750a441a204e3a37$var$userAgentData = (0, $2TIK5.WINDOW).navigator && (0, $2TIK5.WINDOW).navigator.userAgentData;
if ($750a441a204e3a37$var$isUserAgentData($750a441a204e3a37$var$userAgentData)) $750a441a204e3a37$var$userAgentData.getHighEntropyValues([
    'architecture',
    'model',
    'platform',
    'platformVersion',
    'fullVersionList'
]).then((ua)=>{
    $750a441a204e3a37$var$OS_PLATFORM = ua.platform || '';
    $750a441a204e3a37$var$OS_ARCH = ua.architecture || '';
    $750a441a204e3a37$var$OS_MODEL = ua.model || '';
    $750a441a204e3a37$var$OS_PLATFORM_VERSION = ua.platformVersion || '';
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $750a441a204e3a37$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $750a441a204e3a37$var$isProcessedJSSelfProfile(profile) {
    return !('thread_metadata' in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $750a441a204e3a37$export$7cbe6c4f12ea8325(profile) {
    if (!$750a441a204e3a37$var$isProcessedJSSelfProfile(profile)) return profile;
    return $750a441a204e3a37$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $750a441a204e3a37$var$getTraceId(event) {
    const traceId = event && event.contexts && event.contexts['trace'] && event.contexts['trace']['trace_id'];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === 'string' && traceId.length !== 32) {
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== 'string') return '';
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $750a441a204e3a37$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== 'transaction') // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $750a441a204e3a37$var$getTraceId(event);
    const enrichedThreadProfile = $750a441a204e3a37$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : Date.now();
    const transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : Date.now();
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: 'javascript',
        version: '1',
        release: event.release || '',
        environment: event.environment || (0, $gh9LO.DEFAULT_ENVIRONMENT),
        runtime: {
            name: 'javascript',
            version: (0, $2TIK5.WINDOW).navigator.userAgent
        },
        os: {
            name: $750a441a204e3a37$var$OS_PLATFORM,
            version: $750a441a204e3a37$var$OS_PLATFORM_VERSION,
            build_number: $750a441a204e3a37$var$OS_BROWSER
        },
        device: {
            locale: $750a441a204e3a37$var$OS_LOCALE,
            model: $750a441a204e3a37$var$OS_MODEL,
            manufacturer: $750a441a204e3a37$var$OS_BROWSER,
            architecture: $750a441a204e3a37$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $750a441a204e3a37$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || '',
                id: event.event_id || (0, $h7F1u.uuid4)(),
                trace_id: traceId,
                active_thread_id: $750a441a204e3a37$var$THREAD_ID_STRING,
                relative_start_ns: '0',
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function $750a441a204e3a37$export$7c501dd6adb8177c(transaction) {
    return transaction.op === 'pageload';
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $750a441a204e3a37$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$750a441a204e3a37$var$THREAD_ID_STRING]: {
                name: $750a441a204e3a37$var$THREAD_NAME
            }
        }
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : (0, $8t2EY.browserPerformanceTimeOrigin) || 0;
    const adjustForOriginChange = origin - ((0, $8t2EY.browserPerformanceTimeOrigin) || origin);
    for(let i = 0; i < input.samples.length; i++){
        const jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile['samples'][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $750a441a204e3a37$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $750a441a204e3a37$var$THREAD_ID_STRING
            };
            continue;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $750a441a204e3a37$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $750a441a204e3a37$var$THREAD_ID_STRING
        };
        profile['stacks'][STACK_ID] = stack;
        profile['samples'][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $750a441a204e3a37$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: 'profile'
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $750a441a204e3a37$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $eoF3x.forEachEnvelopeItem)(envelope, (item, type)=>{
        if (type !== 'transaction') return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts['profile'] && event.contexts['profile']['profile_id']) events.push(item[j]);
        }
    });
    return events;
}
const $750a441a204e3a37$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $750a441a204e3a37$export$4c0b0d8ee0d018b5(resource_paths) {
    const debugIdMap = (0, $hi3E4.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return [];
    const client = (0, $dmS7i.getClient)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $750a441a204e3a37$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $750a441a204e3a37$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $750a441a204e3a37$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== 'number' && typeof rate !== 'boolean' || typeof rate === 'number' && isNaN(rate)) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $750a441a204e3a37$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $3gMoL.DEBUG_BUILD) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $7I6pg.logger).log('[Profiling] Discarding profile because it contains less than 2 samples');
        return false;
    }
    if (!profile.frames.length) {
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] Discarding profile because it contains no frames');
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $750a441a204e3a37$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $750a441a204e3a37$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $750a441a204e3a37$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === 'function';
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $750a441a204e3a37$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $2TIK5.WINDOW).Profiler;
    if (!$750a441a204e3a37$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.');
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($750a441a204e3a37$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $3gMoL.DEBUG_BUILD) {
            (0, $7I6pg.logger).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $7I6pg.logger).log('[Profiling] Disabling profiling for current user session.');
        }
        $750a441a204e3a37$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $750a441a204e3a37$export$ea6683c0c72c1201(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($750a441a204e3a37$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] Profiling has been disabled for the duration of the current user session.');
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, $3gMoL.DEBUG_BUILD) (0, $7I6pg.logger).log('[Profiling] Discarding profile because transaction was not sampled.');
        return false;
    }
    const client = (0, $dmS7i.getClient)();
    const options = client && client.getOptions();
    if (!options) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Profiling] Profiling disabled, no options found.');
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$750a441a204e3a37$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).warn('[Profiling] Discarding profile because of invalid sample rate.');
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0');
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $750a441a204e3a37$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$750a441a204e3a37$var$isValidProfile(profile)) return null;
    return $750a441a204e3a37$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
const $750a441a204e3a37$var$PROFILE_MAP = new Map();
/**
 *
 */ function $750a441a204e3a37$export$9d723f414195854a() {
    return $750a441a204e3a37$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $750a441a204e3a37$export$6285310796363de1(profile_id) {
    const profile = $750a441a204e3a37$var$PROFILE_MAP.get(profile_id);
    if (profile) $750a441a204e3a37$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $750a441a204e3a37$export$7ddae68097f7e530(profile_id, profile) {
    $750a441a204e3a37$var$PROFILE_MAP.set(profile_id, profile);
    if ($750a441a204e3a37$var$PROFILE_MAP.size > 30) {
        const last = $750a441a204e3a37$var$PROFILE_MAP.keys().next().value;
        $750a441a204e3a37$var$PROFILE_MAP.delete(last);
    }
}

});


parcelRegister("2I8JG", function(module, exports) {
$parcel$export(module.exports, "browserProfilingIntegration", () => $1f96779aa145cb70$export$2c7b5d6dd5622f23);
$parcel$export(module.exports, "BrowserProfilingIntegration", () => $1f96779aa145cb70$export$b0fe88803ed435e0);

var $dFnv4 = parcelRequire("dFnv4");
var $dmS7i = parcelRequire("dmS7i");

var $7I6pg = parcelRequire("7I6pg");

var $3gMoL = parcelRequire("3gMoL");

var $4ylGE = parcelRequire("4ylGE");

var $a306A = parcelRequire("a306A");
const $1f96779aa145cb70$var$INTEGRATION_NAME = 'BrowserProfiling';
const $1f96779aa145cb70$var$_browserProfilingIntegration = ()=>{
    return {
        name: $1f96779aa145cb70$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            const scope = (0, $dmS7i.getCurrentScope)();
            // eslint-disable-next-line deprecation/deprecation
            const transaction = scope.getTransaction();
            if (transaction && (0, $a306A.isAutomatedPageLoadTransaction)(transaction)) {
                if ((0, $a306A.shouldProfileTransaction)(transaction)) (0, $4ylGE.startProfileForTransaction)(transaction);
            }
            if (typeof client.on !== 'function') {
                (0, $7I6pg.logger).warn('[Profiling] Client does not support hooks, profiling will be disabled');
                return;
            }
            client.on('startTransaction', (transaction)=>{
                if ((0, $a306A.shouldProfileTransaction)(transaction)) (0, $4ylGE.startProfileForTransaction)(transaction);
            });
            client.on('beforeEnvelope', (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $a306A.getActiveProfilesCount)()) return;
                const profiledTransactionEvents = (0, $a306A.findProfiledTransactionsFromEnvelope)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context['profile'] && context['profile']['profile_id'];
                    const start_timestamp = context && context['profile'] && context['profile']['start_timestamp'];
                    if (typeof profile_id !== 'string') {
                        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Profiling] cannot find profile for a transaction without a profile context');
                        continue;
                    }
                    if (!profile_id) {
                        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log('[Profiling] cannot find profile for a transaction without a profile context');
                        continue;
                    }
                    // Remove the profile from the transaction context before sending, relay will take care of the rest.
                    if (context && context['profile']) delete context.profile;
                    const profile = (0, $a306A.takeProfileFromGlobalCache)(profile_id);
                    if (!profile) {
                        (0, $3gMoL.DEBUG_BUILD) && (0, $7I6pg.logger).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $a306A.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $a306A.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const $1f96779aa145cb70$export$2c7b5d6dd5622f23 = (0, $dFnv4.defineIntegration)($1f96779aa145cb70$var$_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1f96779aa145cb70$export$b0fe88803ed435e0 = (0, $dFnv4.convertIntegrationFnToClass)($1f96779aa145cb70$var$INTEGRATION_NAME, $1f96779aa145cb70$export$2c7b5d6dd5622f23);

});


parcelRegister("lmSpp", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $f8e5db7c9e14f96a$export$25a43cb5b5c58c08);

var $gPxSj = parcelRequire("gPxSj");
var $i8vMy = parcelRequire("i8vMy");

var $er6T8 = parcelRequire("er6T8");
var $hvgWU = parcelRequire("hvgWU");
var $fIVdo = parcelRequire("fIVdo");
var $1s3dl = parcelRequire("1s3dl");
var $8jOyf = parcelRequire("8jOyf");
var $i4BcD = parcelRequire("i4BcD");
const $f8e5db7c9e14f96a$var$INTEGRATION_NAME = 'CaptureConsole';
const $f8e5db7c9e14f96a$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $fIVdo.CONSOLE_LEVELS);
    return {
        name: $f8e5db7c9e14f96a$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!('console' in (0, $1s3dl.GLOBAL_OBJ))) return;
            (0, $er6T8.addConsoleInstrumentationHandler)(({ args: args, level: level })=>{
                if ((0, $gPxSj.getClient)() !== client || !levels.includes(level)) return;
                $f8e5db7c9e14f96a$var$consoleHandler(args, level);
            });
        }
    };
};
const $f8e5db7c9e14f96a$export$caa9b6c4a4144db4 = (0, $i8vMy.defineIntegration)($f8e5db7c9e14f96a$var$_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f8e5db7c9e14f96a$export$25a43cb5b5c58c08 = (0, $i8vMy.convertIntegrationFnToClass)($f8e5db7c9e14f96a$var$INTEGRATION_NAME, $f8e5db7c9e14f96a$export$caa9b6c4a4144db4);
function $f8e5db7c9e14f96a$var$consoleHandler(args, level) {
    const captureContext = {
        level: (0, $i4BcD.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, $gPxSj.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $hvgWU.addExceptionMechanism)(event, {
                handled: false,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert' && args[0] === false) {
            const message = `Assertion failed: ${(0, $8jOyf.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
            scope.setExtra('arguments', args.slice(1));
            (0, $gPxSj.captureMessage)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === 'error' && error) {
            (0, $gPxSj.captureException)(error, captureContext);
            return;
        }
        const message = (0, $8jOyf.safeJoin)(args, ' ');
        (0, $gPxSj.captureMessage)(message, captureContext);
    });
}

});
parcelRegister("gPxSj", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $c40bafa5ee1108f1$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $c40bafa5ee1108f1$export$45654777c133ae80);
$parcel$export(module.exports, "withScope", () => $c40bafa5ee1108f1$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $c40bafa5ee1108f1$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $c40bafa5ee1108f1$export$6bb76d6eba7e258c);

var $1s3dl = parcelRequire("1s3dl");
var $hh9fP = parcelRequire("hh9fP");
var $fIVdo = parcelRequire("fIVdo");
var $hdMNC = parcelRequire("hdMNC");
var $hvgWU = parcelRequire("hvgWU");

var $92zar = parcelRequire("92zar");

var $86TOa = parcelRequire("86TOa");

var $gZpcN = parcelRequire("gZpcN");

var $4mbA9 = parcelRequire("4mbA9");

var $2s3iD = parcelRequire("2s3iD");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $c40bafa5ee1108f1$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().captureException(exception, (0, $2s3iD.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $c40bafa5ee1108f1$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $c40bafa5ee1108f1$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $c40bafa5ee1108f1$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $c40bafa5ee1108f1$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $gZpcN.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $c40bafa5ee1108f1$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $gZpcN.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $c40bafa5ee1108f1$export$9a4fed82c350c2bd(callback) {
    return (0, $gZpcN.runWithAsyncContext)(()=>{
        return callback((0, $gZpcN.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $c40bafa5ee1108f1$export$e57ac09b143d92a2(span, callback) {
    return $c40bafa5ee1108f1$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $c40bafa5ee1108f1$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c40bafa5ee1108f1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $c40bafa5ee1108f1$export$c7be4b0125a10cba();
    const client = $c40bafa5ee1108f1$export$6bb76d6eba7e258c();
    if (!client) (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $hvgWU.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c40bafa5ee1108f1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $c40bafa5ee1108f1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $hdMNC.timestampInSeconds)();
    function finishCheckIn(status) {
        $c40bafa5ee1108f1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $hdMNC.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $hh9fP.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c40bafa5ee1108f1$export$4909b86c8034bf73(timeout) {
    const client = $c40bafa5ee1108f1$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c40bafa5ee1108f1$export$8360e631d277ea4d(timeout) {
    const client = $c40bafa5ee1108f1$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $c40bafa5ee1108f1$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $c40bafa5ee1108f1$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $c40bafa5ee1108f1$export$3f95c6f800b78024() {
    return !!$c40bafa5ee1108f1$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $c40bafa5ee1108f1$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $gZpcN.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $c40bafa5ee1108f1$export$c0d84948cecf78d8(context) {
    const client = $c40bafa5ee1108f1$export$6bb76d6eba7e258c();
    const isolationScope = (0, $gZpcN.getIsolationScope)();
    const currentScope = $c40bafa5ee1108f1$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $92zar.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1s3dl.GLOBAL_OBJ).navigator || {};
    const session = (0, $4mbA9.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $4mbA9.updateSession)(currentSession, {
        status: 'exited'
    });
    $c40bafa5ee1108f1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $c40bafa5ee1108f1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $gZpcN.getIsolationScope)();
    const currentScope = $c40bafa5ee1108f1$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $4mbA9.closeSession)(session);
    $c40bafa5ee1108f1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $c40bafa5ee1108f1$var$_sendSessionUpdate() {
    const isolationScope = (0, $gZpcN.getIsolationScope)();
    const currentScope = $c40bafa5ee1108f1$export$c7be4b0125a10cba();
    const client = $c40bafa5ee1108f1$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $c40bafa5ee1108f1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $c40bafa5ee1108f1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $c40bafa5ee1108f1$var$_sendSessionUpdate();
}

});
parcelRegister("1s3dl", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $10eae63fe15150a0$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $10eae63fe15150a0$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $10eae63fe15150a0$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $10eae63fe15150a0$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $10eae63fe15150a0$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $10eae63fe15150a0$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $10eae63fe15150a0$var$isGlobalObj(window) || typeof self == 'object' && $10eae63fe15150a0$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $10eae63fe15150a0$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $10eae63fe15150a0$export$256479dc0cea61c4() {
    return $10eae63fe15150a0$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $10eae63fe15150a0$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $10eae63fe15150a0$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("hh9fP", function(module, exports) {
$parcel$export(module.exports, "isError", () => $c93b33eac939fb95$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $c93b33eac939fb95$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $c93b33eac939fb95$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $c93b33eac939fb95$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $c93b33eac939fb95$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $c93b33eac939fb95$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $c93b33eac939fb95$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $c93b33eac939fb95$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $c93b33eac939fb95$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $c93b33eac939fb95$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $c93b33eac939fb95$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $c93b33eac939fb95$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $c93b33eac939fb95$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$e6127cc7fe7395c3(wat) {
    switch($c93b33eac939fb95$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c93b33eac939fb95$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$var$isBuiltin(wat, className) {
    return $c93b33eac939fb95$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$9f9636d330b71954(wat) {
    return $c93b33eac939fb95$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$ef9e2056653f0c8e(wat) {
    return $c93b33eac939fb95$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$12e869b2a583f783(wat) {
    return $c93b33eac939fb95$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$844ec244b1367d54(wat) {
    return $c93b33eac939fb95$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$c3825b437cbdea5c(wat) {
    return wat === null || $c93b33eac939fb95$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$53b83ca8eaab0383(wat) {
    return $c93b33eac939fb95$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c93b33eac939fb95$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c93b33eac939fb95$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$49841c62b9eff15(wat) {
    return $c93b33eac939fb95$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $c93b33eac939fb95$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$bc2894c7158efbac(wat) {
    return $c93b33eac939fb95$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c93b33eac939fb95$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("fIVdo", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $b72758c5cb51de06$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $b72758c5cb51de06$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $b72758c5cb51de06$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $b72758c5cb51de06$export$af88d00dbe7f521);

var $la5bY = parcelRequire("la5bY");

var $1s3dl = parcelRequire("1s3dl");
/** Prefix for logging strings */ const $b72758c5cb51de06$var$PREFIX = 'Sentry Logger ';
const $b72758c5cb51de06$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $b72758c5cb51de06$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $b72758c5cb51de06$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $1s3dl.GLOBAL_OBJ))) return callback();
    const console = (0, $1s3dl.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($b72758c5cb51de06$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $b72758c5cb51de06$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $b72758c5cb51de06$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $la5bY.DEBUG_BUILD) $b72758c5cb51de06$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $b72758c5cb51de06$export$cda52e2a8927a2ca(()=>{
                (0, $1s3dl.GLOBAL_OBJ).console[name](`${$b72758c5cb51de06$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $b72758c5cb51de06$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $b72758c5cb51de06$export$af88d00dbe7f521 = $b72758c5cb51de06$var$makeLogger();

});
parcelRegister("la5bY", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $f67e8f330e9035ef$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f67e8f330e9035ef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("hdMNC", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $c899811c22fdd613$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $c899811c22fdd613$export$ee52dced521e3e18);

var $1s3dl = parcelRequire("1s3dl");
const $c899811c22fdd613$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $c899811c22fdd613$export$7740643b9eeaf0c4() {
    return Date.now() / $c899811c22fdd613$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $c899811c22fdd613$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1s3dl.GLOBAL_OBJ);
    if (!performance || !performance.now) return $c899811c22fdd613$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $c899811c22fdd613$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $c899811c22fdd613$export$ee52dced521e3e18 = $c899811c22fdd613$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $c899811c22fdd613$export$c5907b5a8838db13 = $c899811c22fdd613$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $c899811c22fdd613$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $c899811c22fdd613$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1s3dl.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $c899811c22fdd613$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $c899811c22fdd613$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $c899811c22fdd613$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $c899811c22fdd613$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("hvgWU", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $cbe27ab05e61965b$export$19f53698e68b2496);
$parcel$export(module.exports, "addExceptionMechanism", () => $cbe27ab05e61965b$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "arrayify", () => $cbe27ab05e61965b$export$3131421a7d01b4fb);

var $bC2bl = parcelRequire("bC2bl");

var $8jOyf = parcelRequire("8jOyf");

var $1s3dl = parcelRequire("1s3dl");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $cbe27ab05e61965b$export$19f53698e68b2496() {
    const gbl = (0, $1s3dl.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $cbe27ab05e61965b$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $cbe27ab05e61965b$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $cbe27ab05e61965b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $cbe27ab05e61965b$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $cbe27ab05e61965b$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $cbe27ab05e61965b$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $cbe27ab05e61965b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $cbe27ab05e61965b$export$d364f2020ab30578(input) {
    const match = input.match($cbe27ab05e61965b$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $cbe27ab05e61965b$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $8jOyf.snipLine)(line, 0));
    frame.context_line = (0, $8jOyf.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $8jOyf.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $cbe27ab05e61965b$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $bC2bl.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $cbe27ab05e61965b$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("bC2bl", function(module, exports) {
$parcel$export(module.exports, "fill", () => $8744ef9b4bf37adb$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $8744ef9b4bf37adb$export$e73679ffaf56810e);
$parcel$export(module.exports, "convertToPlainObject", () => $8744ef9b4bf37adb$export$62ff257738bf57f5);
$parcel$export(module.exports, "dropUndefinedKeys", () => $8744ef9b4bf37adb$export$d25f2688db1bb433);

var $7zDdB = parcelRequire("7zDdB");

var $la5bY = parcelRequire("la5bY");

var $hh9fP = parcelRequire("hh9fP");

var $fIVdo = parcelRequire("fIVdo");

var $8jOyf = parcelRequire("8jOyf");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $8744ef9b4bf37adb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $8744ef9b4bf37adb$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $8744ef9b4bf37adb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $la5bY.DEBUG_BUILD) && (0, $fIVdo.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $8744ef9b4bf37adb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $8744ef9b4bf37adb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $8744ef9b4bf37adb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $8744ef9b4bf37adb$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $8744ef9b4bf37adb$export$62ff257738bf57f5(value) {
    if ((0, $hh9fP.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$8744ef9b4bf37adb$var$getOwnProperties(value)
    };
    else if ((0, $hh9fP.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $8744ef9b4bf37adb$var$serializeEventTarget(value.target),
            currentTarget: $8744ef9b4bf37adb$var$serializeEventTarget(value.currentTarget),
            ...$8744ef9b4bf37adb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $hh9fP.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $8744ef9b4bf37adb$var$serializeEventTarget(target) {
    try {
        return (0, $hh9fP.isElement)(target) ? (0, $7zDdB.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $8744ef9b4bf37adb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $8744ef9b4bf37adb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($8744ef9b4bf37adb$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $8jOyf.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $8jOyf.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $8744ef9b4bf37adb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $8744ef9b4bf37adb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $8744ef9b4bf37adb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($8744ef9b4bf37adb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $8744ef9b4bf37adb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($8744ef9b4bf37adb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $8744ef9b4bf37adb$var$isPojo(input) {
    if (!(0, $hh9fP.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $8744ef9b4bf37adb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $hh9fP.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("7zDdB", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $583a39440e240a78$export$5647df6b7814ac86);

var $hh9fP = parcelRequire("hh9fP");

var $1s3dl = parcelRequire("1s3dl");
// eslint-disable-next-line deprecation/deprecation
const $583a39440e240a78$var$WINDOW = (0, $1s3dl.getGlobalObject)();
const $583a39440e240a78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $583a39440e240a78$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $583a39440e240a78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $583a39440e240a78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $583a39440e240a78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($583a39440e240a78$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $hh9fP.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $583a39440e240a78$export$1cfafeee2987818b() {
    try {
        return $583a39440e240a78$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $583a39440e240a78$export$c660c1f3ab49225c(selector) {
    if ($583a39440e240a78$var$WINDOW.document && $583a39440e240a78$var$WINDOW.document.querySelector) return $583a39440e240a78$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $583a39440e240a78$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$583a39440e240a78$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("8jOyf", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $60e74f86ee2026a7$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $60e74f86ee2026a7$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $60e74f86ee2026a7$export$465e9d514283d4fd);

var $hh9fP = parcelRequire("hh9fP");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $60e74f86ee2026a7$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $60e74f86ee2026a7$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $60e74f86ee2026a7$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $hh9fP.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $60e74f86ee2026a7$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $hh9fP.isString)(value)) return false;
    if ((0, $hh9fP.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $hh9fP.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $60e74f86ee2026a7$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$60e74f86ee2026a7$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("92zar", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $694f947bb4444b5f$export$849dbeeeda01ae98);
const $694f947bb4444b5f$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("86TOa", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $5e7a2c98c867e555$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $5e7a2c98c867e555$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("gZpcN", function(module, exports) {
$parcel$export(module.exports, "getCurrentHub", () => $c5e5e51b319b0073$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $c5e5e51b319b0073$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $c5e5e51b319b0073$export$70d775fb1f267027);

var $fIVdo = parcelRequire("fIVdo");
var $hdMNC = parcelRequire("hdMNC");
var $1s3dl = parcelRequire("1s3dl");
var $hh9fP = parcelRequire("hh9fP");
var $hvgWU = parcelRequire("hvgWU");

var $92zar = parcelRequire("92zar");

var $86TOa = parcelRequire("86TOa");

var $lOoLb = parcelRequire("lOoLb");

var $4mbA9 = parcelRequire("4mbA9");

var $j1DBk = parcelRequire("j1DBk");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $c5e5e51b319b0073$export$24a86ef7798177e4 = parseFloat((0, $j1DBk.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $c5e5e51b319b0073$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $c5e5e51b319b0073$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $c5e5e51b319b0073$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $lOoLb.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $lOoLb.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $hh9fP.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $hvgWU.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $hvgWU.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $hvgWU.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $c5e5e51b319b0073$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $hdMNC.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $fIVdo.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $c5e5e51b319b0073$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $c5e5e51b319b0073$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $86TOa.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $fIVdo.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $fIVdo.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $4mbA9.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $92zar.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $1s3dl.GLOBAL_OBJ).navigator || {};
        const session = (0, $4mbA9.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $4mbA9.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $c5e5e51b319b0073$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $c5e5e51b319b0073$export$19eade501500c6c1() {
    (0, $1s3dl.GLOBAL_OBJ).__SENTRY__ = (0, $1s3dl.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $1s3dl.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $c5e5e51b319b0073$export$4188a14ad302d1bc(hub) {
    const registry = $c5e5e51b319b0073$export$19eade501500c6c1();
    const oldHub = $c5e5e51b319b0073$export$bfa8a924a84a76b7(registry);
    $c5e5e51b319b0073$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $c5e5e51b319b0073$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $c5e5e51b319b0073$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $c5e5e51b319b0073$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $c5e5e51b319b0073$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $c5e5e51b319b0073$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $c5e5e51b319b0073$var$getGlobalHub(registry = $c5e5e51b319b0073$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$c5e5e51b319b0073$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $c5e5e51b319b0073$export$bfa8a924a84a76b7(registry).isOlderThan($c5e5e51b319b0073$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $c5e5e51b319b0073$export$849f05434e95d2f2(registry, new $c5e5e51b319b0073$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $c5e5e51b319b0073$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $c5e5e51b319b0073$export$236689a79f5aa020(carrier, parent = $c5e5e51b319b0073$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$c5e5e51b319b0073$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $c5e5e51b319b0073$export$bfa8a924a84a76b7(carrier).isOlderThan($c5e5e51b319b0073$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $c5e5e51b319b0073$export$849f05434e95d2f2(carrier, new $c5e5e51b319b0073$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $c5e5e51b319b0073$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $c5e5e51b319b0073$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $c5e5e51b319b0073$export$70d775fb1f267027(callback, options = {}) {
    const registry = $c5e5e51b319b0073$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $c5e5e51b319b0073$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $c5e5e51b319b0073$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $1s3dl.getGlobalSingleton)('hub', ()=>new $c5e5e51b319b0073$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $c5e5e51b319b0073$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("lOoLb", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $fe11795136497dce$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $fe11795136497dce$export$aa55d5ab8e05984f);

var $hdMNC = parcelRequire("hdMNC");
var $hh9fP = parcelRequire("hh9fP");
var $fIVdo = parcelRequire("fIVdo");
var $hvgWU = parcelRequire("hvgWU");

var $8Fzqm = parcelRequire("8Fzqm");

var $4mbA9 = parcelRequire("4mbA9");

var $7GwVB = parcelRequire("7GwVB");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $fe11795136497dce$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $fe11795136497dce$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $fe11795136497dce$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $fe11795136497dce$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $fe11795136497dce$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $fe11795136497dce$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $4mbA9.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $fe11795136497dce$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $hh9fP.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $fe11795136497dce$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $fe11795136497dce$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $hdMNC.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $7GwVB.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $8Fzqm.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $8Fzqm.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $hvgWU.uuid4)();
        if (!this._client) {
            (0, $fIVdo.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $hvgWU.uuid4)();
        if (!this._client) {
            (0, $fIVdo.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $hvgWU.uuid4)();
        if (!this._client) {
            (0, $fIVdo.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $fe11795136497dce$export$aa55d5ab8e05984f() {
    if (!$fe11795136497dce$var$globalScope) $fe11795136497dce$var$globalScope = new $fe11795136497dce$export$775b6bb06e53a214();
    return $fe11795136497dce$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $fe11795136497dce$export$c83048efd17527d6(scope) {
    $fe11795136497dce$var$globalScope = scope;
}
function $fe11795136497dce$var$generatePropagationContext() {
    return {
        traceId: (0, $hvgWU.uuid4)(),
        spanId: (0, $hvgWU.uuid4)().substring(16)
    };
}

});
parcelRegister("8Fzqm", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventProcessors", () => $64fda18c7817b469$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $64fda18c7817b469$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $64fda18c7817b469$export$bf2a096c3e883e79);

var $1s3dl = parcelRequire("1s3dl");
var $hh9fP = parcelRequire("hh9fP");
var $fIVdo = parcelRequire("fIVdo");
var $lGkpC = parcelRequire("lGkpC");

var $86TOa = parcelRequire("86TOa");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $64fda18c7817b469$export$3c4238858b85e8ac() {
    return (0, $1s3dl.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $64fda18c7817b469$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $64fda18c7817b469$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $64fda18c7817b469$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $lGkpC.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $86TOa.DEBUG_BUILD) && processor.id && result === null && (0, $fIVdo.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $hh9fP.isThenable)(result)) result.then((final)=>$64fda18c7817b469$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $64fda18c7817b469$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("lGkpC", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $fc8d5aa46a97480a$export$6f292d4960313241);

var $hh9fP = parcelRequire("hh9fP");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $fc8d5aa46a97480a$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($fc8d5aa46a97480a$var$States || ($fc8d5aa46a97480a$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $fc8d5aa46a97480a$export$1fda8aa4d135f8aa(value) {
    return new $fc8d5aa46a97480a$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $fc8d5aa46a97480a$export$78e43115b553f358(reason) {
    return new $fc8d5aa46a97480a$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $fc8d5aa46a97480a$export$6f292d4960313241 {
    constructor(executor){
        $fc8d5aa46a97480a$export$6f292d4960313241.prototype.__init.call(this);
        $fc8d5aa46a97480a$export$6f292d4960313241.prototype.__init2.call(this);
        $fc8d5aa46a97480a$export$6f292d4960313241.prototype.__init3.call(this);
        $fc8d5aa46a97480a$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $fc8d5aa46a97480a$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $fc8d5aa46a97480a$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $fc8d5aa46a97480a$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($fc8d5aa46a97480a$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($fc8d5aa46a97480a$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $fc8d5aa46a97480a$var$States.PENDING) return;
            if ((0, $hh9fP.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $fc8d5aa46a97480a$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $fc8d5aa46a97480a$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $fc8d5aa46a97480a$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("4mbA9", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $32c2337bbcf53b1f$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $32c2337bbcf53b1f$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $32c2337bbcf53b1f$export$56521d9ba90f62ee);

var $bC2bl = parcelRequire("bC2bl");
var $hdMNC = parcelRequire("hdMNC");
var $hvgWU = parcelRequire("hvgWU");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $32c2337bbcf53b1f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $hdMNC.timestampInSeconds)();
    const session = {
        sid: (0, $hvgWU.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$32c2337bbcf53b1f$var$sessionToJSON(session)
    };
    if (context) $32c2337bbcf53b1f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $32c2337bbcf53b1f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $hdMNC.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $hvgWU.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $32c2337bbcf53b1f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $32c2337bbcf53b1f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $32c2337bbcf53b1f$var$sessionToJSON(session) {
    return (0, $bC2bl.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("7GwVB", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $5985ff74d81eb780$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $5985ff74d81eb780$export$25ac7e259a513db4);

var $hvgWU = parcelRequire("hvgWU");
var $bC2bl = parcelRequire("bC2bl");

var $5wsNx = parcelRequire("5wsNx");

var $b8s48 = parcelRequire("b8s48");

var $k5OvV = parcelRequire("k5OvV");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $5985ff74d81eb780$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $5985ff74d81eb780$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $5985ff74d81eb780$var$applySpanToEvent(event, span);
    $5985ff74d81eb780$var$applyFingerprintToEvent(event, fingerprint);
    $5985ff74d81eb780$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $5985ff74d81eb780$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $5985ff74d81eb780$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $5985ff74d81eb780$export$b1a120a2871faa46(data, 'extra', extra);
    $5985ff74d81eb780$export$b1a120a2871faa46(data, 'tags', tags);
    $5985ff74d81eb780$export$b1a120a2871faa46(data, 'user', user);
    $5985ff74d81eb780$export$b1a120a2871faa46(data, 'contexts', contexts);
    $5985ff74d81eb780$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $5985ff74d81eb780$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $5985ff74d81eb780$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $bC2bl.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $bC2bl.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $bC2bl.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $bC2bl.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $5985ff74d81eb780$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $5985ff74d81eb780$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $5985ff74d81eb780$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $k5OvV.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $b8s48.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $5wsNx.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $k5OvV.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $5985ff74d81eb780$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $hvgWU.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("5wsNx", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $4056479df822f071$export$a117f995597e25df);

var $bC2bl = parcelRequire("bC2bl");

var $92zar = parcelRequire("92zar");

var $gPxSj = parcelRequire("gPxSj");

var $b8s48 = parcelRequire("b8s48");

var $k5OvV = parcelRequire("k5OvV");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $4056479df822f071$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $bC2bl.dropUndefinedKeys)({
        environment: options.environment || (0, $92zar.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $4056479df822f071$export$a117f995597e25df(span) {
    const client = (0, $gPxSj.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $4056479df822f071$export$366bad00d6815eed((0, $k5OvV.spanToJSON)(span).trace_id || '', client, (0, $gPxSj.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $b8s48.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $k5OvV.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $k5OvV.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("b8s48", function(module, exports) {
$parcel$export(module.exports, "getRootSpan", () => $81b6364fda1a8533$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $81b6364fda1a8533$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("k5OvV", function(module, exports) {
$parcel$export(module.exports, "spanToTraceContext", () => $ea0b754e47784f0a$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $ea0b754e47784f0a$export$92d8c23565496537);
$parcel$export(module.exports, "spanIsSampled", () => $ea0b754e47784f0a$export$5caecac1caaf3a71);

var $bC2bl = parcelRequire("bC2bl");
var $6EJmZ = parcelRequire("6EJmZ");
var $hdMNC = parcelRequire("hdMNC");
// These are aligned with OpenTelemetry trace flags
const $ea0b754e47784f0a$export$208d5b368507fb8b = 0x0;
const $ea0b754e47784f0a$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $ea0b754e47784f0a$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $ea0b754e47784f0a$export$92d8c23565496537(span);
    return (0, $bC2bl.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $ea0b754e47784f0a$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ea0b754e47784f0a$export$5caecac1caaf3a71(span);
    return (0, $6EJmZ.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $ea0b754e47784f0a$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $ea0b754e47784f0a$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $ea0b754e47784f0a$var$ensureTimestampInSeconds(input.getTime());
    return (0, $hdMNC.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $ea0b754e47784f0a$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $ea0b754e47784f0a$export$92d8c23565496537(span) {
    if ($ea0b754e47784f0a$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $ea0b754e47784f0a$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $ea0b754e47784f0a$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $ea0b754e47784f0a$export$eb571cd9b5d98de8);
}

});
parcelRegister("6EJmZ", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $4d89abfd412a90a3$export$f35d907436da45cf);

var $dSVLa = parcelRequire("dSVLa");

var $hvgWU = parcelRequire("hvgWU");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $4d89abfd412a90a3$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $4d89abfd412a90a3$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($4d89abfd412a90a3$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $4d89abfd412a90a3$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $4d89abfd412a90a3$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dSVLa.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $hvgWU.uuid4)(),
            spanId: (0, $hvgWU.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $hvgWU.uuid4)(),
            parentSpanId: parentSpanId || (0, $hvgWU.uuid4)().substring(16),
            spanId: (0, $hvgWU.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $4d89abfd412a90a3$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $4d89abfd412a90a3$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dSVLa.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $hvgWU.uuid4)(),
        spanId: (0, $hvgWU.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $hvgWU.uuid4)(),
        parentSpanId: parentSpanId || (0, $hvgWU.uuid4)().substring(16),
        spanId: (0, $hvgWU.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $4d89abfd412a90a3$export$f35d907436da45cf(traceId = (0, $hvgWU.uuid4)(), spanId = (0, $hvgWU.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("dSVLa", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $a1bd1f60d3b869a0$export$5b96ee2c8421f107);

var $la5bY = parcelRequire("la5bY");

var $hh9fP = parcelRequire("hh9fP");

var $fIVdo = parcelRequire("fIVdo");
const $a1bd1f60d3b869a0$export$9ca9946bd449ac06 = 'baggage';
const $a1bd1f60d3b869a0$export$6e69537d67fa20f = 'sentry-';
const $a1bd1f60d3b869a0$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $a1bd1f60d3b869a0$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $a1bd1f60d3b869a0$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $hh9fP.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $a1bd1f60d3b869a0$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $a1bd1f60d3b869a0$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($a1bd1f60d3b869a0$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($a1bd1f60d3b869a0$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $a1bd1f60d3b869a0$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$a1bd1f60d3b869a0$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $a1bd1f60d3b869a0$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $a1bd1f60d3b869a0$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $a1bd1f60d3b869a0$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $a1bd1f60d3b869a0$export$bdd844ddb2def819) {
            (0, $la5bY.DEBUG_BUILD) && (0, $fIVdo.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("j1DBk", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $dd9cd44108b53c8c$export$31499a9cd224b78c);
const $dd9cd44108b53c8c$export$31499a9cd224b78c = '7.120.3';

});


parcelRegister("2s3iD", function(module, exports) {
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $1c90c18430960786$export$76b5f966996d1653);

var $hvgWU = parcelRequire("hvgWU");
var $hdMNC = parcelRequire("hdMNC");
var $1s3dl = parcelRequire("1s3dl");
var $4gcSf = parcelRequire("4gcSf");
var $8jOyf = parcelRequire("8jOyf");

var $92zar = parcelRequire("92zar");

var $8Fzqm = parcelRequire("8Fzqm");

var $lOoLb = parcelRequire("lOoLb");

var $7GwVB = parcelRequire("7GwVB");

var $k5OvV = parcelRequire("k5OvV");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $1c90c18430960786$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $hvgWU.uuid4)(),
        timestamp: event.timestamp || (0, $hdMNC.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $1c90c18430960786$var$applyClientOptions(prepared, options);
    $1c90c18430960786$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $1c90c18430960786$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $1c90c18430960786$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $hvgWU.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $lOoLb.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $7GwVB.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $7GwVB.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $7GwVB.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $8Fzqm.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $8Fzqm.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $1c90c18430960786$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $1c90c18430960786$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $1c90c18430960786$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $92zar.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $8jOyf.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $8jOyf.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $8jOyf.truncate)(request.url, maxValueLength);
}
const $1c90c18430960786$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $1c90c18430960786$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $1s3dl.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $1c90c18430960786$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $1c90c18430960786$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $1c90c18430960786$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $1c90c18430960786$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $1c90c18430960786$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $4gcSf.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $4gcSf.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $4gcSf.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $4gcSf.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $4gcSf.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $k5OvV.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $4gcSf.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $1c90c18430960786$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $lOoLb.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $1c90c18430960786$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($1c90c18430960786$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($1c90c18430960786$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $1c90c18430960786$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $lOoLb.Scope) || typeof hint === 'function';
}
const $1c90c18430960786$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $1c90c18430960786$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$1c90c18430960786$var$captureContextKeys.includes(key));
}

});
parcelRegister("4gcSf", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $31a2a49072b631a7$export$a3295358bff77e);

var $hh9fP = parcelRequire("hh9fP");

var $jIYQx = parcelRequire("jIYQx");

var $bC2bl = parcelRequire("bC2bl");

var $2rnjp = parcelRequire("2rnjp");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $31a2a49072b631a7$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $31a2a49072b631a7$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $31a2a49072b631a7$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $31a2a49072b631a7$export$a3295358bff77e(object, depth);
    if ($31a2a49072b631a7$var$jsonSize(normalized) > maxSize) return $31a2a49072b631a7$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $31a2a49072b631a7$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $jIYQx.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $hh9fP.isNaN)(value)) return value;
    const stringified = $31a2a49072b631a7$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $31a2a49072b631a7$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $bC2bl.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $31a2a49072b631a7$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $31a2a49072b631a7$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $hh9fP.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $hh9fP.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $2rnjp.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $31a2a49072b631a7$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $31a2a49072b631a7$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $31a2a49072b631a7$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $31a2a49072b631a7$var$jsonSize(value) {
    return $31a2a49072b631a7$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $31a2a49072b631a7$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("jIYQx", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $e5c15338900bfef2$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $e5c15338900bfef2$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("2rnjp", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $1c702fb2cea9855d$export$aad197c7121a6651);

var $5pRiK = parcelRequire("5pRiK");
const $1c702fb2cea9855d$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $1c702fb2cea9855d$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $1c702fb2cea9855d$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $1c702fb2cea9855d$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $1c702fb2cea9855d$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($1c702fb2cea9855d$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $1c702fb2cea9855d$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $1c702fb2cea9855d$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $1c702fb2cea9855d$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $1c702fb2cea9855d$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $1c702fb2cea9855d$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($1c702fb2cea9855d$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($1c702fb2cea9855d$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $1c702fb2cea9855d$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $1c702fb2cea9855d$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $1c702fb2cea9855d$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $1c702fb2cea9855d$var$defaultFunctionName;
        return fn.name || $1c702fb2cea9855d$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $1c702fb2cea9855d$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $1c702fb2cea9855d$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $5pRiK.node)(getModule)
    ];
}

});
parcelRegister("5pRiK", function(module, exports) {
$parcel$export(module.exports, "node", () => $3f18a211cd695481$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $3f18a211cd695481$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $3f18a211cd695481$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $3f18a211cd695481$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("i8vMy", function(module, exports) {
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $d341a0a1153bf74b$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $d341a0a1153bf74b$export$2323046b9414659f);

var $hvgWU = parcelRequire("hvgWU");
var $fIVdo = parcelRequire("fIVdo");

var $86TOa = parcelRequire("86TOa");

var $8Fzqm = parcelRequire("8Fzqm");

var $gPxSj = parcelRequire("gPxSj");

var $gZpcN = parcelRequire("gZpcN");
const $d341a0a1153bf74b$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $d341a0a1153bf74b$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $d341a0a1153bf74b$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $hvgWU.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $d341a0a1153bf74b$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $d341a0a1153bf74b$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $d341a0a1153bf74b$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $d341a0a1153bf74b$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $d341a0a1153bf74b$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $d341a0a1153bf74b$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($d341a0a1153bf74b$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $8Fzqm.addGlobalEventProcessor), (0, $gZpcN.getCurrentHub));
        $d341a0a1153bf74b$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $d341a0a1153bf74b$export$2d8f5188773bcddd(integration) {
    const client = (0, $gPxSj.getClient)();
    if (!client || !client.addIntegration) {
        (0, $86TOa.DEBUG_BUILD) && (0, $fIVdo.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $d341a0a1153bf74b$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $d341a0a1153bf74b$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $d341a0a1153bf74b$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("er6T8", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $a828ee2da7ded1cd$export$1d6e0d073f9e6723);

var $fIVdo = parcelRequire("fIVdo");

var $bC2bl = parcelRequire("bC2bl");

var $1s3dl = parcelRequire("1s3dl");

var $2UuKQ = parcelRequire("2UuKQ");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a828ee2da7ded1cd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $2UuKQ.addHandler)(type, handler);
    (0, $2UuKQ.maybeInstrument)(type, $a828ee2da7ded1cd$var$instrumentConsole);
}
function $a828ee2da7ded1cd$var$instrumentConsole() {
    if (!('console' in (0, $1s3dl.GLOBAL_OBJ))) return;
    (0, $fIVdo.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $1s3dl.GLOBAL_OBJ).console)) return;
        (0, $bC2bl.fill)((0, $1s3dl.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $fIVdo.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $2UuKQ.triggerHandlers)('console', handlerData);
                const log = (0, $fIVdo.originalConsoleMethods)[level];
                log && log.apply((0, $1s3dl.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});
parcelRegister("2UuKQ", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $21e8aaf4195f9ac8$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $21e8aaf4195f9ac8$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $21e8aaf4195f9ac8$export$b18c893e424d3127);

var $la5bY = parcelRequire("la5bY");

var $fIVdo = parcelRequire("fIVdo");

var $2rnjp = parcelRequire("2rnjp");
// We keep the handlers globally
const $21e8aaf4195f9ac8$var$handlers = {};
const $21e8aaf4195f9ac8$var$instrumented = {};
/** Add a handler function. */ function $21e8aaf4195f9ac8$export$a4e09611e30da72e(type, handler) {
    $21e8aaf4195f9ac8$var$handlers[type] = $21e8aaf4195f9ac8$var$handlers[type] || [];
    $21e8aaf4195f9ac8$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $21e8aaf4195f9ac8$export$b17eab759a1cb5fe() {
    Object.keys($21e8aaf4195f9ac8$var$handlers).forEach((key)=>{
        $21e8aaf4195f9ac8$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $21e8aaf4195f9ac8$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$21e8aaf4195f9ac8$var$instrumented[type]) {
        instrumentFn();
        $21e8aaf4195f9ac8$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $21e8aaf4195f9ac8$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $21e8aaf4195f9ac8$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $la5bY.DEBUG_BUILD) && (0, $fIVdo.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $2rnjp.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("i4BcD", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $d2857567c1ddde79$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $d2857567c1ddde79$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $d2857567c1ddde79$export$e01cef29b4327697(level) {
    return $d2857567c1ddde79$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $d2857567c1ddde79$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $d2857567c1ddde79$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("lJt5a", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $fd245c120ab90caf$export$688d98c249d31ad3);

var $i8vMy = parcelRequire("i8vMy");

var $fIVdo = parcelRequire("fIVdo");

var $kppx0 = parcelRequire("kppx0");
const $fd245c120ab90caf$var$INTEGRATION_NAME = 'Dedupe';
const $fd245c120ab90caf$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $fd245c120ab90caf$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($fd245c120ab90caf$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $kppx0.DEBUG_BUILD) && (0, $fIVdo.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $fd245c120ab90caf$export$6d39aa44cd0c7567 = (0, $i8vMy.defineIntegration)($fd245c120ab90caf$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fd245c120ab90caf$export$688d98c249d31ad3 = (0, $i8vMy.convertIntegrationFnToClass)($fd245c120ab90caf$var$INTEGRATION_NAME, $fd245c120ab90caf$export$6d39aa44cd0c7567);
/** only exported for tests. */ function $fd245c120ab90caf$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fd245c120ab90caf$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fd245c120ab90caf$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $fd245c120ab90caf$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fd245c120ab90caf$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fd245c120ab90caf$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $fd245c120ab90caf$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $fd245c120ab90caf$var$_getExceptionFromEvent(previousEvent);
    const currentException = $fd245c120ab90caf$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fd245c120ab90caf$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fd245c120ab90caf$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $fd245c120ab90caf$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $fd245c120ab90caf$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $fd245c120ab90caf$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $fd245c120ab90caf$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $fd245c120ab90caf$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $fd245c120ab90caf$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});
parcelRegister("kppx0", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $edb9f271dd8befdf$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $edb9f271dd8befdf$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("gpdQo", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $bf19b848cc3e65d3$export$56d961ef3a52a072);

var $i8vMy = parcelRequire("i8vMy");

var $bC2bl = parcelRequire("bC2bl");
var $hh9fP = parcelRequire("hh9fP");
var $fIVdo = parcelRequire("fIVdo");
var $4gcSf = parcelRequire("4gcSf");

var $kppx0 = parcelRequire("kppx0");
const $bf19b848cc3e65d3$var$INTEGRATION_NAME = 'ExtraErrorData';
const $bf19b848cc3e65d3$var$_extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: $bf19b848cc3e65d3$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return $bf19b848cc3e65d3$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const $bf19b848cc3e65d3$export$6e0872131894301d = (0, $i8vMy.defineIntegration)($bf19b848cc3e65d3$var$_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $bf19b848cc3e65d3$export$56d961ef3a52a072 = (0, $i8vMy.convertIntegrationFnToClass)($bf19b848cc3e65d3$var$INTEGRATION_NAME, $bf19b848cc3e65d3$export$6e0872131894301d);
function $bf19b848cc3e65d3$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, $hh9fP.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $bf19b848cc3e65d3$var$_extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $4gcSf.normalize)(errorData, depth);
        if ((0, $hh9fP.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $bC2bl.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $bf19b848cc3e65d3$var$_extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $hh9fP.isError)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $hh9fP.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $hh9fP.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $kppx0.DEBUG_BUILD) && (0, $fIVdo.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});

parcelRegister("kb1Yw", function(module, exports) {
$parcel$export(module.exports, "RewriteFrames", () => $eb065defa4d61f19$export$af39fa91d1acf248);

var $i8vMy = parcelRequire("i8vMy");

var $4MONN = parcelRequire("4MONN");
const $eb065defa4d61f19$var$INTEGRATION_NAME = 'RewriteFrames';
const $eb065defa4d61f19$var$_rewriteFramesIntegration = (options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const iteratee = options.iteratee || ((frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $4MONN.relative)(root, filename) : (0, $4MONN.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $eb065defa4d61f19$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
const $eb065defa4d61f19$export$5ed0db6416cb6ea2 = (0, $i8vMy.defineIntegration)($eb065defa4d61f19$var$_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $eb065defa4d61f19$export$af39fa91d1acf248 = (0, $i8vMy.convertIntegrationFnToClass)($eb065defa4d61f19$var$INTEGRATION_NAME, $eb065defa4d61f19$export$5ed0db6416cb6ea2);

});
parcelRegister("4MONN", function(module, exports) {
$parcel$export(module.exports, "relative", () => $37c30d608bb3b4ee$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $37c30d608bb3b4ee$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $37c30d608bb3b4ee$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $37c30d608bb3b4ee$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $37c30d608bb3b4ee$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $37c30d608bb3b4ee$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $37c30d608bb3b4ee$export$f7ad0328861e2f03(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $37c30d608bb3b4ee$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $37c30d608bb3b4ee$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $37c30d608bb3b4ee$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $37c30d608bb3b4ee$export$f7ad0328861e2f03(from).slice(1);
    to = $37c30d608bb3b4ee$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $37c30d608bb3b4ee$var$trim(from.split('/'));
    const toParts = $37c30d608bb3b4ee$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $37c30d608bb3b4ee$export$6af368f973c74c5(path) {
    const isPathAbsolute = $37c30d608bb3b4ee$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $37c30d608bb3b4ee$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $37c30d608bb3b4ee$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $37c30d608bb3b4ee$export$f7e2c8231c57a8bd(...args) {
    return $37c30d608bb3b4ee$export$6af368f973c74c5(args.join('/'));
}
/** JSDoc */ function $37c30d608bb3b4ee$export$7f7b8152cc673abe(path) {
    const result = $37c30d608bb3b4ee$var$splitPath(path);
    const root = result[0];
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $37c30d608bb3b4ee$export$9bf319d8f74f51d1(path, ext) {
    let f = $37c30d608bb3b4ee$var$splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

});


parcelRegister("2HuOR", function(module, exports) {
$parcel$export(module.exports, "LICENSED_PRODUCTS", () => $1a635af383f874cd$export$88049c64f9286584);
$parcel$export(module.exports, "getLicensedProducts", () => $1a635af383f874cd$export$8cc688f27940ac);
$parcel$export(module.exports, "getIsAnonymous", () => $1a635af383f874cd$export$6483e36b59eeec4f);
$parcel$export(module.exports, "getInitialProductList", () => $1a635af383f874cd$export$971bd624a4cf068e);
$parcel$export(module.exports, "getFirstActivationDate", () => $1a635af383f874cd$export$2fc3e4b3f0460c2f);
$parcel$export(module.exports, "determineProductCrossSellConfig", () => $1a635af383f874cd$export$2885d42113231825);
$parcel$export(module.exports, "getEnvironment", () => $1a635af383f874cd$export$57570b1603cf6adb);
$parcel$export(module.exports, "getAtlassianAccountId", () => $1a635af383f874cd$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getTenantContext_DEPRECATED_DO_NOT_USE", () => $1a635af383f874cd$export$374aeba69d52d74d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $978hs = parcelRequire("978hs");

var $7tjnB = parcelRequire("7tjnB");

var $5EbfN = parcelRequire("5EbfN");

var $6bEm8 = parcelRequire("6bEm8");

var $9CNRl = parcelRequire("9CNRl");

var $fEmTm = parcelRequire("fEmTm");

var $bS6BF = parcelRequire("bS6BF");

var $87ZgK = parcelRequire("87ZgK");

var $h7NDP = parcelRequire("h7NDP");
const $1a635af383f874cd$export$88049c64f9286584 = {
    ATLASSIAN_ANALYTICS: 'atlassian-analytics-free',
    JIRA_SOFTWARE: 'jira-software',
    JIRA_SERVICEDESK: 'jira-servicedesk',
    JIRA_PORTFOLIO: 'com.radiantminds.roadmaps-jira',
    JIRA_CORE: 'jira-core',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    CONFLUENCE: 'confluence',
    OPSGENIE: 'opsgenie',
    BITBUCKET: 'com.atlassian.bitbucket',
    STATUS_PAGE: 'statuspage',
    LOOM: 'loom',
    COMPASS: 'compass',
    TOWNSQUARE: 'townsquare',
    PROJECT: 'project',
    GOAL: 'goal'
};
const $1a635af383f874cd$export$b4187945225b3132 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-is-admin');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'admin' : 'non-admin';
};
const $1a635af383f874cd$export$8cc688f27940ac = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-licensed-products') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Invalid list of licensed products: ${error}`);
        return {};
    }
};
const $1a635af383f874cd$export$6483e36b59eeec4f = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    return getMetaImpl('ajs-atlassian-account-id') === '';
};
const $1a635af383f874cd$export$875713824cd90c85 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-product-entitlement-details') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {};
    }
};
const $1a635af383f874cd$export$971bd624a4cf068e = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-initial-product-list');
    if (metaValue === null) return '';
    return metaValue;
};
const $1a635af383f874cd$export$2fc3e4b3f0460c2f = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-first-activation-date');
    if (metaValue === null) return null;
    const timestamp = parseInt(metaValue, 10);
    if (Number.isNaN(timestamp)) return null;
    return timestamp;
};
const $1a635af383f874cd$export$c3fee804514cdf76 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-app-updates-available');
    if (metaValue === null) return null;
    const hasAppUpdates = parseInt(metaValue, 10);
    if (Number.isNaN(hasAppUpdates)) return null;
    return hasAppUpdates;
};
const $1a635af383f874cd$export$2885d42113231825 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-xflow-product-suggestions-enabled');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'enabled' : 'disabled';
};
const $1a635af383f874cd$export$57570b1603cf6adb = ()=>(0, $5EbfN.toEnvironment)((0, $6bEm8.default)('ajs-environment'));
const $1a635af383f874cd$export$f5baf4f0aaa47428 = ()=>(0, $6bEm8.default)('ajs-atlassian-account-id');
const $1a635af383f874cd$export$8ece9c90e8293278 = ()=>{
    return(// Cloud ID is flushed early. Checking only this means critical values are available, but not "all of them".
    typeof (0, $6bEm8.default)('ajs-cloud-id') === 'string' && // Version number is retrieved via slow metadata provider call. its presence should indicate "the rest" are available, too.
    typeof (0, $6bEm8.default)('ajs-version-number') === 'string');
};
/**
 * Use hooks from @atlassian/jira-tenant-context-controller instead of this function. Because reading from 30 <meta> tags in DOM on each call slows page down considerably.
 * More info: https://hello.atlassian.net/wiki/spaces/MAGMA/blog/2022/01/12/1479453433/PSA+getTenantContext+is+now+deprecated
 */ const $1a635af383f874cd$var$getTenantContextFromMeta = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $6bEm8.default) : getMetaCustom;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudId = getMetaImpl('ajs-cloud-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const activationId = getMetaImpl('ajs-activation-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudName = getMetaImpl('ajs-cloud-name');
    const xsrfToken = getMetaImpl === (0, $6bEm8.default) ? (0, $9CNRl.default)() || null : getMetaImpl('atlassian-token');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const languageTag = getMetaImpl('ajs-fspage-locale');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const locale = getMetaImpl('ajs-user-locale');
    const userFullname = getMetaImpl('ajs-remote-user-fullname');
    const username = getMetaImpl('ajs-remote-user');
    const isAdmin = getMetaImpl('ajs-is-admin') === 'true';
    const isSiteAdmin = getMetaImpl('ajs-is-site-admin') === 'true';
    const fabricActivityUrl = '/gateway/api/activity';
    const fabricNotificationLogUrl = '/gateway/api/notification-log';
    const fabricPfDirUrl = getMetaImpl('ajs-fabric-pf-dir-url');
    const appPermissions = (0, $5EbfN.populateApplicationPermissions)({
        hasSoftwareAccess: getMetaImpl('ajs-has-jira-software') === 'true',
        hasServiceDeskAccess: getMetaImpl('ajs-has-jira-service-desk') === 'true',
        hasCoreAccess: getMetaImpl('ajs-has-jira-core') === 'true',
        hasProductDiscoveryAccess: getMetaImpl('ajs-has-jira-product-discovery') === 'true',
        hasCustomerServiceAccess: getMetaImpl('ajs-has-jira-customer-service') === 'true'
    });
    const accountId = getMetaImpl('ajs-atlassian-account-id');
    const isAnonymous = accountId === '';
    const applicationKey = getMetaImpl('ajs-application-key');
    const environment = (0, $5EbfN.toEnvironment)(getMetaImpl('ajs-environment'));
    const areProductSuggestionsEnabled = getMetaImpl('ajs-xflow-product-suggestions-enabled') === 'true';
    const licensedProducts = $1a635af383f874cd$export$8cc688f27940ac(getMetaImpl);
    const productEntitlementDetails = $1a635af383f874cd$export$875713824cd90c85(getMetaImpl);
    if (accountId === null || locale === null || cloudId === null) {
        (0, $fEmTm.captureException)('getTenantContextFromMeta', new Error('Unable to find tenant context (detailed exception)'), {
            teamName: 'jfp-magma',
            isAnonymous: isAnonymous.toString(),
            isAccountIdNull: Boolean(accountId === null).toString(),
            isLocaleNull: Boolean(locale === null).toString(),
            isCloudIdNull: Boolean(cloudId === null).toString()
        });
        throw new Error('Unable to find tenant context');
    }
    if (!(0, $978hs.default).includes(locale)) // eslint-disable-next-line no-console
    console.warn(`Non supported locale in tenant context: ${locale}`);
    const siteAdminStatus = $1a635af383f874cd$export$b4187945225b3132(getMetaImpl);
    const productCrossSellConfig = $1a635af383f874cd$export$2885d42113231825(getMetaImpl);
    const appEditions = (0, $bS6BF.default)(getMetaImpl);
    const productPermissionGated = (0, $h7NDP.default)(getMetaImpl);
    let licenseStates;
    if (getMetaImpl('ajs-product-license-states') !== null) licenseStates = (0, $87ZgK.default)(getMetaImpl);
    else /**
		 * When feature flag is OFF, the value of licenseStates will just depend on ajs-has-* tags.
		 * At the moment, there's no other usages besides <LicenseStateCheck>, so this is safe
		 */ licenseStates = (0, $7tjnB.populateApplicationLicenseStates)({
        core: appPermissions.hasCoreAccess ? (0, $7tjnB.LICENSE_STATE_ACTIVE) : (0, $7tjnB.LICENSE_STATE_UNLICENSED),
        software: appPermissions.hasSoftwareAccess ? (0, $7tjnB.LICENSE_STATE_ACTIVE) : (0, $7tjnB.LICENSE_STATE_UNLICENSED),
        serviceDesk: appPermissions.hasServiceDeskAccess ? (0, $7tjnB.LICENSE_STATE_ACTIVE) : (0, $7tjnB.LICENSE_STATE_UNLICENSED),
        customerService: appPermissions.hasCustomerServiceAccess ? (0, $7tjnB.LICENSE_STATE_ACTIVE) : (0, $7tjnB.LICENSE_STATE_UNLICENSED),
        productDiscovery: appPermissions.hasProductDiscoveryAccess ? (0, $7tjnB.LICENSE_STATE_ACTIVE) : (0, $7tjnB.LICENSE_STATE_UNLICENSED)
    });
    const loggedInUser = username === '' ? null : username;
    const atlassianAccountId = accountId === '' ? null : accountId;
    const isDevMode = getMetaImpl('ajs-dev-mode') === 'true';
    const firstActivationDateMs = $1a635af383f874cd$export$2fc3e4b3f0460c2f(getMetaImpl);
    const isDevopsProjectCreationScenario = getMetaImpl('ajs-devops-project-creation-scenario') === 'true';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const devopsProjectSignupSource = getMetaImpl('ajs-devops-signup-source-scenario');
    const isMarketingOptOut = getMetaImpl('ajs-marketing-opt-out') === 'true';
    const hasDlpEnabled = getMetaImpl('ajs-has-dlp') === 'true';
    const appUpdatesAvailable = $1a635af383f874cd$export$c3fee804514cdf76(getMetaImpl);
    const avpWorkspaceId = getMetaImpl('ajs-avp-workspace-id');
    return {
        appEditions: appEditions,
        applicationKey: applicationKey,
        appPermissions: appPermissions,
        appUpdatesAvailable: appUpdatesAvailable,
        areProductSuggestionsEnabled: areProductSuggestionsEnabled,
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId,
        orgId: getMetaImpl('ajs-org-id') ?? undefined,
        activationId: activationId,
        cloudName: cloudName,
        devopsProjectSignupSource: devopsProjectSignupSource,
        environment: environment,
        fabricActivityUrl: fabricActivityUrl,
        fabricNotificationLogUrl: fabricNotificationLogUrl,
        fabricPfDirUrl: fabricPfDirUrl,
        firstActivationDateMs: firstActivationDateMs,
        isAdmin: isAdmin,
        isAnonymous: isAnonymous,
        isDevMode: isDevMode,
        isDevopsProjectCreationScenario: isDevopsProjectCreationScenario,
        isMarketingOptOut: isMarketingOptOut,
        isSiteAdmin: isSiteAdmin,
        languageTag: languageTag,
        licensedProducts: licensedProducts,
        licenseStates: licenseStates,
        locale: locale,
        loggedInUser: loggedInUser,
        productCrossSellConfig: productCrossSellConfig,
        productEntitlementDetails: productEntitlementDetails,
        productPermissionGated: productPermissionGated,
        siteAdminStatus: siteAdminStatus,
        userFullname: userFullname,
        xsrfToken: xsrfToken,
        hasDlpEnabled: hasDlpEnabled,
        avpWorkspaceId: avpWorkspaceId
    };
};
const $1a635af383f874cd$export$374aeba69d52d74d = (0, $emCaV.default)($1a635af383f874cd$var$getTenantContextFromMeta);

});
parcelRegister("7tjnB", function(module, exports) {
$parcel$export(module.exports, "LICENSE_STATE_ACTIVE", () => $e5f7216b5ff23c4e$export$b1825e21241fc91);
$parcel$export(module.exports, "LICENSE_STATE_SUSPENDED", () => $e5f7216b5ff23c4e$export$da47d37a794d21de);
$parcel$export(module.exports, "LICENSE_STATE_EXPIRED", () => $e5f7216b5ff23c4e$export$7b174e57c0bd6a9c);
$parcel$export(module.exports, "LICENSE_STATE_UNLICENSED", () => $e5f7216b5ff23c4e$export$2547e580661cf303);
$parcel$export(module.exports, "populateApplicationLicenseStates", () => $e5f7216b5ff23c4e$export$d72e24da946cb239);
/* eslint-disable jira/filename-case */ const $e5f7216b5ff23c4e$export$b1825e21241fc91 = 'ACTIVE';
const $e5f7216b5ff23c4e$export$da47d37a794d21de = 'SUSPENDED';
const $e5f7216b5ff23c4e$export$7b174e57c0bd6a9c = 'EXPIRED';
const $e5f7216b5ff23c4e$export$2547e580661cf303 = 'UNLICENSED';
const $e5f7216b5ff23c4e$export$d72e24da946cb239 = (overrides = {}, defaultLicenseState = $e5f7216b5ff23c4e$export$2547e580661cf303)=>({
        core: defaultLicenseState,
        software: defaultLicenseState,
        serviceDesk: defaultLicenseState,
        customerService: defaultLicenseState,
        productDiscovery: defaultLicenseState,
        ...overrides
    });

});

parcelRegister("5EbfN", function(module, exports) {
$parcel$export(module.exports, "populateApplicationPermissions", () => $6cb46ce6e27a7cee$export$4d9dffdb588381aa);
$parcel$export(module.exports, "toEnvironment", () => $6cb46ce6e27a7cee$export$a69dcd7c1d779173);
/* eslint-disable jira/filename-case */ const $6cb46ce6e27a7cee$export$4d9dffdb588381aa = (overrides = {}, defaultPermission = false)=>({
        hasCoreAccess: defaultPermission,
        hasSoftwareAccess: defaultPermission,
        hasServiceDeskAccess: defaultPermission,
        hasCustomerServiceAccess: defaultPermission,
        hasProductDiscoveryAccess: defaultPermission,
        ...overrides
    });
const $6cb46ce6e27a7cee$export$a69dcd7c1d779173 = (value)=>{
    switch(value){
        case 'dev':
            return 'dev';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        case 'local':
            return 'local';
        default:
            return null;
    }
};

});

parcelRegister("9CNRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaf9f8507e588180$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/cookie

var $8BEEb = parcelRequire("8BEEb");
/**
 * Returns 'atlassian-token' aka xsrf required to secure some operation.
 *
 *
 * Security note: it is important to read from cookies - the same source backend will use to validate the operation
 * The attempt to read it from meta-data ('atlassian-token') resulted in Sev2 HOT-108450
 *
 * The cookie is a part of XSRF technology itself and is exempt from "safe cookies"/FedRAMP requirements.
 * The technology is based on one's ability to read the cookie and this is one it shall be preserved.
 *
 * There is ongoing work to migrate from legacy experiences that rely on this sort of protection
 * Until the work is not done, it shall stay untouched
 * See:
 *  - https://jplat.jira.atlassian.cloud/browse/ISSUEHELP-1198
 */ const $aaf9f8507e588180$var$getXSRFToken = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8BEEb))).get('atlassian.xsrf.token');
var $aaf9f8507e588180$export$2e2bcd8739ae039 = $aaf9f8507e588180$var$getXSRFToken;

});

parcelRegister("bS6BF", function(module, exports) {
$parcel$export(module.exports, "default", () => $eacbde19fb9d13a2$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");
const $eacbde19fb9d13a2$var$parseTenantContextEdition = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'f':
            return 0, $d8LhJ.FREE_EDITION;
        case 's':
            return 0, $d8LhJ.STANDARD_EDITION;
        case 'p':
            return 0, $d8LhJ.PREMIUM_EDITION;
        default:
            return 0, $d8LhJ.UNLICENSED;
    }
};
const $eacbde19fb9d13a2$var$parseTenantContextEditions = (tenantContextEditions)=>(0, $d8LhJ.populateApplicationEditions)({
        core: $eacbde19fb9d13a2$var$parseTenantContextEdition(tenantContextEditions['jira-core']),
        software: $eacbde19fb9d13a2$var$parseTenantContextEdition(tenantContextEditions['jira-software']),
        serviceDesk: $eacbde19fb9d13a2$var$parseTenantContextEdition(tenantContextEditions['jira-servicedesk']),
        customerService: $eacbde19fb9d13a2$var$parseTenantContextEdition(tenantContextEditions['jira-customer-service']),
        productDiscovery: $eacbde19fb9d13a2$var$parseTenantContextEdition(tenantContextEditions['jira-product-discovery'])
    });
const $eacbde19fb9d13a2$var$determineApplicationEditions = (getMetaImpl)=>{
    try {
        const tenantContextEditions = JSON.parse(getMetaImpl('ajs-product-editions') || '{}');
        return $eacbde19fb9d13a2$var$parseTenantContextEditions(tenantContextEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return (0, $d8LhJ.populateApplicationEditions)();
    }
};
var $eacbde19fb9d13a2$export$2e2bcd8739ae039 = $eacbde19fb9d13a2$var$determineApplicationEditions;

});
parcelRegister("d8LhJ", function(module, exports) {
$parcel$export(module.exports, "FREE_EDITION", () => $fcc7d5a95859166c$export$e69af2c4378638a2);
$parcel$export(module.exports, "STANDARD_EDITION", () => $fcc7d5a95859166c$export$7bc7dd5faba7ad6b);
$parcel$export(module.exports, "PREMIUM_EDITION", () => $fcc7d5a95859166c$export$3fd0bbb8c68dc4c7);
$parcel$export(module.exports, "UNLICENSED", () => $fcc7d5a95859166c$export$5747d23113da6aa6);
$parcel$export(module.exports, "STANDARD_EDITION_KEY", () => $fcc7d5a95859166c$export$6ad005c3d13398a0);
$parcel$export(module.exports, "PREMIUM_EDITION_KEY", () => $fcc7d5a95859166c$export$ee574a74f490a9e8);
$parcel$export(module.exports, "editionKeyToEdition", () => $fcc7d5a95859166c$export$21d25cf944084a5e);
$parcel$export(module.exports, "editionToEditionKey", () => $fcc7d5a95859166c$export$564d24f5605eb83d);
$parcel$export(module.exports, "populateApplicationEditions", () => $fcc7d5a95859166c$export$6bdd11dc05a96fbd);
$parcel$export(module.exports, "getEdition", () => $fcc7d5a95859166c$export$acf25cbc735b9b90);
$parcel$export(module.exports, "getEditionForProject", () => $fcc7d5a95859166c$export$7f5fd5f8e6705012);
$parcel$export(module.exports, "toEdition", () => $fcc7d5a95859166c$export$59f6e933a5e0096b);
/* eslint-disable jira/filename-case */ 
var $hJL79 = parcelRequire("hJL79");
const $fcc7d5a95859166c$export$e69af2c4378638a2 = 'FREE_EDITION';
const $fcc7d5a95859166c$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $fcc7d5a95859166c$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $fcc7d5a95859166c$export$5747d23113da6aa6 = 'UNLICENSED';
const $fcc7d5a95859166c$export$c8c756d9ef774404 = 'free';
const $fcc7d5a95859166c$export$6ad005c3d13398a0 = 'standard';
const $fcc7d5a95859166c$export$ee574a74f490a9e8 = 'premium';
const $fcc7d5a95859166c$export$21d25cf944084a5e = (editionShort)=>{
    if (editionShort === $fcc7d5a95859166c$export$c8c756d9ef774404) return $fcc7d5a95859166c$export$e69af2c4378638a2;
    if (editionShort === $fcc7d5a95859166c$export$6ad005c3d13398a0) return $fcc7d5a95859166c$export$7bc7dd5faba7ad6b;
    if (editionShort === $fcc7d5a95859166c$export$ee574a74f490a9e8) return $fcc7d5a95859166c$export$3fd0bbb8c68dc4c7;
    return $fcc7d5a95859166c$export$5747d23113da6aa6;
};
const $fcc7d5a95859166c$export$564d24f5605eb83d = (edition)=>{
    switch(edition){
        case $fcc7d5a95859166c$export$e69af2c4378638a2:
            return $fcc7d5a95859166c$export$c8c756d9ef774404;
        case $fcc7d5a95859166c$export$7bc7dd5faba7ad6b:
            return $fcc7d5a95859166c$export$6ad005c3d13398a0;
        case $fcc7d5a95859166c$export$3fd0bbb8c68dc4c7:
            return $fcc7d5a95859166c$export$ee574a74f490a9e8;
        default:
            return undefined;
    }
};
const $fcc7d5a95859166c$export$6bdd11dc05a96fbd = (overrides = {}, defaultEdition = $fcc7d5a95859166c$export$5747d23113da6aa6)=>({
        core: defaultEdition,
        software: defaultEdition,
        serviceDesk: defaultEdition,
        customerService: defaultEdition,
        productDiscovery: defaultEdition,
        ...overrides
    });
const $fcc7d5a95859166c$export$acf25cbc735b9b90 = (application, applicationEditions)=>{
    switch(application){
        case 0, $hJL79.JIRA_CORE:
            return applicationEditions.core;
        case 0, $hJL79.JIRA_SOFTWARE:
            return applicationEditions.software;
        case 0, $hJL79.JIRA_PRODUCT_DISCOVERY:
            return applicationEditions.productDiscovery;
        case 0, $hJL79.JIRA_SERVICE_DESK:
            return applicationEditions.serviceDesk;
        case 0, $hJL79.JIRA_CUSTOMER_SERVICE:
            return applicationEditions.customerService;
        default:
            throw new Error(`Unrecognised application: ${application}`);
    }
};
const $fcc7d5a95859166c$export$7f5fd5f8e6705012 = (projectType, applicationEditions)=>{
    const application = (0, $hJL79.getApplicationForProject)(projectType);
    return $fcc7d5a95859166c$export$acf25cbc735b9b90(application, applicationEditions);
};
const $fcc7d5a95859166c$export$59f6e933a5e0096b = (edition)=>{
    switch(edition){
        case $fcc7d5a95859166c$export$e69af2c4378638a2:
            return $fcc7d5a95859166c$export$e69af2c4378638a2;
        case $fcc7d5a95859166c$export$7bc7dd5faba7ad6b:
            return $fcc7d5a95859166c$export$7bc7dd5faba7ad6b;
        case $fcc7d5a95859166c$export$3fd0bbb8c68dc4c7:
            return $fcc7d5a95859166c$export$3fd0bbb8c68dc4c7;
        case $fcc7d5a95859166c$export$5747d23113da6aa6:
        default:
            return $fcc7d5a95859166c$export$5747d23113da6aa6;
    }
};

});
parcelRegister("hJL79", function(module, exports) {
$parcel$export(module.exports, "JIRA_PORTFOLIO", () => $63062a670597164f$export$29c4c091cb388ff0);
$parcel$export(module.exports, "JIRA_SERVICE_DESK", () => $63062a670597164f$export$3afc372bb8c4538c);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE", () => $63062a670597164f$export$19eb54cb466391c5);
$parcel$export(module.exports, "JIRA_SOFTWARE", () => $63062a670597164f$export$ad9850d60736acbb);
$parcel$export(module.exports, "JIRA_CORE", () => $63062a670597164f$export$66e37ea59188c0b8);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY", () => $63062a670597164f$export$b6c5b3e2284b683b);
$parcel$export(module.exports, "getApplicationForProject", () => $63062a670597164f$export$3804df50ba7ca359);
/* eslint-disable jira/filename-case */ const $63062a670597164f$export$29c4c091cb388ff0 = 'JIRA_PORTFOLIO';
const $63062a670597164f$export$3afc372bb8c4538c = 'JIRA_SERVICE_DESK';
const $63062a670597164f$export$19eb54cb466391c5 = 'JIRA_CUSTOMER_SERVICE';
const $63062a670597164f$export$ad9850d60736acbb = 'JIRA_SOFTWARE';
const $63062a670597164f$export$66e37ea59188c0b8 = 'JIRA_CORE';
const $63062a670597164f$export$b6c5b3e2284b683b = 'JIRA_PRODUCT_DISCOVERY';
const $63062a670597164f$export$3804df50ba7ca359 = (projectType)=>{
    switch(projectType){
        case 'business':
            return $63062a670597164f$export$66e37ea59188c0b8;
        case 'product_discovery':
            return $63062a670597164f$export$b6c5b3e2284b683b;
        case 'software':
            return $63062a670597164f$export$ad9850d60736acbb;
        case 'service_desk':
            return $63062a670597164f$export$3afc372bb8c4538c;
        case 'customer_service':
            return $63062a670597164f$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};
const $63062a670597164f$export$70d16cc42a798666 = (projectType)=>{
    switch(projectType){
        case 'business':
            return $63062a670597164f$export$66e37ea59188c0b8;
        case 'product_discovery':
            return $63062a670597164f$export$b6c5b3e2284b683b;
        case 'software':
            return $63062a670597164f$export$ad9850d60736acbb;
        case 'service_desk':
            return $63062a670597164f$export$3afc372bb8c4538c;
        case 'customer_service':
            return $63062a670597164f$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};

});



parcelRegister("87ZgK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fa1ffb69f94cd23$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7tjnB = parcelRequire("7tjnB");
const $2fa1ffb69f94cd23$var$parseTenantContextLicenseState = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'ACTIVE':
            return 0, $7tjnB.LICENSE_STATE_ACTIVE;
        case 'SUSPENDED':
            return 0, $7tjnB.LICENSE_STATE_SUSPENDED;
        case 'EXPIRED':
            return 0, $7tjnB.LICENSE_STATE_EXPIRED;
        default:
            return 0, $7tjnB.LICENSE_STATE_UNLICENSED;
    }
};
const $2fa1ffb69f94cd23$var$parseTenantContextLicenseStates = (tenantContextLicenseStates)=>(0, $7tjnB.populateApplicationLicenseStates)({
        core: $2fa1ffb69f94cd23$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-core']),
        software: $2fa1ffb69f94cd23$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-software']),
        serviceDesk: $2fa1ffb69f94cd23$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-servicedesk']),
        customerService: $2fa1ffb69f94cd23$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-customer-service']),
        productDiscovery: $2fa1ffb69f94cd23$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-product-discovery'])
    });
const $2fa1ffb69f94cd23$var$determineApplicationLicenseStates = (getMetaImpl)=>{
    try {
        const tenantContextLicenseStates = JSON.parse(getMetaImpl('ajs-product-license-states') || '{}');
        return $2fa1ffb69f94cd23$var$parseTenantContextLicenseStates(tenantContextLicenseStates);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application license states from tenant context: ${error}`);
        return (0, $7tjnB.populateApplicationLicenseStates)();
    }
};
var $2fa1ffb69f94cd23$export$2e2bcd8739ae039 = $2fa1ffb69f94cd23$var$determineApplicationLicenseStates;

});

parcelRegister("h7NDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3c1966953638697$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
// Fallback to true(not allowed) if product does not exist. This makes sense, because the tenant has no product.
// If user tries to somehow access the feature they are not supposed to access, it should be blocked.
const $e3c1966953638697$var$parseProductPermissionGates = (productPermissionGatesRaw)=>({
        core: typeof productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$db515c8cec1e6f79] === 'boolean' ? productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$db515c8cec1e6f79] : true,
        software: typeof productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d] === 'boolean' ? productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$1346c9aa3cbb477d] : true,
        serviceDesk: typeof productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61] === 'boolean' ? productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61] : true,
        productDiscovery: typeof productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$202f50ee62667e32] === 'boolean' ? productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$202f50ee62667e32] : true,
        customerService: typeof productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$e9c56aa3b027d98f] === 'boolean' ? productPermissionGatesRaw[0, $eb8cfa569eede1a9$export$e9c56aa3b027d98f] : true
    });
const $e3c1966953638697$var$defaultProductPermissionGates = {
    core: true,
    software: true,
    serviceDesk: true,
    productDiscovery: true,
    customerService: true
};
const $e3c1966953638697$var$getProductPermissionGates = (getMetaImpl)=>{
    try {
        const productPermissionGatesRaw = JSON.parse(getMetaImpl('ajs-product-permission-gates') || '{}');
        return $e3c1966953638697$var$parseProductPermissionGates(productPermissionGatesRaw);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing product permission gates from tenant context: ${error}`);
        return $e3c1966953638697$var$defaultProductPermissionGates;
    }
};
var $e3c1966953638697$export$2e2bcd8739ae039 = $e3c1966953638697$var$getProductPermissionGates;

});
/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';



parcelRegister("gToGk", function(module, exports) {
$parcel$export(module.exports, "getSsrStatus", () => $afb01c130a3ba6e6$export$1de0a071a0f828c6);
/* eslint-disable jira/filename-case */ 
var $59JfQ = parcelRequire("59JfQ");

var $xuQLH = parcelRequire("xuQLH");
function $afb01c130a3ba6e6$export$1de0a071a0f828c6() {
    if (false) {
        if ((0, $59JfQ.getIsModernSsr)()) {
            if ((0, $xuQLH.getStaticFallbackContext)()) return 'static';
            return 'modern';
        }
        return 'legacy';
    }
    return 'client';
}

});
parcelRegister("59JfQ", function(module, exports) {
$parcel$export(module.exports, "getIsModernSsr", () => $0750283f5e5b7a00$export$6c0348fe79672e74);
/* eslint-disable jira/filename-case */ 
var $aFBfN = parcelRequire("aFBfN");
function $0750283f5e5b7a00$export$6c0348fe79672e74() {
    return 0, $aFBfN.IS_MODERN_SSR;
}

});

parcelRegister("xuQLH", function(module, exports) {
$parcel$export(module.exports, "getStaticFallbackContext", () => $bb7ed67b6c95707e$export$7b4f4d9a4cd11663);
/* eslint-disable jira/filename-case */ let $bb7ed67b6c95707e$var$isInStaticFallbackContext = false;
function $bb7ed67b6c95707e$export$1734e2025f0c9ae5(value) {
    $bb7ed67b6c95707e$var$isInStaticFallbackContext = value;
}
function $bb7ed67b6c95707e$export$7b4f4d9a4cd11663() {
    return $bb7ed67b6c95707e$var$isInStaticFallbackContext;
}

});


parcelRegister("5HYmv", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $91b44a2ca87cb712$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $91b44a2ca87cb712$export$6f14342128c6eaa4);
const $91b44a2ca87cb712$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $91b44a2ca87cb712$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$91b44a2ca87cb712$export$b5bdb04ea16a02e3
];
const $91b44a2ca87cb712$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$91b44a2ca87cb712$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gm');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $91b44a2ca87cb712$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($91b44a2ca87cb712$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $91b44a2ca87cb712$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $91b44a2ca87cb712$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("7YAQr", function(module, exports) {
$parcel$export(module.exports, "normaliseSentryEvent", () => $ee40ade47b410118$export$c1a1d522906bf17c);

var $66ukR = parcelRequire("66ukR");

var $i860n = parcelRequire("i860n");

var $lCetP = parcelRequire("lCetP");

var $41zzZ = parcelRequire("41zzZ");

var $7RVVN = parcelRequire("7RVVN");

var $eXdAp = parcelRequire("eXdAp");

var $ejDuo = parcelRequire("ejDuo");

var $a0kXA = parcelRequire("a0kXA");

var $gXtG2 = parcelRequire("gXtG2");
let $ee40ade47b410118$var$REPORTED_ERRORS = new WeakSet();
let $ee40ade47b410118$var$REPORTED_STRING_ERRORS = new WeakSet();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $ee40ade47b410118$var$REPORTED_ERRORS = new WeakSet();
    $ee40ade47b410118$var$REPORTED_STRING_ERRORS = new WeakSet();
});
const $ee40ade47b410118$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = new Set();
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.add(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    return Array.from(fragmentNames);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ee40ade47b410118$var$getBackendStatus = (exception)=>exception.statusCode || exception.cause?.statusCode || exception.cause?.extensions?.statusCode || exception.metadata?.statusCode || (0, $lCetP.isBackendAPIError)(exception) && 'true' || 'false';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ee40ade47b410118$var$getTraceId = (exception)=>exception.traceId || exception.cause?.traceId || exception.cause?.extensions?.traceId || undefined;
// Add custom tags based on stack trace
const $ee40ade47b410118$var$getTaggedData = (data, hint, samplingResult)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    if (typeof exception === 'string') return data;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    taggedData.tags = {
        backend: $ee40ade47b410118$var$getBackendStatus(exception),
        hash: (0, $eXdAp.getErrorHash)(exception),
        userLocation: (0, $41zzZ.getUserLocation)(),
        traceId: $ee40ade47b410118$var$getTraceId(exception),
        ...taggedData.tags
    };
    const fragmentNames = $ee40ade47b410118$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    if (samplingResult && samplingResult.samplingRate !== null) // this tag indicates the true volume of the exception being sampled
    taggedData.tags.sampled = `1/${samplingResult.samplingRate}`;
    return taggedData;
};
/**
 * It's possible to receive an event with a string exception instead of an Error object.
 * This is typically the case when we catch a console.error.
 *
 * This function performs the same normalisation as `normaliseSentryEvent`, but only includes the steps that are relevant for strings
 */ const $ee40ade47b410118$var$normaliseStringException = (event, hint)=>{
    const exception = hint?.originalException;
    if (typeof exception !== 'string') return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($ee40ade47b410118$var$REPORTED_STRING_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $ee40ade47b410118$var$REPORTED_STRING_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $7RVVN.default)(updatedData.request.url);
    updatedData = (0, $a0kXA.stackFrameAssetRewrite)(updatedData);
    const samplingResult = (0, $ejDuo.default)(exception, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    updatedData.tags = {
        userLocation: (0, $41zzZ.getUserLocation)(),
        ...updatedData.tags
    };
    return updatedData;
};
const $ee40ade47b410118$export$c1a1d522906bf17c = (event, hint)=>{
    // We want to report only real exceptions, so we filter out everything that is non-error
    const exception = hint?.originalException;
    if (!event || event.environment === 'development') return null;
    if (typeof exception === 'string' && (0, $i860n.fg)('jira-capture-console-errors-in-sentry')) return $ee40ade47b410118$var$normaliseStringException(event, hint);
    if (!(exception instanceof Error)) return null;
    // Ignore errors coming from unsupported browsers (or faking it)
    const isSupportedUA = (0, $66ukR.isChrome)(84) || (0, $66ukR.isFirefox)(76) || (0, $66ukR.isSafari)(15) || (0, $66ukR.isEdge)(84);
    if (!('allSettled' in Promise) || !isSupportedUA) return null;
    // Ignore errors that explicitly want to skip Sentry
    if ('skipSentry' in exception && (exception.skipSentry === true || typeof exception.skipSentry === 'function' && exception.skipSentry())) return null;
    // Ignore network-like errors
    if ((0, $lCetP.isClientFetchError)(exception)) return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($ee40ade47b410118$var$REPORTED_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $ee40ade47b410118$var$REPORTED_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $7RVVN.default)(updatedData.request.url);
    updatedData = (0, $a0kXA.stackFrameAssetRewrite)(updatedData);
    let samplingResult = (0, $ejDuo.default)(exception?.message, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    if ((0, $lCetP.isBackendAPIError)(exception)) {
        // capture only 1/X of backend API errors
        const samplingRate = 20;
        samplingResult = {
            limitCaptureException: Math.random() <= 1 / samplingRate,
            samplingRate: samplingRate
        };
        if (samplingResult.limitCaptureException) return null;
    }
    updatedData = $ee40ade47b410118$var$getTaggedData(updatedData, hint, samplingResult);
    return updatedData;
};

});
parcelRegister("7RVVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $405efef2510c9104$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $6Y4rz = parcelRequire("6Y4rz");
const $405efef2510c9104$var$applyMatchers = (url, mappings)=>{
    for(let i = 0; i < mappings.length; i += 1){
        const mapping = mappings[i];
        if (!mapping.matcher) return mapping.transformer;
        const match = url.match(mapping.matcher);
        if (match) {
            if (typeof mapping.transformer === 'string') {
                if (match.length > 1) throw new Error('Grouped matcher requires a match => string transformer');
                return mapping.transformer;
            }
            if (match.length === 1) throw new Error('Basic matcher only supports a string transformer');
            return mapping.transformer(match);
        }
    }
    throw new Error('No URL mappers matched! Expected a default matcher.');
};
const $405efef2510c9104$var$normaliseUrl = (url, mappings = (0, $6Y4rz.default))=>{
    let parsedUrl;
    try {
        // This is a little bit of a hack, it's really hard to actually get `url-parse` to throw an
        // error, so instead we set the default base URL to be the fallback - if parsing fails the
        // fallback URL will be the parsed URL
        parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(url, (0, $6Y4rz.PARSE_ERROR_FALLBACK_URL));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // we can't log the original URL or message because we could end up with UGC, so we return a
        // safe fallback URL so we don't lose the error
        return 0, $6Y4rz.PARSE_ERROR_FALLBACK_URL;
    }
    const partialUrl = `${parsedUrl.pathname}${parsedUrl.query}`;
    const result = $405efef2510c9104$var$applyMatchers(partialUrl, mappings);
    // For the purposes of normalisation, we assume we're only returning a path im the normalised URL
    return `${parsedUrl.protocol}//${parsedUrl.host}${result}`;
};
var $405efef2510c9104$export$2e2bcd8739ae039 = $405efef2510c9104$var$normaliseUrl;

});
parcelRegister("6Y4rz", function(module, exports) {
$parcel$export(module.exports, "PARSE_ERROR_FALLBACK_URL", () => $6fa81be8f940ba99$export$92f2182a552c2178);
$parcel$export(module.exports, "default", () => $6fa81be8f940ba99$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $6fa81be8f940ba99$var$PARSE_ERROR_FALLBACK_PATH = '/could-not-parse/';
const $6fa81be8f940ba99$export$92f2182a552c2178 = `https://unknown.example.com${$6fa81be8f940ba99$var$PARSE_ERROR_FALLBACK_PATH}`;
const $6fa81be8f940ba99$var$defaultMappings = [
    {
        matcher: /^\/browse\/.*/i,
        transformer: '/browse/:issueKey'
    },
    {
        matcher: /^\/project\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/project/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/c/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/servicedesk/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/core\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/core/projects/:projectKey/issues'
    },
    {
        matcher: /^\/issues/i,
        transformer: '/issues'
    },
    {
        matcher: /^\/jira\/issues/i,
        transformer: '/jira/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/backlog|\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/c/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/rest\/agile\/(.*?)\/board\/\d+\/configuration/i,
        transformer: (match)=>`/rest/agile/${match[1]}/board/:boardId/configuration`
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/backlog\/sprint-commitment/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/backlog/sprint-commitment'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/workload/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/workload'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/sprint-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/sprint-progress'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/blocked-issues/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/blocked-issues'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/epic-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/epic-progress'
    },
    {
        matcher: /^\/gateway\/api\/aris\/jira\/[a-f0-9-]+\/board\/\d+\/config/i,
        transformer: '/gateway/api/aris/jira/:cloudId/board/:boardId/config'
    },
    {
        matcher: /^\/gateway\/api\/jira-insights\/settings\/board\/\d+\/permissions\/board-admin/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId/permissions/board-admin'
    },
    {
        matcher: /\/gateway\/api\/jira-insights\/settings\/board\/\d+/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId'
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/sprint\/\d+\/burndown/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/sprint/:sprintId/burndown'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/queues\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/section\/[A-Z]+\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/section/:category/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+\/settings(\/[a-z]+)?/i,
        transformer: (match)=>`/projects/settings${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+.*?selectedItem=com\.atlassian\.jira\.jira-projects-plugin:(\w+)/i,
        transformer: (match)=>`/projects/:projectKey?selectedItem=com.atlassian.jira.jira-projects-plugin:${match[1]}`
    },
    {
        matcher: /^\/secure\/ConfigureReport!default.jspa.*?reportKey=com.atlassian.jira.plugin.system.reports:(\w+)/i,
        transformer: (match)=>`/secure/ConfigureReport!default.jspa?reportKey=com.atlassian.jira.plugin.system.reports:${match[1]}`
    },
    {
        matcher: /^\/secure\/((.*?\/)?\w+.jspa)/i,
        transformer: (match)=>`/secure/${match[1]}`
    },
    {
        matcher: /^\/plugins\/servlet\/(\w+)/i,
        transformer: (match)=>`/plugins/servlet/${match[1]}`
    },
    {
        matcher: /^\/jira\/your-work/i,
        transformer: '/jira/your-work'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/program\/\d+/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/summary/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/summary'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/calendar/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/teams/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/teams'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/releases/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/releases'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/dependencies/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+\/timeline/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
    },
    {
        matcher: /^\/jira\/plans\/\d+\/scenarios\/\d+/i,
        transformer: '/jira/plans/:planId/scenarios/:scenarioId'
    },
    // Part of the hack around detecting invalid URLs, if we've parsed to the fallback URL, then
    // we return the fallback path instead of the generic "unknown" path
    {
        matcher: new RegExp($6fa81be8f940ba99$var$PARSE_ERROR_FALLBACK_PATH),
        transformer: '/could-not-parse/'
    },
    {
        matcher: null,
        transformer: '/unknown'
    }
];
var $6fa81be8f940ba99$export$2e2bcd8739ae039 = $6fa81be8f940ba99$var$defaultMappings;

});


parcelRegister("eXdAp", function(module, exports) {
$parcel$export(module.exports, "getErrorHash", () => $53e5fc3ce884c427$export$211977f0fb53738b);
/* eslint-disable no-bitwise, no-fallthrough, default-case */ /**
 * JS Implementation of MurmurHash2
 * http://github.com/garycourt/murmurhash-js
 * http://sites.google.com/site/murmurhash/
 */ 
var $gXtG2 = parcelRequire("gXtG2");
const $53e5fc3ce884c427$var$murmurHash2 = (str, seed = 1)=>{
    let l = str.length;
    let h = seed ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
};
const $53e5fc3ce884c427$export$156fa11ef8a619c3 = (stack)=>{
    const assetPaths = stack.match(/\/([\w.~\-_]+)\.[jt]sx?/g);
    const lineCols = stack.match(/:\d+:\d+/g);
    // uncomment this to get more specific paths
    // const uniquePaths = (assetPaths || [])
    //     .slice(0, 10)
    //     .reduce((acc, v) => {
    //         const [asset] = v.split(':');
    //         if (!acc.includes(asset)) acc.push(asset);
    //         return acc;
    //     }, [])
    //     .slice(1, 5);
    return (assetPaths?.[0] ?? '') + (lineCols?.[0] ?? '');
};
let $53e5fc3ce884c427$var$cache = new WeakMap();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $53e5fc3ce884c427$var$cache = new WeakMap();
});
const $53e5fc3ce884c427$export$211977f0fb53738b = (error)=>{
    if ($53e5fc3ce884c427$var$cache.has(error)) return $53e5fc3ce884c427$var$cache.get(error);
    let stackStr = '';
    if (error.stack !== undefined) try {
        stackStr = $53e5fc3ce884c427$export$156fa11ef8a619c3(error.stack);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    let errorString = `${error.name} ${stackStr || error.message}`;
    const hash = $53e5fc3ce884c427$var$murmurHash2(errorString).toString(36).toUpperCase();
    try {
        $53e5fc3ce884c427$var$cache.set(error, hash);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    return hash;
};

});

parcelRegister("ejDuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f46f995e7e1168$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $WqSvO = parcelRequire("WqSvO");

var $8zwuE = parcelRequire("8zwuE");
const $b9f46f995e7e1168$var$checkForRuleMatch = (config, message, url)=>{
    const { matcher: matcher, route: route } = config;
    // Rule #1: no regex match on message
    if (!matcher.test(message || '')) return false;
    // Rule #2: If the config has a route specific condition
    if (route !== undefined) {
        // the sampling config requires the error originates from a certain route to be limited
        const matchesRoute = Boolean(url !== undefined && url.endsWith(route));
        if (!matchesRoute) return false;
    }
    return true;
};
// The Math.random produces a 0-1 number then multiplied by samplingRate
const $b9f46f995e7e1168$var$shouldLimit = (samplingRate)=>Math.floor(Math.random() * samplingRate) !== 0;
const $b9f46f995e7e1168$export$bb9cc46c6e38bd57 = (ruleSet, shouldLimitFn)=>(message, url)=>{
        // Find the matching config and store the rate, otherwise null
        const rule = ruleSet.find((config)=>$b9f46f995e7e1168$var$checkForRuleMatch(config, message, url));
        const samplingRate = !(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(rule) ? rule.samplingRate : null;
        return {
            limitCaptureException: !(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(samplingRate) ? shouldLimitFn(samplingRate) : false,
            samplingRate: samplingRate
        };
    };
const $b9f46f995e7e1168$var$sentrySampling = $b9f46f995e7e1168$export$bb9cc46c6e38bd57((0, $8zwuE.default), $b9f46f995e7e1168$var$shouldLimit);
var $b9f46f995e7e1168$export$2e2bcd8739ae039 = $b9f46f995e7e1168$var$sentrySampling;

});
parcelRegister("8zwuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f353cfb11801f65$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ /**
 * BEFORE adding a new sampling configuration:
 * - Ensure no recent change in volume for the error type
 * - Talk to the owners of the error. Confirm there is no other easy fix
 * - Create an issue to improve signal to noise for the error type
 */ const $1f353cfb11801f65$var$SENTRY_SAMPLING_CONFIG = [
    {
        // Ignore postrobot errors triggered by forge as team won't fix
        // https://atlassian.slack.com/archives/C03MMQ1B39V/p1671517439783989
        matcher: /postrobot_method/,
        samplingRate: 0
    },
    {
        // Ignore e.source.postMessage from monolith Connect JS as caused by callback on a closed window
        // https://atlassian.slack.com/archives/CFGTZ99TL/p1677032642940009
        matcher: /postMessage'\)/,
        samplingRate: 0
    },
    {
        // JFP-1542
        matcher: /^\[Frontend PubSub\] Failed to retrieve subscription configuration \[object Object\]$/,
        samplingRate: 10
    },
    {
        // Filter out local storage quota exceeded errors for atlassian-analytics.jira.lock
        // Non-actionable browser quota limitation errors that create noise in Sentry
        matcher: /Setting the value of 'atlassian-analytics\.jira\.lock' exceeded the quota/,
        samplingRate: 0
    }
];
var $1f353cfb11801f65$export$2e2bcd8739ae039 = $1f353cfb11801f65$var$SENTRY_SAMPLING_CONFIG;

});


parcelRegister("a0kXA", function(module, exports) {
$parcel$export(module.exports, "stackFrameAssetRewrite", () => $eb71ab8c635f3dba$export$94684a7ef5037b24);
const $eb71ab8c635f3dba$export$94684a7ef5037b24 = (data)=>{
    // There isn't a strong type definition for the `data` object with
    // raven-js (it's literally `any`), so we have to do some shape validation to find the deep
    // part we're interested in (if it exists). We're also extra defensive by wrapping the whole
    // thing in a try/catch - if an error occurs we'll just return the data as-is.
    try {
        const rewriteStacktrace = (value)=>{
            if (!(value && value.stacktrace && value.stacktrace.frames && value.stacktrace.frames.length)) return;
            value.stacktrace.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                // eslint-disable-next-line no-param-reassign
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `data.stacktrace`
        rewriteStacktrace(data);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (!(data.exception && data.exception.values && data.exception.values.length)) return data;
        data.exception.values.forEach(rewriteStacktrace);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return data;
};

});


parcelRegister("dcgSS", function(module, exports) {
$parcel$export(module.exports, "handleAtlaspackErrors", () => $d9c08012e26d28bd$export$5087a2ae4570e1ae);

var $i860n = parcelRequire("i860n");

var $fEmTm = parcelRequire("fEmTm");
class $d9c08012e26d28bd$var$AtlaspackErrors extends Array {
    constructor(...args){
        super(...args);
        // Report errors immediately on initialisation, as atlaspack may have already pushed errors
        this.reportErrors();
    }
    push(...args) {
        const result = super.push(...args);
        // Report errors immediately after pushing
        this.reportErrors();
        return result;
    }
    /**
	 * Report errors in this array state to Sentry
	 */ reportErrors() {
        while(this.length > 0){
            const error = this.shift();
            if (error) (0, $fEmTm.captureException)('atlaspack', error);
        }
    }
}
$d9c08012e26d28bd$var$AtlaspackErrors.displayName = "AtlaspackErrors";
const $d9c08012e26d28bd$export$5087a2ae4570e1ae = ()=>{
    if (!(0, $i860n.fg)('jira_atlaspack_errors_array_tracker')) return;
    // This variable is defined by Atlaspack, cast so we can have type safety in this file
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = globalThis;
    if (!(globalVar.__ATLASPACK_ERRORS instanceof $d9c08012e26d28bd$var$AtlaspackErrors)) globalVar.__ATLASPACK_ERRORS = new $d9c08012e26d28bd$var$AtlaspackErrors(...globalVar.__ATLASPACK_ERRORS ?? []);
};

});



parcelRegister("lSsUZ", function(module, exports) {
$parcel$export(module.exports, "platformErrorHandler", () => $009062697f811da2$export$51242f403a159805);

var $cCE2Z = parcelRequire("cCE2Z");
function $009062697f811da2$export$51242f403a159805(payload) {
    (0, $cCE2Z.reportError)(payload.error, payload.errorInfo, {
        id: payload.interactionId
    });
}

});
parcelRegister("cCE2Z", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $48c37dfaf97d1345$export$b33b857ad1d9900e);
$parcel$export(module.exports, "default", () => $48c37dfaf97d1345$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $5ARAC = parcelRequire("5ARAC");

var $eXdAp = parcelRequire("eXdAp");

var $4FR7Y = parcelRequire("4FR7Y");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $jnHs7 = parcelRequire("jnHs7");

var $6CfY5 = parcelRequire("6CfY5");

var $fEmTm = parcelRequire("fEmTm");

var $75sVW = parcelRequire("75sVW");

var $i860n = parcelRequire("i860n");

var $9nZGZ = parcelRequire("9nZGZ");
const $48c37dfaf97d1345$var$EGRESS_LIMIT = 5;
const $48c37dfaf97d1345$var$getLocation = ({ id: id, packageName: packageName, prefixOverride: prefixOverride })=>{
    const prefix = prefixOverride != null ? prefixOverride : 'common';
    if (id != null) return packageName != null ? `${prefix}.error-boundary.${packageName}.${id}` : `${prefix}.error-boundary.${id}`;
    return `${prefix}.error-boundary`;
};
const $48c37dfaf97d1345$var$ErrorBoundary = (props)=>{
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    const interactionContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    const OwnershipMarker = (0, $5ARAC.useOwnershipMarkerComponent)({
        markerType: 'error-boundary',
        name: props.id ?? 'unknown',
        packageName: props.packageName,
        teamName: props.teamName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(OwnershipMarker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($48c37dfaf97d1345$export$4b4ea7be124cdbd8, {
        ...props,
        ufoInteractionId: interactionId.current,
        ufoLabelStack: interactionContext?.labelStack
    }));
};
$48c37dfaf97d1345$var$ErrorBoundary.displayName = "ErrorBoundary";
function $48c37dfaf97d1345$export$b33b857ad1d9900e(error, info, { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData = {} }, interactionId, labelStack) {
    // Somehow, the ErrorBoundary component catch an undefined error.
    // So this check helps to reduce the noise in our Sentry.
    const errorToReport = error ?? new (0, $9nZGZ.UnknownError)();
    const isFetchOrValidationError = errorToReport instanceof (0, $75sVW.default) || errorToReport instanceof (0, $75sVW.ValidationError);
    const isRelayError = (0, $75sVW.isRelayNetworkError)(errorToReport);
    const getErrorStatusCode = ()=>{
        if (isFetchOrValidationError) return errorToReport.statusCode;
        if (isRelayError) return errorToReport.source?.errors?.[0]?.extensions?.statusCode;
    };
    const hash = (0, $eXdAp.getErrorHash)(errorToReport);
    const event = {
        teamName: teamName ?? null,
        ...extraEventData,
        message: errorToReport.message ?? null,
        stack: errorToReport.stack ?? null,
        // FIXME type "ErrorInfo" used to be mistyped but the type fix propagates in a non-trivial way,
        // cf. PR https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137436/
        // Progress over perfection: I'm casting to keep the above PR type-only.
        // Next dev actively changing this code, please remove the type cast and use selective inclusion instead.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        componentStack: info.componentStack,
        hash: hash ?? null
    };
    const location = $48c37dfaf97d1345$var$getLocation({
        id: id,
        packageName: packageName,
        prefixOverride: prefixOverride
    });
    $48c37dfaf97d1345$export$4b4ea7be124cdbd8.logErrorToSplunk(hash, location, event);
    (0, $fEmTm.captureException)(location, errorToReport, // @ts-expect-error TS2345: Index signature for type string is missing in type ErrorInfo
    info);
    if (interactionId) {
        if ((0, $i860n.fg)('obsrve-2504-add-errorhash-to-ufo-message')) (0, $siTdT.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, hash, getErrorStatusCode());
        else (0, $siTdT.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, undefined, getErrorStatusCode());
    } else if ((0, $i860n.fg)('obsrve-2504-add-errorhash-to-ufo-message')) (0, $siTdT.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, hash, getErrorStatusCode());
    else (0, $siTdT.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, getErrorStatusCode());
    if (onError) onError(location, errorToReport, event);
}
class $48c37dfaf97d1345$export$4b4ea7be124cdbd8 extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            children: null,
            extraEventData: {},
            render: ()=>null,
            withExperienceTracker: false,
            onError: ()=>undefined,
            ufoInteractionId: null,
            ufoLabelStack: null
        };
    }
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.errorFrequencyMap = new Map();
    }
    // go/jfe-eslint
    // eslint-disable-next-line react/sort-comp
    static logErrorToSplunk(hash, location, event) {
        let occurrences;
        if (hash !== undefined) {
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            occurrences = (this.errorFrequencyMap.get(hash) ?? 0) + 1;
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            this.errorFrequencyMap.set(hash, occurrences);
        } else // If there's no hash, treat it as the first time
        occurrences = 1;
        // Only send the error log if we are below the egress limit
        if (occurrences <= $48c37dfaf97d1345$var$EGRESS_LIMIT) (0, $6CfY5.default).safeErrorWithoutCustomerData(location, 'Unhandled error caught by error boundary', event);
    }
    static getDerivedStateFromProps(props, state) {
        if (!!props.resetCaughtError && state.caughtError?.error === props.resetCaughtError) return {
            ...state,
            caughtError: null
        };
        return state;
    }
    componentDidCatch(error, info) {
        const { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData } = this.props;
        this.setState({
            caughtError: {
                error: error,
                info: info
            }
        });
        // passing this.props will cause "'onError' PropType is defined but prop is never used" eslint error
        $48c37dfaf97d1345$export$b33b857ad1d9900e(error, info, {
            id: id,
            packageName: packageName,
            teamName: teamName,
            prefixOverride: prefixOverride,
            onError: onError,
            extraEventData: extraEventData
        }, this.props.ufoInteractionId, this.props.ufoLabelStack);
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: RenderFallback, withExperienceTracker: withExperienceTracker, extraEventData: extraEventData } = this.props;
        if (!caughtError) return children;
        const location = $48c37dfaf97d1345$var$getLocation(this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(RenderFallback, {
            error: caughtError.error
        }), withExperienceTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jnHs7.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: extraEventData
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}
$48c37dfaf97d1345$export$4b4ea7be124cdbd8.displayName = "ErrorBoundaryInner";
var $48c37dfaf97d1345$export$2e2bcd8739ae039 = $48c37dfaf97d1345$var$ErrorBoundary;

});
parcelRegister("5ARAC", function(module, exports) {
$parcel$export(module.exports, "useOwnershipMarkerComponent", () => $43e32f420c1ba142$export$3e3d8535d27f3df3);

var $euxye = parcelRequire("euxye");

var $gXtG2 = parcelRequire("gXtG2");

var $6t4Ql = parcelRequire("6t4Ql");
const $43e32f420c1ba142$var$MARKER_COMPONENTS = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $43e32f420c1ba142$var$MARKER_COMPONENTS.clear();
});
const $43e32f420c1ba142$var$createKeyForComponent = ({ markerType: markerType, name: name, packageName: packageName, teamName: teamName })=>{
    return `${markerType}/${name}/${packageName ?? (0, $6t4Ql.NULL_STR)}/${teamName ?? (0, $6t4Ql.NULL_STR)}`;
};
const $43e32f420c1ba142$export$3e3d8535d27f3df3 = (nextParams)=>{
    const params = (0, $euxye.useRef)(nextParams).current;
    const componentKey = $43e32f420c1ba142$var$createKeyForComponent(params);
    const ExistingComponent = $43e32f420c1ba142$var$MARKER_COMPONENTS.get(componentKey);
    if (ExistingComponent) return ExistingComponent;
    const NewComponent = ({ children: children })=>children;
    const ownershipMarkerName = $43e32f420c1ba142$var$encodeDisplayName(params);
    Object.defineProperty(NewComponent, 'name', {
        value: ownershipMarkerName
    });
    NewComponent.displayName = ownershipMarkerName;
    $43e32f420c1ba142$var$MARKER_COMPONENTS.set(componentKey, NewComponent);
    return NewComponent;
};
const $43e32f420c1ba142$var$encodeDisplayName = ({ markerType: markerType, name: name, packageName: packageName = (0, $6t4Ql.NULL_STR), teamName: teamName = (0, $6t4Ql.NULL_STR) })=>{
    return `${0, $6t4Ql.OWNER_PREFIX}${markerType}___${name}___${packageName}___${teamName}`;
};

});
parcelRegister("6t4Ql", function(module, exports) {
$parcel$export(module.exports, "NULL_STR", () => $ca3b5979b7c393d8$export$f930edd3f4fc2523);
$parcel$export(module.exports, "OWNER_PREFIX", () => $ca3b5979b7c393d8$export$e7fd45b374bf8fc0);
$parcel$export(module.exports, "extractOwnershipStack", () => $ca3b5979b7c393d8$export$2835e4008154306c);
$parcel$export(module.exports, "getOwningTeam", () => $ca3b5979b7c393d8$export$d6e429d0895093);
$parcel$export(module.exports, "getContainingPackageName", () => $ca3b5979b7c393d8$export$26973c6d18aa1840);
/* eslint-disable jira/filename-case */ const $ca3b5979b7c393d8$export$f930edd3f4fc2523 = '-';
const $ca3b5979b7c393d8$export$e7fd45b374bf8fc0 = 'OwnerMark___';
const $ca3b5979b7c393d8$export$2835e4008154306c = (reactComponentStack)=>{
    return reactComponentStack.split('\n').flatMap((untrimmedLine)=>{
        const line = untrimmedLine.trim();
        if (line.startsWith(`at ${$ca3b5979b7c393d8$export$e7fd45b374bf8fc0}`)) {
            const withoutPrefix = line.replace(`at ${$ca3b5979b7c393d8$export$e7fd45b374bf8fc0}`, '');
            // Exclude trailing `(source path + line number)`
            const withoutSuffix = withoutPrefix.split(' ')[0];
            return [
                withoutSuffix
            ];
        }
        return [];
    }).flatMap((line)=>{
        const parts = line.split('___');
        if (parts.length !== 4) return [];
        const [markerType, name, packageName, teamName] = parts;
        return [
            {
                markerType: markerType,
                name: name,
                packageName: packageName !== $ca3b5979b7c393d8$export$f930edd3f4fc2523 ? packageName : null,
                teamName: teamName !== $ca3b5979b7c393d8$export$f930edd3f4fc2523 ? teamName : null
            }
        ];
    });
};
const $ca3b5979b7c393d8$export$d6e429d0895093 = (ownershipStack)=>{
    return ownershipStack.map(({ teamName: teamName })=>teamName).find((teamName)=>teamName !== null) ?? null;
};
const $ca3b5979b7c393d8$export$26973c6d18aa1840 = (ownershipStack)=>{
    return ownershipStack.map(({ packageName: packageName })=>packageName).find((packageName)=>packageName !== null) ?? null;
};

});


parcelRegister("jnHs7", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccessTracker", () => $f675384fc482ef12$export$b721eda798584098);
$parcel$export(module.exports, "ExperienceFailureTracker", () => $f675384fc482ef12$export$7877e129ff70728d);
$parcel$export(module.exports, "ExperienceAbortTracker", () => $f675384fc482ef12$export$69d4d8a5c14b1454);
$parcel$export(module.exports, "ExperienceResultFromPropsTracker", () => $f675384fc482ef12$export$be2c49f6982d0964);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $l7vxt = parcelRequire("l7vxt");
class $f675384fc482ef12$export$3908b77264c263e4 extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            hasSucceeded: false,
            hasFailed: false,
            hasAborted: false,
            children: null
        };
    }
    componentDidMount() {
        this.postRenderChecks();
    }
    componentDidUpdate() {
        this.postRenderChecks();
    }
    postRenderChecks() {
        const { onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted } = this.props;
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }
    render() {
        return this.props.children;
    }
}
$f675384fc482ef12$export$3908b77264c263e4.displayName = "ResultDeclaredTrackerChildOld";
const $f675384fc482ef12$export$5ffc4962dc653e10 = ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded = false, hasFailed: hasFailed = false, hasAborted: hasAborted = false, children: children = null })=>{
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $euxye.useEffect)(()=>{
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }, [
        hasSucceeded,
        hasFailed,
        hasAborted,
        onExperienceSuccess,
        onExperienceFailure,
        onExperienceAbort
    ]);
    return children;
};
$f675384fc482ef12$export$5ffc4962dc653e10.displayName = "ResultDeclaredTrackerChildNew";
const $f675384fc482ef12$export$2a8244c81400d030 = $f675384fc482ef12$export$5ffc4962dc653e10;
const $f675384fc482ef12$export$b721eda798584098 = ({ children: children = null, failureEventAttributes: failureEventAttributes = null, parentProviders: parentProviders = null, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7vxt.ExperienceTracker), {
        failureEventAttributes: failureEventAttributes,
        parentProviders: parentProviders,
        ...props
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f675384fc482ef12$export$2a8244c81400d030, {
            hasSucceeded: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$f675384fc482ef12$export$b721eda798584098.displayName = "ExperienceSuccessTracker";
const $f675384fc482ef12$export$7877e129ff70728d = ({ children: children = null, failureEventAttributes: failureEventAttributes = null, parentProviders: parentProviders = null, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7vxt.ExperienceTracker), {
        failureEventAttributes: failureEventAttributes,
        parentProviders: parentProviders,
        ...props
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f675384fc482ef12$export$2a8244c81400d030, {
            hasFailed: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$f675384fc482ef12$export$7877e129ff70728d.displayName = "ExperienceFailureTracker";
const $f675384fc482ef12$export$69d4d8a5c14b1454 = ({ children: children = null, failureEventAttributes: failureEventAttributes = null, parentProviders: parentProviders = null, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7vxt.ExperienceTracker), {
        failureEventAttributes: failureEventAttributes,
        parentProviders: parentProviders,
        ...props
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f675384fc482ef12$export$2a8244c81400d030, {
            hasAborted: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$f675384fc482ef12$export$69d4d8a5c14b1454.displayName = "ExperienceAbortTracker";
const $f675384fc482ef12$export$be2c49f6982d0964 = ({ hasSucceeded: hasSucceeded = false, hasFailed: hasFailed = false, hasAborted: hasAborted = false, children: children = null, failureEventAttributes: failureEventAttributes = null, parentProviders: parentProviders = null, ...trackerProps })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l7vxt.ExperienceTracker), {
        failureEventAttributes: failureEventAttributes,
        parentProviders: parentProviders,
        ...trackerProps
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($f675384fc482ef12$export$2a8244c81400d030, {
            hasSucceeded: hasSucceeded,
            hasFailed: hasFailed,
            hasAborted: hasAborted,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$f675384fc482ef12$export$be2c49f6982d0964.displayName = "ExperienceResultFromPropsTracker";

});
parcelRegister("l7vxt", function(module, exports) {
$parcel$export(module.exports, "ExperienceTracker", () => $6009f6f6bee711fa$export$12b6b072930fd68f);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $6DzQn = parcelRequire("6DzQn");

var $3mIJe = parcelRequire("3mIJe");
const $6009f6f6bee711fa$export$12b6b072930fd68f = ({ children: children = null, location: location, failureEventAttributes: failureEventAttributes = null, parentProviders: parentProviders = null })=>{
    const experienceTrackerId = (0, $euxye.useId)();
    const context = (0, $euxye.useContext)((0, $6DzQn.default));
    (0, $euxye.useEffect)(()=>{
        if (context === null) (0, $6CfY5.default).safeErrorWithoutCustomerData('experience-tracker.missing-provider', 'Experience tracker rendered without a provider');
    }, [
        context
    ]);
    if (context == null || false) return typeof children === 'function' ? children({
        onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        onExperienceFailure: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        onExperienceAbort: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mIJe.default), {
        experienceTrackerId: (0, $i860n.fg)('jfp-magma-use-location-for-experience-tracker') ? location : experienceTrackerId,
        location: location,
        experienceContext: context,
        failureEventAttributes: failureEventAttributes,
        parentProvidersWhitelist: parentProviders
    }, children);
};
$6009f6f6bee711fa$export$12b6b072930fd68f.displayName = "ExperienceTracker";

});
parcelRegister("6DzQn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e342321bc2f6ef6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $6e342321bc2f6ef6$var$ExperienceContext = /*#__PURE__*/ (0, $euxye.createContext)(null);
var $6e342321bc2f6ef6$export$2e2bcd8739ae039 = $6e342321bc2f6ef6$var$ExperienceContext;

});

parcelRegister("3mIJe", function(module, exports) {
$parcel$export(module.exports, "default", () => $10b59616aa8956d8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $lCetP = parcelRequire("lCetP");
class $10b59616aa8956d8$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    constructor(props){
        super(props), this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess && this.isReportingToCurrentProvider()) {
                this.hasSignalledSuccess = true;
                this.props.experienceContext.consumerCallbacks.onSuccess(this.props.experienceTrackerId);
            }
        }, this.onFailure = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onFailure: onFailure } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onFailure(concatenatedLocation, mergedFailureAttributes);
            }
        }, this.onAbort = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onAbort: onAbort } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onAbort(concatenatedLocation, mergedFailureAttributes);
            }
        };
        this.resetTracker();
    }
    componentDidCatch(error) {
        if (!(0, $lCetP.isClientFetchError)(error)) this.onFailure(undefined, {
            errorMessage: error.message
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    componentWillUnmount() {
        // This guards against scenarios where the experience tracker has an unstable parent.
        // With concurrent rendering, it's possible that this component was rendered, but never "committed",
        // in this scenario, we would have called onPending for a version of this component at would never succeed OR fail.
        if ((0, $i860n.fg)('jfp-magma-fix-experience-tracker-concurrency')) this.props.experienceContext.consumerCallbacks.onClearPending(this.props.experienceTrackerId);
    }
    isReportingToCurrentProvider() {
        const { experience: experience } = this.props.experienceContext;
        return(// parentProviders is an OPTIONAL whitelist. If not specified, then we are definitely reporting to the current experience
        this.parentProvidersWhitelistSet == null || // otherwise make sure we are currently in one of the listed experiences
        this.parentProvidersWhitelistSet.has(experience));
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetTracker() {
        this.hasSignalledFailure = false;
        this.hasSignalledSuccess = false;
        this.lastExperienceId = this.props.experienceContext.experienceId;
        // Must only respect updates to `parentProvidersWhitelist` when the experience resets, otherwise weird bugs can arise.
        // Eg: a component could call onSuccess when it never called onPending, this would result in premature experience successes.
        this.parentProvidersWhitelistSet = this.props.parentProvidersWhitelist ? new Set(this.props.parentProvidersWhitelist) : null;
        this.isReportingToCurrentProvider() && this.props.experienceContext.consumerCallbacks.onPending(this.props.experienceTrackerId);
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.lastExperienceId !== this.props.experienceContext.experienceId) this.resetTracker();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        const { children: children } = this.props;
        return typeof children === 'function' ? children({
            onExperienceSuccess: this.onSuccess,
            onExperienceFailure: this.onFailure,
            onExperienceAbort: this.onAbort
        }) : children;
    }
}
$10b59616aa8956d8$export$2e2bcd8739ae039.displayName = "TrackerBase";

});



parcelRegister("9nZGZ", function(module, exports) {
$parcel$export(module.exports, "UnknownError", () => $28814c01b1ee1c4e$export$ff4405149dbd0c5c);
class $28814c01b1ee1c4e$export$ff4405149dbd0c5c extends Error {
    constructor(){
        super();
        this.name = 'UnknownError';
        this.message = 'There is something wrong and ErrorBoundary component catch an undefined error.';
    }
}
$28814c01b1ee1c4e$export$ff4405149dbd0c5c.displayName = "UnknownError";

});




parcelRegister("8w5ez", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "AnalyticsProviders", () => $4cc7cf5603460a40$export$fe99df39f319f93e);
$parcel$export(module.exports, "default", () => $4cc7cf5603460a40$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $7Odw0 = parcelRequire("7Odw0");

var $6CfY5 = parcelRequire("6CfY5");

var $aZMdt = parcelRequire("aZMdt");

var $6zTYs = parcelRequire("6zTYs");

var $eijVy = parcelRequire("eijVy");

var $6bEm8 = parcelRequire("6bEm8");

var $ffNik = parcelRequire("ffNik");

var $599w8 = parcelRequire("599w8");
const $4cc7cf5603460a40$export$fe99df39f319f93e = ({ children: children })=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    (0, $euxye.useEffect)(()=>{
        if (false) return;
        try {
            const success = (0, $ffNik.initAnalytics)({
                ...tenantContext,
                orgId: orgId
            });
            if (success === undefined) throw new Error('observability.analytics-providers-error: @atlassiansox/analytics-web-client AnalyticsClient in src/common/analytics-web-react/web-client/index.js failed to initialise successfully');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData('observability.analytics-providers.analytics', e);
        }
    }, [
        orgId,
        tenantContext
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
    // Temporary analytics for our experiment
    const mobileAnalytics = {
        isMobileUserAgent: (0, $7Odw0.isSupportedUserAgent)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        userAgent: navigator?.userAgent
    };
    /**
	 * As per Jira: Incident Detection and Reliability Uplift we need to add shard and region to the analytics context
	 * This will add shard and region to all analytics events fired throughout the application
	 * we check for false above to ensure SSR does not break with getMeta()
	 */ const shardAndRegionAnalytics = {
        shard: (0, $6bEm8.default)('ajs-shard') || '',
        region: (0, $6bEm8.default)('ajs-region') || ''
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $599w8.JiraStructuredAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: {
            isSPA: __SPA__,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            variant: window.BUILD_VARIANT,
            ...mobileAnalytics,
            ...shardAndRegionAnalytics
        }
    }, children));
};
$4cc7cf5603460a40$export$fe99df39f319f93e.displayName = "AnalyticsProviders";
var $4cc7cf5603460a40$export$2e2bcd8739ae039 = $4cc7cf5603460a40$export$fe99df39f319f93e;

});
parcelRegister("7Odw0", function(module, exports) {
$parcel$export(module.exports, "isSupportedUserAgent", () => $fed2988c07101471$export$2b0f0a801c573b06);
$parcel$export(module.exports, "isAndroidUserAgent", () => $fed2988c07101471$export$6053d3a1e6477e0f);
$parcel$export(module.exports, "isTabletUserAgent", () => $fed2988c07101471$export$a33e336659bb3eb6);
$parcel$export(module.exports, "shouldShowReturnToMobileBanner", () => $fed2988c07101471$export$604401c0b63e5273);
$parcel$export(module.exports, "shouldShowDismissButton", () => $fed2988c07101471$export$5ad7f0440f4fd036);
$parcel$export(module.exports, "determineOperatingSystemAttribute", () => $fed2988c07101471$export$d9f2497f8d710783);
$parcel$export(module.exports, "default", () => $fed2988c07101471$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/cookie -- This reduced TS complexity by 3,114,190 across Jira

var $8BEEb = parcelRequire("8BEEb");
/*
This logic was ported from MobileUtils class from jira monolith to
provide the same conditions for checking whether the user agent is mobile or not.
*/ const $fed2988c07101471$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $fed2988c07101471$var$MOBILE_USER_AGENT_REGEX = /Android|iPhone|iPad|Mobil/i;
const $fed2988c07101471$var$MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const $fed2988c07101471$var$IPAD_USER_AGENT = new RegExp('iPad;');
const $fed2988c07101471$var$IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const $fed2988c07101471$var$ANDROID_USER_AGENT = new RegExp('Android');
// This regex matches the following iOS rendering engines:
// 1. Chrome for iOS
// 2. Firefox for iOS
// 3. Edge for iOS
const $fed2988c07101471$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT = new RegExp('CriOS|FxiOS|EdgiOS');
// Fallback for SSR where navigator.userAgent is not available
let $fed2988c07101471$var$userAgentHeader;
function $fed2988c07101471$export$1eb6cb6b3175e409(userAgent) {
    $fed2988c07101471$var$userAgentHeader = userAgent;
}
const $fed2988c07101471$export$2b0f0a801c573b06 = ()=>{
    const userAgent = globalThis.navigator?.userAgent ?? $fed2988c07101471$var$userAgentHeader;
    return userAgent !== undefined && $fed2988c07101471$var$MOBILE_USER_AGENT_REGEX.test(userAgent);
};
const $fed2988c07101471$export$6053d3a1e6477e0f = ()=>{
    const userAgent = globalThis.navigator?.userAgent ?? $fed2988c07101471$var$userAgentHeader;
    return userAgent !== undefined && $fed2988c07101471$var$ANDROID_USER_AGENT.test(userAgent);
};
const $fed2988c07101471$export$b4161aa2f4036482 = ()=>{
    const userAgent = globalThis.navigator?.userAgent ?? $fed2988c07101471$var$userAgentHeader;
    return userAgent !== undefined && $fed2988c07101471$var$IOS_USER_AGENT.test(userAgent);
};
const $fed2988c07101471$export$a33e336659bb3eb6 = ()=>{
    const userAgent = globalThis.navigator?.userAgent ?? $fed2988c07101471$var$userAgentHeader;
    if (!userAgent) return false;
    return $fed2988c07101471$var$IPAD_USER_AGENT.test(userAgent) || $fed2988c07101471$export$6053d3a1e6477e0f() && !$fed2988c07101471$var$MOBILE_STRING_IN_USER_AGENT.test(userAgent);
};
const $fed2988c07101471$var$isDesktopSwitchEnabled = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8BEEb))).get($fed2988c07101471$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const $fed2988c07101471$var$isMobileUserAgent = ()=>$fed2988c07101471$export$2b0f0a801c573b06() && !$fed2988c07101471$var$isDesktopSwitchEnabled();
const $fed2988c07101471$export$1cb1de725ba5b3e3 = ()=>{
    const userAgent = globalThis.navigator?.userAgent ?? $fed2988c07101471$var$userAgentHeader;
    if (!userAgent) return false;
    return $fed2988c07101471$export$b4161aa2f4036482() && !$fed2988c07101471$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT.test(userAgent);
};
const $fed2988c07101471$export$604401c0b63e5273 = ()=>{
    return $fed2988c07101471$export$2b0f0a801c573b06() && !$fed2988c07101471$export$1cb1de725ba5b3e3();
};
const $fed2988c07101471$export$5ad7f0440f4fd036 = ()=>$fed2988c07101471$export$604401c0b63e5273() && $fed2988c07101471$export$a33e336659bb3eb6();
const $fed2988c07101471$export$d9f2497f8d710783 = ()=>{
    if ($fed2988c07101471$export$b4161aa2f4036482()) return 'ios';
    if ($fed2988c07101471$export$6053d3a1e6477e0f()) return 'android';
    return 'other';
};
var $fed2988c07101471$export$2e2bcd8739ae039 = $fed2988c07101471$var$isMobileUserAgent;

});

parcelRegister("aZMdt", function(module, exports) {
$parcel$export(module.exports, "extractContextualData", () => $c7c14bdb8c107ef6$export$dc30f43798194b03);
$parcel$export(module.exports, "ContextualAnalyticsData", () => $c7c14bdb8c107ef6$export$198470770171c65);
/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $808aL = parcelRequire("808aL");

var $3irVK = parcelRequire("3irVK");

var $hUqPj = parcelRequire("hUqPj");
const $c7c14bdb8c107ef6$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
};
const $c7c14bdb8c107ef6$export$198470770171c65 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    const data = $c7c14bdb8c107ef6$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hUqPj.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, props.children));
});

});

parcelRegister("6zTYs", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $c92854a71bb403ca$export$52a03a3207af3687);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $6bEm8 = parcelRequire("6bEm8");
const $c92854a71bb403ca$export$52a03a3207af3687 = ()=>{
    const orgId = (0, $6bEm8.default)('ajs-org-id');
    return {
        data: orgId || undefined
    };
};

});

parcelRegister("eijVy", function(module, exports) {
$parcel$export(module.exports, "TenantContextContainer", () => $cdf7003c8b36303b$export$8b5d54c1fa2f746f);
$parcel$export(module.exports, "TenantContextSubscriber", () => $cdf7003c8b36303b$export$9d1e1d1d0f8eeb35);
$parcel$export(module.exports, "useTenantContextHook", () => $cdf7003c8b36303b$export$b24a99788063c041);
$parcel$export(module.exports, "useTenantContext", () => $cdf7003c8b36303b$export$28e7c557f4d454d9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $iGu4q = parcelRequire("iGu4q");

var $1vdeU = parcelRequire("1vdeU");

var $8GgAm = parcelRequire("8GgAm");
const $cdf7003c8b36303b$export$8b5d54c1fa2f746f = (0, $dB6ay.createContainer)((0, $8GgAm.default), {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($1vdeU.bootstrap())
});
const $cdf7003c8b36303b$export$9d1e1d1d0f8eeb35 = (0, $iGu4q.createSubscriber)((0, $8GgAm.default), {
    displayName: 'TenantContextSubscriber'
});
const $cdf7003c8b36303b$export$b24a99788063c041 = (0, $3h1FP.createHook)((0, $8GgAm.default));
const $cdf7003c8b36303b$export$28e7c557f4d454d9 = ()=>{
    const [{ tenantContext: tenantContext }] = $cdf7003c8b36303b$export$b24a99788063c041();
    return tenantContext;
};

});
parcelRegister("1vdeU", function(module, exports) {
$parcel$export(module.exports, "bootstrap", () => $3f193903393266db$export$36aff1fbb4f5dfc6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2HuOR = parcelRequire("2HuOR");
const $3f193903393266db$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState, getState: getState }, { getMeta: getMeta })=>{
        if (getState().tenantContext) return;
        const tenantContext = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)(getMeta);
        setState({
            tenantContext: tenantContext
        });
    };

});

parcelRegister("8GgAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c83073ade7f367a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5QDqc = parcelRequire("5QDqc");

var $1vdeU = parcelRequire("1vdeU");
// @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'TenantContext'.
const $2c83073ade7f367a$var$initialState = {
    tenantContext: null
};
const $2c83073ade7f367a$var$tenantContextStore = (0, $5QDqc.createStore)({
    name: 'tenantContext',
    initialState: $2c83073ade7f367a$var$initialState,
    actions: $1vdeU
});
var $2c83073ade7f367a$export$2e2bcd8739ae039 = $2c83073ade7f367a$var$tenantContextStore;

});


parcelRegister("ffNik", function(module, exports) {
$parcel$export(module.exports, "initAnalytics", () => $f0dbc2fded0931b2$export$f2a39aaa42ea357a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hz0Ap = parcelRequire("hz0Ap");

var $l9ND4 = parcelRequire("l9ND4");

var $4D4Jz = parcelRequire("4D4Jz");

var $aNyDs = parcelRequire("aNyDs");

var $ajsFq = parcelRequire("ajsFq");
const $f0dbc2fded0931b2$export$f2a39aaa42ea357a = ({ cloudId: cloudId, cloudName: cloudName, atlassianAccountId: atlassianAccountId, environment: environment, locale: locale, orgId: orgId, activationId: workspaceId })=>(0, $hz0Ap.initAnalyticsWebClient)({
        tenantId: cloudId,
        ...atlassianAccountId ? {
            userId: atlassianAccountId
        } : undefined,
        ...orgId && {
            orgId: orgId
        },
        ...workspaceId && {
            workspaceId: workspaceId
        },
        product: 'jira',
        environment: environment === 'prod' ? 'prod' : (0, $aNyDs.default)({
            cloudId: cloudId,
            cloudName: cloudName,
            environment: environment
        }),
        callback: (0, $ajsFq.logEmau),
        subProduct: (0, $4D4Jz.default),
        solutions: (0, $l9ND4.default)(),
        locale: locale
    });

});
parcelRegister("l9ND4", function(module, exports) {
$parcel$export(module.exports, "default", () => $06c16b3110b719f3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $4D4Jz = parcelRequire("4D4Jz");
const $06c16b3110b719f3$var$getApplicationSolutions = ()=>(0, $4D4Jz.default)() === 'serviceDesk' ? [
        (0, $382ab3343e49976c$export$c8b406ad8ee0dab9)
    ] : undefined;
var $06c16b3110b719f3$export$2e2bcd8739ae039 = $06c16b3110b719f3$var$getApplicationSolutions;

});
/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

parcelRegister("4D4Jz", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb86f4faec71b1a5$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6bEm8 = parcelRequire("6bEm8");

var $aYD0q = parcelRequire("aYD0q");
const $eb86f4faec71b1a5$var$getApplicationSubProduct = ()=>(0, $aYD0q.default)((0, $6bEm8.default)('ajs-application-key'));
var $eb86f4faec71b1a5$export$2e2bcd8739ae039 = $eb86f4faec71b1a5$var$getApplicationSubProduct;

});
parcelRegister("aYD0q", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6c75115c7ee6fc0$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Transforms sub-product identifiers into a simplified or generic form, providing
 * a default when unspecified. This aids in standardizing the representation of
 * sub-product names across different contexts.
 */ const $c6c75115c7ee6fc0$var$transformSubProducts = (subProduct)=>{
    if (!subProduct) return 'unknown';
    if (subProduct === 'family') return 'platform';
    if (subProduct === 'jira-servicedesk') return 'serviceDesk';
    if (subProduct.startsWith('jira-')) return subProduct.replace('jira-', '');
    return subProduct;
};
var $c6c75115c7ee6fc0$export$2e2bcd8739ae039 = $c6c75115c7ee6fc0$var$transformSubProducts;

});



parcelRegister("aNyDs", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba1e300a2718d362$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // MR - stands for the atlassian monorepo prefix
const $ba1e300a2718d362$var$isOverridingFragments = ()=>{
    const buildKey = globalThis.BUILD_KEY;
    return !!(buildKey && !/^(?:(?:MR)?JF-PROD-\d+|\d+\.\d+\.\d+-[0-9a-f]+)$/.test(buildKey));
};
const $ba1e300a2718d362$var$isOverridingSsr = ()=>{
    const ssrBuildKey = globalThis.SSR_BUILD_KEY;
    return !!(ssrBuildKey && !/^(?:(?:MR)?JF-PROD-\d+|\d+\.\d+\.\d+-[0-9a-f]+)$/i.test(ssrBuildKey));
};
const $ba1e300a2718d362$var$isVoltExplore = ({ cloudId: cloudId, cloudName: cloudName })=>/^(TEST--)/.test(cloudId) && /^(atl-vertigo--jira-jira-branch)/.test(cloudName);
/**
 * Selects the 'staging' environment under specific conditions, defaulting to 'dev' otherwise.
 * This decision is based on the current environment setting and the absence of specific overrides.
 */ const $ba1e300a2718d362$var$getStagingEnvironment = ({ environment: environment, cloudId: cloudId, cloudName: cloudName })=>{
    if (environment === 'staging' && !$ba1e300a2718d362$var$isOverridingFragments() && !$ba1e300a2718d362$var$isOverridingSsr() && !$ba1e300a2718d362$var$isVoltExplore({
        cloudId: cloudId,
        cloudName: cloudName
    })) return environment;
    return 'dev';
};
var $ba1e300a2718d362$export$2e2bcd8739ae039 = $ba1e300a2718d362$var$getStagingEnvironment;

});

parcelRegister("ajsFq", function(module, exports) {
$parcel$export(module.exports, "logEmau", () => $239ba0f8c0ed7265$export$f6d9e07ca353aa2e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ff8AH = parcelRequire("ff8AH");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $239ba0f8c0ed7265$var$logEmauForJira = (subproduct, url, urlParams)=>{
    const body = JSON.stringify({
        eventData: {
            url: url,
            subproduct: subproduct,
            urlParams: urlParams
        }
    });
    const endpointUrl = '/rest/internal/2/log/unsafe/emau';
    const fetchOptions = {
        ...(0, $ff8AH.getDefaultOptions)(endpointUrl),
        method: 'POST',
        body: body
    };
    return fetch(endpointUrl, fetchOptions);
};
const $239ba0f8c0ed7265$export$f6d9e07ca353aa2e = ({ product: product, subproduct: subproduct })=>{
    if (product === 'jira') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $239ba0f8c0ed7265$var$logEmauForJira(subproduct, window.location.pathname, window.location.search);
};

});


parcelRegister("599w8", function(module, exports) {
$parcel$export(module.exports, "JiraStructuredAnalyticsListener", () => $8fb37cfffab73007$export$ba6a124597fff04a);

var $euxye = parcelRequire("euxye");

var $bHcfq = parcelRequire("bHcfq");

var $f6SzU = parcelRequire("f6SzU");

var $3mujO = parcelRequire("3mujO");

var $6CfY5 = parcelRequire("6CfY5");

var $7RK6D = parcelRequire("7RK6D");

var $6Kdw4 = parcelRequire("6Kdw4");

var $ieuXy = parcelRequire("ieuXy");
const $8fb37cfffab73007$var$EXCLUDED_CHANNELS = [
    (0, $bHcfq.FabricChannel).atlaskit
];
const $8fb37cfffab73007$var$addSearchPayload = (event, isProductAnalyticsV3 = false)=>{
    try {
        const searchPayload = (0, $ieuXy.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) {
            if (isProductAnalyticsV3) // eslint-disable-next-line no-param-reassign
            event.payload.attributes = {
                ...event.payload.attributes,
                ...searchPayload
            };
            else // eslint-disable-next-line no-param-reassign
            event.payload = {
                ...event.payload,
                ...searchPayload
            };
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('observability.analytics-providers.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
const $8fb37cfffab73007$var$getAnalyticsWebClientInstance = ()=>(0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $8fb37cfffab73007$var$sendAnalyticsEvent = (event)=>{
    // Preemptively create an error so we can find who sends invalid events in Sentry
    const callError = new Error(`This ${event.type} event is not valid`);
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        try {
            client.sendEvent(event);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            err.cause = callError;
            throw err;
        }
    });
};
const $8fb37cfffab73007$var$onStructuredAnalyticsEvent = (event)=>{
    const enrichedEvent = $8fb37cfffab73007$var$addSearchPayload(event);
    $8fb37cfffab73007$var$sendAnalyticsEvent((0, $3mujO.default)(enrichedEvent));
};
const $8fb37cfffab73007$var$onProductAnalyticsV3 = (event)=>{
    const enrichedEvent = $8fb37cfffab73007$var$addSearchPayload(event, true);
    $8fb37cfffab73007$var$sendAnalyticsEvent((0, $7RK6D.getEvent)(enrichedEvent));
};
const $8fb37cfffab73007$var$JiraAnalyticsListener = ({ onEvent: onEvent, onEventV3: onEventV3, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f6SzU.default), {
        onEvent: onEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f6SzU.default), {
        onEvent: onEventV3,
        channel: "productAnalytics"
    }, children));
$8fb37cfffab73007$var$JiraAnalyticsListener.displayName = "JiraAnalyticsListener";
const $8fb37cfffab73007$export$ba6a124597fff04a = ({ children: children })=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bHcfq.default), {
        // @ts-expect-error - Type 'GasPurePayload' is not assignable to type 'UITrackAndOperationalEventPayload'.
        client: $8fb37cfffab73007$var$getAnalyticsWebClientInstance(),
        excludedChannels: $8fb37cfffab73007$var$EXCLUDED_CHANNELS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8fb37cfffab73007$var$JiraAnalyticsListener, {
        onEvent: $8fb37cfffab73007$var$onStructuredAnalyticsEvent,
        onEventV3: $8fb37cfffab73007$var$onProductAnalyticsV3
    }, children));
};
$8fb37cfffab73007$export$ba6a124597fff04a.displayName = "JiraStructuredAnalyticsListener";

});
parcelRegister("3mujO", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c2d6c53416841f7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $808aL = parcelRequire("808aL");

var $hlxpN = parcelRequire("hlxpN");

var $3irVK = parcelRequire("3irVK");

var $7iRBQ = parcelRequire("7iRBQ");

var $8BtfF = parcelRequire("8BtfF");
const $7c2d6c53416841f7$var$formatActionSubjectId = (name, actionSubject)=>actionSubject ? `${name}${actionSubject[0].toUpperCase()}${actionSubject.substring(1)}` : name;
const $7c2d6c53416841f7$var$getActionSubjectForEventType = (event, analyticsType)=>{
    if (analyticsType === (0, $7iRBQ.TRACK_EVENT_TYPE)) return (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $8BtfF.getActionSubjects)(event));
    return (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $8BtfF.getComponents)(event));
};
const $7c2d6c53416841f7$var$getActionSubjectIdForEventType = (event, analyticsType, actionSubject)=>{
    const name = (0, $8BtfF.getName)(event);
    // for UI and operational events, the actionSubjectId is generated
    // but for operational events name is optional, since it doesnt always make sense.
    // Consider a high level component BespokeComponent. If this fires an internal event
    // The unique instance of the component is likely to be BespokeComponent (ie there is 1)
    // so if name wasn't optional we would end up with actionSubjectId=bespokeComponentBespokeComponent
    if (analyticsType === (0, $7iRBQ.OPERATIONAL_EVENT_TYPE)) return name ? $7c2d6c53416841f7$var$formatActionSubjectId(name, actionSubject) : actionSubject;
    if (analyticsType === (0, $7iRBQ.UI_EVENT_TYPE)) return $7c2d6c53416841f7$var$formatActionSubjectId(name, actionSubject);
    return (0, $8BtfF.getActionSubjectId)(event);
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * Atlaskit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ const $7c2d6c53416841f7$var$getEvent = (event)=>{
    const sources = (0, $8BtfF.getSources)(event);
    const analyticsType = (0, $8BtfF.getAnalyticsType)(event);
    const actionSubject = $7c2d6c53416841f7$var$getActionSubjectForEventType(event, analyticsType);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(sources);
    const action = (0, $8BtfF.getAction)(event);
    const attributes = {
        ...(0, $8BtfF.getAttributes)(event),
        namespaces: sources.join('.')
    };
    const containers = (0, $8BtfF.getContainers)(event);
    if (action === (0, $7iRBQ.PAGE_EVENT_ACTION)) return {
        type: (0, $7iRBQ.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $7iRBQ.UI_EVENT_TYPE:
        case 0, $7iRBQ.TRACK_EVENT_TYPE:
        case 0, $7iRBQ.OPERATIONAL_EVENT_TYPE:
            {
                const actionSubjectId = $7c2d6c53416841f7$var$getActionSubjectIdForEventType(event, analyticsType, actionSubject);
                const containerId = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $8BtfF.getContainerIds)(event));
                const containerType = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $8BtfF.getContainerTypes)(event));
                const objectId = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $8BtfF.getObjectIds)(event));
                const objectType = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))((0, $8BtfF.getObjectTypes)(event));
                const tags = (0, $8BtfF.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};
var $7c2d6c53416841f7$export$2e2bcd8739ae039 = $7c2d6c53416841f7$var$getEvent;

});
parcelRegister("7iRBQ", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $6543bada61774d98$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $6543bada61774d98$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $6543bada61774d98$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $6543bada61774d98$export$12346a674644c156);
$parcel$export(module.exports, "PAGE_EVENT_ACTION", () => $6543bada61774d98$export$a953886d20994732);
$parcel$export(module.exports, "ScreenTypes", () => $6543bada61774d98$export$9dd85b191ff3384f);
/* eslint-disable jira/filename-case */ /**
 * ANALYTICS WEB CLIENT EVENTS
 */ // those events are going to the analytics web client
const $6543bada61774d98$export$a1562d08625f5d7e = 'UI';
const $6543bada61774d98$export$947dac6c72b26f81 = 'TRACK';
const $6543bada61774d98$export$f1d537d508d2945a = 'SCREEN';
const $6543bada61774d98$export$12346a674644c156 = 'OPERATIONAL';
const $6543bada61774d98$export$a953886d20994732 = 'page-view';
const $6543bada61774d98$var$SCREEN = 'Screen';
const $6543bada61774d98$var$DRAWER = 'Drawer';
const $6543bada61774d98$var$MODAL = 'Modal';
const $6543bada61774d98$var$INLINE_DIALOG = 'InlineDialog';
const $6543bada61774d98$var$DROPDOWN = 'Dropdown';
const $6543bada61774d98$export$9dd85b191ff3384f = {
    SCREEN: $6543bada61774d98$var$SCREEN,
    MODAL: $6543bada61774d98$var$MODAL,
    DRAWER: $6543bada61774d98$var$DRAWER,
    INLINE_DIALOG: $6543bada61774d98$var$INLINE_DIALOG,
    DROPDOWN: $6543bada61774d98$var$DROPDOWN
};

});

parcelRegister("8BtfF", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $943e4ffc124a17e5$export$4e811121b221213b);
$parcel$export(module.exports, "getActionSubjects", () => $943e4ffc124a17e5$export$d9a2a7d6b7a9497b);
$parcel$export(module.exports, "getSources", () => $943e4ffc124a17e5$export$5f9bc633b116660f);
$parcel$export(module.exports, "getAttributes", () => $943e4ffc124a17e5$export$fe94072fee8a6976);
$parcel$export(module.exports, "getTags", () => $943e4ffc124a17e5$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainerTypes", () => $943e4ffc124a17e5$export$94b487dda8940141);
$parcel$export(module.exports, "getContainerIds", () => $943e4ffc124a17e5$export$9a462447889d734e);
$parcel$export(module.exports, "getObjectTypes", () => $943e4ffc124a17e5$export$9ed2cbb83cd51da0);
$parcel$export(module.exports, "getObjectIds", () => $943e4ffc124a17e5$export$2e78a279ad2bf08);
$parcel$export(module.exports, "getActionSubjectId", () => $943e4ffc124a17e5$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getAnalyticsType", () => $943e4ffc124a17e5$export$a3569ac53b82a914);
$parcel$export(module.exports, "getName", () => $943e4ffc124a17e5$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getAction", () => $943e4ffc124a17e5$export$6ca3170acb89054);
$parcel$export(module.exports, "getContainers", () => $943e4ffc124a17e5$export$ae861c5c02c4c14c);
/* eslint-disable jira/filename-case */ 
var $808aL = parcelRequire("808aL");

var $6Fltw = parcelRequire("6Fltw");

var $3irVK = parcelRequire("3irVK");

var $9O1Qa = parcelRequire("9O1Qa");
const $943e4ffc124a17e5$var$extractFromEventContext = (propertyNames, event)=>event.context // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $943e4ffc124a17e5$var$extractFromEventPayload = (propertyName, event)=>event.payload[propertyName];
const $943e4ffc124a17e5$var$extractFromPayloadOrContext = (propertyName, event)=>{
    const payloadProp = $943e4ffc124a17e5$var$extractFromEventPayload(propertyName, event);
    const contextProps = $943e4ffc124a17e5$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
const $943e4ffc124a17e5$var$extractPayloadAttributes = (event)=>{
    const { tags: tags, actionSubjectId: actionSubjectId, containerType: containerType, containerId: containerId, objectType: objectType, objectId: objectId, analyticsType: analyticsType, name: name, action: action, ...attributes } = event.payload;
    return attributes;
};
const $943e4ffc124a17e5$export$4e811121b221213b = (event)=>$943e4ffc124a17e5$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
const $943e4ffc124a17e5$export$d9a2a7d6b7a9497b = (event)=>$943e4ffc124a17e5$var$extractFromEventContext([
        'actionSubject'
    ], event);
const $943e4ffc124a17e5$export$5f9bc633b116660f = (event)=>$943e4ffc124a17e5$var$extractFromEventContext([
        'source'
    ], event);
const $943e4ffc124a17e5$export$fe94072fee8a6976 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $943e4ffc124a17e5$var$extractFromEventContext([
        'attributes'
    ], event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraAttributes), {}), $943e4ffc124a17e5$var$extractPayloadAttributes(event));
const $943e4ffc124a17e5$export$af63d7414243dad3 = (event)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))($943e4ffc124a17e5$var$extractFromEventContext([
        'tags'
    ], event) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, extraTags)=>result.concat(extraTags), []).concat($943e4ffc124a17e5$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
const $943e4ffc124a17e5$export$94b487dda8940141 = (event)=>$943e4ffc124a17e5$var$extractFromPayloadOrContext('containerType', event);
const $943e4ffc124a17e5$export$9a462447889d734e = (event)=>$943e4ffc124a17e5$var$extractFromPayloadOrContext('containerId', event);
const $943e4ffc124a17e5$export$9ed2cbb83cd51da0 = (event)=>$943e4ffc124a17e5$var$extractFromPayloadOrContext('objectType', event);
const $943e4ffc124a17e5$export$2e78a279ad2bf08 = (event)=>$943e4ffc124a17e5$var$extractFromPayloadOrContext('objectId', event);
const $943e4ffc124a17e5$export$b6f8db3ad0711b02 = (event)=>$943e4ffc124a17e5$var$extractFromEventPayload('actionSubjectId', event);
const $943e4ffc124a17e5$export$a3569ac53b82a914 = (event)=>$943e4ffc124a17e5$var$extractFromEventPayload('analyticsType', event);
const $943e4ffc124a17e5$export$7d9f7e9c1c02b41e = (event)=>$943e4ffc124a17e5$var$extractFromEventPayload('name', event);
const $943e4ffc124a17e5$export$6ca3170acb89054 = (event)=>$943e4ffc124a17e5$var$extractFromEventPayload('action', event);
const $943e4ffc124a17e5$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $943e4ffc124a17e5$var$extractFromEventContext([
        'containers'
    ], event);
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce((result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("ieuXy", function(module, exports) {
$parcel$export(module.exports, "addSearchSessionAttributes", () => $010cda67ec428279$export$ee9fabaf3a23e7bf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eSVkV = parcelRequire("eSVkV");

var $dAmGh = parcelRequire("dAmGh");

var $6bEm8 = parcelRequire("6bEm8");
const $010cda67ec428279$export$ee9fabaf3a23e7bf = (payload)=>{
    const safePayload = payload || {};
    const sessionAttributes = {
        searchSessionId: 'searchSessionId' in safePayload && safePayload.searchSessionId ? safePayload.searchSessionId : (0, $6bEm8.default)('ajs-search-session-id'),
        searchObjectId: 'searchObjectId' in safePayload && safePayload.searchObjectId ? safePayload.searchObjectId : (0, $6bEm8.default)('ajs-search-object-id'),
        searchContainerId: 'searchContainerId' in safePayload && safePayload.searchContainerId ? safePayload.searchContainerId : (0, $6bEm8.default)('ajs-search-container-id'),
        searchContentType: 'searchContentType' in safePayload && safePayload.searchContentType ? safePayload.searchContentType : (0, $6bEm8.default)('ajs-search-content-type')
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...payload,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))(sessionAttributes, (0, (/*@__PURE__*/$parcel$interopDefault($eSVkV))))
    };
};

});



parcelRegister("lPmfV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ec9eda366f1daafe$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hIipg = parcelRequire("hIipg");

var $gjqtf = parcelRequire("gjqtf");

var $5EbfN = parcelRequire("5EbfN");

var $kNBjd = parcelRequire("kNBjd");

var $6bEm8 = parcelRequire("6bEm8");

var $6Kdw4 = parcelRequire("6Kdw4");
/**
 * Conditionally renders its children or enriches them with specific configurations for engagement and analytics. This component acts differently based on the execution environment (server vs client) and the availability of user metadata, aiming to seamlessly integrate analytics functionality where applicable.
 */ const $ec9eda366f1daafe$var$EngagementProvider = (props)=>{
    if (false) return props.children;
    const environment = (0, $5EbfN.toEnvironment)((0, $6bEm8.default)('ajs-environment'));
    const getEnvironmentType = (env)=>{
        if (env === 'prod') return (0, $hIipg.envType).PROD;
        if (env === 'staging') return (0, $hIipg.envType).STAGING;
        return (0, $hIipg.envType).DEV;
    };
    const aaid = (0, $6bEm8.default)('ajs-atlassian-account-id');
    if (aaid === null) return props.children;
    const config = {
        aaid: aaid,
        cloudId: (0, $6bEm8.default)('ajs-cloud-id') || '',
        locale: (0, $6bEm8.default)('ajs-user-locale') || '',
        product: 'jira',
        stargateUrl: '/gateway/api',
        orgId: props.orgId
    };
    const coordinationOptions = {
        envType: getEnvironmentType(environment),
        enableChoreographer: true,
        additionalData: {
            sourceProductId: (0, $kNBjd.ProductIds).JIRA
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gjqtf.default), {
        ...props,
        config: config,
        analyticsClientInstance: Promise.resolve((0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())),
        coordinationOptions: coordinationOptions
    });
};
$ec9eda366f1daafe$var$EngagementProvider.displayName = "EngagementProvider";
var $ec9eda366f1daafe$export$2e2bcd8739ae039 = $ec9eda366f1daafe$var$EngagementProvider;

});

parcelRegister("9OCIS", function(module, exports) {
$parcel$export(module.exports, "localePropType", () => $2a1ca3129a24e054$export$ade363a7f01ce39d);
$parcel$export(module.exports, "defaultLocale", () => (parcelRequire("dwzGJ")).defaultLocale);
$parcel$export(module.exports, "supportedLanguagesMap", () => (parcelRequire("dwzGJ")).supportedLanguagesMap);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("d5gEK")).getLocale);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => (parcelRequire("d5gEK")).formatTimezonedWithLocale);
$parcel$export(module.exports, "floatDifferenceOfDates", () => (parcelRequire("d5gEK")).floatDifferenceOfDates);
$parcel$export(module.exports, "formatWithLocale", () => (parcelRequire("d5gEK")).formatWithLocale);
$parcel$export(module.exports, "formatDistanceWithLocale", () => (parcelRequire("d5gEK")).formatDistanceWithLocale);
$parcel$export(module.exports, "formatRelativeWithLocale", () => (parcelRequire("d5gEK")).formatRelativeWithLocale);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => (parcelRequire("d5gEK")).formatDistanceStrictWithLocale);
$parcel$export(module.exports, "weekStartDayWithLocale", () => (parcelRequire("d5gEK")).weekStartDayWithLocale);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => (parcelRequire("d5gEK")).formatZonedDateTimeWithZone);
$parcel$export(module.exports, "parseZoneDateTime", () => (parcelRequire("d5gEK")).parseZoneDateTime);
$parcel$export(module.exports, "setTimezoneOffset", () => (parcelRequire("d5gEK")).setTimezoneOffset);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => (parcelRequire("d5gEK")).setNumberOffsetToISODate);
$parcel$export(module.exports, "formatDateStringToISO", () => (parcelRequire("d5gEK")).formatDateStringToISO);
$parcel$export(module.exports, "isValidTimeZone", () => (parcelRequire("d5gEK")).isValidTimeZone);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/prop-types

var $bUjzO = parcelRequire("bUjzO");

var $cVLWE = parcelRequire("cVLWE");

var $dwzGJ = parcelRequire("dwzGJ");

var $d5gEK = parcelRequire("d5gEK");
const $2a1ca3129a24e054$export$ade363a7f01ce39d = (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).oneOf(Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($cVLWE)))));

});
parcelRegister("cVLWE", function(module, exports) {
module.exports = JSON.parse("{\"cs_CZ\":\"cs-CZ\",\"cs\":\"cs-CZ\",\"da_DK\":\"da-DK\",\"da\":\"da-DK\",\"de_DE\":\"de-DE\",\"de\":\"de-DE\",\"en_GB\":\"en-GB\",\"en-GB\":\"en-GB\",\"en_UK\":\"en-US\",\"en-UK\":\"en-US\",\"enUS\":\"enUS\",\"en_US\":\"en-US\",\"en-US\":\"en-US\",\"es-ES\":\"es-ES\",\"es\":\"es-ES\",\"et_EE\":\"et-EE\",\"et\":\"et-EE\",\"fi_FI\":\"fi-FI\",\"fi\":\"fi-FI\",\"fr_FR\":\"fr-FR\",\"fr\":\"fr-FR\",\"hu_HU\":\"hu-HU\",\"hu\":\"hu-HU\",\"is_IS\":\"is-IS\",\"is\":\"is-IS\",\"it_IT\":\"it-IT\",\"it\":\"it-IT\",\"ja_JP\":\"ja-JP\",\"ja\":\"ja-JP\",\"ko_KR\":\"ko-KR\",\"ko\":\"ko-KR\",\"nb_NO\":\"nb-NO\",\"nb\":\"nb-NO\",\"nl_NL\":\"nl-NL\",\"nl\":\"nl-NL\",\"pl_PL\":\"pl-PL\",\"pl\":\"pl-PL\",\"pt_BR\":\"pt-BR\",\"pt-BR\":\"pt-BR\",\"pt_PT\":\"pt-PT\",\"pt\":\"pt-PT\",\"ro_RO\":\"ro-RO\",\"ro\":\"ro-RO\",\"ru_RU\":\"ru-RU\",\"ru\":\"ru-RU\",\"sk_SK\":\"sk-SK\",\"sk\":\"sk-SK\",\"sv_SE\":\"sv-SE\",\"sv\":\"sv-SE\",\"tr\":\"tr-TR\",\"tr_TR\":\"tr-TR\",\"tr-TR\":\"tr-TR\",\"zh_CN\":\"zh-CN\",\"zh-CN\":\"zh-CN\",\"zh_TW\":\"zh-TW\",\"zh-TW\":\"zh-TW\"}");

});

parcelRegister("dwzGJ", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $2c94a88b1f340f0f$export$d7f512c98c859244);
$parcel$export(module.exports, "supportedLanguagesMap", () => $2c94a88b1f340f0f$export$ff4f0d1b20f0caad);
/* eslint-disable jira/filename-case */ const $2c94a88b1f340f0f$export$d7f512c98c859244 = 'enUS';
const $2c94a88b1f340f0f$var$arabicLocale = 'arDZ';
const $2c94a88b1f340f0f$export$ff4f0d1b20f0caad = {
    ar: $2c94a88b1f340f0f$var$arabicLocale,
    ar_DZ: $2c94a88b1f340f0f$var$arabicLocale,
    ar_MA: $2c94a88b1f340f0f$var$arabicLocale,
    ar_SA: $2c94a88b1f340f0f$var$arabicLocale,
    cs_CZ: 'cs',
    cs: 'cs',
    da_DK: 'da',
    da: 'da',
    de_DE: 'de',
    de: 'de',
    en_GB: 'enGB',
    'en-GB': 'enGB',
    en_UK: $2c94a88b1f340f0f$export$d7f512c98c859244,
    'en-UK': $2c94a88b1f340f0f$export$d7f512c98c859244,
    en_US: $2c94a88b1f340f0f$export$d7f512c98c859244,
    'en-US': $2c94a88b1f340f0f$export$d7f512c98c859244,
    en_AU: 'enAU',
    es_ES: 'es',
    es: 'es',
    et_EE: 'et',
    et: 'et',
    fi_FI: 'fi',
    fi: 'fi',
    fr_FR: 'fr',
    fr: 'fr',
    hu_HU: 'hu',
    hu: 'hu',
    is_IS: 'is',
    is: 'is',
    it_IT: 'it',
    it: 'it',
    ja_JP: 'ja',
    ja: 'ja',
    ko_KR: 'ko',
    ko: 'ko',
    nb_NO: 'nb',
    nb: 'nb',
    nl_NL: 'nl',
    nl: 'nl',
    pl_PL: 'pl',
    pl: 'pl',
    pt_BR: 'ptBR',
    'pt-BR': 'ptBR',
    pt_PT: 'pt',
    pt: 'pt',
    ro_RO: 'ro',
    ro: 'ro',
    ru_RU: 'ru',
    ru: 'ru',
    sk_SK: 'sk',
    sk: 'sk',
    sv_SE: 'sv',
    sv: 'sv',
    tr: 'tr',
    tr_TR: 'tr',
    zh_CN: 'zhCN',
    'zh-CN': 'zhCN',
    zh_TW: 'zhTW',
    'zh-TW': 'zhTW'
};

});

parcelRegister("d5gEK", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => $cd2a521f39616eb5$export$180605366c04f0cd);
$parcel$export(module.exports, "parseISODate", () => $cd2a521f39616eb5$export$ee8e61141c87635a);
$parcel$export(module.exports, "isValidTimeZone", () => $cd2a521f39616eb5$export$c793e14020d7c7b);
$parcel$export(module.exports, "formatWithLocale", () => $cd2a521f39616eb5$export$fb3485f471c77284);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => $cd2a521f39616eb5$export$4383dd42a084ef32);
$parcel$export(module.exports, "formatDistanceWithLocale", () => $cd2a521f39616eb5$export$c2180807b950d3da);
$parcel$export(module.exports, "formatRelativeWithLocale", () => $cd2a521f39616eb5$export$12b50b1737ea07fc);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => $cd2a521f39616eb5$export$7a7656c130da0e93);
$parcel$export(module.exports, "weekStartDayWithLocale", () => $cd2a521f39616eb5$export$d2c1381944cd40d9);
$parcel$export(module.exports, "parseZoneDateTime", () => $cd2a521f39616eb5$export$736ce978ed45f974);
$parcel$export(module.exports, "setTimezoneOffset", () => $cd2a521f39616eb5$export$11ef0295ba6f3d21);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => $cd2a521f39616eb5$export$fe2193e77e11d739);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => $cd2a521f39616eb5$export$dd52464bfc436f72);
$parcel$export(module.exports, "formatDateStringToISO", () => $cd2a521f39616eb5$export$108dbdcbc1363368);
$parcel$export(module.exports, "floatDifferenceOfDates", () => $cd2a521f39616eb5$export$8b999908ff0a4991);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jAWvZ = parcelRequire("jAWvZ");
var $lvb5q = parcelRequire("lvb5q");
var $1Ubq3 = parcelRequire("1Ubq3");
var $dYbSv = parcelRequire("dYbSv");
var $f59Wr = parcelRequire("f59Wr");
var $4TdwU = parcelRequire("4TdwU");
var $5ssT5 = parcelRequire("5ssT5");
var $3qzB7 = parcelRequire("3qzB7");
var $gLA6A = parcelRequire("gLA6A");
var $lFmbd = parcelRequire("lFmbd");
var $dGdlo = parcelRequire("dGdlo");
var $cAvrm = parcelRequire("cAvrm");
var $7cCLc = parcelRequire("7cCLc");
var $TsgOl = parcelRequire("TsgOl");

var $36Ugw = parcelRequire("36Ugw");
var $av4S1 = parcelRequire("av4S1");

var $dt1y6 = parcelRequire("dt1y6");
var $49Ri2 = parcelRequire("49Ri2");
var $8TAdq = parcelRequire("8TAdq");
var $21fcH = parcelRequire("21fcH");
var $3xzlf = parcelRequire("3xzlf");
var $fgiQ0 = parcelRequire("fgiQ0");
var $gcFTj = parcelRequire("gcFTj");
var $gtbIq = parcelRequire("gtbIq");
var $7dVeQ = parcelRequire("7dVeQ");
var $gKLIX = parcelRequire("gKLIX");
var $cuaUr = parcelRequire("cuaUr");
var $8mQhO = parcelRequire("8mQhO");
var $7ah7A = parcelRequire("7ah7A");
var $e0GTq = parcelRequire("e0GTq");
var $59R5I = parcelRequire("59R5I");
var $ieyUQ = parcelRequire("ieyUQ");
var $irUpT = parcelRequire("irUpT");
var $35xWZ = parcelRequire("35xWZ");
var $jlGdp = parcelRequire("jlGdp");
var $glUk8 = parcelRequire("glUk8");
var $7koEZ = parcelRequire("7koEZ");
var $afHG0 = parcelRequire("afHG0");
var $8PQ29 = parcelRequire("8PQ29");
var $4NUsi = parcelRequire("4NUsi");
var $1DRvc = parcelRequire("1DRvc");
var $jdMAw = parcelRequire("jdMAw");
var $8Bhf4 = parcelRequire("8Bhf4");
var $8zwm9 = parcelRequire("8zwm9");

var $dwzGJ = parcelRequire("dwzGJ");
const $cd2a521f39616eb5$var$locales = {
    arDZ: $dt1y6.default,
    cs: $49Ri2.default,
    cs_CZ: (0, $49Ri2.default),
    da: $8TAdq.default,
    da_DK: (0, $8TAdq.default),
    de: $21fcH.default,
    de_DE: (0, $21fcH.default),
    enUS: $gcFTj.default,
    en_US: (0, $gcFTj.default),
    'en-US': (0, $gcFTj.default),
    enGB: $fgiQ0.default,
    en_UK: (0, $fgiQ0.default),
    'en-UK': (0, $fgiQ0.default),
    'en-GB': (0, $fgiQ0.default),
    en_GB: (0, $fgiQ0.default),
    enAU: $3xzlf.default,
    es: $gtbIq.default,
    es_ES: (0, $gtbIq.default),
    et: $7dVeQ.default,
    et_EE: (0, $7dVeQ.default),
    fi: $gKLIX.default,
    fi_FI: (0, $gKLIX.default),
    fr: $cuaUr.default,
    fr_FR: (0, $cuaUr.default),
    hu: $8mQhO.default,
    hu_HU: (0, $8mQhO.default),
    is: $7ah7A.default,
    is_IS: (0, $7ah7A.default),
    it: $e0GTq.default,
    it_IT: (0, $e0GTq.default),
    ja: $59R5I.default,
    ja_JP: (0, $59R5I.default),
    ko: $ieyUQ.default,
    ko_KR: (0, $ieyUQ.default),
    nb: $irUpT.default,
    nb_NO: (0, $irUpT.default),
    nl: $35xWZ.default,
    nl_NL: (0, $35xWZ.default),
    pl: $jlGdp.default,
    pl_PL: (0, $jlGdp.default),
    pt: $glUk8.default,
    'pt-PT': (0, $glUk8.default),
    pt_PT: (0, $glUk8.default),
    ptBR: $7koEZ.default,
    'pt-BR': (0, $7koEZ.default),
    pt_BR: (0, $7koEZ.default),
    ro: $afHG0.default,
    ro_RO: (0, $afHG0.default),
    ru: $8PQ29.default,
    ru_RU: (0, $8PQ29.default),
    sk: $4NUsi.default,
    sk_SK: (0, $4NUsi.default),
    sv: $1DRvc.default,
    sv_SE: (0, $1DRvc.default),
    tr: $jdMAw.default,
    'tr-TR': (0, $jdMAw.default),
    tr_TR: (0, $jdMAw.default),
    zhCN: $8Bhf4.default,
    'zh-CN': (0, $8Bhf4.default),
    zh_CN: (0, $8Bhf4.default),
    zhTW: $8zwm9.default,
    'zh-TW': (0, $8zwm9.default),
    zh_TW: (0, $8zwm9.default)
};
const $cd2a521f39616eb5$var$nonUTCFullZoneRegExp = new RegExp(/:\d\d(\.\d+)?[-,+]\d\d:\d\d$/);
const $cd2a521f39616eb5$var$negativeZoneRegExp = new RegExp(/:\d\d(\.\d+)?-/);
const $cd2a521f39616eb5$var$milliseconds\u0421oefficients = {
    seconds: 1000,
    minutes: 60000,
    // 1000 * 60
    hours: 3600000,
    // 1000 * 60 * 60
    days: 86400000,
    // 1000 * 60 * 60 * 24
    weeks: 604800000
};
const $cd2a521f39616eb5$export$180605366c04f0cd = (locale)=>{
    const dateFnsLocale = (0, $dwzGJ.supportedLanguagesMap)[locale] || (0, $dwzGJ.defaultLocale);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly arDZ: Locale; readonly cs: Locale; readonly cs_CZ: Locale; readonly da: Locale; readonly da_DK: Locale; readonly de: Locale; ... 56 more ...; readonly zh_TW: Locale; }'.
    return $cd2a521f39616eb5$var$locales[dateFnsLocale];
};
const $cd2a521f39616eb5$export$ee8e61141c87635a = (dateString)=>{
    const parsedDate = (0, $7cCLc.default)(dateString);
    return (0, $dGdlo.default)(parsedDate) ? new Date(dateString) : undefined;
};
const $cd2a521f39616eb5$export$c793e14020d7c7b = (tz)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: tz
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        return false;
    }
};
const $cd2a521f39616eb5$export$fb3485f471c77284 = (date, formatStyle, locale)=>(0, $dYbSv.default)(date, formatStyle, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale)
    });
const $cd2a521f39616eb5$export$4383dd42a084ef32 = (date, formatStyle, locale, timeZone)=>$cd2a521f39616eb5$export$c793e14020d7c7b(timeZone) ? (0, $36Ugw.default)((0, $av4S1.default)(date, timeZone), formatStyle, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale),
        timeZone: timeZone
    }) : (0, $36Ugw.default)((0, $av4S1.default)(date, 'utc'), formatStyle, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale),
        timeZone: 'utc'
    });
const $cd2a521f39616eb5$export$c2180807b950d3da = (date, baseDate, locale, addSuffix = false)=>(0, $f59Wr.default)(date, baseDate, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $cd2a521f39616eb5$export$12b50b1737ea07fc = (date, baseDate, locale)=>(0, $5ssT5.default)(date, baseDate, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale)
    });
const $cd2a521f39616eb5$export$7a7656c130da0e93 = (date, baseDate, locale, addSuffix = false)=>(0, $4TdwU.default)(date, baseDate, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $cd2a521f39616eb5$export$d2c1381944cd40d9 = (date, locale)=>(0, $TsgOl.default)(date, {
        locale: $cd2a521f39616eb5$export$180605366c04f0cd(locale)
    });
const $cd2a521f39616eb5$export$736ce978ed45f974 = (parsingDate)=>{
    const date = typeof parsingDate === 'string' ? parsingDate : new Date().toISOString();
    const indxs = {
        positiveZoneStartIndex: date.indexOf('+'),
        negativeZoneStartIndex: $cd2a521f39616eb5$var$negativeZoneRegExp.test(date) ? date.lastIndexOf('-') : -1,
        utcZoneStartIndex: date.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    const parsedDate = typeof zoneStartIndex === 'number' ? date.substring(0, zoneStartIndex) : date;
    let zone = '';
    if (typeof zoneStartIndex === 'number') zone = $cd2a521f39616eb5$var$nonUTCFullZoneRegExp.test(date) ? date.substring(zoneStartIndex, zoneStartIndex + 6) : `${date.substring(zoneStartIndex, zoneStartIndex + 3)}:00`;
    return {
        date: (0, $7cCLc.default)(parsedDate),
        zone: indxs.utcZoneStartIndex > -1 ? '+00:00' : zone
    };
};
const $cd2a521f39616eb5$var$calcOffset = (zone)=>Number.parseInt(zone, 10) * 60 + Number.parseInt(`${zone.substring(0, 1)}${zone.substring(4)}`, 10);
const $cd2a521f39616eb5$export$11ef0295ba6f3d21 = (date, offsetSource)=>{
    const dateOffset = date.getTimezoneOffset();
    const offset = $cd2a521f39616eb5$var$calcOffset($cd2a521f39616eb5$export$736ce978ed45f974(offsetSource).zone);
    return (0, $jAWvZ.default)(date, offset + dateOffset); // plus because getTimezoneOffset returns difference in minutes (e.g. +3:00 => -180)
};
const $cd2a521f39616eb5$export$fe2193e77e11d739 = (date, offsetHoursNumber)=>{
    const parsedDate = $cd2a521f39616eb5$export$736ce978ed45f974(date);
    const originalOffset = $cd2a521f39616eb5$var$calcOffset(parsedDate.zone);
    const calculatedDateTime = (0, $jAWvZ.default)(parsedDate.date, offsetHoursNumber * 60 - originalOffset);
    return calculatedDateTime;
};
const $cd2a521f39616eb5$export$dd52464bfc436f72 = (date, formatString, zone)=>{
    let res = '';
    const formatedString = (0, $dYbSv.default)(date, formatString);
    const indxs = {
        positiveZoneStartIndex: formatedString.indexOf('+'),
        negativeZoneStartIndex: $cd2a521f39616eb5$var$negativeZoneRegExp.test(formatedString) ? formatedString.lastIndexOf('-') : -1,
        utcZoneStartIndex: formatedString.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    if (typeof zoneStartIndex === 'number') res = `${formatedString.substring(0, zoneStartIndex)}${zone}`; // e.g. 2021-12-12T12:00:00+13:00
    return res;
};
const $cd2a521f39616eb5$export$108dbdcbc1363368 = (date, formatString = 'yyyy-MM-dd')=>{
    const defaultReturnValue = '';
    if (date == null || date === '') return defaultReturnValue;
    const parsedDate = (0, $cAvrm.default)(date, formatString, new Date(0, 0, 0, 0, 0, 0));
    if (!(0, $dGdlo.default)(parsedDate)) return defaultReturnValue;
    return parsedDate.toISOString(); // formatISO can have issues with timezones: https://github.com/date-fns/date-fns/issues/2151 (
};
// this is copy of diff functions from moment.js
// @ts-expect-error - TS7023 - 'monthDiff' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $cd2a521f39616eb5$var$monthDiff = (a, b)=>{
    if ((0, $3qzB7.default)(a) < (0, $3qzB7.default)(b)) // end-of-month calculations work correct when the start month has more
    // days than the end month.
    return -$cd2a521f39616eb5$var$monthDiff(b, a);
    // difference in months
    const wholeMonthDiff = ((0, $lFmbd.default)(b) - (0, $lFmbd.default)(a)) * 12 + ((0, $gLA6A.default)(b) - (0, $gLA6A.default)(a));
    // b is in (anchor - 1 month, anchor + 1 month)
    const anchor = (0, $lvb5q.default)(a, wholeMonthDiff);
    let anchor2;
    let adjust;
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    if (b - anchor < 0) {
        anchor2 = (0, $lvb5q.default)(a, wholeMonthDiff - 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = (0, $lvb5q.default)(a, wholeMonthDiff + 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
};
const $cd2a521f39616eb5$export$8b999908ff0a4991 = (endDate, startDate, measurement)=>{
    const zoneDelta = startDate.getTimezoneOffset() * -60000 - endDate.getTimezoneOffset() * -60000; // copied from moment
    switch(measurement){
        case 'years':
            return $cd2a521f39616eb5$var$monthDiff(endDate, startDate) / 12;
        case 'quarters':
            return $cd2a521f39616eb5$var$monthDiff(endDate, startDate) / 3;
        case 'months':
            return $cd2a521f39616eb5$var$monthDiff(endDate, startDate);
        case 'weeks':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $cd2a521f39616eb5$var$milliseconds\u0421oefficients.weeks;
        // negate dst
        case 'days':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $cd2a521f39616eb5$var$milliseconds\u0421oefficients.days;
        // negate dst
        case 'hours':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $cd2a521f39616eb5$var$milliseconds\u0421oefficients.hours;
        case 'minutes':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $cd2a521f39616eb5$var$milliseconds\u0421oefficients.minutes;
        case 'seconds':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $cd2a521f39616eb5$var$milliseconds\u0421oefficients.seconds;
        default:
            return (0, $1Ubq3.default)(endDate, startDate);
    }
};

});



parcelRegister("4aWLY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ed8344343286bb9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $kwMul = parcelRequire("kwMul");
function $9ed8344343286bb9$export$cb52beecfc9ea9e6({ id: // FIXME: id should be required
id = '@jira/platform__utils-app-base::unknown-app', packageName: // FIXME: packageName should be required
packageName = '@jira/platform__utils-app-base', teamName: teamName, fallback: // JSErrorBoundary fallback default is 'page' but AppBase is used around any "app"
fallback = 'flag', store: store, children: children }) {
    let contents = children;
    if (store) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kwMul.Provider), {
        store: store
    }, contents);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        fallback: fallback,
        packageName: packageName
    }, contents);
}
$9ed8344343286bb9$export$cb52beecfc9ea9e6.displayName = "AppBase";
var $9ed8344343286bb9$export$2e2bcd8739ae039 = $9ed8344343286bb9$export$cb52beecfc9ea9e6;

});
parcelRegister("h8QGu", function(module, exports) {
$parcel$export(module.exports, "JSErrorBoundary", () => $b28b79bf95c9c78c$export$1e964c961b2b98bf);

var $euxye = parcelRequire("euxye");

var $dCJKF = parcelRequire("dCJKF");

var $g7inT = parcelRequire("g7inT");

var $8xoxE = parcelRequire("8xoxE");

var $i860n = parcelRequire("i860n");

var $cCE2Z = parcelRequire("cCE2Z");
const $b28b79bf95c9c78c$var$Empty = ()=>null;
const $b28b79bf95c9c78c$var$getFallback = (fallback, ErrorFlag, ErrorPageFallback)=>{
    switch(fallback){
        case 'page':
            return ErrorPageFallback;
        case 'flag':
            return ErrorFlag;
        case 'unmount':
            return $b28b79bf95c9c78c$var$Empty;
        default:
            return fallback;
    }
};
const $b28b79bf95c9c78c$var$DEFAULT_EXTRA_EVENT_DATA = {};
const $b28b79bf95c9c78c$export$1e964c961b2b98bf = ({ id: id, packageName: packageName, teamName: teamName, fallback: fallback = 'page', children: children, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, onError: onError, extraEventData: extraEventData = $b28b79bf95c9c78c$var$DEFAULT_EXTRA_EVENT_DATA, ...rest })=>{
    const ErrorFlag = (0, $euxye.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8xoxE.ErrorFlagRenderer), {
            id: id,
            error: error,
            packageName: packageName,
            teamName: teamName
        }), [
        id,
        packageName,
        teamName
    ]);
    const ErrorPage = (0, $euxye.useCallback)(({ error: error })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g7inT.JSErrorPageAsync), {
            error: error,
            id: id,
            packageName: packageName,
            teamName: teamName
        });
    }, [
        teamName,
        packageName,
        id
    ]);
    const onErrorRef = (0, $euxye.useRef)(onError);
    onErrorRef.current = onError;
    const onErrorHandler = (0, $euxye.useCallback)((location, error, errorAttributes)=>{
        onErrorRef.current?.(location, error, errorAttributes);
    }, []);
    const fallbackType = typeof fallback === 'function' ? 'custom' : fallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        render: $b28b79bf95c9c78c$var$getFallback(fallback, ErrorFlag, ErrorPage),
        onError: onErrorHandler,
        extraEventData: extraEventData,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: attributes,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk,
        fallbackType: (0, $i860n.fg)('jserrorboundary_analytics_update') ? fallbackType : undefined
    }, children));
};
$b28b79bf95c9c78c$export$1e964c961b2b98bf.displayName = "JSErrorBoundary";

});
parcelRegister("dCJKF", function(module, exports) {
$parcel$export(module.exports, "ReportErrors", () => $b551bcfe905a6a9e$export$ffd17f83e27b9460);

var $euxye = parcelRequire("euxye");

var $4FR7Y = parcelRequire("4FR7Y");

var $inMxE = parcelRequire("inMxE");

var $i860n = parcelRequire("i860n");

var $hFtK7 = parcelRequire("hFtK7");
const $b551bcfe905a6a9e$export$7549babf6b1dfb78 = (labelStack)=>{
    if ((0, $i860n.fg)('jserrorboundary_analytics_update')) return labelStack?.find((label)=>(0, $hFtK7.isViewSupported)(label.name))?.name;
    const view = labelStack?.find((label)=>(0, $hFtK7.VIEW_WHITELIST).has(label.name));
    return view?.name;
};
class $b551bcfe905a6a9e$var$CatchAndReportErrors extends (0, $euxye.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, teamName: teamName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, ufoLabelStack: ufoLabelStack, fallbackType: fallbackType } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $hFtK7.fireErrorAnalytics)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: typeof attributes === 'function' ? attributes(error) : attributes,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk,
            view: $b551bcfe905a6a9e$export$7549babf6b1dfb78(ufoLabelStack),
            fallbackType: (0, $i860n.fg)('jserrorboundary_analytics_update') ? fallbackType : undefined
        });
        throw error;
    }
    render() {
        return this.props.children;
    }
}
$b551bcfe905a6a9e$var$CatchAndReportErrors.displayName = "CatchAndReportErrors";
const $b551bcfe905a6a9e$export$ffd17f83e27b9460 = (props)=>{
    const interactionContext = (0, $4FR7Y.useInteractionContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b551bcfe905a6a9e$var$CatchAndReportErrors, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        ufoLabelStack: interactionContext?.labelStack
    });
};
$b551bcfe905a6a9e$export$ffd17f83e27b9460.displayName = "ReportErrors";

});

parcelRegister("g7inT", function(module, exports) {
$parcel$export(module.exports, "JSErrorPageAsync", () => $217b2fed918b90f1$export$f5794426a1f1dedd);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $217b2fed918b90f1$var$LazyJSErrorPage = (0, $l8G1z.lazy)(()=>(parcelRequire("8RLuL")).then((module)=>module.JSErrorPage), {
    moduleId: "./src/packages/platform/js-error-page/src/JSErrorPage.tsx"
});
const $217b2fed918b90f1$export$f5794426a1f1dedd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-js-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($217b2fed918b90f1$var$LazyJSErrorPage, props));
$217b2fed918b90f1$export$f5794426a1f1dedd.displayName = "JSErrorPageAsync";

});
parcelRegister("a8EUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5430bd7923ccb433$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PlaceholderWithNativeSuspense", () => $5430bd7923ccb433$export$64cdcd2c25694f20);
$parcel$export(module.exports, "ConditionalPlaceholderWithNativeSuspense", () => $5430bd7923ccb433$export$d679f6aff3edf041);
$parcel$export(module.exports, "ConditionalHydrationBoundaryPlaceholder", () => $5430bd7923ccb433$export$f13307ff82e05e2b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $5ARAC = parcelRequire("5ARAC");

var $TTcqD = parcelRequire("TTcqD");

var $4FR7Y = parcelRequire("4FR7Y");

var $aEpnN = parcelRequire("aEpnN");

var $6x5Yw = parcelRequire("6x5Yw");
var $8tMC2 = parcelRequire("8tMC2");

var $aWliK = parcelRequire("aWliK");

var $deTZV = parcelRequire("deTZV");

var $kUkw0 = parcelRequire("kUkw0");
function $5430bd7923ccb433$var$Hold({ name: name }) {
    const interactionContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    const waitContext = (0, $euxye.useContext)((0, $8tMC2.WaitContext));
    const nameWithUnderscores = name?.replaceAll('/', '_');
    // Runs synchronously, to allow us to identify async items
    (0, $aEpnN.default)(()=>{
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(nameWithUnderscores);
    }, [
        interactionContext,
        nameWithUnderscores,
        waitContext
    ]);
    return null;
}
$5430bd7923ccb433$var$Hold.displayName = "Hold";
/**
 * This is a "safe-to-use" Placeholder but it's actually expected to be used only around React-Loosely-Lazy components.
 * WARNING: Make sure we use same placeholders in a rendering tree.
 * Mixed use may cause unexpected behavior, such as rendering child component twice.
 * Ref: https://hello.atlassian.net/wiki/x/iJpOHwE
 */ function $5430bd7923ccb433$var$RLLPlaceholder({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    const OwnershipMarker = (0, $5ARAC.useOwnershipMarkerComponent)({
        markerType: 'placeholder',
        name: name
    });
    const mountTracker = (0, $kUkw0.useMountTracker)(`placeholder:${name}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(OwnershipMarker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6x5Yw.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5430bd7923ccb433$var$Hold, {
            name: name
        })),
        name: name
    }, kids, mountTracker));
}
$5430bd7923ccb433$var$RLLPlaceholder.displayName = "RLLPlaceholder";
const $5430bd7923ccb433$var$Placeholder = (0, $aWliK.componentWithCondition)(// this condition is coupled with hydration rollout, not the fact of hydration
// SuspensePlaceholder can be used for non-hydrating pages as well, if no "SSR content preservation" is required
// See PlaceholderWithNativeSuspense
()=>(0, $TTcqD.useIsHydrateRenderMode)(), (0, $deTZV.SuspensePlaceholder), $5430bd7923ccb433$var$RLLPlaceholder);
var $5430bd7923ccb433$export$2e2bcd8739ae039 = $5430bd7923ccb433$var$Placeholder;
const $5430bd7923ccb433$export$64cdcd2c25694f20 = (0, $deTZV.SuspensePlaceholder);
function $5430bd7923ccb433$export$d679f6aff3edf041({ name: name, condition: condition, children: children, fallback: fallback }) {
    const [frozenCondition] = (0, $euxye.useState)(condition);
    if (frozenCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5430bd7923ccb433$export$64cdcd2c25694f20, {
        name: name,
        fallback: fallback
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
}
$5430bd7923ccb433$export$d679f6aff3edf041.displayName = "ConditionalPlaceholderWithNativeSuspense";
const $5430bd7923ccb433$export$f13307ff82e05e2b = $5430bd7923ccb433$export$d679f6aff3edf041;

});
parcelRegister("TTcqD", function(module, exports) {
$parcel$export(module.exports, "useIsHydrateRenderMode", () => $0c073aade956e688$export$50c1edaaed881ec4);
$parcel$export(module.exports, "useSsrPlaceholders", () => $0c073aade956e688$export$5b86f8a52685e7a6);
$parcel$export(module.exports, "setIsHydrationRenderMode", () => $0c073aade956e688$export$1005a4e5bbaa775b);
$parcel$export(module.exports, "reportHydrationEnd", () => $0c073aade956e688$export$365316c4efc7213);
$parcel$export(module.exports, "getIsHydrationInProgress", () => $0c073aade956e688$export$aaae7fa8de9c1841);

var $gXtG2 = parcelRequire("gXtG2");

var $i860n = parcelRequire("i860n");
const $0c073aade956e688$var$DEFAULT_STATE = {
    renderMode: 'createRoot'
};
let $0c073aade956e688$var$state = Object.freeze($0c073aade956e688$var$DEFAULT_STATE);
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $0c073aade956e688$var$state = $0c073aade956e688$var$DEFAULT_STATE;
});
const $0c073aade956e688$export$50c1edaaed881ec4 = ()=>$0c073aade956e688$var$state.renderMode === 'hydrateRoot';
const $0c073aade956e688$export$5b86f8a52685e7a6 = ()=>$0c073aade956e688$var$state.renderMode !== 'hydrateRoot' || !(0, $i860n.fg)('jfp-magma-data-ssr-placeholder-retain');
const $0c073aade956e688$export$1005a4e5bbaa775b = ()=>{
    $0c073aade956e688$var$state = {
        renderMode: 'hydrateRoot',
        isComplete: false
    };
};
const $0c073aade956e688$export$365316c4efc7213 = ()=>{
    if ($0c073aade956e688$var$state.renderMode === 'hydrateRoot') $0c073aade956e688$var$state.isComplete = true;
};
const $0c073aade956e688$export$aaae7fa8de9c1841 = ()=>$0c073aade956e688$var$state.renderMode === 'hydrateRoot' && !$0c073aade956e688$var$state.isComplete;

});

parcelRegister("aEpnN", function(module, exports) {
$parcel$export(module.exports, "default", () => $61f634256d064c00$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
// eslint-disable-next-line jira/jira-ssr/no-server-variable
const $61f634256d064c00$var$useLayoutEffectSafe = false ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);
var $61f634256d064c00$export$2e2bcd8739ae039 = $61f634256d064c00$var$useLayoutEffectSafe;

});

parcelRegister("aWliK", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $51c433dc7b5bd701$export$6e8ea24b15199873);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");
function $51c433dc7b5bd701$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
        // in the majority of cases extra support for componentWithCondition(_, C1, C2) is required
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $1uH7N.di)(ComponentFalse, ComponentTrue);
        return condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        });
    });
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("deTZV", function(module, exports) {
$parcel$export(module.exports, "SuspensePlaceholder", () => $b6f93a91320433e5$export$25177ae6586aed49);

var $euxye = parcelRequire("euxye");

var $5ARAC = parcelRequire("5ARAC");

var $TTcqD = parcelRequire("TTcqD");

var $aLkSN = parcelRequire("aLkSN");

var $48XUH = parcelRequire("48XUH");

var $6hiHV = parcelRequire("6hiHV");
const $b6f93a91320433e5$var$SuspenseWrapper = ({ fallback: fallback, fallbackRender: fallbackRender, children: children, childrenRender: childrenRender })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $euxye.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, fallback, fallbackRender)
    }, children, childrenRender);
$b6f93a91320433e5$var$SuspenseWrapper.displayName = "SuspenseWrapper";
/**
 * intermediate memo to avoid LazySuspense re-rendering when locked
 * also replaces useMemo for children and fallback "componsition"
 */ const $b6f93a91320433e5$var$MemoizedSuspense = /*#__PURE__*/ (0, $euxye.memo)($b6f93a91320433e5$var$SuspenseWrapper, (prev, next)=>{
    if (!next.unlocked) return true;
    return next.fallback === prev.fallback && next.children === prev.children;
});
const $b6f93a91320433e5$export$25177ae6586aed49 = ({ name: name, children: children, fallback: fallback })=>{
    const [renderedPath, renderedPathRef, render] = (0, $48XUH.useSwitchControl)(name);
    const isHoldEnabled = (0, $euxye.useCallback)(()=>renderedPathRef.current !== 'children', [
        renderedPathRef
    ]);
    (0, $6hiHV.useHold)(name, // hold is "controlled" by the fact of children render
    renderedPath !== 'children', // if children become visible we don't need to hold anymore
    isHoldEnabled);
    const isContentRendered = Boolean(renderedPath);
    (0, $aLkSN.useHydrationSubtreeCompleter)({
        isSubtreeRendered: isContentRendered,
        name: name
    });
    const OwnershipMarker = (0, $5ARAC.useOwnershipMarkerComponent)({
        markerType: 'placeholder',
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(OwnershipMarker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6f93a91320433e5$var$MemoizedSuspense, {
        fallback: fallback,
        fallbackRender: render.fallback,
        childrenRender: render.children,
        unlocked: isContentRendered || !(0, $TTcqD.getIsHydrationInProgress)()
    }, children));
};
$b6f93a91320433e5$export$25177ae6586aed49.displayName = "SuspensePlaceholder";

});
parcelRegister("aLkSN", function(module, exports) {
$parcel$export(module.exports, "useHydrationSubtreeCompleter", () => $0fcec71878150d82$export$507a191610ed3a18);

var $euxye = parcelRequire("euxye");

var $5XU1N = parcelRequire("5XU1N");

var $i860n = parcelRequire("i860n");

var $8tMC2 = parcelRequire("8tMC2");
const $0fcec71878150d82$export$4f6961ac4cc356c9 = (useIdValue)=>useIdValue.startsWith(':R');
const $0fcec71878150d82$export$507a191610ed3a18 = ({ isSubtreeRendered: isSubtreeRendered, name: unstableName })=>{
    const id = (0, $euxye.useId)();
    const [name] = (0, $euxye.useState)(unstableName);
    const { addPendingSubtree: addPendingSubtree, completePendingSubtree: completePendingSubtree } = (0, $5XU1N.useGlobalHydrationActions)();
    const waitContext = (0, $euxye.useContext)((0, $8tMC2.WaitContext));
    (0, $euxye.useEffect)(()=>{
        if (waitContext?.currentValue() === 0) // no effect if we are inside a LazyWait boundary
        return;
        if ((0, $i860n.fg)('jfp-magma-hydration-completion-fix-timing')) {
            if (!$0fcec71878150d82$export$4f6961ac4cc356c9(id)) return;
        }
        if (isSubtreeRendered) completePendingSubtree(id);
        else addPendingSubtree(id, name);
    }, [
        isSubtreeRendered,
        id,
        name,
        completePendingSubtree,
        addPendingSubtree,
        waitContext
    ]);
    // Exists to ensure that we complete a subtree if it unmounts before `isSubtreeRendered` flips to true
    (0, $euxye.useEffect)(()=>{
        if ((0, $i860n.fg)('jfp-magma-hydration-completion-fix-timing')) {
            if (!$0fcec71878150d82$export$4f6961ac4cc356c9(id)) return;
        }
        return ()=>{
            completePendingSubtree(id);
        };
    }, [
        id,
        completePendingSubtree
    ]);
    // prevent dead code removal
    return id;
};

});
parcelRegister("5XU1N", function(module, exports) {
$parcel$export(module.exports, "getIsGlobalTimedOut", () => $a15d41e843107bba$export$d01b42f7210902a0);
$parcel$export(module.exports, "useIsGlobalHydrationComplete", () => $a15d41e843107bba$export$2f0a8b29a48aa524);
$parcel$export(module.exports, "useGlobalHydrationActions", () => $a15d41e843107bba$export$a92d0836dfe80799);

var $TTcqD = parcelRequire("TTcqD");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $gXtG2 = parcelRequire("gXtG2");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");

var $fngNu = parcelRequire("fngNu");

var $9uN8d = parcelRequire("9uN8d");
let $a15d41e843107bba$var$DEBUG_INFO = {
    pendingIds: {},
    firstPendingCallAt: null,
    lastCompletionCallAt: null,
    addPendingSubTreeCallCount: 0,
    completeSubTreeCallCount: 0,
    unorderlyCompleteSubtreeCalls: 0,
    completionAttempts: 0,
    idleCallbackTimedOut: false,
    globalTimedOut: false
};
const $a15d41e843107bba$export$1e5cd4e4a7a96cc9 = ()=>{
    return Object.values($a15d41e843107bba$var$DEBUG_INFO.pendingIds);
};
const $a15d41e843107bba$export$d01b42f7210902a0 = ()=>$a15d41e843107bba$var$DEBUG_INFO.globalTimedOut;
let $a15d41e843107bba$var$clearNextCallback = null;
const $a15d41e843107bba$var$setOrReplaceNextCallback = (createCallback)=>{
    if ($a15d41e843107bba$var$clearNextCallback != null) $a15d41e843107bba$var$clearNextCallback();
    $a15d41e843107bba$var$clearNextCallback = createCallback();
};
let $a15d41e843107bba$var$clearGlobalTimeout = null;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $a15d41e843107bba$var$DEBUG_INFO = {
        pendingIds: {},
        firstPendingCallAt: null,
        lastCompletionCallAt: null,
        addPendingSubTreeCallCount: 0,
        completeSubTreeCallCount: 0,
        unorderlyCompleteSubtreeCalls: 0,
        completionAttempts: 0,
        idleCallbackTimedOut: false,
        globalTimedOut: false
    };
    $a15d41e843107bba$var$clearNextCallback?.();
    $a15d41e843107bba$var$clearNextCallback = null;
    $a15d41e843107bba$var$clearGlobalTimeout?.();
    $a15d41e843107bba$var$clearGlobalTimeout = null;
});
const $a15d41e843107bba$var$TIMEOUT_AFTER_LAST_SUBTREE_START = 5000;
const $a15d41e843107bba$var$OLD_GLOBAL_TIMEOUT = 30000;
const $a15d41e843107bba$var$GLOBAL_TIMEOUT = 60000;
const $a15d41e843107bba$var$HYDRATION_COMPLETE_WINDOW_EVENT = 'jira:hydration-complete';
const $a15d41e843107bba$var$oldActions = {
    addPendingSubtree: (componentId, name)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            if (!(0, $TTcqD.getIsHydrationInProgress)()) return;
            $a15d41e843107bba$var$DEBUG_INFO.addPendingSubTreeCallCount++;
            if ($a15d41e843107bba$var$DEBUG_INFO.firstPendingCallAt == null) $a15d41e843107bba$var$DEBUG_INFO.firstPendingCallAt = Date.now();
            if ($a15d41e843107bba$var$clearGlobalTimeout == null) {
                const timerId = setTimeout(()=>{
                    $a15d41e843107bba$var$DEBUG_INFO.globalTimedOut = true;
                    dispatch($a15d41e843107bba$var$oldActions.complete());
                }, $a15d41e843107bba$var$OLD_GLOBAL_TIMEOUT);
                $a15d41e843107bba$var$clearGlobalTimeout = ()=>clearTimeout(timerId);
            }
            const previousPendingIds = getState().pendingIds;
            if (!Object.hasOwn(previousPendingIds, componentId)) {
                const updatedPendingIds = {
                    ...previousPendingIds,
                    [componentId]: name
                };
                setState({
                    pendingIds: updatedPendingIds
                });
                $a15d41e843107bba$var$DEBUG_INFO.pendingIds = updatedPendingIds;
                // Fallback logic to end hydration 5s after the last pending subtree is added, if we get stuck
                $a15d41e843107bba$var$setOrReplaceNextCallback(()=>{
                    const timerId = setTimeout(()=>{
                        dispatch($a15d41e843107bba$var$oldActions.complete());
                    }, $a15d41e843107bba$var$TIMEOUT_AFTER_LAST_SUBTREE_START);
                    return ()=>clearTimeout(timerId);
                });
            }
        },
    completePendingSubtree: (componentId)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            if (!(0, $TTcqD.getIsHydrationInProgress)()) return;
            $a15d41e843107bba$var$DEBUG_INFO.completeSubTreeCallCount++;
            $a15d41e843107bba$var$DEBUG_INFO.lastCompletionCallAt = Date.now();
            const previousPendingIds = getState().pendingIds;
            if (!Object.hasOwn(previousPendingIds, componentId)) $a15d41e843107bba$var$DEBUG_INFO.unorderlyCompleteSubtreeCalls++;
            const updatedPendingIds = {
                ...previousPendingIds
            };
            delete updatedPendingIds[componentId];
            setState({
                pendingIds: updatedPendingIds
            });
            $a15d41e843107bba$var$DEBUG_INFO.pendingIds = updatedPendingIds;
            if (Object.keys(updatedPendingIds).length === 0) {
                $a15d41e843107bba$var$DEBUG_INFO.completionAttempts++;
                $a15d41e843107bba$var$setOrReplaceNextCallback(()=>{
                    return (0, $9uN8d.callWhenIdleWithTimeout)((deadline)=>{
                        if (deadline?.didTimeout) $a15d41e843107bba$var$DEBUG_INFO.idleCallbackTimedOut = true;
                        dispatch($a15d41e843107bba$var$oldActions.complete());
                    });
                });
            }
        },
    complete: ()=>({ setState: setState })=>{
            if (!(0, $TTcqD.getIsHydrationInProgress)()) return;
            (0, $TTcqD.reportHydrationEnd)();
            setState({
                isComplete: true
            });
            $a15d41e843107bba$var$clearNextCallback?.();
            $a15d41e843107bba$var$clearGlobalTimeout?.();
            if (globalThis.window) globalThis.window.dispatchEvent(new CustomEvent($a15d41e843107bba$var$HYDRATION_COMPLETE_WINDOW_EVENT));
            const { pendingIds: pendingIds, firstPendingCallAt: firstPendingCallAt, lastCompletionCallAt: lastCompletionCallAt, addPendingSubTreeCallCount: addPendingSubTreeCallCount, completeSubTreeCallCount: completeSubTreeCallCount, unorderlyCompleteSubtreeCalls: unorderlyCompleteSubtreeCalls, completionAttempts: completionAttempts, idleCallbackTimedOut: idleCallbackTimedOut, globalTimedOut: globalTimedOut } = $a15d41e843107bba$var$DEBUG_INFO;
            const pendingSubtreeNames = Object.values(pendingIds);
            if ((pendingSubtreeNames.length > 0 || globalTimedOut) && (0, $i860n.fg)('jfp-magma-log-dirty-hydration-completion')) {
                let totalHydrationDuration = null;
                if (firstPendingCallAt != null && lastCompletionCallAt != null) totalHydrationDuration = lastCompletionCallAt - firstPendingCallAt;
                (0, $6CfY5.default).safeErrorWithoutCustomerData('hydration-completion', [
                    'Failed to cleanly mark hydration as complete',
                    `addPendingSubTreeCallCount=${addPendingSubTreeCallCount}`,
                    `completeSubTreeCallCount=${completeSubTreeCallCount}`,
                    `unorderlyCompleteSubtreeCalls=${unorderlyCompleteSubtreeCalls}`,
                    `globalCompletionAttempts=${completionAttempts}`,
                    `idleCallbackTimedOut=${idleCallbackTimedOut}`,
                    `totalHydrationDuration=${totalHydrationDuration}`,
                    `globalTimedOut=${globalTimedOut}`,
                    `pendingSubtreeNames: [${pendingSubtreeNames.join(', ')}]`
                ].join(', '));
            }
        }
};
const $a15d41e843107bba$var$oldStore = (0, $5QDqc.createStore)({
    name: 'hydration-global-completion',
    initialState: ()=>({
            isComplete: false,
            pendingIds: {}
        }),
    actions: $a15d41e843107bba$var$oldActions
});
let $a15d41e843107bba$var$clearCompletionCallback = null;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $a15d41e843107bba$var$clearCompletionCallback?.();
    $a15d41e843107bba$var$clearCompletionCallback = null;
});
const $a15d41e843107bba$var$actions = {
    addPendingSubtree: (componentId, name)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            if (!(0, $TTcqD.getIsHydrationInProgress)()) return;
            const previousPendingIds = getState().pendingIds;
            if (Object.hasOwn(previousPendingIds, componentId)) return;
            if ($a15d41e843107bba$var$DEBUG_INFO.firstPendingCallAt == null) $a15d41e843107bba$var$DEBUG_INFO.firstPendingCallAt = Date.now();
            if ($a15d41e843107bba$var$clearGlobalTimeout == null) {
                const timerId = setTimeout(()=>{
                    $a15d41e843107bba$var$DEBUG_INFO.globalTimedOut = true;
                    dispatch($a15d41e843107bba$var$actions.complete());
                }, $a15d41e843107bba$var$GLOBAL_TIMEOUT);
                $a15d41e843107bba$var$clearGlobalTimeout = ()=>clearTimeout(timerId);
            }
            $a15d41e843107bba$var$DEBUG_INFO.addPendingSubTreeCallCount++;
            $a15d41e843107bba$var$clearCompletionCallback?.();
            const updatedPendingIds = {
                ...previousPendingIds,
                [componentId]: name
            };
            setState({
                pendingIds: updatedPendingIds,
                lastSubtreeChangeAt: Date.now()
            });
            $a15d41e843107bba$var$DEBUG_INFO.pendingIds = updatedPendingIds;
        },
    completePendingSubtree: (componentId)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            if (!(0, $TTcqD.getIsHydrationInProgress)()) return;
            const previousPendingIds = getState().pendingIds;
            if (!Object.hasOwn(previousPendingIds, componentId)) return;
            $a15d41e843107bba$var$DEBUG_INFO.completeSubTreeCallCount++;
            const calledAt = Date.now();
            $a15d41e843107bba$var$DEBUG_INFO.lastCompletionCallAt = calledAt;
            const updatedPendingIds = {
                ...previousPendingIds
            };
            delete updatedPendingIds[componentId];
            setState({
                pendingIds: updatedPendingIds,
                lastSubtreeChangeAt: calledAt
            });
            $a15d41e843107bba$var$DEBUG_INFO.pendingIds = updatedPendingIds;
            if (Object.keys(updatedPendingIds).length === 0) {
                const scheduleCompletionCallback = (remainingDeferrals)=>{
                    if (remainingDeferrals <= 0) {
                        dispatch($a15d41e843107bba$var$actions.complete());
                        $a15d41e843107bba$var$clearCompletionCallback = null;
                        return;
                    }
                    $a15d41e843107bba$var$clearCompletionCallback = (0, $fngNu.callWhenIdle)(()=>{
                        const timerId = setTimeout(()=>{
                            scheduleCompletionCallback(remainingDeferrals - 1);
                        }, 1000);
                        $a15d41e843107bba$var$clearCompletionCallback = ()=>clearTimeout(timerId);
                    });
                };
                $a15d41e843107bba$var$clearCompletionCallback?.();
                scheduleCompletionCallback(5);
            }
        },
    complete: ()=>({ setState: setState })=>{
            if (!(0, $TTcqD.getIsHydrationInProgress)()) return;
            (0, $TTcqD.reportHydrationEnd)();
            setState({
                isComplete: true
            });
            $a15d41e843107bba$var$clearGlobalTimeout?.();
            $a15d41e843107bba$var$clearCompletionCallback?.();
            if (globalThis.window) globalThis.window.dispatchEvent(new CustomEvent($a15d41e843107bba$var$HYDRATION_COMPLETE_WINDOW_EVENT));
            const { pendingIds: pendingIds, firstPendingCallAt: firstPendingCallAt, lastCompletionCallAt: lastCompletionCallAt, addPendingSubTreeCallCount: addPendingSubTreeCallCount, completeSubTreeCallCount: completeSubTreeCallCount, globalTimedOut: globalTimedOut } = $a15d41e843107bba$var$DEBUG_INFO;
            const pendingSubtreeNames = Object.values(pendingIds);
            if ((pendingSubtreeNames.length > 0 || globalTimedOut) && (0, $i860n.fg)('jfp-magma-log-dirty-hydration-completion')) {
                let totalHydrationDuration = null;
                if (firstPendingCallAt != null && lastCompletionCallAt != null) totalHydrationDuration = lastCompletionCallAt - firstPendingCallAt;
                (0, $6CfY5.default).safeErrorWithoutCustomerData('hydration-completion', [
                    'Failed to cleanly mark hydration as complete',
                    `addPendingSubTreeCallCount=${addPendingSubTreeCallCount}`,
                    `completeSubTreeCallCount=${completeSubTreeCallCount}`,
                    `totalHydrationDuration=${totalHydrationDuration}`,
                    `globalTimedOut=${globalTimedOut}`,
                    `pendingSubtreeNames: [${pendingSubtreeNames.join(', ')}]`
                ].join(', '));
            }
        }
};
/**
 * We need access to global hydration state inside React (reactive) and outside React, so have both a store and module state.
 */ const $a15d41e843107bba$var$store = (0, $5QDqc.createStore)({
    name: 'hydration-global-completion',
    initialState: ()=>({
            isComplete: false,
            lastSubtreeChangeAt: null,
            pendingIds: {}
        }),
    actions: $a15d41e843107bba$var$actions
});
const $a15d41e843107bba$export$2f0a8b29a48aa524 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-magma-hydration-completion-fix-timing'), (0, $3h1FP.createStateHook)($a15d41e843107bba$var$store, {
    selector: ({ isComplete: isComplete })=>isComplete
}), (0, $3h1FP.createStateHook)($a15d41e843107bba$var$oldStore, {
    selector: ({ isComplete: isComplete })=>isComplete
}));
const $a15d41e843107bba$export$a92d0836dfe80799 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-magma-hydration-completion-fix-timing'), (0, $3h1FP.createActionsHook)($a15d41e843107bba$var$store), (0, $3h1FP.createActionsHook)($a15d41e843107bba$var$oldStore));

});
parcelRegister("6ZLJT", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $5294b1913b2f497d$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $5294b1913b2f497d$export$c41c28c1d883fcd5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/react-magnetic-di/no-unneeded

var $1uH7N = parcelRequire("1uH7N");
function $5294b1913b2f497d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>{
        // we "di" directly to allow overrides for extra cases not covered by "auto-di"
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $1uH7N.di)(functionFalse, functionTrue);
        return condition() ? functionTrue(...args) : functionFalse(...args);
    };
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $5294b1913b2f497d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $5294b1913b2f497d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("fngNu", function(module, exports) {
$parcel$export(module.exports, "callWhenIdle", () => $8c6a589dc43dc9c9$export$d2542992df1e054);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $8c6a589dc43dc9c9$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});

parcelRegister("9uN8d", function(module, exports) {
$parcel$export(module.exports, "callWhenIdleWithTimeout", () => $b3c6f40490a9c4fd$export$e977ed0a38bf70a0);
/**
 * Like callWhenIdle from @jira/platform__utils-call-when-idle, but modified to add a timeout and debugging info due to
 * suspected render loops meaning requestIdleCallback never runs.
 */ const $b3c6f40490a9c4fd$export$e977ed0a38bf70a0 = (callback)=>{
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        const callbackId = window.requestIdleCallback(callback, // In case there's a render loop on the page starving out idle callbacks
        {
            timeout: 5000
        });
        return ()=>cancelIdleCallback(callbackId);
    }
    // Browsers without requestIdleCallback
    const timer = setTimeout(callback, 2000);
    return ()=>{
        clearTimeout(timer);
    };
};

});



parcelRegister("48XUH", function(module, exports) {
$parcel$export(module.exports, "useSwitchControl", () => $ba2fdcbe90f96527$export$ecfdf004dc213783);

var $euxye = parcelRequire("euxye");

var $aEpnN = parcelRequire("aEpnN");

var $kUkw0 = parcelRequire("kUkw0");
const $ba2fdcbe90f96527$var$ReportLocation = ({ cb: cb, location: location })=>{
    (0, $aEpnN.default)(()=>{
        cb(location);
    }, [
        cb,
        location
    ]);
    return null;
};
$ba2fdcbe90f96527$var$ReportLocation.displayName = "ReportLocation";
const $ba2fdcbe90f96527$export$ecfdf004dc213783 = (name)=>{
    const locationRef = (0, $euxye.useRef)(undefined);
    const [location, setLocationState] = (0, $euxye.useState)(undefined);
    const setLocation = (0, $euxye.useCallback)((loc)=>{
        locationRef.current = loc;
        setLocationState(loc);
    }, []);
    const mountTracker = (0, $kUkw0.useMountTracker)(`placeholder:${name}`);
    return [
        location,
        locationRef,
        (0, $euxye.useMemo)(()=>({
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ba2fdcbe90f96527$var$ReportLocation, {
                    key: "unfreeze",
                    cb: setLocation,
                    location: "fallback"
                }),
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($ba2fdcbe90f96527$var$ReportLocation, {
                    key: "unfreeze",
                    cb: setLocation,
                    location: "children"
                }), mountTracker)
            }), [
            setLocation,
            mountTracker
        ])
    ];
};

});
parcelRegister("kUkw0", function(module, exports) {
$parcel$export(module.exports, "getPlaceholderMountTracker", () => $a26a8ffa5600dec9$export$7e6c1c61561a70cf);
$parcel$export(module.exports, "ReportMountAttempt", () => $a26a8ffa5600dec9$export$233d4beb75b532b5);
$parcel$export(module.exports, "useMountTracker", () => $a26a8ffa5600dec9$export$9ec4877667f48bf0);

var $euxye = parcelRequire("euxye");

var $6t4Ql = parcelRequire("6t4Ql");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");

var $gXtG2 = parcelRequire("gXtG2");
let $a26a8ffa5600dec9$var$mountTracker = {};
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $a26a8ffa5600dec9$var$mountTracker = {};
});
const $a26a8ffa5600dec9$var$extractOwnershipStack = (fiberNode)=>{
    const stack = [];
    let currentNode = fiberNode;
    // eslint-disable-next-line no-cond-assign
    while(currentNode = currentNode?.return)if (typeof currentNode.elementType === 'function') {
        const componentName = currentNode.elementType.name || 'unnamed';
        if (componentName.startsWith((0, $6t4Ql.OWNER_PREFIX))) stack.push(componentName);
    }
    return stack.reverse();
};
const $a26a8ffa5600dec9$export$7e6c1c61561a70cf = ()=>{
    return Object.fromEntries(Object.entries($a26a8ffa5600dec9$var$mountTracker).map(([key, { fiberNode: fiberNode, ...value }])=>{
        return [
            key,
            {
                ...value,
                stack: $a26a8ffa5600dec9$var$extractOwnershipStack(fiberNode)
            }
        ];
    }));
};
const $a26a8ffa5600dec9$export$21c23c04794cc2e9 = ()=>{
    // Get the current owner
    const { ReactCurrentOwner: ReactCurrentOwner } = (0, $euxye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED);
    const currentOwner = ReactCurrentOwner.current;
    if (currentOwner && currentOwner.elementType) return currentOwner;
    return null;
};
const $a26a8ffa5600dec9$export$233d4beb75b532b5 = ({ id: id })=>{
    (0, $euxye.useMemo)(()=>{
        // eslint-disable-next-line react-hooks/immutability
        $a26a8ffa5600dec9$var$mountTracker[id] = $a26a8ffa5600dec9$var$mountTracker[id] ?? {
            renderCount: 0,
            state: 'rendered',
            fiberNode: null
        };
        if (!false) {
            $a26a8ffa5600dec9$var$mountTracker[id].fiberNode = $a26a8ffa5600dec9$export$21c23c04794cc2e9();
            $a26a8ffa5600dec9$var$mountTracker[id].renderCount++;
        }
    }, [
        id
    ]);
    (0, $euxye.useEffect)(()=>{
        $a26a8ffa5600dec9$var$mountTracker[id].state = 'commited';
        return ()=>{
            $a26a8ffa5600dec9$var$mountTracker[id].state = 'unmounted';
        };
    }, [
        id
    ]);
    return null;
};
$a26a8ffa5600dec9$export$233d4beb75b532b5.displayName = "ReportMountAttempt";
const $a26a8ffa5600dec9$export$11774ed9ca6fd7e4 = ()=>(0, $euxye.useId)();
const $a26a8ffa5600dec9$var$useMountTrackerInternal = (name)=>{
    const id = $a26a8ffa5600dec9$export$11774ed9ca6fd7e4();
    return (0, $euxye.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($a26a8ffa5600dec9$export$233d4beb75b532b5, {
            id: `${name}::${id}`
        }), [
        name,
        id
    ]);
};
const $a26a8ffa5600dec9$export$9ec4877667f48bf0 = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-magma-track-placeholder-mounts'), $a26a8ffa5600dec9$var$useMountTrackerInternal, ()=>null);

});


parcelRegister("6hiHV", function(module, exports) {
$parcel$export(module.exports, "useHold", () => $71005809495c5a33$export$9b6ebe8ffd9dc981);

var $euxye = parcelRequire("euxye");

var $4FR7Y = parcelRequire("4FR7Y");

var $8tMC2 = parcelRequire("8tMC2");

var $aEpnN = parcelRequire("aEpnN");
const $71005809495c5a33$export$518d3dc8bbe6d22b = ()=>(0, $euxye.useContext)((0, $4FR7Y.default));
const $71005809495c5a33$var$returnTrue = ()=>true;
const $71005809495c5a33$export$9b6ebe8ffd9dc981 = (name, lock, isEnabled = $71005809495c5a33$var$returnTrue)=>{
    const interactionContext = $71005809495c5a33$export$518d3dc8bbe6d22b();
    const waitContext = (0, $euxye.useContext)((0, $8tMC2.WaitContext));
    // Runs synchronously, to allow us to identify async items
    (0, $aEpnN.default)(()=>{
        if (!lock || !isEnabled()) return;
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(name);
    }, [
        interactionContext,
        name,
        waitContext,
        lock,
        isEnabled
    ]);
};

});



parcelRegister("8RLuL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("5qC72"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("eAoL3"),
    $4cvLQ("15ZAZ"),
    $4cvLQ("cu5IN")
]).then(()=>parcelRequire('5UBut'));

});
parcelRegister("4cvLQ", function(module, exports) {
"use strict";

function $30f0ed6275c09e08$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("96thM")).resolve(id));
}
module.exports = $30f0ed6275c09e08$var$load;

});
parcelRegister("96thM", function(module, exports) {
$parcel$export(module.exports, "register", () => $6a0b641ff72a0641$export$6503ec6e8aabbaf, (v) => $6a0b641ff72a0641$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $6a0b641ff72a0641$export$f7ad0328861e2f03, (v) => $6a0b641ff72a0641$export$f7ad0328861e2f03 = v);
var $6a0b641ff72a0641$export$6503ec6e8aabbaf;
var $6a0b641ff72a0641$export$f7ad0328861e2f03;
"use strict";
var $6a0b641ff72a0641$var$mapping = new Map();
function $6a0b641ff72a0641$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6a0b641ff72a0641$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6a0b641ff72a0641$var$resolve(id) {
    var resolved = $6a0b641ff72a0641$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6a0b641ff72a0641$export$6503ec6e8aabbaf = $6a0b641ff72a0641$var$register;
$6a0b641ff72a0641$export$f7ad0328861e2f03 = $6a0b641ff72a0641$var$resolve;

});




parcelRegister("8xoxE", function(module, exports) {
$parcel$export(module.exports, "ErrorFlagRenderer", () => $cee168e57e84cb3d$export$71d5b03f33fc194b);
$parcel$export(module.exports, "ErrorBoundaryFlag", () => $cee168e57e84cb3d$export$7b744ef274d5ae99);

var $euxye = parcelRequire("euxye");

var $eXdAp = parcelRequire("eXdAp");

var $dCJKF = parcelRequire("dCJKF");

var $kKbVr = parcelRequire("kKbVr");

var $lCetP = parcelRequire("lCetP");

var $cCE2Z = parcelRequire("cCE2Z");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

const $cee168e57e84cb3d$var$ErrorFlagRendererLazy = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $l8G1z.lazy)(()=>(parcelRequire("jabq1")).then((m)=>m.ErrorFlagManager), {
    moduleId: "./src/packages/platform/error-flag-renderer/src/ErrorFlagManager.tsx"
});
const $cee168e57e84cb3d$export$71d5b03f33fc194b = ({ id: id, error: error, packageName: packageName, teamName: teamName })=>{
    (0, $kKbVr.useReportTerminalError)(error, {
        teamName: teamName,
        packageName: packageName,
        errorBoundaryId: id,
        fallbackType: 'flag',
        errorHash: error ? (0, $eXdAp.getErrorHash)(error) : undefined,
        isClientNetworkError: (0, $lCetP.isClientFetchError)(error)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: id,
        packageName: packageName ?? 'jiraErrorBoundary',
        teamName: teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        id: id,
        packageName: packageName ?? 'jiraErrorBoundary',
        teamName: teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-error-flag-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cee168e57e84cb3d$var$ErrorFlagRendererLazy, {
        id: id,
        error: error
    }))));
};
$cee168e57e84cb3d$export$71d5b03f33fc194b.displayName = "ErrorFlagRenderer";
const $cee168e57e84cb3d$var$DEFAULT_EXTRA_EVENT_DATA = {};
const $cee168e57e84cb3d$export$7b744ef274d5ae99 = ({ children: children, extraEventData: extraEventData = $cee168e57e84cb3d$var$DEFAULT_EXTRA_EVENT_DATA, id: id, packageName: packageName, teamName: teamName, withExperienceTracker: withExperienceTracker })=>{
    const renderErrorFlag = (0, $euxye.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cee168e57e84cb3d$export$71d5b03f33fc194b, {
            id: "error-boundary",
            error: error,
            packageName: packageName,
            teamName: teamName
        }), [
        packageName,
        teamName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        extraEventData: extraEventData,
        id: id,
        packageName: packageName,
        teamName: teamName,
        withExperienceTracker: withExperienceTracker,
        render: renderErrorFlag
    }, children);
};
$cee168e57e84cb3d$export$7b744ef274d5ae99.displayName = "ErrorBoundaryFlag";

});
parcelRegister("jabq1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("5mDdu")
]).then(()=>parcelRequire('lvy9k'));

});




parcelRegister("fDxFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e83f5b528b61e7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, no-restricted-properties */ 
var $fcq2N = parcelRequire("fcq2N");
const $b4e83f5b528b61e7$var$getPerf = ()=>{
    try {
        // TODO - Write up an explanation to why we are doing this, if this method is approved.
        // oxlint-disable no-cond-assign
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.performance.clearResourceTimings && (window.performance.clearResourceTimings = (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.performance;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // no op implementation
        return {
            now: ()=>0,
            // @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'PerformanceMark'.
            mark: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            clearMarks: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            clearResourceTimings: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            getEntriesByType: (_type)=>[],
            getEntriesByName: (_name)=>[],
            // Replace with lodash/noop
            // @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'PerformanceMeasure'.
            measure: (_measureName, _start, _end)=>{
            /* empty */ }
        };
    }
};
const $b4e83f5b528b61e7$var$perf = $b4e83f5b528b61e7$var$getPerf();
var $b4e83f5b528b61e7$export$2e2bcd8739ae039 = $b4e83f5b528b61e7$var$perf;

});

parcelRegister("6xuJS", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $bda1fe3c753006cf$export$f45af69d005a6ed);
$parcel$export(module.exports, "setMark", () => $bda1fe3c753006cf$export$f7a1fb90d8604165);
$parcel$export(module.exports, "setMeasure", () => $bda1fe3c753006cf$export$3d472a4be9f2b366);
$parcel$export(module.exports, "measureFunc", () => $bda1fe3c753006cf$export$25a311d3df56652d);
/* eslint-disable jira/filename-case, no-console */ 
var $fDxFn = parcelRequire("fDxFn");
const $bda1fe3c753006cf$export$f45af69d005a6ed = (markName)=>{
    if (!(0, $fDxFn.default).getEntriesByName) return null;
    const marks = (0, $fDxFn.default).getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};
const $bda1fe3c753006cf$export$f7a1fb90d8604165 = (markName, markOptions)=>{
    if (!(0, $fDxFn.default).mark) return undefined;
    const entry = (0, $fDxFn.default).mark(markName, markOptions);
    if (console.timeStamp) console.timeStamp(markName);
    return entry;
};
const $bda1fe3c753006cf$export$3d472a4be9f2b366 = (measureName, start, end)=>{
    // performance.measure will throw an exception if either start/end marks are not set
    try {
        return (0, $fDxFn.default).measure(measureName, start, end);
    // eslint-disable-next-line no-empty
    } catch (_err) {}
    return undefined;
};
function $bda1fe3c753006cf$export$25a311d3df56652d(measureName, func) {
    $bda1fe3c753006cf$export$f7a1fb90d8604165(`${measureName}:start`);
    const result = func();
    $bda1fe3c753006cf$export$f7a1fb90d8604165(`${measureName}:end`);
    $bda1fe3c753006cf$export$3d472a4be9f2b366(measureName, `${measureName}:start`, `${measureName}:end`);
    return result;
}

});

parcelRegister("2DyVr", function(module, exports) {
$parcel$export(module.exports, "getMemoryUsageReport", () => $425dcb417a701141$export$e5bd2d61c7c80651);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // This is an approximation of the start of the session
const $425dcb417a701141$var$sessionStart = Date.now();
const $425dcb417a701141$export$e5bd2d61c7c80651 = ()=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const now = Date.now();
    const sessionTime = now - $425dcb417a701141$var$sessionStart;
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("lwmtx", function(module, exports) {
$parcel$export(module.exports, "ssr", () => $5f44adff9f2187f5$export$ea2375f6c0c9ffdc);
$parcel$export(module.exports, "ssrExtended", () => $5f44adff9f2187f5$export$b821aa3bb9044abf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $6bEm8 = parcelRequire("6bEm8");

var $1sVtJ = parcelRequire("1sVtJ");

var $kX67D = parcelRequire("kX67D");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5f44adff9f2187f5$var$getSSRFeatureFlags = (0, $emCaV.default)(()=>{
    try {
        const metaTagValue = (0, $6bEm8.default)('spa-service-flags');
        if (metaTagValue === null) return null;
        return JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $5f44adff9f2187f5$export$ea2375f6c0c9ffdc = {
    getDoneMark: (0, $1sVtJ.getSSRMark),
    getTimings: (0, $kX67D.getSSRTimings),
    getFeatureFlags: $5f44adff9f2187f5$var$getSSRFeatureFlags
};
const $5f44adff9f2187f5$export$b821aa3bb9044abf = {
    ...$5f44adff9f2187f5$export$ea2375f6c0c9ffdc,
    includeFeatureFlags: 'when-available'
};

});
parcelRegister("1sVtJ", function(module, exports) {
$parcel$export(module.exports, "getSSRMark", () => $a25d8e3eff288999$export$1faf7d001841a41c);
/* eslint-disable jira/filename-case */ 
var $6xuJS = parcelRequire("6xuJS");

const $a25d8e3eff288999$export$1faf7d001841a41c = ()=>(0, $6xuJS.getMark)((0, $07aa4ba62fd6dab4$export$135c96ab5afee429))?.startTime || null;

});
/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("kX67D", function(module, exports) {
$parcel$export(module.exports, "getSSRTimings", () => $ce94fcad4b2fd652$export$bf7408e83532dcd0);
/* eslint-disable jira/filename-case */ 
var $hBj11 = parcelRequire("hBj11");
const $ce94fcad4b2fd652$export$bf7408e83532dcd0 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.SPA_STATE) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($hBj11)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
};

});


parcelRegister("7bitu", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetrics3", () => $630df43f8cc41493$export$156d1d35be797a9d);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $9yf7o = parcelRequire("9yf7o");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $1awbE = parcelRequire("1awbE");

var $6Kdw4 = parcelRequire("6Kdw4");

var $ipvkO = parcelRequire("ipvkO");
var $211nO = parcelRequire("211nO");
var $4HRn5 = parcelRequire("4HRn5");

var $fB57Z = parcelRequire("fB57Z");

var $pabd0 = parcelRequire("pabd0");

var $jKrQU = parcelRequire("jKrQU");

var $jM9B9 = parcelRequire("jM9B9");

var $5QGqk = parcelRequire("5QGqk");

var $cBLn7 = parcelRequire("cBLn7");

var $4FfW8 = parcelRequire("4FfW8");

var $6rWlk = parcelRequire("6rWlk");
var $dANgO = parcelRequire("dANgO");

var $lwmtx = parcelRequire("lwmtx");
const $630df43f8cc41493$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $630df43f8cc41493$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $1awbE.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $630df43f8cc41493$var$getFileName = (url)=>$630df43f8cc41493$var$isWRMResource(url) ? $630df43f8cc41493$var$getWRMAssetName(url) : (0, $1awbE.sanitiseAssetName)(false)(url);
const $630df43f8cc41493$export$156d1d35be797a9d = ()=>{
    (0, $dANgO.startLSObserver)();
    (0, $dANgO.startLTObserver)();
    const info = {
        product: 'jira',
        app: {
            version: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                web: window.BUILD_KEY,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ssr: window.SSR_BUILD_KEY
            },
            framework: {
                name: 'react',
                version: $euxye.version
            }
        },
        region: (0, $6bEm8.default)('ajs-region') || 'unknown'
    };
    const endpoints = {
        eventPipelineClient: (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client.getInstance();
            if (!(0, $i860n.fg)('uip_bm3_stop-page-load')) return instance;
            return {
                sendOperationalEvent: (payload)=>{
                    const type = payload?.attributes?.properties?.['event:type'];
                    if (type === 'page-load') return;
                    return instance.sendOperationalEvent(payload);
                }
            };
        })
    };
    const resourceTimings = {
        sanitiseEndpoints: $cBLn7.sanitiseEndpoints,
        mapResources: $630df43f8cc41493$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-branch') || $630df43f8cc41493$var$isWRMResource(url),
        // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
    const featureFlagClient = {
        getValue: (_featureFlagName)=>{
            return undefined;
        }
    };
    const featureFlags = {
        client: Promise.resolve(featureFlagClient)
    };
    const plugins = {
        featureFlags: featureFlags,
        resourceTimings: resourceTimings,
        bundleEvalTimings: $fB57Z.bundleEvalTimings
    };
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $211nO.payloadPublisher).setup({
            product: 'jira',
            app: {
                version: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    web: window.BUILD_KEY,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ssr: window.SSR_BUILD_KEY
                },
                framework: {
                    name: 'react',
                    version: $euxye.version
                }
            },
            region: (0, $6bEm8.default)('ajs-region') || 'unknown',
            tenantType: (0, $6bEm8.default)('ajs-is-synthetic') === 'true' ? (0, $4HRn5.TenantType).Synthetic : (0, $4HRn5.TenantType).RealUser,
            gasv3: client.getInstance(),
            bundleEvalTimings: // @ts-expect-error - TS2322 - Type '{ readonly mapPerformanceMark: (mark: string) => { name: string; type: string; } | null; }' is not assignable to type 'BundleEvalTimingsConfig'.
            $fB57Z.bundleEvalTimings,
            resourceTimings: resourceTimings,
            featureFlagClient: featureFlagClient,
            featureFlags: [
                ...(0, $jM9B9.featureFlagsAddedToEVERYJiraEvent),
                ...(0, $4FfW8.jfpPerfFeatureFlags),
                ...(0, $5QGqk.featureFlagsAddedToEVERYPageLoadEvent)
            ],
            plugins: [
                // all
                (0, $pabd0.getCustomData),
                // @ts-expect-error - TS2322 - Type '(data: {    start: number;}) => Record<string, any> | null' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $cBLn7.getMarks),
                (0, $cBLn7.getMemoryMetrics),
                // page-load
                (0, $jKrQU.getPageSizeMetrics),
                (0, $jKrQU.getExtraNavigationTimings),
                // @ts-expect-error - TS2322 - Type '() => (() => unknown)[]' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $cBLn7.getPageLoadPlugins)
            ],
            ssr: $lwmtx.ssr,
            performanceConfig: {
                histogram: {
                    [(0, $ipvkO.ExperiencePerformanceTypes).PageLoad]: {
                        initial: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '4000_4500_5000_6000_7000_8000_9000'
                        },
                        transition: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '2500_3000_3500_4000_5000_6000'
                        }
                    },
                    [(0, $ipvkO.ExperiencePerformanceTypes).InlineResult]: {
                        result: '100_200_500_1000_1500',
                        response: '50_100_150_200_300_500'
                    },
                    [(0, $ipvkO.ExperiencePerformanceTypes).Custom]: {
                        duration: '250_500_1000_1500_2000_3000_4000'
                    }
                }
            }
        });
    });
    (0, $9yf7o.browserMetrics).init({
        info: info,
        endpoints: // @ts-expect-error - TS2322 - Type '{ eventPipelineClient: Promise<AnalyticsWebClient> | Promise<IEventPipelineClient>; metalClient: Promise<MetalClient>; }' is not assignable to type '{ eventPipelineClient: Promise<{ sendOperationalEvent: (payload: GasPurePayload) => void; }>; metalClient?: Promise<{ metric: { submit: (payload: unknown) => void; }; }> | undefined; }'.
        endpoints,
        plugins: // @ts-expect-error - TS2322 - Type '{ featureFlags: { client: Promise<{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }>; }; resourceTimings: { sanitiseEndpoints: (url: string) => string; mapResources: (url: string) => any; hasTimingHeaders: (url: string) => boolean; xhrFilter: (url: any) => any; }; bundleEvalTimings: { ...; }; }' is not assignable to type '{ resourceTimings: ResourceTimingsConfig; bundleEvalTimings?: BundleEvalTimingsConfig | undefined; featureFlags: { client: FeatureFlagsClientPromise; }; }'.
        plugins,
        events: {
            all: {
                featureFlags: [
                    ...(0, $jM9B9.featureFlagsAddedToEVERYJiraEvent),
                    ...(0, $4FfW8.jfpPerfFeatureFlags)
                ],
                plugins: [
                    (0, $cBLn7.getMarks),
                    (0, $cBLn7.getMemoryMetrics),
                    (0, $6rWlk.getLighthouseMetrics),
                    (0, $pabd0.newGetCustomData)
                ]
            },
            PAGE_LOAD: {
                featureFlags: [
                    ...(0, $5QGqk.featureFlagsAddedToEVERYPageLoadEvent)
                ],
                custom: {
                    ...(0, $jKrQU.getPageSizeMetrics)(),
                    ...(0, $jKrQU.getExtraNavigationTimings)()
                },
                // @ts-expect-error - TS2322 - Type '(() => unknown)[]' is not assignable to type 'CustomPlugin[]'.
                plugins: (0, $cBLn7.getPageLoadPlugins)(),
                histogram: {
                    initial: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '4000_4500_5000_6000_7000_8000_9000'
                    },
                    transition: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '2500_3000_3500_4000_5000_6000'
                    }
                }
            },
            INLINE_RESULT: {
                histogram: {
                    result: '100_200_500_1000_1500',
                    response: '50_100_150_200_300_500'
                }
            },
            CUSTOM: {
                histogram: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            },
            WEB_VITALS: {
                enabled: !false && (0, $6bEm8.default)('ajs-is-synthetic') === 'true'
            }
        },
        // @ts-expect-error - TS2322 - Type '{ readonly includeFeatureFlags: "when-available"; readonly getDoneMark: () => number | null; readonly getTimings: () => any; readonly getFeatureFlags: MemoizedFn<() => any>; }' is not assignable to type 'SSRConfig'.
        ssr: (0, $lwmtx.ssrExtended)
    });
    (0, $9yf7o.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("fB57Z", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $74a8f2aae7853f4a$export$1a2bb347935fc536);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lhWE3 = parcelRequire("lhWE3");
const $74a8f2aae7853f4a$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $lhWE3.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $lhWE3.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $lhWE3.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $lhWE3.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("pabd0", function(module, exports) {
$parcel$export(module.exports, "newGetCustomData", () => $372f413af3d36cc6$export$bc962f7892f5542c);
$parcel$export(module.exports, "getCustomData", () => $372f413af3d36cc6$export$c740a965f4a07e8e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aUPBc = parcelRequire("aUPBc");

var $emCaV = parcelRequire("emCaV");

var $6bEm8 = parcelRequire("6bEm8");

var $bMqRl = parcelRequire("bMqRl");

var $gWfLh = parcelRequire("gWfLh");

var $lgfkb = parcelRequire("lgfkb");

var $kq0hx = parcelRequire("kq0hx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $372f413af3d36cc6$var$customData = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const commonCustomData = {};
    const shard = (0, $6bEm8.default)('ajs-shard');
    if (shard !== null && shard !== '') commonCustomData.shard = shard;
    commonCustomData['jira:productEditions'] = (0, $bMqRl.getProductEditions)();
    commonCustomData['network:assetEncoding'] = (0, $gWfLh.getAssetEncoding)();
    const buildVariant = (0, $lgfkb.getBuildVariant)();
    if (buildVariant) commonCustomData['app:buildVariant'] = buildVariant;
    const bundlerVersion = (0, $kq0hx.getBundlerVersion)();
    if (bundlerVersion) commonCustomData['app:bundlerVersion'] = bundlerVersion;
    commonCustomData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    return commonCustomData;
};
const $372f413af3d36cc6$export$bc962f7892f5542c = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))($372f413af3d36cc6$var$customData, ()=>true);
const $372f413af3d36cc6$export$c740a965f4a07e8e = (0, $emCaV.default)($372f413af3d36cc6$var$customData);

});
parcelRegister("gWfLh", function(module, exports) {
$parcel$export(module.exports, "getAssetEncoding", () => $0b40947738bcb48a$export$fd12d8f45e126585);
/* eslint-disable jira/filename-case */ const $0b40947738bcb48a$export$fd12d8f45e126585 = ()=>{
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
};

});

parcelRegister("lgfkb", function(module, exports) {
$parcel$export(module.exports, "getBuildVariant", () => $9f3f8575f5dac0ad$export$ca0c40b5b7c3b911);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $9f3f8575f5dac0ad$export$ca0c40b5b7c3b911 = ()=>window.BUILD_VARIANT;

});

parcelRegister("kq0hx", function(module, exports) {
$parcel$export(module.exports, "getBundlerVersion", () => $86ea452164229c63$export$5dca7b2a9cf4f500);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/no-explicit-any
const $86ea452164229c63$export$5dca7b2a9cf4f500 = ()=>window.BUNDLER_VERSION;

});


parcelRegister("jKrQU", function(module, exports) {
$parcel$export(module.exports, "getPageSizeMetrics", () => $2ad535cbe47aeaae$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $2ad535cbe47aeaae$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $2ad535cbe47aeaae$export$b72e035af6568be7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fDxFn = parcelRequire("fDxFn");
const $2ad535cbe47aeaae$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $2ad535cbe47aeaae$export$b37a70af06e58097 = ()=>{
    if (!(0, $fDxFn.default)) return {};
    const navigation = (0, $fDxFn.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $2ad535cbe47aeaae$var$assetsTypes = [
    'script',
    'link'
];
const $2ad535cbe47aeaae$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $2ad535cbe47aeaae$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $fDxFn.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($2ad535cbe47aeaae$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("jM9B9", function(module, exports) {
$parcel$export(module.exports, "featureFlagsAddedToEVERYJiraEvent", () => $239d6f124fb3c970$export$8f6204c7f33d9925);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // by adding feature flag to this array you agree that this feature flag:
// * is expected to impact all performance metrics in Jira (page load, interactions, etc)
// * is expected to be short term
const $239d6f124fb3c970$export$8f6204c7f33d9925 = [];

});

parcelRegister("5QGqk", function(module, exports) {
$parcel$export(module.exports, "featureFlagsAddedToEVERYPageLoadEvent", () => $fa1da02dfc731ef3$export$85fd4da798ef108b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // by adding feature flag to this array you agree that this feature flag:
// * is expected to impact *all page load* performance metrics in Jira
// * is expected to be short term
const $fa1da02dfc731ef3$export$85fd4da798ef108b = [];

});

parcelRegister("cBLn7", function(module, exports) {
$parcel$export(module.exports, "getPageLoadPlugins", () => $1322a3e300aa092f$export$4d5c3be18e81b958);
$parcel$export(module.exports, "getMemoryMetrics", () => $1322a3e300aa092f$export$500422125b861bab);
$parcel$export(module.exports, "getMarks", () => $1322a3e300aa092f$export$9d952633c9c2237b);
$parcel$export(module.exports, "sanitiseEndpoints", () => $1322a3e300aa092f$export$6dfc8bfc2349f367);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $a622V = parcelRequire("a622V");

var $lhWE3 = parcelRequire("lhWE3");

var $2DyVr = parcelRequire("2DyVr");

var $eX7KM = parcelRequire("eX7KM");

var $jKrQU = parcelRequire("jKrQU");

var $4KGG4 = parcelRequire("4KGG4");

var $2pe2G = parcelRequire("2pe2G");

var $lHLb3 = parcelRequire("lHLb3");

var $4Krsy = parcelRequire("4Krsy");
const $1322a3e300aa092f$var$endpointsWithOperationNameRegex = new RegExp('/rest/graphql/1/|/rest/gira/1/|/gateway/api/graphql|/jsw2/graphql');
const $1322a3e300aa092f$export$4d5c3be18e81b958 = ()=>{
    const pageLoadCustomData = [];
    pageLoadCustomData.push((data)=>{
        // initial load only
        const startTime = data?.start || data?.result?.startTime || 0;
        if (startTime !== 0) return {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries((0, $eX7KM.getServerDurationMetrics)()).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            acc[key] = value;
            return acc;
        }, {});
    });
    pageLoadCustomData.push((0, $lHLb3.getRouterResourceMetrics));
    pageLoadCustomData.push((0, $4Krsy.getWRMStats));
    pageLoadCustomData.push((0, $4KGG4.getCacheHitRatio));
    pageLoadCustomData.push((0, $2pe2G.getCHRInfo));
    pageLoadCustomData.push((0, $jKrQU.getPageSizeInfo));
    return pageLoadCustomData;
};
const $1322a3e300aa092f$export$500422125b861bab = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customData = {};
    const memoryUsageReport = (0, $2DyVr.getMemoryUsageReport)();
    if (memoryUsageReport) customData.memory = memoryUsageReport;
    return customData;
};
const $1322a3e300aa092f$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $a622V.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $lhWE3.JS_EVAL_START)) && !item.name.endsWith((0, $lhWE3.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};
const $1322a3e300aa092f$export$6dfc8bfc2349f367 = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(url, true);
    let fileName = parsedUrl.pathname.replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/gi, '<uuid>').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/\d+$/i, '/<id>');
    /**
	 * For these endpoints we make a special exception to add the query parameters so that we can distinguish calls using different queries
	 */ if ($1322a3e300aa092f$var$endpointsWithOperationNameRegex.test(fileName)) {
        const { operation: operation } = parsedUrl.query;
        if (operation) fileName += `?operation=${operation}`;
    }
    return fileName;
};

});
parcelRegister("eX7KM", function(module, exports) {
$parcel$export(module.exports, "getServerDurationMetrics", () => $baf96aee16f64d91$export$efd8b60b870e5282);
/* eslint-disable jira/filename-case */ /**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $baf96aee16f64d91$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("4KGG4", function(module, exports) {
$parcel$export(module.exports, "getCacheHitRatio", () => $6009e684a55d62c8$export$e8a9322c3d9da8a6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fDxFn = parcelRequire("fDxFn");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $6009e684a55d62c8$var$cacheableTypes = [
    'script',
    'link'
];
const $6009e684a55d62c8$var$CACHE_NETWORK = 'network';
const $6009e684a55d62c8$var$CACHE_MEMORY = 'memory';
const $6009e684a55d62c8$var$CACHE_DISK = 'disk';
const $6009e684a55d62c8$var$calculateTransferType = (type, duration, size)=>{
    if (!$6009e684a55d62c8$var$cacheableTypes.includes(type)) return $6009e684a55d62c8$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $6009e684a55d62c8$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $6009e684a55d62c8$var$CACHE_DISK;
    if (size === undefined) return null;
    return $6009e684a55d62c8$var$CACHE_NETWORK;
};
const $6009e684a55d62c8$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $fDxFn.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $6009e684a55d62c8$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("2pe2G", function(module, exports) {
$parcel$export(module.exports, "getCHRInfo", () => $c537756d2e27197f$export$9e005e111be93521);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fDxFn = parcelRequire("fDxFn");

var $1sVtJ = parcelRequire("1sVtJ");

var $lW1DP = parcelRequire("lW1DP");
const $c537756d2e27197f$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = (0, $1sVtJ.getSSRMark)();
    const reporter = new (0, $lW1DP.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $fDxFn.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("lW1DP", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", () => $b4de85b0847fbe60$export$7d0d4cfb6455ffa5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $j1uVX = parcelRequire("j1uVX");

var $ftutm = parcelRequire("ftutm");
class $b4de85b0847fbe60$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $ftutm.CHRSummary)();
        this.all = new (0, $ftutm.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $j1uVX.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $ftutm.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $ftutm.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $ftutm.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $ftutm.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $ftutm.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round(summary.size[(0, $ftutm.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round(summary.size[(0, $ftutm.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round(summary.size[(0, $ftutm.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $b4de85b0847fbe60$export$7d0d4cfb6455ffa5.round((summary.size[(0, $ftutm.CHRSummary).MEMORY_KEY] + summary.size[(0, $ftutm.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}
$b4de85b0847fbe60$export$7d0d4cfb6455ffa5.displayName = "CHRReporter";

});
parcelRegister("j1uVX", function(module, exports) {
$parcel$export(module.exports, "cacheableTypes", () => $f490654d89856867$export$5e1aa91d6932ddaa);
/* eslint-disable jira/filename-case */ /* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f490654d89856867$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("ftutm", function(module, exports) {
$parcel$export(module.exports, "CHRSummary", () => $6a01ba43d12411a9$export$783d6618ee601ba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $j1uVX = parcelRequire("j1uVX");
const $6a01ba43d12411a9$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $j1uVX.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $6a01ba43d12411a9$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $6a01ba43d12411a9$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $6a01ba43d12411a9$export$783d6618ee601ba.NETWORK_KEY;
};
class $6a01ba43d12411a9$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $6a01ba43d12411a9$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$6a01ba43d12411a9$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$6a01ba43d12411a9$export$783d6618ee601ba.DISK_KEY]: 0,
            [$6a01ba43d12411a9$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$6a01ba43d12411a9$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$6a01ba43d12411a9$export$783d6618ee601ba.DISK_KEY]: 0,
            [$6a01ba43d12411a9$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}
$6a01ba43d12411a9$export$783d6618ee601ba.displayName = "CHRSummary";

});



parcelRegister("lHLb3", function(module, exports) {
$parcel$export(module.exports, "getRouterResourceMetrics", () => $8500ed990ef8d35c$export$e703af446a67c7f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $8500ed990ef8d35c$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("4Krsy", function(module, exports) {
$parcel$export(module.exports, "getWRMStats", () => $1833720e0a25e381$export$d2d916ddd03b82bc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $1833720e0a25e381$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("4FfW8", function(module, exports) {
$parcel$export(module.exports, "jfpPerfFeatureFlags", () => $7ccb23b281e133f8$export$b1f8075e4696e880);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7ccb23b281e133f8$export$b1f8075e4696e880 = [];

});

parcelRegister("6rWlk", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $6101be4a773d91ca$export$b46cecdf698e4bb5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8z3u = parcelRequire("d8z3u");

var $zoKQi = parcelRequire("zoKQi");

var $haWdL = parcelRequire("haWdL");

var $1tJfM = parcelRequire("1tJfM");

var $dANgO = parcelRequire("dANgO");
const $6101be4a773d91ca$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $haWdL.getTBT)(start, stop, (0, $1tJfM.EntriesBuffer)[(0, $zoKQi.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $d8z3u.getCLS)(start, stop, (0, $1tJfM.EntriesBuffer)[(0, $zoKQi.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("d8z3u", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $13f60f89a116c672$export$fc6227831ee7c7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $13f60f89a116c672$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("zoKQi", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $dde5d729e8382a93$export$a4def92db6fc8e17);
/* eslint-disable jira/filename-case */ const $dde5d729e8382a93$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("haWdL", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $254f22ce2b9f3383$export$2d6e933b35bd3407);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $254f22ce2b9f3383$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $254f22ce2b9f3383$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $254f22ce2b9f3383$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $254f22ce2b9f3383$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $254f22ce2b9f3383$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("1tJfM", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $639be625a2edae25$export$f7dc16cbd16f7bbe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $zoKQi = parcelRequire("zoKQi");
class $639be625a2edae25$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
$639be625a2edae25$export$2c6e86519c9e8188.displayName = "BufferWithMaxLength";
const $639be625a2edae25$export$f7dc16cbd16f7bbe = {
    [(0, $zoKQi.PerformanceObserverEntryTypes).LongTask]: new $639be625a2edae25$export$2c6e86519c9e8188(),
    [(0, $zoKQi.PerformanceObserverEntryTypes).LayoutShift]: new $639be625a2edae25$export$2c6e86519c9e8188()
};

});

parcelRegister("dANgO", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $cdfee6d471ac7c62$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $cdfee6d471ac7c62$export$54fb8b6aaf70ec9c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $zoKQi = parcelRequire("zoKQi");

var $1tJfM = parcelRequire("1tJfM");
let $cdfee6d471ac7c62$var$pe = null;
const $cdfee6d471ac7c62$var$getObserver = ()=>{
    if ($cdfee6d471ac7c62$var$pe !== null) return $cdfee6d471ac7c62$var$pe;
    $cdfee6d471ac7c62$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $zoKQi.PerformanceObserverEntryTypes).LayoutShift) (0, $1tJfM.EntriesBuffer)[(0, $zoKQi.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $zoKQi.PerformanceObserverEntryTypes).LongTask) (0, $1tJfM.EntriesBuffer)[(0, $zoKQi.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $cdfee6d471ac7c62$var$pe;
};
const $cdfee6d471ac7c62$export$768ccc3ab7bac3ea = ()=>{
    $cdfee6d471ac7c62$var$getObserver().observe({
        type: (0, $zoKQi.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $cdfee6d471ac7c62$export$54fb8b6aaf70ec9c = ()=>{
    $cdfee6d471ac7c62$var$getObserver().observe({
        type: (0, $zoKQi.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});



const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

/* eslint-disable jira/filename-case */ const $0ce01f968965dadd$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $0ce01f968965dadd$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $0ce01f968965dadd$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $0ce01f968965dadd$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $0ce01f968965dadd$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $0ce01f968965dadd$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $0ce01f968965dadd$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $0ce01f968965dadd$export$4695c1a423ffe431 = 'DASHBOARD';
const $0ce01f968965dadd$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $0ce01f968965dadd$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $0ce01f968965dadd$export$9a80695e72849f84 = 'X-Atlassian-Capability';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $c3b876b1e2716851$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $8312ee7c6ac197b8$export$93809551debf385f = '0.1.7';

const $dd841321bc924872$export$b98e411ae80c806f = '/';


$parcel$global.rlb("f15cT")
//# sourceMappingURL=shared~commons~ar.00e5f240.js.map
